(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9743"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9743"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8upap", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
$parcel$export(module.exports, "loadModule", () => loadModule, (v) => loadModule = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $7eDcu = parcelRequire("7eDcu");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $7eDcu.isBrowserBundle)() && Object.prototype.toString.call(0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("7eDcu", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", () => $54483f9c35a67705$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $54483f9c35a67705$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

});


parcelRegister("cQg0t", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);
$parcel$export(module.exports, "timestampInSeconds", () => timestampInSeconds, (v) => timestampInSeconds = v);
$parcel$export(module.exports, "timestampWithMs", () => timestampWithMs, (v) => timestampWithMs = v);
$parcel$export(module.exports, "browserPerformanceTimeOrigin", () => browserPerformanceTimeOrigin, (v) => browserPerformanceTimeOrigin = v);

var $1SlwS = parcelRequire("1SlwS");

var $8upap = parcelRequire("8upap");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $1SlwS.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $8upap.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $8upap.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $1SlwS.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});
parcelRegister("1SlwS", function(module, exports) {

$parcel$export(module.exports, "getGlobalObject", () => $15db88df49823d53$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $15db88df49823d53$export$7e223ec222791509);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $8upap = parcelRequire("8upap");
var $15db88df49823d53$var$fallbackGlobalObject = {};
function $15db88df49823d53$export$256479dc0cea61c4() {
    return (0, $8upap.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $15db88df49823d53$var$fallbackGlobalObject;
}
function $15db88df49823d53$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $15db88df49823d53$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});


parcelRegister("3siHg", function(module, exports) {

$parcel$export(module.exports, "startIdleTransaction", () => startIdleTransaction, (v) => startIdleTransaction = v);
$parcel$export(module.exports, "addExtensionMethods", () => addExtensionMethods, (v) => addExtensionMethods = v);

var $gztBd = parcelRequire("gztBd");

var $6cwj6 = parcelRequire("6cwj6");
parcelRequire("2ktyf");
var $8upap = parcelRequire("8upap");
var $5QZE4 = parcelRequire("5QZE4");
var $7htw4 = parcelRequire("7htw4");

var $8Wz1M = parcelRequire("8Wz1M");

var $2mkHy = parcelRequire("2mkHy");

var $kCOHN = parcelRequire("kCOHN");

var $j8tm1 = parcelRequire("j8tm1");

var $b1qwm = parcelRequire("b1qwm");
/** Returns all trace headers that are currently on the top scope. */ function traceHeaders() {
    var scope = this.getScope();
    if (scope) {
        var span = scope.getSpan();
        if (span) return {
            'sentry-trace': span.toTraceparent()
        };
    }
    return {};
}
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */ function sample(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $b1qwm.hasTracingEnabled)(options)) {
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    if (transaction.sampled !== undefined) {
        transaction.setMetadata({
            transactionSampling: {
                method: 'explicitly_set'
            }
        });
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    var sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setMetadata({
            transactionSampling: {
                method: 'client_sampler',
                // cast to number in case it's a boolean
                rate: Number(sampleRate)
            }
        });
    } else if (samplingContext.parentSampled !== undefined) {
        sampleRate = samplingContext.parentSampled;
        transaction.setMetadata({
            transactionSampling: {
                method: 'inheritance'
            }
        });
    } else {
        sampleRate = options.tracesSampleRate;
        transaction.setMetadata({
            transactionSampling: {
                method: 'client_rate',
                // cast to number in case it's a boolean
                rate: Number(sampleRate)
            }
        });
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!isValidSampleRate(sampleRate)) {
        (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).warn('[Tracing] Discarding transaction because of invalid sample rate.');
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log("[Tracing] Discarding transaction because " + (typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'));
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    if (!transaction.sampled) {
        (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log("[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = " + Number(sampleRate) + ")");
        return transaction;
    }
    (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log("[Tracing] starting " + transaction.op + " transaction - " + transaction.name);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $5QZE4.isNaN)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
        (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).warn("[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got " + JSON.stringify(rate) + " of type " + JSON.stringify(typeof rate) + ".");
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).warn("[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got " + rate + ".");
        return false;
    }
    return true;
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function _startTransaction(transactionContext, customSamplingContext) {
    var client = this.getClient();
    var options = client && client.getOptions() || {};
    var transaction = new (0, $j8tm1.Transaction)(transactionContext, this);
    transaction = sample(transaction, options, (0, $gztBd.__assign)({
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext
    }, customSamplingContext));
    if (transaction.sampled) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    return transaction;
}
function startIdleTransaction(hub, transactionContext, idleTimeout, onScope, customSamplingContext) {
    var client = hub.getClient();
    var options = client && client.getOptions() || {};
    var transaction = new (0, $kCOHN.IdleTransaction)(transactionContext, hub, idleTimeout, onScope);
    transaction = sample(transaction, options, (0, $gztBd.__assign)({
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext
    }, customSamplingContext));
    if (transaction.sampled) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    return transaction;
}
function _addTracingExtensions() {
    var carrier = (0, $6cwj6.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
}
/**
 * @private
 */ function _autoloadDatabaseIntegrations() {
    var carrier = (0, $6cwj6.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    var packageToIntegrationMapping = {
        mongodb: function() {
            var integration = (0, $8upap.dynamicRequire)(module, './integrations/node/mongo');
            return new integration.Mongo();
        },
        mongoose: function() {
            var integration = (0, $8upap.dynamicRequire)(module, './integrations/node/mongo');
            return new integration.Mongo({
                mongoose: true
            });
        },
        mysql: function() {
            var integration = (0, $8upap.dynamicRequire)(module, './integrations/node/mysql');
            return new integration.Mysql();
        },
        pg: function() {
            var integration = (0, $8upap.dynamicRequire)(module, './integrations/node/postgres');
            return new integration.Postgres();
        }
    };
    var mappedPackages = Object.keys(packageToIntegrationMapping).filter(function(moduleName) {
        return !!(0, $8upap.loadModule)(moduleName);
    }).map(function(pkg) {
        try {
            return packageToIntegrationMapping[pkg]();
        } catch (e) {
            return undefined;
        }
    }).filter(function(p) {
        return p;
    });
    if (mappedPackages.length > 0) carrier.__SENTRY__.integrations = (0, $gztBd.__spread)(carrier.__SENTRY__.integrations || [], mappedPackages);
}
function addExtensionMethods() {
    _addTracingExtensions();
    // Detect and automatically load specified integrations.
    if ((0, $8upap.isNodeEnv)()) _autoloadDatabaseIntegrations();
    // If an error happens globally, we should make sure transaction status is set to error.
    (0, $8Wz1M.registerErrorInstrumentation)();
}

});
parcelRegister("gztBd", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $c106e002a49a00cb$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $c106e002a49a00cb$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $c106e002a49a00cb$export$3c9a16f847548506);
$parcel$export(module.exports, "__values", () => $c106e002a49a00cb$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $c106e002a49a00cb$export$8d051b38c9118094);
$parcel$export(module.exports, "__spread", () => $c106e002a49a00cb$export$afc72e2116322959);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $c106e002a49a00cb$var$extendStatics = function(d, b) {
    $c106e002a49a00cb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $c106e002a49a00cb$var$extendStatics(d, b);
};
function $c106e002a49a00cb$export$a8ba968b8961cb8a(d, b) {
    $c106e002a49a00cb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c106e002a49a00cb$export$18ce0697a983be9b = function() {
    $c106e002a49a00cb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c106e002a49a00cb$export$18ce0697a983be9b.apply(this, arguments);
};
function $c106e002a49a00cb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c106e002a49a00cb$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c106e002a49a00cb$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c106e002a49a00cb$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c106e002a49a00cb$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c106e002a49a00cb$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $c106e002a49a00cb$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $c106e002a49a00cb$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $c106e002a49a00cb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c106e002a49a00cb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c106e002a49a00cb$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c106e002a49a00cb$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c106e002a49a00cb$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c106e002a49a00cb$export$10c90e4f7922046c(v) {
    return this instanceof $c106e002a49a00cb$export$10c90e4f7922046c ? (this.v = v, this) : new $c106e002a49a00cb$export$10c90e4f7922046c(v);
}
function $c106e002a49a00cb$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c106e002a49a00cb$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c106e002a49a00cb$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c106e002a49a00cb$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $c106e002a49a00cb$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c106e002a49a00cb$export$19a8beecd37a4c45 === "function" ? $c106e002a49a00cb$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c106e002a49a00cb$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $c106e002a49a00cb$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $c106e002a49a00cb$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $c106e002a49a00cb$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $c106e002a49a00cb$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("6cwj6", function(module, exports) {

$parcel$export(module.exports, "Hub", () => $483cec974d1e37d9$export$8c41bb232f1008b1);
$parcel$export(module.exports, "getMainCarrier", () => $483cec974d1e37d9$export$19eade501500c6c1);
$parcel$export(module.exports, "getCurrentHub", () => $483cec974d1e37d9$export$a07cdf6544bbd7c);

var $gztBd = parcelRequire("gztBd");
parcelRequire("2ktyf");
var $7htw4 = parcelRequire("7htw4");
var $cQg0t = parcelRequire("cQg0t");
var $1SlwS = parcelRequire("1SlwS");
var $8upap = parcelRequire("8upap");
var $HgoiY = parcelRequire("HgoiY");

var $iv17a = parcelRequire("iv17a");

var $ka93y = parcelRequire("ka93y");

var $lk785 = parcelRequire("lk785");
var $483cec974d1e37d9$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var $483cec974d1e37d9$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ var $483cec974d1e37d9$export$8c41bb232f1008b1 = /** @class */ function() {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */ function Hub(client, scope, _version) {
        if (scope === void 0) scope = new (0, $ka93y.Scope)();
        if (_version === void 0) _version = $483cec974d1e37d9$export$24a86ef7798177e4;
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */ this._stack = [
            {}
        ];
        this.getStackTop().scope = scope;
        if (client) this.bindClient(client);
    }
    /**
     * @inheritDoc
     */ Hub.prototype.isOlderThan = function(version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.bindClient = function(client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.pushScope = function() {
        // We want to clone the content of prev scope
        var scope = (0, $ka93y.Scope).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.popScope = function() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.withScope = function(callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getClient = function() {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */ Hub.prototype.getScope = function() {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */ Hub.prototype.getStack = function() {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */ Hub.prototype.getStackTop = function() {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function(exception, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $HgoiY.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureException', exception, (0, $gztBd.__assign)((0, $gztBd.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureMessage = function(message, level, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $HgoiY.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureMessage', message, level, (0, $gztBd.__assign)((0, $gztBd.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureEvent = function(event, hint) {
        var eventId = hint && hint.event_id ? hint.event_id : (0, $HgoiY.uuid4)();
        if (event.type !== 'transaction') this._lastEventId = eventId;
        this._invokeClient('captureEvent', event, (0, $gztBd.__assign)((0, $gztBd.__assign)({}, hint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.lastEventId = function() {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.addBreadcrumb = function(breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client) return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = client.getOptions && client.getOptions() || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? $483cec974d1e37d9$var$DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0) return;
        var timestamp = (0, $cQg0t.dateTimestampInSeconds)();
        var mergedBreadcrumb = (0, $gztBd.__assign)({
            timestamp: timestamp
        }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb ? (0, $7htw4.consoleSandbox)(function() {
            return beforeBreadcrumb(mergedBreadcrumb, hint);
        }) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setUser = function(user) {
        var scope = this.getScope();
        if (scope) scope.setUser(user);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTags = function(tags) {
        var scope = this.getScope();
        if (scope) scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtras = function(extras) {
        var scope = this.getScope();
        if (scope) scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTag = function(key, value) {
        var scope = this.getScope();
        if (scope) scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtra = function(key, extra) {
        var scope = this.getScope();
        if (scope) scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function(name, context) {
        var scope = this.getScope();
        if (scope) scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.configureScope = function(callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) callback(scope);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.run = function(callback) {
        var oldHub = $483cec974d1e37d9$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $483cec974d1e37d9$export$4188a14ad302d1bc(oldHub);
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getIntegration = function(integration) {
        var client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $iv17a.IS_DEBUG_BUILD) && (0, $7htw4.logger).warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSpan = function(context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startTransaction = function(context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.traceHeaders = function() {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureSession = function(endSession) {
        if (endSession === void 0) endSession = false;
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.endSession = function() {
        var layer = this.getStackTop();
        var scope = layer && layer.scope;
        var session = scope && scope.getSession();
        if (session) session.close();
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) scope.setSession();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSession = function(context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = client && client.getOptions() || {}, release = _b.release, environment = _b.environment;
        // Will fetch userAgent if called from browser sdk
        var global = (0, $1SlwS.getGlobalObject)();
        var userAgent = (global.navigator || {}).userAgent;
        var session = new (0, $lk785.Session)((0, $gztBd.__assign)((0, $gztBd.__assign)((0, $gztBd.__assign)({
            release: release,
            environment: environment
        }, scope && {
            user: scope.getUser()
        }), userAgent && {
            userAgent: userAgent
        }), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === 'ok') currentSession.update({
                status: 'exited'
            });
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */ Hub.prototype._sendSessionUpdate = function() {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope) return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) client.captureSession(session);
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function(method) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        (_a = client)[method].apply(_a, (0, $gztBd.__spread)(args, [
            scope
        ]));
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function(method) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var carrier = $483cec974d1e37d9$export$19eade501500c6c1();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $iv17a.IS_DEBUG_BUILD) && (0, $7htw4.logger).warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}();
function $483cec974d1e37d9$export$19eade501500c6c1() {
    var carrier = (0, $1SlwS.getGlobalObject)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return carrier;
}
function $483cec974d1e37d9$export$4188a14ad302d1bc(hub) {
    var registry = $483cec974d1e37d9$export$19eade501500c6c1();
    var oldHub = $483cec974d1e37d9$export$bfa8a924a84a76b7(registry);
    $483cec974d1e37d9$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
function $483cec974d1e37d9$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    var registry = $483cec974d1e37d9$export$19eade501500c6c1();
    // If there's no hub, or its an old API, assign a new one
    if (!$483cec974d1e37d9$var$hasHubOnCarrier(registry) || $483cec974d1e37d9$export$bfa8a924a84a76b7(registry).isOlderThan($483cec974d1e37d9$export$24a86ef7798177e4)) $483cec974d1e37d9$export$849f05434e95d2f2(registry, new $483cec974d1e37d9$export$8c41bb232f1008b1());
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0, $8upap.isNodeEnv)()) return $483cec974d1e37d9$var$getHubFromActiveDomain(registry);
    // Return hub that lives on a global object
    return $483cec974d1e37d9$export$bfa8a924a84a76b7(registry);
}
function $483cec974d1e37d9$export$1c4d656130202699() {
    (0, $iv17a.IS_DEBUG_BUILD) && (0, $7htw4.logger).warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
    var sentry = $483cec974d1e37d9$export$19eade501500c6c1().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */ function $483cec974d1e37d9$var$getHubFromActiveDomain(registry) {
    try {
        var sentry = $483cec974d1e37d9$export$19eade501500c6c1().__SENTRY__;
        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) return $483cec974d1e37d9$export$bfa8a924a84a76b7(registry);
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!$483cec974d1e37d9$var$hasHubOnCarrier(activeDomain) || $483cec974d1e37d9$export$bfa8a924a84a76b7(activeDomain).isOlderThan($483cec974d1e37d9$export$24a86ef7798177e4)) {
            var registryHubTopStack = $483cec974d1e37d9$export$bfa8a924a84a76b7(registry).getStackTop();
            $483cec974d1e37d9$export$849f05434e95d2f2(activeDomain, new $483cec974d1e37d9$export$8c41bb232f1008b1(registryHubTopStack.client, (0, $ka93y.Scope).clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return $483cec974d1e37d9$export$bfa8a924a84a76b7(activeDomain);
    } catch (_Oo) {
        // Return hub that lives on a global object
        return $483cec974d1e37d9$export$bfa8a924a84a76b7(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $483cec974d1e37d9$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
function $483cec974d1e37d9$export$bfa8a924a84a76b7(carrier) {
    return (0, $1SlwS.getGlobalSingleton)('hub', function() {
        return new $483cec974d1e37d9$export$8c41bb232f1008b1();
    }, carrier);
}
function $483cec974d1e37d9$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("2ktyf", function(module, exports) {
$parcel$export(module.exports, "forget", () => (parcelRequire("fYxH9")).forget);
$parcel$export(module.exports, "getLocationHref", () => (parcelRequire("eAaWR")).getLocationHref);
$parcel$export(module.exports, "htmlTreeAsString", () => (parcelRequire("eAaWR")).htmlTreeAsString);
$parcel$export(module.exports, "dsnToString", () => (parcelRequire("UMf0P")).dsnToString);
$parcel$export(module.exports, "makeDsn", () => (parcelRequire("UMf0P")).makeDsn);
$parcel$export(module.exports, "SentryError", () => (parcelRequire("h5dmQ")).SentryError);
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("1SlwS")).getGlobalObject);
$parcel$export(module.exports, "getGlobalSingleton", () => (parcelRequire("1SlwS")).getGlobalSingleton);
$parcel$export(module.exports, "addInstrumentationHandler", () => (parcelRequire("lDX8u")).addInstrumentationHandler);
$parcel$export(module.exports, "isDOMError", () => (parcelRequire("5QZE4")).isDOMError);
$parcel$export(module.exports, "isDOMException", () => (parcelRequire("5QZE4")).isDOMException);
$parcel$export(module.exports, "isError", () => (parcelRequire("5QZE4")).isError);
$parcel$export(module.exports, "isErrorEvent", () => (parcelRequire("5QZE4")).isErrorEvent);
$parcel$export(module.exports, "isEvent", () => (parcelRequire("5QZE4")).isEvent);
$parcel$export(module.exports, "isInstanceOf", () => (parcelRequire("5QZE4")).isInstanceOf);
$parcel$export(module.exports, "isNaN", () => (parcelRequire("5QZE4")).isNaN);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("5QZE4")).isPlainObject);
$parcel$export(module.exports, "isPrimitive", () => (parcelRequire("5QZE4")).isPrimitive);
$parcel$export(module.exports, "isString", () => (parcelRequire("5QZE4")).isString);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("5QZE4")).isThenable);
$parcel$export(module.exports, "consoleSandbox", () => (parcelRequire("7htw4")).consoleSandbox);
$parcel$export(module.exports, "logger", () => (parcelRequire("7htw4")).logger);
$parcel$export(module.exports, "addExceptionMechanism", () => (parcelRequire("HgoiY")).addExceptionMechanism);
$parcel$export(module.exports, "addExceptionTypeValue", () => (parcelRequire("HgoiY")).addExceptionTypeValue);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => (parcelRequire("HgoiY")).checkOrSetAlreadyCaught);
$parcel$export(module.exports, "getEventDescription", () => (parcelRequire("HgoiY")).getEventDescription);
$parcel$export(module.exports, "parseUrl", () => (parcelRequire("HgoiY")).parseUrl);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("HgoiY")).uuid4);
$parcel$export(module.exports, "normalize", () => (parcelRequire("jn5uz")).normalize);
$parcel$export(module.exports, "normalizeToSize", () => (parcelRequire("jn5uz")).normalizeToSize);
$parcel$export(module.exports, "addNonEnumerableProperty", () => (parcelRequire("bP4Y8")).addNonEnumerableProperty);
$parcel$export(module.exports, "dropUndefinedKeys", () => (parcelRequire("bP4Y8")).dropUndefinedKeys);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => (parcelRequire("bP4Y8")).extractExceptionKeysForMessage);
$parcel$export(module.exports, "fill", () => (parcelRequire("bP4Y8")).fill);
$parcel$export(module.exports, "getOriginalFunction", () => (parcelRequire("bP4Y8")).getOriginalFunction);
$parcel$export(module.exports, "markFunctionWrapped", () => (parcelRequire("bP4Y8")).markFunctionWrapped);
$parcel$export(module.exports, "urlEncode", () => (parcelRequire("bP4Y8")).urlEncode);
$parcel$export(module.exports, "makePromiseBuffer", () => (parcelRequire("bPACs")).makePromiseBuffer);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("gYqyD")).severityFromString);
$parcel$export(module.exports, "createStackParser", () => (parcelRequire("6Iopj")).createStackParser);
$parcel$export(module.exports, "getFunctionName", () => (parcelRequire("6Iopj")).getFunctionName);
$parcel$export(module.exports, "eventStatusFromHttpCode", () => (parcelRequire("ew5rY")).eventStatusFromHttpCode);
$parcel$export(module.exports, "isMatchingPattern", () => (parcelRequire("jP2vU")).isMatchingPattern);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("jP2vU")).safeJoin);
$parcel$export(module.exports, "truncate", () => (parcelRequire("jP2vU")).truncate);
$parcel$export(module.exports, "isNativeFetch", () => (parcelRequire("8PJbC")).isNativeFetch);
$parcel$export(module.exports, "supportsFetch", () => (parcelRequire("8PJbC")).supportsFetch);
$parcel$export(module.exports, "supportsReferrerPolicy", () => (parcelRequire("8PJbC")).supportsReferrerPolicy);
$parcel$export(module.exports, "rejectedSyncPromise", () => (parcelRequire("i7ar8")).rejectedSyncPromise);
$parcel$export(module.exports, "resolvedSyncPromise", () => (parcelRequire("i7ar8")).resolvedSyncPromise);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("i7ar8")).SyncPromise);
$parcel$export(module.exports, "extractTraceparentData", () => (parcelRequire("lS7eK")).extractTraceparentData);
$parcel$export(module.exports, "createEnvelope", () => (parcelRequire("jCHqX")).createEnvelope);
$parcel$export(module.exports, "getEnvelopeType", () => (parcelRequire("jCHqX")).getEnvelopeType);
$parcel$export(module.exports, "serializeEnvelope", () => (parcelRequire("jCHqX")).serializeEnvelope);
$parcel$export(module.exports, "createClientReportEnvelope", () => (parcelRequire("99zbJ")).createClientReportEnvelope);
$parcel$export(module.exports, "disabledUntil", () => (parcelRequire("iCHNb")).disabledUntil);
$parcel$export(module.exports, "isRateLimited", () => (parcelRequire("iCHNb")).isRateLimited);
$parcel$export(module.exports, "updateRateLimits", () => (parcelRequire("iCHNb")).updateRateLimits);
parcelRequire("fYxH9");
parcelRequire("eAaWR");
parcelRequire("UMf0P");

parcelRequire("h5dmQ");
parcelRequire("1SlwS");
parcelRequire("lDX8u");
parcelRequire("5QZE4");
parcelRequire("7htw4");

parcelRequire("HgoiY");

var $8upap = parcelRequire("8upap");
parcelRequire("jn5uz");
parcelRequire("bP4Y8");

parcelRequire("bPACs");
parcelRequire("gYqyD");
parcelRequire("6Iopj");
parcelRequire("ew5rY");
parcelRequire("jP2vU");
parcelRequire("8PJbC");
parcelRequire("i7ar8");

var $cQg0t = parcelRequire("cQg0t");
parcelRequire("lS7eK");

parcelRequire("jCHqX");
parcelRequire("99zbJ");
parcelRequire("iCHNb");
$parcel$exportWildcard(module.exports, $8upap);
$parcel$exportWildcard(module.exports, $cQg0t);

});
parcelRegister("fYxH9", function(module, exports) {

$parcel$export(module.exports, "forget", () => $ba1698ba49fb81f8$export$93c25f2590a5b540);
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ba1698ba49fb81f8$export$93c25f2590a5b540(promise) {
    promise.then(null, function(e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}

});

parcelRegister("eAaWR", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", () => $a9dceb93bbd7f017$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $a9dceb93bbd7f017$export$1cfafeee2987818b);

var $1SlwS = parcelRequire("1SlwS");

var $5QZE4 = parcelRequire("5QZE4");
function $a9dceb93bbd7f017$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $a9dceb93bbd7f017$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $a9dceb93bbd7f017$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $5QZE4.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $a9dceb93bbd7f017$export$1cfafeee2987818b() {
    var global = (0, $1SlwS.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

});
parcelRegister("5QZE4", function(module, exports) {

$parcel$export(module.exports, "isError", () => $4431a087fbf663bd$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $4431a087fbf663bd$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $4431a087fbf663bd$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $4431a087fbf663bd$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $4431a087fbf663bd$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $4431a087fbf663bd$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $4431a087fbf663bd$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $4431a087fbf663bd$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $4431a087fbf663bd$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $4431a087fbf663bd$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $4431a087fbf663bd$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $4431a087fbf663bd$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $4431a087fbf663bd$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $4431a087fbf663bd$export$c9f5652083b8129d);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $4431a087fbf663bd$var$objectToString = Object.prototype.toString;
function $4431a087fbf663bd$export$e6127cc7fe7395c3(wat) {
    switch($4431a087fbf663bd$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $4431a087fbf663bd$export$49034edbe6b62415(wat, Error);
    }
}
function $4431a087fbf663bd$var$isBuiltin(wat, ty) {
    return $4431a087fbf663bd$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $4431a087fbf663bd$export$9f9636d330b71954(wat) {
    return $4431a087fbf663bd$var$isBuiltin(wat, 'ErrorEvent');
}
function $4431a087fbf663bd$export$ef9e2056653f0c8e(wat) {
    return $4431a087fbf663bd$var$isBuiltin(wat, 'DOMError');
}
function $4431a087fbf663bd$export$12e869b2a583f783(wat) {
    return $4431a087fbf663bd$var$isBuiltin(wat, 'DOMException');
}
function $4431a087fbf663bd$export$844ec244b1367d54(wat) {
    return $4431a087fbf663bd$var$isBuiltin(wat, 'String');
}
function $4431a087fbf663bd$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $4431a087fbf663bd$export$53b83ca8eaab0383(wat) {
    return $4431a087fbf663bd$var$isBuiltin(wat, 'Object');
}
function $4431a087fbf663bd$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $4431a087fbf663bd$export$49034edbe6b62415(wat, Event);
}
function $4431a087fbf663bd$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $4431a087fbf663bd$export$49034edbe6b62415(wat, Element);
}
function $4431a087fbf663bd$export$49841c62b9eff15(wat) {
    return $4431a087fbf663bd$var$isBuiltin(wat, 'RegExp');
}
function $4431a087fbf663bd$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $4431a087fbf663bd$export$bc2894c7158efbac(wat) {
    return $4431a087fbf663bd$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $4431a087fbf663bd$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $4431a087fbf663bd$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});


parcelRegister("UMf0P", function(module, exports) {

$parcel$export(module.exports, "dsnToString", () => $0aaaa6c30c5fe7e9$export$44d472fbb931a776);
$parcel$export(module.exports, "makeDsn", () => $0aaaa6c30c5fe7e9$export$128827c3562ec0cb);

var $gztBd = parcelRequire("gztBd");

var $h5dmQ = parcelRequire("h5dmQ");

var $kgGk0 = parcelRequire("kgGk0");
/** Regular expression used to parse a Dsn. */ var $0aaaa6c30c5fe7e9$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $0aaaa6c30c5fe7e9$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
function $0aaaa6c30c5fe7e9$export$44d472fbb931a776(dsn, withPassword) {
    if (withPassword === void 0) withPassword = false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') + ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId);
}
function $0aaaa6c30c5fe7e9$var$dsnFromString(str) {
    var match = $0aaaa6c30c5fe7e9$var$DSN_REGEX.exec(str);
    if (!match) throw new (0, $h5dmQ.SentryError)("Invalid Sentry Dsn: " + str);
    var _a = (0, $gztBd.__read)(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $0aaaa6c30c5fe7e9$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $0aaaa6c30c5fe7e9$var$dsnFromComponents(components) {
    // TODO this is for backwards compatibility, and can be removed in a future version
    if ('user' in components && !('publicKey' in components)) components.publicKey = components.user;
    return {
        user: components.publicKey || '',
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $0aaaa6c30c5fe7e9$var$validateDsn(dsn) {
    if (!(0, $kgGk0.IS_DEBUG_BUILD)) return;
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    requiredComponents.forEach(function(component) {
        if (!dsn[component]) throw new (0, $h5dmQ.SentryError)("Invalid Sentry Dsn: " + component + " missing");
    });
    if (!projectId.match(/^\d+$/)) throw new (0, $h5dmQ.SentryError)("Invalid Sentry Dsn: Invalid projectId " + projectId);
    if (!$0aaaa6c30c5fe7e9$var$isValidProtocol(protocol)) throw new (0, $h5dmQ.SentryError)("Invalid Sentry Dsn: Invalid protocol " + protocol);
    if (port && isNaN(parseInt(port, 10))) throw new (0, $h5dmQ.SentryError)("Invalid Sentry Dsn: Invalid port " + port);
    return true;
}
function $0aaaa6c30c5fe7e9$export$128827c3562ec0cb(from) {
    var components = typeof from === 'string' ? $0aaaa6c30c5fe7e9$var$dsnFromString(from) : $0aaaa6c30c5fe7e9$var$dsnFromComponents(from);
    $0aaaa6c30c5fe7e9$var$validateDsn(components);
    return components;
}

});
parcelRegister("h5dmQ", function(module, exports) {

$parcel$export(module.exports, "SentryError", () => $c6fd45cff0488a2d$export$5949942ba2a7c0e2);

var $gztBd = parcelRequire("gztBd");

var $8RogN = parcelRequire("8RogN");
/** An error emitted by Sentry SDKs and related utilities. */ var $c6fd45cff0488a2d$export$5949942ba2a7c0e2 = /** @class */ function(_super) {
    (0, $gztBd.__extends)(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        (0, $8RogN.setPrototypeOf)(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error);

});
parcelRegister("8RogN", function(module, exports) {

$parcel$export(module.exports, "setPrototypeOf", () => $67361976a228b3ab$export$1cb0d91350beb6cc);
var $67361976a228b3ab$export$1cb0d91350beb6cc = Object.setPrototypeOf || (({
    __proto__: []
}) instanceof Array ? $67361976a228b3ab$var$setProtoOf : $67361976a228b3ab$var$mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $67361976a228b3ab$var$setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $67361976a228b3ab$var$mixinProperties(obj, proto) {
    for(var prop in proto)if (!Object.prototype.hasOwnProperty.call(obj, prop)) // @ts-ignore typescript complains about indexing so we remove
    obj[prop] = proto[prop];
    return obj;
}

});


parcelRegister("kgGk0", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $ec16217543872c7a$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $ec16217543872c7a$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("lDX8u", function(module, exports) {

$parcel$export(module.exports, "addInstrumentationHandler", () => $fc1b1caaa2bc8b42$export$285b9172a3741fb7);

var $gztBd = parcelRequire("gztBd");

var $kgGk0 = parcelRequire("kgGk0");

var $1SlwS = parcelRequire("1SlwS");

var $5QZE4 = parcelRequire("5QZE4");

var $7htw4 = parcelRequire("7htw4");

var $bP4Y8 = parcelRequire("bP4Y8");

var $6Iopj = parcelRequire("6Iopj");

var $8PJbC = parcelRequire("8PJbC");
var $fc1b1caaa2bc8b42$var$global = (0, $1SlwS.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ var $fc1b1caaa2bc8b42$var$handlers = {};
var $fc1b1caaa2bc8b42$var$instrumented = {};
/** Instruments given API */ function $fc1b1caaa2bc8b42$var$instrument(type) {
    if ($fc1b1caaa2bc8b42$var$instrumented[type]) return;
    $fc1b1caaa2bc8b42$var$instrumented[type] = true;
    switch(type){
        case 'console':
            $fc1b1caaa2bc8b42$var$instrumentConsole();
            break;
        case 'dom':
            $fc1b1caaa2bc8b42$var$instrumentDOM();
            break;
        case 'xhr':
            $fc1b1caaa2bc8b42$var$instrumentXHR();
            break;
        case 'fetch':
            $fc1b1caaa2bc8b42$var$instrumentFetch();
            break;
        case 'history':
            $fc1b1caaa2bc8b42$var$instrumentHistory();
            break;
        case 'error':
            $fc1b1caaa2bc8b42$var$instrumentError();
            break;
        case 'unhandledrejection':
            $fc1b1caaa2bc8b42$var$instrumentUnhandledRejection();
            break;
        default:
            (0, $kgGk0.IS_DEBUG_BUILD) && (0, $7htw4.logger).warn('unknown instrumentation type:', type);
            return;
    }
}
function $fc1b1caaa2bc8b42$export$285b9172a3741fb7(type, callback) {
    $fc1b1caaa2bc8b42$var$handlers[type] = $fc1b1caaa2bc8b42$var$handlers[type] || [];
    $fc1b1caaa2bc8b42$var$handlers[type].push(callback);
    $fc1b1caaa2bc8b42$var$instrument(type);
}
/** JSDoc */ function $fc1b1caaa2bc8b42$var$triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !$fc1b1caaa2bc8b42$var$handlers[type]) return;
    try {
        for(var _b = (0, $gztBd.__values)($fc1b1caaa2bc8b42$var$handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()){
            var handler = _c.value;
            try {
                handler(data);
            } catch (e) {
                (0, $kgGk0.IS_DEBUG_BUILD) && (0, $7htw4.logger).error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0, $6Iopj.getFunctionName)(handler) + "\nError:", e);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
/** JSDoc */ function $fc1b1caaa2bc8b42$var$instrumentConsole() {
    if (!('console' in $fc1b1caaa2bc8b42$var$global)) return;
    (0, $7htw4.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in $fc1b1caaa2bc8b42$var$global.console)) return;
        (0, $bP4Y8.fill)($fc1b1caaa2bc8b42$var$global.console, level, function(originalConsoleMethod) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                $fc1b1caaa2bc8b42$var$triggerHandlers('console', {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleMethod) originalConsoleMethod.apply($fc1b1caaa2bc8b42$var$global.console, args);
            };
        });
    });
}
/** JSDoc */ function $fc1b1caaa2bc8b42$var$instrumentFetch() {
    if (!(0, $8PJbC.supportsNativeFetch)()) return;
    (0, $bP4Y8.fill)($fc1b1caaa2bc8b42$var$global, 'fetch', function(originalFetch) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var handlerData = {
                args: args,
                fetchData: {
                    method: $fc1b1caaa2bc8b42$var$getFetchMethod(args),
                    url: $fc1b1caaa2bc8b42$var$getFetchUrl(args)
                },
                startTimestamp: Date.now()
            };
            $fc1b1caaa2bc8b42$var$triggerHandlers('fetch', (0, $gztBd.__assign)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($fc1b1caaa2bc8b42$var$global, args).then(function(response) {
                $fc1b1caaa2bc8b42$var$triggerHandlers('fetch', (0, $gztBd.__assign)((0, $gztBd.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    response: response
                }));
                return response;
            }, function(error) {
                $fc1b1caaa2bc8b42$var$triggerHandlers('fetch', (0, $gztBd.__assign)((0, $gztBd.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    error: error
                }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Extract `method` from fetch call arguments */ function $fc1b1caaa2bc8b42$var$getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if ('Request' in $fc1b1caaa2bc8b42$var$global && (0, $5QZE4.isInstanceOf)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
    if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
    return 'GET';
}
/** Extract `url` from fetch call arguments */ function $fc1b1caaa2bc8b42$var$getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if (typeof fetchArgs[0] === 'string') return fetchArgs[0];
    if ('Request' in $fc1b1caaa2bc8b42$var$global && (0, $5QZE4.isInstanceOf)(fetchArgs[0], Request)) return fetchArgs[0].url;
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */ /** JSDoc */ function $fc1b1caaa2bc8b42$var$instrumentXHR() {
    if (!('XMLHttpRequest' in $fc1b1caaa2bc8b42$var$global)) return;
    var xhrproto = XMLHttpRequest.prototype;
    (0, $bP4Y8.fill)(xhrproto, 'open', function(originalOpen) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            var xhrInfo = xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $5QZE4.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $5QZE4.isString)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    } catch (e) {
                    /* do nothing */ }
                    $fc1b1caaa2bc8b42$var$triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') (0, $bP4Y8.fill)(xhr, 'onreadystatechange', function(original) {
                return function() {
                    var readyStateArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)readyStateArgs[_i] = arguments[_i];
                    onreadystatechangeHandler();
                    return original.apply(xhr, readyStateArgs);
                };
            });
            else xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            return originalOpen.apply(xhr, args);
        };
    });
    (0, $bP4Y8.fill)(xhrproto, 'send', function(originalSend) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.__sentry_xhr__ && args[0] !== undefined) this.__sentry_xhr__.body = args[0];
            $fc1b1caaa2bc8b42$var$triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
var $fc1b1caaa2bc8b42$var$lastHref;
/** JSDoc */ function $fc1b1caaa2bc8b42$var$instrumentHistory() {
    if (!(0, $8PJbC.supportsHistory)()) return;
    var oldOnPopState = $fc1b1caaa2bc8b42$var$global.onpopstate;
    $fc1b1caaa2bc8b42$var$global.onpopstate = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var to = $fc1b1caaa2bc8b42$var$global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = $fc1b1caaa2bc8b42$var$lastHref;
        $fc1b1caaa2bc8b42$var$lastHref = to;
        $fc1b1caaa2bc8b42$var$triggerHandlers('history', {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = $fc1b1caaa2bc8b42$var$lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $fc1b1caaa2bc8b42$var$lastHref = to;
                $fc1b1caaa2bc8b42$var$triggerHandlers('history', {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $bP4Y8.fill)($fc1b1caaa2bc8b42$var$global.history, 'pushState', historyReplacementFunction);
    (0, $bP4Y8.fill)($fc1b1caaa2bc8b42$var$global.history, 'replaceState', historyReplacementFunction);
}
var $fc1b1caaa2bc8b42$var$debounceDuration = 1000;
var $fc1b1caaa2bc8b42$var$debounceTimerID;
var $fc1b1caaa2bc8b42$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $fc1b1caaa2bc8b42$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $fc1b1caaa2bc8b42$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') return false;
    try {
        var target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $fc1b1caaa2bc8b42$var$makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) globalListener = false;
    return function(event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $fc1b1caaa2bc8b42$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($fc1b1caaa2bc8b42$var$shouldSkipDOMEvent(event)) return;
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($fc1b1caaa2bc8b42$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $fc1b1caaa2bc8b42$var$lastCapturedEvent = event;
        } else if ($fc1b1caaa2bc8b42$var$shouldShortcircuitPreviousDebounce($fc1b1caaa2bc8b42$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $fc1b1caaa2bc8b42$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($fc1b1caaa2bc8b42$var$debounceTimerID);
        $fc1b1caaa2bc8b42$var$debounceTimerID = $fc1b1caaa2bc8b42$var$global.setTimeout(function() {
            $fc1b1caaa2bc8b42$var$debounceTimerID = undefined;
        }, $fc1b1caaa2bc8b42$var$debounceDuration);
    };
}
/** JSDoc */ function $fc1b1caaa2bc8b42$var$instrumentDOM() {
    if (!('document' in $fc1b1caaa2bc8b42$var$global)) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = $fc1b1caaa2bc8b42$var$triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = $fc1b1caaa2bc8b42$var$makeDOMEventHandler(triggerDOMHandler, true);
    $fc1b1caaa2bc8b42$var$global.document.addEventListener('click', globalDOMEventHandler, false);
    $fc1b1caaa2bc8b42$var$global.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach(function(target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = $fc1b1caaa2bc8b42$var$global[target] && $fc1b1caaa2bc8b42$var$global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $bP4Y8.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_1 = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_1[type] = handlers_1[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        var handler = $fc1b1caaa2bc8b42$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount += 1;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $bP4Y8.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_2[type];
                    if (handlerForType) {
                        handlerForType.refCount -= 1;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers_2).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var $fc1b1caaa2bc8b42$var$_oldOnErrorHandler = null;
/** JSDoc */ function $fc1b1caaa2bc8b42$var$instrumentError() {
    $fc1b1caaa2bc8b42$var$_oldOnErrorHandler = $fc1b1caaa2bc8b42$var$global.onerror;
    $fc1b1caaa2bc8b42$var$global.onerror = function(msg, url, line, column, error) {
        $fc1b1caaa2bc8b42$var$triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($fc1b1caaa2bc8b42$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $fc1b1caaa2bc8b42$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
}
var $fc1b1caaa2bc8b42$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $fc1b1caaa2bc8b42$var$instrumentUnhandledRejection() {
    $fc1b1caaa2bc8b42$var$_oldOnUnhandledRejectionHandler = $fc1b1caaa2bc8b42$var$global.onunhandledrejection;
    $fc1b1caaa2bc8b42$var$global.onunhandledrejection = function(e) {
        $fc1b1caaa2bc8b42$var$triggerHandlers('unhandledrejection', e);
        if ($fc1b1caaa2bc8b42$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $fc1b1caaa2bc8b42$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
}

});
parcelRegister("7htw4", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", () => $54d1043b2228e29f$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "consoleSandbox", () => $54d1043b2228e29f$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $54d1043b2228e29f$export$af88d00dbe7f521);

var $gztBd = parcelRequire("gztBd");

var $kgGk0 = parcelRequire("kgGk0");

var $1SlwS = parcelRequire("1SlwS");
// TODO: Implement different loggers for different environments
var $54d1043b2228e29f$var$global = (0, $1SlwS.getGlobalObject)();
/** Prefix for logging strings */ var $54d1043b2228e29f$var$PREFIX = 'Sentry Logger ';
var $54d1043b2228e29f$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $54d1043b2228e29f$export$cda52e2a8927a2ca(callback) {
    var global = (0, $1SlwS.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $54d1043b2228e29f$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $54d1043b2228e29f$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $kgGk0.IS_DEBUG_BUILD) $54d1043b2228e29f$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $54d1043b2228e29f$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $54d1043b2228e29f$var$global.console)[name].apply(_a, (0, $gztBd.__spread)([
                    $54d1043b2228e29f$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $54d1043b2228e29f$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $54d1043b2228e29f$export$af88d00dbe7f521;
if (0, $kgGk0.IS_DEBUG_BUILD) $54d1043b2228e29f$export$af88d00dbe7f521 = (0, $1SlwS.getGlobalSingleton)('logger', $54d1043b2228e29f$var$makeLogger);
else $54d1043b2228e29f$export$af88d00dbe7f521 = $54d1043b2228e29f$var$makeLogger();

});

parcelRegister("bP4Y8", function(module, exports) {

$parcel$export(module.exports, "fill", () => $89b84fdfd1cfae9c$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $89b84fdfd1cfae9c$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $89b84fdfd1cfae9c$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $89b84fdfd1cfae9c$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "urlEncode", () => $89b84fdfd1cfae9c$export$9ef804feabbcbaf1);
$parcel$export(module.exports, "convertToPlainObject", () => $89b84fdfd1cfae9c$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $89b84fdfd1cfae9c$export$b0244d5063c0b61b);
$parcel$export(module.exports, "dropUndefinedKeys", () => $89b84fdfd1cfae9c$export$d25f2688db1bb433);

var $gztBd = parcelRequire("gztBd");

var $eAaWR = parcelRequire("eAaWR");

var $5QZE4 = parcelRequire("5QZE4");

var $jP2vU = parcelRequire("jP2vU");
function $89b84fdfd1cfae9c$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $89b84fdfd1cfae9c$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $89b84fdfd1cfae9c$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $89b84fdfd1cfae9c$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $89b84fdfd1cfae9c$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $89b84fdfd1cfae9c$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $89b84fdfd1cfae9c$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $89b84fdfd1cfae9c$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $5QZE4.isError)(value)) newObj = (0, $gztBd.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $89b84fdfd1cfae9c$var$getOwnProperties(value));
    else if ((0, $5QZE4.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $gztBd.__assign)({
            type: event_1.type,
            target: $89b84fdfd1cfae9c$var$serializeEventTarget(event_1.target),
            currentTarget: $89b84fdfd1cfae9c$var$serializeEventTarget(event_1.currentTarget)
        }, $89b84fdfd1cfae9c$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $5QZE4.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $89b84fdfd1cfae9c$var$serializeEventTarget(target) {
    try {
        return (0, $5QZE4.isElement)(target) ? (0, $eAaWR.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $89b84fdfd1cfae9c$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $89b84fdfd1cfae9c$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($89b84fdfd1cfae9c$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $jP2vU.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $jP2vU.truncate)(serialized, maxLength);
    }
    return '';
}
function $89b84fdfd1cfae9c$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $5QZE4.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $gztBd.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $89b84fdfd1cfae9c$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($89b84fdfd1cfae9c$export$d25f2688db1bb433);
    return val;
}
function $89b84fdfd1cfae9c$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $5QZE4.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("jP2vU", function(module, exports) {

$parcel$export(module.exports, "truncate", () => $e6e4baebb92dff28$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $e6e4baebb92dff28$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $e6e4baebb92dff28$export$465e9d514283d4fd);
$parcel$export(module.exports, "isMatchingPattern", () => $e6e4baebb92dff28$export$cdded5b28a5f8c6d);

var $5QZE4 = parcelRequire("5QZE4");
function $e6e4baebb92dff28$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $e6e4baebb92dff28$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $e6e4baebb92dff28$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $e6e4baebb92dff28$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $5QZE4.isString)(value)) return false;
    if ((0, $5QZE4.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $e6e4baebb92dff28$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

});


parcelRegister("6Iopj", function(module, exports) {

$parcel$export(module.exports, "createStackParser", () => $4e39c8ebcb5dcbe2$export$a5739666fb2d03d4);
$parcel$export(module.exports, "getFunctionName", () => $4e39c8ebcb5dcbe2$export$aad197c7121a6651);

var $gztBd = parcelRequire("gztBd");
var $4e39c8ebcb5dcbe2$var$STACKTRACE_LIMIT = 50;
function $4e39c8ebcb5dcbe2$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $gztBd.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $gztBd.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $4e39c8ebcb5dcbe2$export$c55c24c0eeba0205(frames);
    };
}
function $4e39c8ebcb5dcbe2$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $4e39c8ebcb5dcbe2$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $gztBd.__assign)((0, $gztBd.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $4e39c8ebcb5dcbe2$var$defaultFunctionName = '<anonymous>';
function $4e39c8ebcb5dcbe2$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $4e39c8ebcb5dcbe2$var$defaultFunctionName;
        return fn.name || $4e39c8ebcb5dcbe2$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $4e39c8ebcb5dcbe2$var$defaultFunctionName;
    }
}

});

parcelRegister("8PJbC", function(module, exports) {

$parcel$export(module.exports, "supportsFetch", () => $66e623382a10017c$export$edf3cb81fd7d2a3e);
$parcel$export(module.exports, "isNativeFetch", () => $66e623382a10017c$export$18cf36ed71d733e7);
$parcel$export(module.exports, "supportsNativeFetch", () => $66e623382a10017c$export$c82d238e23c40b21);
$parcel$export(module.exports, "supportsReferrerPolicy", () => $66e623382a10017c$export$2d308b428295192f);
$parcel$export(module.exports, "supportsHistory", () => $66e623382a10017c$export$67fc34576016d6ec);

var $kgGk0 = parcelRequire("kgGk0");

var $1SlwS = parcelRequire("1SlwS");

var $7htw4 = parcelRequire("7htw4");
function $66e623382a10017c$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
function $66e623382a10017c$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
function $66e623382a10017c$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
function $66e623382a10017c$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in (0, $1SlwS.getGlobalObject)())) return false;
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
function $66e623382a10017c$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $66e623382a10017c$export$c82d238e23c40b21() {
    if (!$66e623382a10017c$export$edf3cb81fd7d2a3e()) return false;
    var global = (0, $1SlwS.getGlobalObject)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($66e623382a10017c$export$18cf36ed71d733e7(global.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $66e623382a10017c$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $kgGk0.IS_DEBUG_BUILD) && (0, $7htw4.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
function $66e623382a10017c$export$531055a6c684a70a() {
    return 'ReportingObserver' in (0, $1SlwS.getGlobalObject)();
}
function $66e623382a10017c$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$66e623382a10017c$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}
function $66e623382a10017c$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0, $1SlwS.getGlobalObject)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});


parcelRegister("HgoiY", function(module, exports) {

$parcel$export(module.exports, "uuid4", () => $0820bb2e6cc9979f$export$19f53698e68b2496);
$parcel$export(module.exports, "parseUrl", () => $0820bb2e6cc9979f$export$7a5253c0f62e0150);
$parcel$export(module.exports, "getEventDescription", () => $0820bb2e6cc9979f$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $0820bb2e6cc9979f$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $0820bb2e6cc9979f$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $0820bb2e6cc9979f$export$6de4ffac6a2f1098);

var $gztBd = parcelRequire("gztBd");

var $1SlwS = parcelRequire("1SlwS");

var $bP4Y8 = parcelRequire("bP4Y8");

var $jP2vU = parcelRequire("jP2vU");
function $0820bb2e6cc9979f$export$19f53698e68b2496() {
    var global = (0, $1SlwS.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $0820bb2e6cc9979f$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $0820bb2e6cc9979f$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $0820bb2e6cc9979f$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $0820bb2e6cc9979f$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function $0820bb2e6cc9979f$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function $0820bb2e6cc9979f$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $0820bb2e6cc9979f$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $gztBd.__assign)((0, $gztBd.__assign)((0, $gztBd.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $0820bb2e6cc9979f$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $0820bb2e6cc9979f$export$d364f2020ab30578(input) {
    var match = input.match($0820bb2e6cc9979f$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $0820bb2e6cc9979f$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $jP2vU.snipLine)(line, 0);
    });
    frame.context_line = (0, $jP2vU.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $jP2vU.snipLine)(line, 0);
    });
}
function $0820bb2e6cc9979f$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $0820bb2e6cc9979f$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $bP4Y8.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});

parcelRegister("jn5uz", function(module, exports) {

$parcel$export(module.exports, "normalize", () => $e1a46ce691765a57$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $e1a46ce691765a57$export$23fbbb20bed71033);

var $gztBd = parcelRequire("gztBd");

var $5QZE4 = parcelRequire("5QZE4");

var $8GdYS = parcelRequire("8GdYS");

var $bP4Y8 = parcelRequire("bP4Y8");

var $6Iopj = parcelRequire("6Iopj");
function $e1a46ce691765a57$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $e1a46ce691765a57$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $e1a46ce691765a57$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $e1a46ce691765a57$export$a3295358bff77e(object, depth);
    if ($e1a46ce691765a57$var$jsonSize(normalized) > maxSize) return $e1a46ce691765a57$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $e1a46ce691765a57$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $8GdYS.memoBuilder)();
    var _a = (0, $gztBd.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $5QZE4.isNaN)(value)) return value;
    var stringified = $e1a46ce691765a57$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $5QZE4.isError)(value) || (0, $5QZE4.isEvent)(value) ? (0, $bP4Y8.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $e1a46ce691765a57$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $e1a46ce691765a57$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $5QZE4.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $6Iopj.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $e1a46ce691765a57$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $e1a46ce691765a57$var$jsonSize(value) {
    return $e1a46ce691765a57$var$utf8Length(JSON.stringify(value));
}

});
parcelRegister("8GdYS", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", () => $651d1743a990a360$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $651d1743a990a360$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});


parcelRegister("bPACs", function(module, exports) {

$parcel$export(module.exports, "makePromiseBuffer", () => $89d0dcf1088279a8$export$85a4f67f852183e6);

var $h5dmQ = parcelRequire("h5dmQ");

var $i7ar8 = parcelRequire("i7ar8");
function $89d0dcf1088279a8$export$85a4f67f852183e6(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
     * Remove a promise from the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
     *
     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
     *        limit check.
     * @returns The original promise.
     */ function add(taskProducer) {
        if (!isReady()) return (0, $i7ar8.rejectedSyncPromise)(new (0, $h5dmQ.SentryError)('Not adding Promise due to buffer limit reached.'));
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(function() {
            return remove(task);
        })// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, function() {
            return remove(task).then(null, function() {
            // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
     * `false` otherwise
     */ function drain(timeout) {
        return new (0, $i7ar8.SyncPromise)(function(resolve, reject) {
            var counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function() {
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function(item) {
                (0, $i7ar8.resolvedSyncPromise)(item).then(function() {
                    // eslint-disable-next-line no-plusplus
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});
parcelRegister("i7ar8", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", () => $d300f9ef2197f7c0$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $d300f9ef2197f7c0$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $d300f9ef2197f7c0$export$78e43115b553f358);
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $5QZE4 = parcelRequire("5QZE4");
function $d300f9ef2197f7c0$export$1fda8aa4d135f8aa(value) {
    return new $d300f9ef2197f7c0$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $d300f9ef2197f7c0$export$78e43115b553f358(reason) {
    return new $d300f9ef2197f7c0$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $d300f9ef2197f7c0$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $5QZE4.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

});


parcelRegister("gYqyD", function(module, exports) {

$parcel$export(module.exports, "severityFromString", () => $c5b6d9b7617d0f9a$export$e01cef29b4327697);

var $9lo5J = parcelRequire("9lo5J");

var $a3c2a = parcelRequire("a3c2a");
function $c5b6d9b7617d0f9a$var$isSupportedSeverity(level) {
    return (0, $a3c2a.SeverityLevels).indexOf(level) !== -1;
}
function $c5b6d9b7617d0f9a$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $9lo5J.Severity).Warning;
    if ($c5b6d9b7617d0f9a$var$isSupportedSeverity(level)) return level;
    return (0, $9lo5J.Severity).Log;
}

});
parcelRegister("9lo5J", function(module, exports) {

$parcel$export(module.exports, "Severity", () => $6cd8c34c883acadf$export$918a9776c0a3cf27);
/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */ var $6cd8c34c883acadf$export$918a9776c0a3cf27;
(function(Severity) {
    /** JSDoc */ Severity["Fatal"] = "fatal";
    /** JSDoc */ Severity["Error"] = "error";
    /** JSDoc */ Severity["Warning"] = "warning";
    /** JSDoc */ Severity["Log"] = "log";
    /** JSDoc */ Severity["Info"] = "info";
    /** JSDoc */ Severity["Debug"] = "debug";
    /** JSDoc */ Severity["Critical"] = "critical";
})($6cd8c34c883acadf$export$918a9776c0a3cf27 || ($6cd8c34c883acadf$export$918a9776c0a3cf27 = {}));
var $6cd8c34c883acadf$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});

parcelRegister("a3c2a", function(module, exports) {

$parcel$export(module.exports, "SeverityLevels", () => $751384e646d28c9a$export$484b1ea9aec914c);
var $751384e646d28c9a$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});


parcelRegister("ew5rY", function(module, exports) {

$parcel$export(module.exports, "eventStatusFromHttpCode", () => $a91848216df2eec5$export$82713360d763c449);
/**
 * Converts an HTTP status code to sentry status {@link EventStatus}.
 *
 * @param code number HTTP status code
 * @returns EventStatus
 */ function $a91848216df2eec5$export$82713360d763c449(code) {
    if (code >= 200 && code < 300) return 'success';
    if (code === 429) return 'rate_limit';
    if (code >= 400 && code < 500) return 'invalid';
    if (code >= 500) return 'failed';
    return 'unknown';
}

});

parcelRegister("lS7eK", function(module, exports) {

$parcel$export(module.exports, "extractTraceparentData", () => $fec4413c5c229d86$export$8e9a29865c0a1226);
var $fec4413c5c229d86$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
function $fec4413c5c229d86$export$8e9a29865c0a1226(traceparent) {
    var matches = traceparent.match($fec4413c5c229d86$export$394a210812ba3012);
    if (matches) {
        var parentSampled = void 0;
        if (matches[3] === '1') parentSampled = true;
        else if (matches[3] === '0') parentSampled = false;
        return {
            traceId: matches[1],
            parentSampled: parentSampled,
            parentSpanId: matches[2]
        };
    }
    return undefined;
}

});

parcelRegister("jCHqX", function(module, exports) {

$parcel$export(module.exports, "createEnvelope", () => $e49341fc8a37f226$export$f93f7f385160c44e);
$parcel$export(module.exports, "getEnvelopeType", () => $e49341fc8a37f226$export$d84939284bbafcd4);
$parcel$export(module.exports, "serializeEnvelope", () => $e49341fc8a37f226$export$32f9b428425aac85);

var $gztBd = parcelRequire("gztBd");

var $5QZE4 = parcelRequire("5QZE4");
function $e49341fc8a37f226$export$f93f7f385160c44e(headers, items) {
    if (items === void 0) items = [];
    return [
        headers,
        items
    ];
}
function $e49341fc8a37f226$export$d650323442802f6f(envelope, newItem) {
    var _a = (0, $gztBd.__read)(envelope, 2), headers = _a[0], items = _a[1];
    return [
        headers,
        (0, $gztBd.__spread)(items, [
            newItem
        ])
    ];
}
function $e49341fc8a37f226$export$d84939284bbafcd4(envelope) {
    var _a = (0, $gztBd.__read)(envelope, 2), _b = (0, $gztBd.__read)(_a[1], 1), _c = (0, $gztBd.__read)(_b[0], 1), firstItemHeader = _c[0];
    return firstItemHeader.type;
}
function $e49341fc8a37f226$export$32f9b428425aac85(envelope) {
    var _a = (0, $gztBd.__read)(envelope, 2), headers = _a[0], items = _a[1];
    var serializedHeaders = JSON.stringify(headers);
    // Have to cast items to any here since Envelope is a union type
    // Fixed in Typescript 4.2
    // TODO: Remove any[] cast when we upgrade to TS 4.2
    // https://github.com/microsoft/TypeScript/issues/36390
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return items.reduce(function(acc, item) {
        var _a = (0, $gztBd.__read)(item, 2), itemHeaders = _a[0], payload = _a[1];
        // We do not serialize payloads that are primitives
        var serializedPayload = (0, $5QZE4.isPrimitive)(payload) ? String(payload) : JSON.stringify(payload);
        return acc + "\n" + JSON.stringify(itemHeaders) + "\n" + serializedPayload;
    }, serializedHeaders);
}

});

parcelRegister("99zbJ", function(module, exports) {

$parcel$export(module.exports, "createClientReportEnvelope", () => $6aa03ff1f717d06a$export$f3b9ed77c03eeb00);

var $jCHqX = parcelRequire("jCHqX");

var $cQg0t = parcelRequire("cQg0t");
function $6aa03ff1f717d06a$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $cQg0t.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $jCHqX.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("iCHNb", function(module, exports) {

$parcel$export(module.exports, "disabledUntil", () => $d8edbed396e0ce87$export$b89fc7b2e4c799e7);
$parcel$export(module.exports, "isRateLimited", () => $d8edbed396e0ce87$export$6c91fec22056810a);
$parcel$export(module.exports, "updateRateLimits", () => $d8edbed396e0ce87$export$699aff705e0d49d4);

var $gztBd = parcelRequire("gztBd");
var $d8edbed396e0ce87$export$b09ce39faaeb1e7c = 60000; // 60 seconds
function $d8edbed396e0ce87$export$615352e17ed7741(header, now) {
    if (now === void 0) now = Date.now();
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) return headerDate - now;
    return $d8edbed396e0ce87$export$b09ce39faaeb1e7c;
}
function $d8edbed396e0ce87$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
function $d8edbed396e0ce87$export$6c91fec22056810a(limits, category, now) {
    if (now === void 0) now = Date.now();
    return $d8edbed396e0ce87$export$b89fc7b2e4c799e7(limits, category) > now;
}
function $d8edbed396e0ce87$export$699aff705e0d49d4(limits, headers, now) {
    var e_1, _a, e_2, _b;
    if (now === void 0) now = Date.now();
    var updatedRateLimits = (0, $gztBd.__assign)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers['x-sentry-rate-limits'];
    var retryAfterHeader = headers['retry-after'];
    if (rateLimitHeader) try {
        /**
             * rate limit headers are of the form
             *     <header>,<header>,..
             * where each <header> is of the form
             *     <retry_after>: <categories>: <scope>: <reason_code>
             * where
             *     <retry_after> is a delay in seconds
             *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
             *         <category>;<category>;...
             *     <scope> is what's being limited (org, project, or key) - ignored by SDK
             *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
             */ for(var _c = (0, $gztBd.__values)(rateLimitHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()){
            var limit = _d.value;
            var parameters = limit.split(':', 2);
            var headerDelay = parseInt(parameters[0], 10);
            var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
            if (!parameters[1]) updatedRateLimits.all = now + delay;
            else try {
                for(var _e = (e_2 = void 0, (0, $gztBd.__values)(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()){
                    var category = _f.value;
                    updatedRateLimits[category] = now + delay;
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $d8edbed396e0ce87$export$615352e17ed7741(retryAfterHeader, now);
    return updatedRateLimits;
}

});


parcelRegister("iv17a", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $d77bfc98045d55c9$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $d77bfc98045d55c9$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("ka93y", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $eadbc43ca441ab2c$export$775b6bb06e53a214);
$parcel$export(module.exports, "addGlobalEventProcessor", () => $eadbc43ca441ab2c$export$8e4e25f54d456511);

var $gztBd = parcelRequire("gztBd");
parcelRequire("2ktyf");
var $cQg0t = parcelRequire("cQg0t");
var $1SlwS = parcelRequire("1SlwS");
var $5QZE4 = parcelRequire("5QZE4");
var $i7ar8 = parcelRequire("i7ar8");
/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */ var $eadbc43ca441ab2c$var$MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var $eadbc43ca441ab2c$export$775b6bb06e53a214 = /** @class */ function() {
    function Scope() {
        /** Flag if notifying is happening. */ this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */ this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */ this._eventProcessors = [];
        /** Array of breadcrumbs. */ this._breadcrumbs = [];
        /** User */ this._user = {};
        /** Tags */ this._tags = {};
        /** Extra */ this._extra = {};
        /** Contexts */ this._contexts = {};
        /**
         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
         * sent to Sentry
         */ this._sdkProcessingMetadata = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */ Scope.clone = function(scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = (0, $gztBd.__spread)(scope._breadcrumbs);
            newScope._tags = (0, $gztBd.__assign)({}, scope._tags);
            newScope._extra = (0, $gztBd.__assign)({}, scope._extra);
            newScope._contexts = (0, $gztBd.__assign)({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = (0, $gztBd.__spread)(scope._eventProcessors);
            newScope._requestSession = scope._requestSession;
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */ Scope.prototype.addScopeListener = function(callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addEventProcessor = function(callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setUser = function(user) {
        this._user = user || {};
        if (this._session) this._session.update({
            user: user
        });
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getUser = function() {
        return this._user;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getRequestSession = function() {
        return this._requestSession;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setRequestSession = function(requestSession) {
        this._requestSession = requestSession;
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTags = function(tags) {
        this._tags = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTag = function(key, value) {
        var _a;
        this._tags = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtras = function(extras) {
        this._extra = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtra = function(key, extra) {
        var _a;
        this._extra = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setFingerprint = function(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setLevel = function(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTransactionName = function(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */ Scope.prototype.setTransaction = function(name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setContext = function(key, context) {
        var _a;
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this._contexts), (_a = {}, _a[key] = context, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSpan = function(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSpan = function() {
        return this._span;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getTransaction = function() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        var span = this.getSpan();
        return span && span.transaction;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSession = function(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSession = function() {
        return this._session;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.update = function(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this._tags), captureContext._tags);
            this._extra = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this._extra), captureContext._extra);
            this._contexts = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
        } else if ((0, $5QZE4.isPlainObject)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this._tags), captureContext.tags);
            this._extra = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this._extra), captureContext.extra);
            this._contexts = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this._contexts), captureContext.contexts);
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
        }
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clear = function() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addBreadcrumb = function(breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, $eadbc43ca441ab2c$var$MAX_BREADCRUMBS) : $eadbc43ca441ab2c$var$MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        var mergedBreadcrumb = (0, $gztBd.__assign)({
            timestamp: (0, $cQg0t.dateTimestampInSeconds)()
        }, breadcrumb);
        this._breadcrumbs = (0, $gztBd.__spread)(this._breadcrumbs, [
            mergedBreadcrumb
        ]).slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clearBreadcrumbs = function() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional information about the original exception.
     * @hidden
     */ Scope.prototype.applyToEvent = function(event, hint) {
        if (this._extra && Object.keys(this._extra).length) event.extra = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this._extra), event.extra);
        if (this._tags && Object.keys(this._tags).length) event.tags = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this._tags), event.tags);
        if (this._user && Object.keys(this._user).length) event.user = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this._user), event.user);
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this._contexts), event.contexts);
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = (0, $gztBd.__assign)({
                trace: this._span.getTraceContext()
            }, event.contexts);
            var transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) event.tags = (0, $gztBd.__assign)({
                transaction: transactionName
            }, event.tags);
        }
        this._applyFingerprint(event);
        event.breadcrumbs = (0, $gztBd.__spread)(event.breadcrumbs || [], this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
        return this._notifyEventProcessors((0, $gztBd.__spread)($eadbc43ca441ab2c$var$getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * Add data which will be accessible during event processing but won't get sent to Sentry
     */ Scope.prototype.setSDKProcessingMetadata = function(newData) {
        this._sdkProcessingMetadata = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this._sdkProcessingMetadata), newData);
        return this;
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */ Scope.prototype._notifyEventProcessors = function(processors, event, hint, index) {
        var _this = this;
        if (index === void 0) index = 0;
        return new (0, $i7ar8.SyncPromise)(function(resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') resolve(event);
            else {
                var result = processor((0, $gztBd.__assign)({}, event), hint);
                if ((0, $5QZE4.isThenable)(result)) result.then(function(final) {
                    return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                }).then(null, reject);
                else _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    };
    /**
     * This will be called on every set call.
     */ Scope.prototype._notifyScopeListeners = function() {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function(callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */ Scope.prototype._applyFingerprint = function(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
            event.fingerprint
        ] : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    };
    return Scope;
}();
/**
 * Returns the global event processors.
 */ function $eadbc43ca441ab2c$var$getGlobalEventProcessors() {
    return (0, $1SlwS.getGlobalSingleton)('globalEventProcessors', function() {
        return [];
    });
}
function $eadbc43ca441ab2c$export$8e4e25f54d456511(callback) {
    $eadbc43ca441ab2c$var$getGlobalEventProcessors().push(callback);
}

});

parcelRegister("lk785", function(module, exports) {

$parcel$export(module.exports, "Session", () => $f860fefcde4e5907$export$1fb4852a55678982);
parcelRequire("2ktyf");
var $bP4Y8 = parcelRequire("bP4Y8");
var $cQg0t = parcelRequire("cQg0t");
var $HgoiY = parcelRequire("HgoiY");
/**
 * @inheritdoc
 */ var $f860fefcde4e5907$export$1fb4852a55678982 = /** @class */ function() {
    function Session(context) {
        this.errors = 0;
        this.sid = (0, $HgoiY.uuid4)();
        this.duration = 0;
        this.status = 'ok';
        this.init = true;
        this.ignoreDuration = false;
        // Both timestamp and started are in seconds since the UNIX epoch.
        var startingTime = (0, $cQg0t.timestampInSeconds)();
        this.timestamp = startingTime;
        this.started = startingTime;
        if (context) this.update(context);
    }
    /** JSDoc */ // eslint-disable-next-line complexity
    Session.prototype.update = function(context) {
        if (context === void 0) context = {};
        if (context.user) {
            if (!this.ipAddress && context.user.ip_address) this.ipAddress = context.user.ip_address;
            if (!this.did && !context.did) this.did = context.user.id || context.user.email || context.user.username;
        }
        this.timestamp = context.timestamp || (0, $cQg0t.timestampInSeconds)();
        if (context.ignoreDuration) this.ignoreDuration = context.ignoreDuration;
        if (context.sid) // Good enough uuid validation. — Kamil
        this.sid = context.sid.length === 32 ? context.sid : (0, $HgoiY.uuid4)();
        if (context.init !== undefined) this.init = context.init;
        if (!this.did && context.did) this.did = "" + context.did;
        if (typeof context.started === 'number') this.started = context.started;
        if (this.ignoreDuration) this.duration = undefined;
        else if (typeof context.duration === 'number') this.duration = context.duration;
        else {
            var duration = this.timestamp - this.started;
            this.duration = duration >= 0 ? duration : 0;
        }
        if (context.release) this.release = context.release;
        if (context.environment) this.environment = context.environment;
        if (!this.ipAddress && context.ipAddress) this.ipAddress = context.ipAddress;
        if (!this.userAgent && context.userAgent) this.userAgent = context.userAgent;
        if (typeof context.errors === 'number') this.errors = context.errors;
        if (context.status) this.status = context.status;
    };
    /** JSDoc */ Session.prototype.close = function(status) {
        if (status) this.update({
            status: status
        });
        else if (this.status === 'ok') this.update({
            status: 'exited'
        });
        else this.update();
    };
    /** JSDoc */ Session.prototype.toJSON = function() {
        return (0, $bP4Y8.dropUndefinedKeys)({
            sid: "" + this.sid,
            init: this.init,
            // Make sure that sec is converted to ms for date constructor
            started: new Date(this.started * 1000).toISOString(),
            timestamp: new Date(this.timestamp * 1000).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: {
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent
            }
        });
    };
    return Session;
}();

});


parcelRegister("8Wz1M", function(module, exports) {

$parcel$export(module.exports, "registerErrorInstrumentation", () => $682ee94929d9342d$export$637857c1d87b640c);
parcelRequire("2ktyf");
var $lDX8u = parcelRequire("lDX8u");
var $7htw4 = parcelRequire("7htw4");

var $2mkHy = parcelRequire("2mkHy");

var $b1qwm = parcelRequire("b1qwm");
function $682ee94929d9342d$export$637857c1d87b640c() {
    (0, $lDX8u.addInstrumentationHandler)('error', $682ee94929d9342d$var$errorCallback);
    (0, $lDX8u.addInstrumentationHandler)('unhandledrejection', $682ee94929d9342d$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $682ee94929d9342d$var$errorCallback() {
    var activeTransaction = (0, $b1qwm.getActiveTransaction)();
    if (activeTransaction) {
        var status_1 = 'internal_error';
        (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log("[Tracing] Transaction: " + status_1 + " -> Global error occured");
        activeTransaction.setStatus(status_1);
    }
}

});
parcelRegister("2mkHy", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $1b7db1bfa04aab6f$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $1b7db1bfa04aab6f$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("b1qwm", function(module, exports) {

$parcel$export(module.exports, "hasTracingEnabled", () => $80645c3a970289f9$export$5008da00b1b6dee6);
$parcel$export(module.exports, "getActiveTransaction", () => $80645c3a970289f9$export$a7feb32fdd923295);
$parcel$export(module.exports, "msToSec", () => $80645c3a970289f9$export$b4785dbd4a81b33f);
$parcel$export(module.exports, "secToMs", () => $80645c3a970289f9$export$a3ba11b11516dfdb);

var $6cwj6 = parcelRequire("6cwj6");
parcelRequire("2ktyf");
var $lS7eK = parcelRequire("lS7eK");
function $80645c3a970289f9$export$5008da00b1b6dee6(maybeOptions) {
    var client = (0, $6cwj6.getCurrentHub)().getClient();
    var options = maybeOptions || client && client.getOptions();
    return !!options && ('tracesSampleRate' in options || 'tracesSampler' in options);
}
function $80645c3a970289f9$export$a7feb32fdd923295(maybeHub) {
    var hub = maybeHub || (0, $6cwj6.getCurrentHub)();
    var scope = hub.getScope();
    return scope && scope.getTransaction();
}
function $80645c3a970289f9$export$b4785dbd4a81b33f(time) {
    return time / 1000;
}
function $80645c3a970289f9$export$a3ba11b11516dfdb(time) {
    return time * 1000;
}

});


parcelRegister("kCOHN", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_IDLE_TIMEOUT", () => $f03eb04d4a9e0be3$export$68a507a5e6cb6de5);
$parcel$export(module.exports, "IdleTransaction", () => $f03eb04d4a9e0be3$export$b279e6bd7040371f);

var $gztBd = parcelRequire("gztBd");
parcelRequire("2ktyf");
var $7htw4 = parcelRequire("7htw4");
var $cQg0t = parcelRequire("cQg0t");

var $5kNcg = parcelRequire("5kNcg");

var $2mkHy = parcelRequire("2mkHy");

var $ajjwc = parcelRequire("ajjwc");

var $j8tm1 = parcelRequire("j8tm1");
var $f03eb04d4a9e0be3$export$68a507a5e6cb6de5 = 1000;
var $f03eb04d4a9e0be3$export$31c453b5fe09788d = 5000;
/**
 * @inheritDoc
 */ var $f03eb04d4a9e0be3$export$370d6113c18ba86c = /** @class */ function(_super) {
    (0, $gztBd.__extends)(IdleTransactionSpanRecorder, _super);
    function IdleTransactionSpanRecorder(_pushActivity, _popActivity, transactionSpanId, maxlen) {
        if (transactionSpanId === void 0) transactionSpanId = '';
        var _this = _super.call(this, maxlen) || this;
        _this._pushActivity = _pushActivity;
        _this._popActivity = _popActivity;
        _this.transactionSpanId = transactionSpanId;
        return _this;
    }
    /**
     * @inheritDoc
     */ IdleTransactionSpanRecorder.prototype.add = function(span) {
        var _this = this;
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanId !== this.transactionSpanId) {
            // We patch span.finish() to pop an activity after setting an endTimestamp.
            span.finish = function(endTimestamp) {
                span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0, $cQg0t.timestampWithMs)();
                _this._popActivity(span.spanId);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if (span.endTimestamp === undefined) this._pushActivity(span.spanId);
        }
        _super.prototype.add.call(this, span);
    };
    return IdleTransactionSpanRecorder;
}((0, $ajjwc.SpanRecorder));
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ var $f03eb04d4a9e0be3$export$b279e6bd7040371f = /** @class */ function(_super) {
    (0, $gztBd.__extends)(IdleTransaction, _super);
    function IdleTransaction(transactionContext, _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished.
     * @default 1000
     */ _idleTimeout, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope) {
        if (_idleTimeout === void 0) _idleTimeout = $f03eb04d4a9e0be3$export$68a507a5e6cb6de5;
        if (_onScope === void 0) _onScope = false;
        var _this = _super.call(this, transactionContext, _idleHub) || this;
        _this._idleHub = _idleHub;
        _this._idleTimeout = _idleTimeout;
        _this._onScope = _onScope;
        // Activities store a list of active spans
        _this.activities = {};
        // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
        _this._heartbeatCounter = 0;
        // We should not use heartbeat if we finished a transaction
        _this._finished = false;
        _this._beforeFinishCallbacks = [];
        if (_idleHub && _onScope) {
            // There should only be one active transaction on the scope
            $f03eb04d4a9e0be3$var$clearActiveTransaction(_idleHub);
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log("Setting idle transaction on scope. Span ID: " + _this.spanId);
            _idleHub.configureScope(function(scope) {
                return scope.setSpan(_this);
            });
        }
        _this._initTimeout = setTimeout(function() {
            if (!_this._finished) _this.finish();
        }, _this._idleTimeout);
        return _this;
    }
    /** {@inheritDoc} */ IdleTransaction.prototype.finish = function(endTimestamp) {
        var e_1, _a;
        var _this = this;
        if (endTimestamp === void 0) endTimestamp = (0, $cQg0t.timestampWithMs)();
        this._finished = true;
        this.activities = {};
        if (this.spanRecorder) {
            (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);
            try {
                for(var _b = (0, $gztBd.__values)(this._beforeFinishCallbacks), _c = _b.next(); !_c.done; _c = _b.next()){
                    var callback = _c.value;
                    callback(this, endTimestamp);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            this.spanRecorder.spans = this.spanRecorder.spans.filter(function(span) {
                // If we are dealing with the transaction itself, we just return it
                if (span.spanId === _this.spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!span.endTimestamp) {
                    span.endTimestamp = endTimestamp;
                    span.setStatus('cancelled');
                    (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
                }
                var keepSpan = span.startTimestamp < endTimestamp;
                if (!keepSpan) (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log('[Tracing] discarding Span since it happened after Transaction was finished', JSON.stringify(span, undefined, 2));
                return keepSpan;
            });
            (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log('[Tracing] flushing IdleTransaction');
        } else (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log('[Tracing] No active IdleTransaction');
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) $f03eb04d4a9e0be3$var$clearActiveTransaction(this._idleHub);
        return _super.prototype.finish.call(this, endTimestamp);
    };
    /**
     * Register a callback function that gets excecuted before the transaction finishes.
     * Useful for cleanup or if you want to add any additional spans based on current context.
     *
     * This is exposed because users have no other way of running something before an idle transaction
     * finishes.
     */ IdleTransaction.prototype.registerBeforeFinishCallback = function(callback) {
        this._beforeFinishCallbacks.push(callback);
    };
    /**
     * @inheritDoc
     */ IdleTransaction.prototype.initSpanRecorder = function(maxlen) {
        var _this = this;
        if (!this.spanRecorder) {
            var pushActivity = function(id) {
                if (_this._finished) return;
                _this._pushActivity(id);
            };
            var popActivity = function(id) {
                if (_this._finished) return;
                _this._popActivity(id);
            };
            this.spanRecorder = new $f03eb04d4a9e0be3$export$370d6113c18ba86c(pushActivity, popActivity, this.spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log('Starting heartbeat');
            this._pingHeartbeat();
        }
        this.spanRecorder.add(this);
    };
    /**
     * Start tracking a specific activity.
     * @param spanId The span id that represents the activity
     */ IdleTransaction.prototype._pushActivity = function(spanId) {
        if (this._initTimeout) {
            clearTimeout(this._initTimeout);
            this._initTimeout = undefined;
        }
        (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log("[Tracing] pushActivity: " + spanId);
        this.activities[spanId] = true;
        (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log('[Tracing] new activities count', Object.keys(this.activities).length);
    };
    /**
     * Remove an activity from usage
     * @param spanId The span id that represents the activity
     */ IdleTransaction.prototype._popActivity = function(spanId) {
        var _this = this;
        if (this.activities[spanId]) {
            (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log("[Tracing] popActivity " + spanId);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log('[Tracing] new activities count', Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            var timeout = this._idleTimeout;
            // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampWithMs is in seconds, timeout is in ms
            var end_1 = (0, $cQg0t.timestampWithMs)() + timeout / 1000;
            setTimeout(function() {
                if (!_this._finished) {
                    _this.setTag((0, $5kNcg.FINISH_REASON_TAG), (0, $5kNcg.IDLE_TRANSACTION_FINISH_REASONS)[1]);
                    _this.finish(end_1);
                }
            }, timeout);
        }
    };
    /**
     * Checks when entries of this.activities are not changing for 3 beats.
     * If this occurs we finish the transaction.
     */ IdleTransaction.prototype._beat = function() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        var heartbeatString = Object.keys(this.activities).join('');
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter += 1;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log('[Tracing] Transaction finished because of no change for 3 heart beats');
            this.setStatus('deadline_exceeded');
            this.setTag((0, $5kNcg.FINISH_REASON_TAG), (0, $5kNcg.IDLE_TRANSACTION_FINISH_REASONS)[0]);
            this.finish();
        } else this._pingHeartbeat();
    };
    /**
     * Pings the heartbeat
     */ IdleTransaction.prototype._pingHeartbeat = function() {
        var _this = this;
        (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log("pinging Heartbeat -> current counter: " + this._heartbeatCounter);
        setTimeout(function() {
            _this._beat();
        }, $f03eb04d4a9e0be3$export$31c453b5fe09788d);
    };
    return IdleTransaction;
}((0, $j8tm1.Transaction));
/**
 * Reset transaction on scope to `undefined`
 */ function $f03eb04d4a9e0be3$var$clearActiveTransaction(hub) {
    if (hub) {
        var scope = hub.getScope();
        if (scope) {
            var transaction = scope.getTransaction();
            if (transaction) scope.setSpan(undefined);
        }
    }
}

});
parcelRegister("5kNcg", function(module, exports) {

$parcel$export(module.exports, "FINISH_REASON_TAG", () => $3e24fb75515763d8$export$b1aed1fb82b4571);
$parcel$export(module.exports, "IDLE_TRANSACTION_FINISH_REASONS", () => $3e24fb75515763d8$export$1bb0f6e8310f734);
// Store finish reasons in tuple to save on bundle size
// Readonly type should enforce that this is not mutated.
var $3e24fb75515763d8$export$b1aed1fb82b4571 = 'finishReason';
var $3e24fb75515763d8$export$1bb0f6e8310f734 = [
    'heartbeatFailed',
    'idleTimeout',
    'documentHidden'
];

});

parcelRegister("ajjwc", function(module, exports) {

$parcel$export(module.exports, "SpanRecorder", () => $781ad1a658e514bd$export$10c95c129cd0d4fe);
$parcel$export(module.exports, "Span", () => $781ad1a658e514bd$export$5f1714a13ed34c01);

var $gztBd = parcelRequire("gztBd");
parcelRequire("2ktyf");
var $bP4Y8 = parcelRequire("bP4Y8");
var $cQg0t = parcelRequire("cQg0t");
var $HgoiY = parcelRequire("HgoiY");
/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ var $781ad1a658e514bd$export$10c95c129cd0d4fe = /** @class */ function() {
    function SpanRecorder(maxlen) {
        if (maxlen === void 0) maxlen = 1000;
        this.spans = [];
        this._maxlen = maxlen;
    }
    /**
     * This is just so that we don't run out of memory while recording a lot
     * of spans. At some point we just stop and flush out the start of the
     * trace tree (i.e.the first n spans with the smallest
     * start_timestamp).
     */ SpanRecorder.prototype.add = function(span) {
        if (this.spans.length > this._maxlen) span.spanRecorder = undefined;
        else this.spans.push(span);
    };
    return SpanRecorder;
}();
/**
 * Span contains all data about a span
 */ var $781ad1a658e514bd$export$5f1714a13ed34c01 = /** @class */ function() {
    /**
     * You should never call the constructor manually, always use `Sentry.startTransaction()`
     * or call `startChild()` on an existing span.
     * @internal
     * @hideconstructor
     * @hidden
     */ function Span(spanContext) {
        /**
         * @inheritDoc
         */ this.traceId = (0, $HgoiY.uuid4)();
        /**
         * @inheritDoc
         */ this.spanId = (0, $HgoiY.uuid4)().substring(16);
        /**
         * Timestamp in seconds when the span was created.
         */ this.startTimestamp = (0, $cQg0t.timestampWithMs)();
        /**
         * @inheritDoc
         */ this.tags = {};
        /**
         * @inheritDoc
         */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.data = {};
        if (!spanContext) return this;
        if (spanContext.traceId) this.traceId = spanContext.traceId;
        if (spanContext.spanId) this.spanId = spanContext.spanId;
        if (spanContext.parentSpanId) this.parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this.sampled = spanContext.sampled;
        if (spanContext.op) this.op = spanContext.op;
        if (spanContext.description) this.description = spanContext.description;
        if (spanContext.data) this.data = spanContext.data;
        if (spanContext.tags) this.tags = spanContext.tags;
        if (spanContext.status) this.status = spanContext.status;
        if (spanContext.startTimestamp) this.startTimestamp = spanContext.startTimestamp;
        if (spanContext.endTimestamp) this.endTimestamp = spanContext.endTimestamp;
    }
    /**
     * @inheritDoc
     * @deprecated
     */ Span.prototype.child = function(spanContext) {
        return this.startChild(spanContext);
    };
    /**
     * @inheritDoc
     */ Span.prototype.startChild = function(spanContext) {
        var childSpan = new Span((0, $gztBd.__assign)((0, $gztBd.__assign)({}, spanContext), {
            parentSpanId: this.spanId,
            sampled: this.sampled,
            traceId: this.traceId
        }));
        childSpan.spanRecorder = this.spanRecorder;
        if (childSpan.spanRecorder) childSpan.spanRecorder.add(childSpan);
        childSpan.transaction = this.transaction;
        return childSpan;
    };
    /**
     * @inheritDoc
     */ Span.prototype.setTag = function(key, value) {
        var _a;
        this.tags = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this.tags), (_a = {}, _a[key] = value, _a));
        return this;
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Span.prototype.setData = function(key, value) {
        var _a;
        this.data = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this.data), (_a = {}, _a[key] = value, _a));
        return this;
    };
    /**
     * @inheritDoc
     */ Span.prototype.setStatus = function(value) {
        this.status = value;
        return this;
    };
    /**
     * @inheritDoc
     */ Span.prototype.setHttpStatus = function(httpStatus) {
        this.setTag('http.status_code', String(httpStatus));
        var spanStatus = $781ad1a658e514bd$export$ac65c70d78fcdb55(httpStatus);
        if (spanStatus !== 'unknown_error') this.setStatus(spanStatus);
        return this;
    };
    /**
     * @inheritDoc
     */ Span.prototype.isSuccess = function() {
        return this.status === 'ok';
    };
    /**
     * @inheritDoc
     */ Span.prototype.finish = function(endTimestamp) {
        this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0, $cQg0t.timestampWithMs)();
    };
    /**
     * @inheritDoc
     */ Span.prototype.toTraceparent = function() {
        var sampledString = '';
        if (this.sampled !== undefined) sampledString = this.sampled ? '-1' : '-0';
        return this.traceId + "-" + this.spanId + sampledString;
    };
    /**
     * @inheritDoc
     */ Span.prototype.toContext = function() {
        return (0, $bP4Y8.dropUndefinedKeys)({
            data: this.data,
            description: this.description,
            endTimestamp: this.endTimestamp,
            op: this.op,
            parentSpanId: this.parentSpanId,
            sampled: this.sampled,
            spanId: this.spanId,
            startTimestamp: this.startTimestamp,
            status: this.status,
            tags: this.tags,
            traceId: this.traceId
        });
    };
    /**
     * @inheritDoc
     */ Span.prototype.updateWithContext = function(spanContext) {
        var _a, _b, _c, _d, _e;
        this.data = (_a = spanContext.data, _a !== null && _a !== void 0 ? _a : {});
        this.description = spanContext.description;
        this.endTimestamp = spanContext.endTimestamp;
        this.op = spanContext.op;
        this.parentSpanId = spanContext.parentSpanId;
        this.sampled = spanContext.sampled;
        this.spanId = (_b = spanContext.spanId, _b !== null && _b !== void 0 ? _b : this.spanId);
        this.startTimestamp = (_c = spanContext.startTimestamp, _c !== null && _c !== void 0 ? _c : this.startTimestamp);
        this.status = spanContext.status;
        this.tags = (_d = spanContext.tags, _d !== null && _d !== void 0 ? _d : {});
        this.traceId = (_e = spanContext.traceId, _e !== null && _e !== void 0 ? _e : this.traceId);
        return this;
    };
    /**
     * @inheritDoc
     */ Span.prototype.getTraceContext = function() {
        return (0, $bP4Y8.dropUndefinedKeys)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            trace_id: this.traceId
        });
    };
    /**
     * @inheritDoc
     */ Span.prototype.toJSON = function() {
        return (0, $bP4Y8.dropUndefinedKeys)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            start_timestamp: this.startTimestamp,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this.endTimestamp,
            trace_id: this.traceId
        });
    };
    return Span;
}();
function $781ad1a658e514bd$export$ac65c70d78fcdb55(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return 'ok';
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return 'unauthenticated';
        case 403:
            return 'permission_denied';
        case 404:
            return 'not_found';
        case 409:
            return 'already_exists';
        case 413:
            return 'failed_precondition';
        case 429:
            return 'resource_exhausted';
        default:
            return 'invalid_argument';
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return 'unimplemented';
        case 503:
            return 'unavailable';
        case 504:
            return 'deadline_exceeded';
        default:
            return 'internal_error';
    }
    return 'unknown_error';
}

});

parcelRegister("j8tm1", function(module, exports) {

$parcel$export(module.exports, "Transaction", () => $dee588d3f5b1596b$export$febc5573c75cefb0);

var $gztBd = parcelRequire("gztBd");

var $6cwj6 = parcelRequire("6cwj6");
parcelRequire("2ktyf");
var $bP4Y8 = parcelRequire("bP4Y8");
var $5QZE4 = parcelRequire("5QZE4");
var $7htw4 = parcelRequire("7htw4");

var $2mkHy = parcelRequire("2mkHy");

var $ajjwc = parcelRequire("ajjwc");
/** JSDoc */ var $dee588d3f5b1596b$export$febc5573c75cefb0 = /** @class */ function(_super) {
    (0, $gztBd.__extends)(Transaction, _super);
    /**
     * This constructor should never be called manually. Those instrumenting tracing should use
     * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
     * @internal
     * @hideconstructor
     * @hidden
     */ function Transaction(transactionContext, hub) {
        var _this = _super.call(this, transactionContext) || this;
        _this._measurements = {};
        /**
         * The reference to the current hub.
         */ _this._hub = (0, $6cwj6.getCurrentHub)();
        if ((0, $5QZE4.isInstanceOf)(hub, (0, $6cwj6.Hub))) _this._hub = hub;
        _this.name = transactionContext.name || '';
        _this.metadata = transactionContext.metadata || {};
        _this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        _this.transaction = _this;
        return _this;
    }
    /**
     * JSDoc
     */ Transaction.prototype.setName = function(name) {
        this.name = name;
    };
    /**
     * Attaches SpanRecorder to the span itself
     * @param maxlen maximum number of spans that can be recorded
     */ Transaction.prototype.initSpanRecorder = function(maxlen) {
        if (maxlen === void 0) maxlen = 1000;
        if (!this.spanRecorder) this.spanRecorder = new (0, $ajjwc.SpanRecorder)(maxlen);
        this.spanRecorder.add(this);
    };
    /**
     * Set observed measurements for this transaction.
     * @hidden
     */ Transaction.prototype.setMeasurements = function(measurements) {
        this._measurements = (0, $gztBd.__assign)({}, measurements);
    };
    /**
     * Set metadata for this transaction.
     * @hidden
     */ Transaction.prototype.setMetadata = function(newMetadata) {
        this.metadata = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this.metadata), newMetadata);
    };
    /**
     * @inheritDoc
     */ Transaction.prototype.finish = function(endTimestamp) {
        var _this = this;
        // This transaction is already finished, so we should not flush it again.
        if (this.endTimestamp !== undefined) return undefined;
        if (!this.name) {
            (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this.name = '<unlabeled transaction>';
        }
        // just sets the end timestamp
        _super.prototype.finish.call(this, endTimestamp);
        if (this.sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
            var client = this._hub.getClient();
            var transport = client && client.getTransport && client.getTransport();
            if (transport && transport.recordLostEvent) transport.recordLostEvent('sample_rate', 'transaction');
            return undefined;
        }
        var finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(function(s) {
            return s !== _this && s.endTimestamp;
        }) : [];
        if (this._trimEnd && finishedSpans.length > 0) this.endTimestamp = finishedSpans.reduce(function(prev, current) {
            if (prev.endTimestamp && current.endTimestamp) return prev.endTimestamp > current.endTimestamp ? prev : current;
            return prev;
        }).endTimestamp;
        var transaction = {
            contexts: {
                trace: this.getTraceContext()
            },
            spans: finishedSpans,
            start_timestamp: this.startTimestamp,
            tags: this.tags,
            timestamp: this.endTimestamp,
            transaction: this.name,
            type: 'transaction',
            sdkProcessingMetadata: this.metadata
        };
        var hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log("[Tracing] Finishing " + this.op + " transaction: " + this.name + ".");
        return this._hub.captureEvent(transaction);
    };
    /**
     * @inheritDoc
     */ Transaction.prototype.toContext = function() {
        var spanContext = _super.prototype.toContext.call(this);
        return (0, $bP4Y8.dropUndefinedKeys)((0, $gztBd.__assign)((0, $gztBd.__assign)({}, spanContext), {
            name: this.name,
            trimEnd: this._trimEnd
        }));
    };
    /**
     * @inheritDoc
     */ Transaction.prototype.updateWithContext = function(transactionContext) {
        var _a;
        _super.prototype.updateWithContext.call(this, transactionContext);
        this.name = (_a = transactionContext.name, _a !== null && _a !== void 0 ? _a : '');
        this._trimEnd = transactionContext.trimEnd;
        return this;
    };
    return Transaction;
}((0, $ajjwc.Span));

});



/*
Stimulus 3.2.1
Copyright © 2023 Basecamp, LLC
 */ class $1e1b4d625d583414$var$EventListener {
    constructor(eventTarget, eventName, eventOptions){
        this.eventTarget = eventTarget;
        this.eventName = eventName;
        this.eventOptions = eventOptions;
        this.unorderedBindings = new Set();
    }
    connect() {
        this.eventTarget.addEventListener(this.eventName, this, this.eventOptions);
    }
    disconnect() {
        this.eventTarget.removeEventListener(this.eventName, this, this.eventOptions);
    }
    bindingConnected(binding) {
        this.unorderedBindings.add(binding);
    }
    bindingDisconnected(binding) {
        this.unorderedBindings.delete(binding);
    }
    handleEvent(event) {
        const extendedEvent = $1e1b4d625d583414$var$extendEvent(event);
        for (const binding of this.bindings){
            if (extendedEvent.immediatePropagationStopped) break;
            else binding.handleEvent(extendedEvent);
        }
    }
    hasBindings() {
        return this.unorderedBindings.size > 0;
    }
    get bindings() {
        return Array.from(this.unorderedBindings).sort((left, right)=>{
            const leftIndex = left.index, rightIndex = right.index;
            return leftIndex < rightIndex ? -1 : leftIndex > rightIndex ? 1 : 0;
        });
    }
}
function $1e1b4d625d583414$var$extendEvent(event) {
    if ("immediatePropagationStopped" in event) return event;
    else {
        const { stopImmediatePropagation: stopImmediatePropagation } = event;
        return Object.assign(event, {
            immediatePropagationStopped: false,
            stopImmediatePropagation () {
                this.immediatePropagationStopped = true;
                stopImmediatePropagation.call(this);
            }
        });
    }
}
class $1e1b4d625d583414$var$Dispatcher {
    constructor(application){
        this.application = application;
        this.eventListenerMaps = new Map();
        this.started = false;
    }
    start() {
        if (!this.started) {
            this.started = true;
            this.eventListeners.forEach((eventListener)=>eventListener.connect());
        }
    }
    stop() {
        if (this.started) {
            this.started = false;
            this.eventListeners.forEach((eventListener)=>eventListener.disconnect());
        }
    }
    get eventListeners() {
        return Array.from(this.eventListenerMaps.values()).reduce((listeners, map)=>listeners.concat(Array.from(map.values())), []);
    }
    bindingConnected(binding) {
        this.fetchEventListenerForBinding(binding).bindingConnected(binding);
    }
    bindingDisconnected(binding, clearEventListeners = false) {
        this.fetchEventListenerForBinding(binding).bindingDisconnected(binding);
        if (clearEventListeners) this.clearEventListenersForBinding(binding);
    }
    handleError(error, message, detail = {}) {
        this.application.handleError(error, `Error ${message}`, detail);
    }
    clearEventListenersForBinding(binding) {
        const eventListener = this.fetchEventListenerForBinding(binding);
        if (!eventListener.hasBindings()) {
            eventListener.disconnect();
            this.removeMappedEventListenerFor(binding);
        }
    }
    removeMappedEventListenerFor(binding) {
        const { eventTarget: eventTarget, eventName: eventName, eventOptions: eventOptions } = binding;
        const eventListenerMap = this.fetchEventListenerMapForEventTarget(eventTarget);
        const cacheKey = this.cacheKey(eventName, eventOptions);
        eventListenerMap.delete(cacheKey);
        if (eventListenerMap.size == 0) this.eventListenerMaps.delete(eventTarget);
    }
    fetchEventListenerForBinding(binding) {
        const { eventTarget: eventTarget, eventName: eventName, eventOptions: eventOptions } = binding;
        return this.fetchEventListener(eventTarget, eventName, eventOptions);
    }
    fetchEventListener(eventTarget, eventName, eventOptions) {
        const eventListenerMap = this.fetchEventListenerMapForEventTarget(eventTarget);
        const cacheKey = this.cacheKey(eventName, eventOptions);
        let eventListener = eventListenerMap.get(cacheKey);
        if (!eventListener) {
            eventListener = this.createEventListener(eventTarget, eventName, eventOptions);
            eventListenerMap.set(cacheKey, eventListener);
        }
        return eventListener;
    }
    createEventListener(eventTarget, eventName, eventOptions) {
        const eventListener = new $1e1b4d625d583414$var$EventListener(eventTarget, eventName, eventOptions);
        if (this.started) eventListener.connect();
        return eventListener;
    }
    fetchEventListenerMapForEventTarget(eventTarget) {
        let eventListenerMap = this.eventListenerMaps.get(eventTarget);
        if (!eventListenerMap) {
            eventListenerMap = new Map();
            this.eventListenerMaps.set(eventTarget, eventListenerMap);
        }
        return eventListenerMap;
    }
    cacheKey(eventName, eventOptions) {
        const parts = [
            eventName
        ];
        Object.keys(eventOptions).sort().forEach((key)=>{
            parts.push(`${eventOptions[key] ? "" : "!"}${key}`);
        });
        return parts.join(":");
    }
}
const $1e1b4d625d583414$var$defaultActionDescriptorFilters = {
    stop ({ event: event, value: value }) {
        if (value) event.stopPropagation();
        return true;
    },
    prevent ({ event: event, value: value }) {
        if (value) event.preventDefault();
        return true;
    },
    self ({ event: event, value: value, element: element }) {
        if (value) return element === event.target;
        else return true;
    }
};
const $1e1b4d625d583414$var$descriptorPattern = /^(?:(?:([^.]+?)\+)?(.+?)(?:\.(.+?))?(?:@(window|document))?->)?(.+?)(?:#([^:]+?))(?::(.+))?$/;
function $1e1b4d625d583414$var$parseActionDescriptorString(descriptorString) {
    const source = descriptorString.trim();
    const matches = source.match($1e1b4d625d583414$var$descriptorPattern) || [];
    let eventName = matches[2];
    let keyFilter = matches[3];
    if (keyFilter && ![
        "keydown",
        "keyup",
        "keypress"
    ].includes(eventName)) {
        eventName += `.${keyFilter}`;
        keyFilter = "";
    }
    return {
        eventTarget: $1e1b4d625d583414$var$parseEventTarget(matches[4]),
        eventName: eventName,
        eventOptions: matches[7] ? $1e1b4d625d583414$var$parseEventOptions(matches[7]) : {},
        identifier: matches[5],
        methodName: matches[6],
        keyFilter: matches[1] || keyFilter
    };
}
function $1e1b4d625d583414$var$parseEventTarget(eventTargetName) {
    if (eventTargetName == "window") return window;
    else if (eventTargetName == "document") return document;
}
function $1e1b4d625d583414$var$parseEventOptions(eventOptions) {
    return eventOptions.split(":").reduce((options, token)=>Object.assign(options, {
            [token.replace(/^!/, "")]: !/^!/.test(token)
        }), {});
}
function $1e1b4d625d583414$var$stringifyEventTarget(eventTarget) {
    if (eventTarget == window) return "window";
    else if (eventTarget == document) return "document";
}
function $1e1b4d625d583414$var$camelize(value) {
    return value.replace(/(?:[_-])([a-z0-9])/g, (_, char)=>char.toUpperCase());
}
function $1e1b4d625d583414$var$namespaceCamelize(value) {
    return $1e1b4d625d583414$var$camelize(value.replace(/--/g, "-").replace(/__/g, "_"));
}
function $1e1b4d625d583414$var$capitalize(value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
}
function $1e1b4d625d583414$var$dasherize(value) {
    return value.replace(/([A-Z])/g, (_, char)=>`-${char.toLowerCase()}`);
}
function $1e1b4d625d583414$var$tokenize(value) {
    return value.match(/[^\s]+/g) || [];
}
function $1e1b4d625d583414$var$isSomething(object) {
    return object !== null && object !== undefined;
}
function $1e1b4d625d583414$var$hasProperty(object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
}
const $1e1b4d625d583414$var$allModifiers = [
    "meta",
    "ctrl",
    "alt",
    "shift"
];
class $1e1b4d625d583414$var$Action {
    constructor(element, index, descriptor, schema){
        this.element = element;
        this.index = index;
        this.eventTarget = descriptor.eventTarget || element;
        this.eventName = descriptor.eventName || $1e1b4d625d583414$var$getDefaultEventNameForElement(element) || $1e1b4d625d583414$var$error("missing event name");
        this.eventOptions = descriptor.eventOptions || {};
        this.identifier = descriptor.identifier || $1e1b4d625d583414$var$error("missing identifier");
        this.methodName = descriptor.methodName || $1e1b4d625d583414$var$error("missing method name");
        this.keyFilter = descriptor.keyFilter || "";
        this.schema = schema;
    }
    static forToken(token, schema) {
        return new this(token.element, token.index, $1e1b4d625d583414$var$parseActionDescriptorString(token.content), schema);
    }
    toString() {
        const eventFilter = this.keyFilter ? `.${this.keyFilter}` : "";
        const eventTarget = this.eventTargetName ? `@${this.eventTargetName}` : "";
        return `${this.eventName}${eventFilter}${eventTarget}->${this.identifier}#${this.methodName}`;
    }
    shouldIgnoreKeyboardEvent(event) {
        if (!this.keyFilter) return false;
        const filters = this.keyFilter.split("+");
        if (this.keyFilterDissatisfied(event, filters)) return true;
        const standardFilter = filters.filter((key)=>!$1e1b4d625d583414$var$allModifiers.includes(key))[0];
        if (!standardFilter) return false;
        if (!$1e1b4d625d583414$var$hasProperty(this.keyMappings, standardFilter)) $1e1b4d625d583414$var$error(`contains unknown key filter: ${this.keyFilter}`);
        return this.keyMappings[standardFilter].toLowerCase() !== event.key.toLowerCase();
    }
    shouldIgnoreMouseEvent(event) {
        if (!this.keyFilter) return false;
        const filters = [
            this.keyFilter
        ];
        if (this.keyFilterDissatisfied(event, filters)) return true;
        return false;
    }
    get params() {
        const params = {};
        const pattern = new RegExp(`^data-${this.identifier}-(.+)-param$`, "i");
        for (const { name: name, value: value } of Array.from(this.element.attributes)){
            const match = name.match(pattern);
            const key = match && match[1];
            if (key) params[$1e1b4d625d583414$var$camelize(key)] = $1e1b4d625d583414$var$typecast(value);
        }
        return params;
    }
    get eventTargetName() {
        return $1e1b4d625d583414$var$stringifyEventTarget(this.eventTarget);
    }
    get keyMappings() {
        return this.schema.keyMappings;
    }
    keyFilterDissatisfied(event, filters) {
        const [meta, ctrl, alt, shift] = $1e1b4d625d583414$var$allModifiers.map((modifier)=>filters.includes(modifier));
        return event.metaKey !== meta || event.ctrlKey !== ctrl || event.altKey !== alt || event.shiftKey !== shift;
    }
}
const $1e1b4d625d583414$var$defaultEventNames = {
    a: ()=>"click",
    button: ()=>"click",
    form: ()=>"submit",
    details: ()=>"toggle",
    input: (e)=>e.getAttribute("type") == "submit" ? "click" : "input",
    select: ()=>"change",
    textarea: ()=>"input"
};
function $1e1b4d625d583414$var$getDefaultEventNameForElement(element) {
    const tagName = element.tagName.toLowerCase();
    if (tagName in $1e1b4d625d583414$var$defaultEventNames) return $1e1b4d625d583414$var$defaultEventNames[tagName](element);
}
function $1e1b4d625d583414$var$error(message) {
    throw new Error(message);
}
function $1e1b4d625d583414$var$typecast(value) {
    try {
        return JSON.parse(value);
    } catch (o_O) {
        return value;
    }
}
class $1e1b4d625d583414$var$Binding {
    constructor(context, action){
        this.context = context;
        this.action = action;
    }
    get index() {
        return this.action.index;
    }
    get eventTarget() {
        return this.action.eventTarget;
    }
    get eventOptions() {
        return this.action.eventOptions;
    }
    get identifier() {
        return this.context.identifier;
    }
    handleEvent(event) {
        const actionEvent = this.prepareActionEvent(event);
        if (this.willBeInvokedByEvent(event) && this.applyEventModifiers(actionEvent)) this.invokeWithEvent(actionEvent);
    }
    get eventName() {
        return this.action.eventName;
    }
    get method() {
        const method = this.controller[this.methodName];
        if (typeof method == "function") return method;
        throw new Error(`Action "${this.action}" references undefined method "${this.methodName}"`);
    }
    applyEventModifiers(event) {
        const { element: element } = this.action;
        const { actionDescriptorFilters: actionDescriptorFilters } = this.context.application;
        const { controller: controller } = this.context;
        let passes = true;
        for (const [name, value] of Object.entries(this.eventOptions)){
            if (name in actionDescriptorFilters) {
                const filter = actionDescriptorFilters[name];
                passes = passes && filter({
                    name: name,
                    value: value,
                    event: event,
                    element: element,
                    controller: controller
                });
            } else continue;
        }
        return passes;
    }
    prepareActionEvent(event) {
        return Object.assign(event, {
            params: this.action.params
        });
    }
    invokeWithEvent(event) {
        const { target: target, currentTarget: currentTarget } = event;
        try {
            this.method.call(this.controller, event);
            this.context.logDebugActivity(this.methodName, {
                event: event,
                target: target,
                currentTarget: currentTarget,
                action: this.methodName
            });
        } catch (error) {
            const { identifier: identifier, controller: controller, element: element, index: index } = this;
            const detail = {
                identifier: identifier,
                controller: controller,
                element: element,
                index: index,
                event: event
            };
            this.context.handleError(error, `invoking action "${this.action}"`, detail);
        }
    }
    willBeInvokedByEvent(event) {
        const eventTarget = event.target;
        if (event instanceof KeyboardEvent && this.action.shouldIgnoreKeyboardEvent(event)) return false;
        if (event instanceof MouseEvent && this.action.shouldIgnoreMouseEvent(event)) return false;
        if (this.element === eventTarget) return true;
        else if (eventTarget instanceof Element && this.element.contains(eventTarget)) return this.scope.containsElement(eventTarget);
        else return this.scope.containsElement(this.action.element);
    }
    get controller() {
        return this.context.controller;
    }
    get methodName() {
        return this.action.methodName;
    }
    get element() {
        return this.scope.element;
    }
    get scope() {
        return this.context.scope;
    }
}
class $1e1b4d625d583414$export$12e07a2a9f87578a {
    constructor(element, delegate){
        this.mutationObserverInit = {
            attributes: true,
            childList: true,
            subtree: true
        };
        this.element = element;
        this.started = false;
        this.delegate = delegate;
        this.elements = new Set();
        this.mutationObserver = new MutationObserver((mutations)=>this.processMutations(mutations));
    }
    start() {
        if (!this.started) {
            this.started = true;
            this.mutationObserver.observe(this.element, this.mutationObserverInit);
            this.refresh();
        }
    }
    pause(callback) {
        if (this.started) {
            this.mutationObserver.disconnect();
            this.started = false;
        }
        callback();
        if (!this.started) {
            this.mutationObserver.observe(this.element, this.mutationObserverInit);
            this.started = true;
        }
    }
    stop() {
        if (this.started) {
            this.mutationObserver.takeRecords();
            this.mutationObserver.disconnect();
            this.started = false;
        }
    }
    refresh() {
        if (this.started) {
            const matches = new Set(this.matchElementsInTree());
            for (const element of Array.from(this.elements))if (!matches.has(element)) this.removeElement(element);
            for (const element of Array.from(matches))this.addElement(element);
        }
    }
    processMutations(mutations) {
        if (this.started) for (const mutation of mutations)this.processMutation(mutation);
    }
    processMutation(mutation) {
        if (mutation.type == "attributes") this.processAttributeChange(mutation.target, mutation.attributeName);
        else if (mutation.type == "childList") {
            this.processRemovedNodes(mutation.removedNodes);
            this.processAddedNodes(mutation.addedNodes);
        }
    }
    processAttributeChange(element, attributeName) {
        if (this.elements.has(element)) {
            if (this.delegate.elementAttributeChanged && this.matchElement(element)) this.delegate.elementAttributeChanged(element, attributeName);
            else this.removeElement(element);
        } else if (this.matchElement(element)) this.addElement(element);
    }
    processRemovedNodes(nodes) {
        for (const node of Array.from(nodes)){
            const element = this.elementFromNode(node);
            if (element) this.processTree(element, this.removeElement);
        }
    }
    processAddedNodes(nodes) {
        for (const node of Array.from(nodes)){
            const element = this.elementFromNode(node);
            if (element && this.elementIsActive(element)) this.processTree(element, this.addElement);
        }
    }
    matchElement(element) {
        return this.delegate.matchElement(element);
    }
    matchElementsInTree(tree = this.element) {
        return this.delegate.matchElementsInTree(tree);
    }
    processTree(tree, processor) {
        for (const element of this.matchElementsInTree(tree))processor.call(this, element);
    }
    elementFromNode(node) {
        if (node.nodeType == Node.ELEMENT_NODE) return node;
    }
    elementIsActive(element) {
        if (element.isConnected != this.element.isConnected) return false;
        else return this.element.contains(element);
    }
    addElement(element) {
        if (!this.elements.has(element)) {
            if (this.elementIsActive(element)) {
                this.elements.add(element);
                if (this.delegate.elementMatched) this.delegate.elementMatched(element);
            }
        }
    }
    removeElement(element) {
        if (this.elements.has(element)) {
            this.elements.delete(element);
            if (this.delegate.elementUnmatched) this.delegate.elementUnmatched(element);
        }
    }
}
class $1e1b4d625d583414$export$fe68319d413d05cb {
    constructor(element, attributeName, delegate){
        this.attributeName = attributeName;
        this.delegate = delegate;
        this.elementObserver = new $1e1b4d625d583414$export$12e07a2a9f87578a(element, this);
    }
    get element() {
        return this.elementObserver.element;
    }
    get selector() {
        return `[${this.attributeName}]`;
    }
    start() {
        this.elementObserver.start();
    }
    pause(callback) {
        this.elementObserver.pause(callback);
    }
    stop() {
        this.elementObserver.stop();
    }
    refresh() {
        this.elementObserver.refresh();
    }
    get started() {
        return this.elementObserver.started;
    }
    matchElement(element) {
        return element.hasAttribute(this.attributeName);
    }
    matchElementsInTree(tree) {
        const match = this.matchElement(tree) ? [
            tree
        ] : [];
        const matches = Array.from(tree.querySelectorAll(this.selector));
        return match.concat(matches);
    }
    elementMatched(element) {
        if (this.delegate.elementMatchedAttribute) this.delegate.elementMatchedAttribute(element, this.attributeName);
    }
    elementUnmatched(element) {
        if (this.delegate.elementUnmatchedAttribute) this.delegate.elementUnmatchedAttribute(element, this.attributeName);
    }
    elementAttributeChanged(element, attributeName) {
        if (this.delegate.elementAttributeValueChanged && this.attributeName == attributeName) this.delegate.elementAttributeValueChanged(element, attributeName);
    }
}
function $1e1b4d625d583414$export$e16d8520af44a096(map, key, value) {
    $1e1b4d625d583414$export$e7aa7bc5c1b3cfb3(map, key).add(value);
}
function $1e1b4d625d583414$export$1d2f21e549771e67(map, key, value) {
    $1e1b4d625d583414$export$e7aa7bc5c1b3cfb3(map, key).delete(value);
    $1e1b4d625d583414$export$d6cf75919f12ca5a(map, key);
}
function $1e1b4d625d583414$export$e7aa7bc5c1b3cfb3(map, key) {
    let values = map.get(key);
    if (!values) {
        values = new Set();
        map.set(key, values);
    }
    return values;
}
function $1e1b4d625d583414$export$d6cf75919f12ca5a(map, key) {
    const values = map.get(key);
    if (values != null && values.size == 0) map.delete(key);
}
class $1e1b4d625d583414$export$8bd4ad37b76db6ba {
    constructor(){
        this.valuesByKey = new Map();
    }
    get keys() {
        return Array.from(this.valuesByKey.keys());
    }
    get values() {
        const sets = Array.from(this.valuesByKey.values());
        return sets.reduce((values, set)=>values.concat(Array.from(set)), []);
    }
    get size() {
        const sets = Array.from(this.valuesByKey.values());
        return sets.reduce((size, set)=>size + set.size, 0);
    }
    add(key, value) {
        $1e1b4d625d583414$export$e16d8520af44a096(this.valuesByKey, key, value);
    }
    delete(key, value) {
        $1e1b4d625d583414$export$1d2f21e549771e67(this.valuesByKey, key, value);
    }
    has(key, value) {
        const values = this.valuesByKey.get(key);
        return values != null && values.has(value);
    }
    hasKey(key) {
        return this.valuesByKey.has(key);
    }
    hasValue(value) {
        const sets = Array.from(this.valuesByKey.values());
        return sets.some((set)=>set.has(value));
    }
    getValuesForKey(key) {
        const values = this.valuesByKey.get(key);
        return values ? Array.from(values) : [];
    }
    getKeysForValue(value) {
        return Array.from(this.valuesByKey).filter(([_key, values])=>values.has(value)).map(([key, _values])=>key);
    }
}
class $1e1b4d625d583414$export$a7c3d2c2552a674d extends $1e1b4d625d583414$export$8bd4ad37b76db6ba {
    constructor(){
        super();
        this.keysByValue = new Map();
    }
    get values() {
        return Array.from(this.keysByValue.keys());
    }
    add(key, value) {
        super.add(key, value);
        $1e1b4d625d583414$export$e16d8520af44a096(this.keysByValue, value, key);
    }
    delete(key, value) {
        super.delete(key, value);
        $1e1b4d625d583414$export$1d2f21e549771e67(this.keysByValue, value, key);
    }
    hasValue(value) {
        return this.keysByValue.has(value);
    }
    getKeysForValue(value) {
        const set = this.keysByValue.get(value);
        return set ? Array.from(set) : [];
    }
}
class $1e1b4d625d583414$export$116e0b48509995b {
    constructor(element, selector, delegate, details){
        this._selector = selector;
        this.details = details;
        this.elementObserver = new $1e1b4d625d583414$export$12e07a2a9f87578a(element, this);
        this.delegate = delegate;
        this.matchesByElement = new $1e1b4d625d583414$export$8bd4ad37b76db6ba();
    }
    get started() {
        return this.elementObserver.started;
    }
    get selector() {
        return this._selector;
    }
    set selector(selector) {
        this._selector = selector;
        this.refresh();
    }
    start() {
        this.elementObserver.start();
    }
    pause(callback) {
        this.elementObserver.pause(callback);
    }
    stop() {
        this.elementObserver.stop();
    }
    refresh() {
        this.elementObserver.refresh();
    }
    get element() {
        return this.elementObserver.element;
    }
    matchElement(element) {
        const { selector: selector } = this;
        if (selector) {
            const matches = element.matches(selector);
            if (this.delegate.selectorMatchElement) return matches && this.delegate.selectorMatchElement(element, this.details);
            return matches;
        } else return false;
    }
    matchElementsInTree(tree) {
        const { selector: selector } = this;
        if (selector) {
            const match = this.matchElement(tree) ? [
                tree
            ] : [];
            const matches = Array.from(tree.querySelectorAll(selector)).filter((match)=>this.matchElement(match));
            return match.concat(matches);
        } else return [];
    }
    elementMatched(element) {
        const { selector: selector } = this;
        if (selector) this.selectorMatched(element, selector);
    }
    elementUnmatched(element) {
        const selectors = this.matchesByElement.getKeysForValue(element);
        for (const selector of selectors)this.selectorUnmatched(element, selector);
    }
    elementAttributeChanged(element, _attributeName) {
        const { selector: selector } = this;
        if (selector) {
            const matches = this.matchElement(element);
            const matchedBefore = this.matchesByElement.has(selector, element);
            if (matches && !matchedBefore) this.selectorMatched(element, selector);
            else if (!matches && matchedBefore) this.selectorUnmatched(element, selector);
        }
    }
    selectorMatched(element, selector) {
        this.delegate.selectorMatched(element, selector, this.details);
        this.matchesByElement.add(selector, element);
    }
    selectorUnmatched(element, selector) {
        this.delegate.selectorUnmatched(element, selector, this.details);
        this.matchesByElement.delete(selector, element);
    }
}
class $1e1b4d625d583414$export$da226bebbf7f6caa {
    constructor(element, delegate){
        this.element = element;
        this.delegate = delegate;
        this.started = false;
        this.stringMap = new Map();
        this.mutationObserver = new MutationObserver((mutations)=>this.processMutations(mutations));
    }
    start() {
        if (!this.started) {
            this.started = true;
            this.mutationObserver.observe(this.element, {
                attributes: true,
                attributeOldValue: true
            });
            this.refresh();
        }
    }
    stop() {
        if (this.started) {
            this.mutationObserver.takeRecords();
            this.mutationObserver.disconnect();
            this.started = false;
        }
    }
    refresh() {
        if (this.started) for (const attributeName of this.knownAttributeNames)this.refreshAttribute(attributeName, null);
    }
    processMutations(mutations) {
        if (this.started) for (const mutation of mutations)this.processMutation(mutation);
    }
    processMutation(mutation) {
        const attributeName = mutation.attributeName;
        if (attributeName) this.refreshAttribute(attributeName, mutation.oldValue);
    }
    refreshAttribute(attributeName, oldValue) {
        const key = this.delegate.getStringMapKeyForAttribute(attributeName);
        if (key != null) {
            if (!this.stringMap.has(attributeName)) this.stringMapKeyAdded(key, attributeName);
            const value = this.element.getAttribute(attributeName);
            if (this.stringMap.get(attributeName) != value) this.stringMapValueChanged(value, key, oldValue);
            if (value == null) {
                const oldValue = this.stringMap.get(attributeName);
                this.stringMap.delete(attributeName);
                if (oldValue) this.stringMapKeyRemoved(key, attributeName, oldValue);
            } else this.stringMap.set(attributeName, value);
        }
    }
    stringMapKeyAdded(key, attributeName) {
        if (this.delegate.stringMapKeyAdded) this.delegate.stringMapKeyAdded(key, attributeName);
    }
    stringMapValueChanged(value, key, oldValue) {
        if (this.delegate.stringMapValueChanged) this.delegate.stringMapValueChanged(value, key, oldValue);
    }
    stringMapKeyRemoved(key, attributeName, oldValue) {
        if (this.delegate.stringMapKeyRemoved) this.delegate.stringMapKeyRemoved(key, attributeName, oldValue);
    }
    get knownAttributeNames() {
        return Array.from(new Set(this.currentAttributeNames.concat(this.recordedAttributeNames)));
    }
    get currentAttributeNames() {
        return Array.from(this.element.attributes).map((attribute)=>attribute.name);
    }
    get recordedAttributeNames() {
        return Array.from(this.stringMap.keys());
    }
}
class $1e1b4d625d583414$export$3aa21c2f03ef6b3b {
    constructor(element, attributeName, delegate){
        this.attributeObserver = new $1e1b4d625d583414$export$fe68319d413d05cb(element, attributeName, this);
        this.delegate = delegate;
        this.tokensByElement = new $1e1b4d625d583414$export$8bd4ad37b76db6ba();
    }
    get started() {
        return this.attributeObserver.started;
    }
    start() {
        this.attributeObserver.start();
    }
    pause(callback) {
        this.attributeObserver.pause(callback);
    }
    stop() {
        this.attributeObserver.stop();
    }
    refresh() {
        this.attributeObserver.refresh();
    }
    get element() {
        return this.attributeObserver.element;
    }
    get attributeName() {
        return this.attributeObserver.attributeName;
    }
    elementMatchedAttribute(element) {
        this.tokensMatched(this.readTokensForElement(element));
    }
    elementAttributeValueChanged(element) {
        const [unmatchedTokens, matchedTokens] = this.refreshTokensForElement(element);
        this.tokensUnmatched(unmatchedTokens);
        this.tokensMatched(matchedTokens);
    }
    elementUnmatchedAttribute(element) {
        this.tokensUnmatched(this.tokensByElement.getValuesForKey(element));
    }
    tokensMatched(tokens) {
        tokens.forEach((token)=>this.tokenMatched(token));
    }
    tokensUnmatched(tokens) {
        tokens.forEach((token)=>this.tokenUnmatched(token));
    }
    tokenMatched(token) {
        this.delegate.tokenMatched(token);
        this.tokensByElement.add(token.element, token);
    }
    tokenUnmatched(token) {
        this.delegate.tokenUnmatched(token);
        this.tokensByElement.delete(token.element, token);
    }
    refreshTokensForElement(element) {
        const previousTokens = this.tokensByElement.getValuesForKey(element);
        const currentTokens = this.readTokensForElement(element);
        const firstDifferingIndex = $1e1b4d625d583414$var$zip(previousTokens, currentTokens).findIndex(([previousToken, currentToken])=>!$1e1b4d625d583414$var$tokensAreEqual(previousToken, currentToken));
        if (firstDifferingIndex == -1) return [
            [],
            []
        ];
        else return [
            previousTokens.slice(firstDifferingIndex),
            currentTokens.slice(firstDifferingIndex)
        ];
    }
    readTokensForElement(element) {
        const attributeName = this.attributeName;
        const tokenString = element.getAttribute(attributeName) || "";
        return $1e1b4d625d583414$var$parseTokenString(tokenString, element, attributeName);
    }
}
function $1e1b4d625d583414$var$parseTokenString(tokenString, element, attributeName) {
    return tokenString.trim().split(/\s+/).filter((content)=>content.length).map((content, index)=>({
            element: element,
            attributeName: attributeName,
            content: content,
            index: index
        }));
}
function $1e1b4d625d583414$var$zip(left, right) {
    const length = Math.max(left.length, right.length);
    return Array.from({
        length: length
    }, (_, index)=>[
            left[index],
            right[index]
        ]);
}
function $1e1b4d625d583414$var$tokensAreEqual(left, right) {
    return left && right && left.index == right.index && left.content == right.content;
}
class $1e1b4d625d583414$export$d27fa4c7330a452e {
    constructor(element, attributeName, delegate){
        this.tokenListObserver = new $1e1b4d625d583414$export$3aa21c2f03ef6b3b(element, attributeName, this);
        this.delegate = delegate;
        this.parseResultsByToken = new WeakMap();
        this.valuesByTokenByElement = new WeakMap();
    }
    get started() {
        return this.tokenListObserver.started;
    }
    start() {
        this.tokenListObserver.start();
    }
    stop() {
        this.tokenListObserver.stop();
    }
    refresh() {
        this.tokenListObserver.refresh();
    }
    get element() {
        return this.tokenListObserver.element;
    }
    get attributeName() {
        return this.tokenListObserver.attributeName;
    }
    tokenMatched(token) {
        const { element: element } = token;
        const { value: value } = this.fetchParseResultForToken(token);
        if (value) {
            this.fetchValuesByTokenForElement(element).set(token, value);
            this.delegate.elementMatchedValue(element, value);
        }
    }
    tokenUnmatched(token) {
        const { element: element } = token;
        const { value: value } = this.fetchParseResultForToken(token);
        if (value) {
            this.fetchValuesByTokenForElement(element).delete(token);
            this.delegate.elementUnmatchedValue(element, value);
        }
    }
    fetchParseResultForToken(token) {
        let parseResult = this.parseResultsByToken.get(token);
        if (!parseResult) {
            parseResult = this.parseToken(token);
            this.parseResultsByToken.set(token, parseResult);
        }
        return parseResult;
    }
    fetchValuesByTokenForElement(element) {
        let valuesByToken = this.valuesByTokenByElement.get(element);
        if (!valuesByToken) {
            valuesByToken = new Map();
            this.valuesByTokenByElement.set(element, valuesByToken);
        }
        return valuesByToken;
    }
    parseToken(token) {
        try {
            const value = this.delegate.parseValueForToken(token);
            return {
                value: value
            };
        } catch (error) {
            return {
                error: error
            };
        }
    }
}
class $1e1b4d625d583414$var$BindingObserver {
    constructor(context, delegate){
        this.context = context;
        this.delegate = delegate;
        this.bindingsByAction = new Map();
    }
    start() {
        if (!this.valueListObserver) {
            this.valueListObserver = new $1e1b4d625d583414$export$d27fa4c7330a452e(this.element, this.actionAttribute, this);
            this.valueListObserver.start();
        }
    }
    stop() {
        if (this.valueListObserver) {
            this.valueListObserver.stop();
            delete this.valueListObserver;
            this.disconnectAllActions();
        }
    }
    get element() {
        return this.context.element;
    }
    get identifier() {
        return this.context.identifier;
    }
    get actionAttribute() {
        return this.schema.actionAttribute;
    }
    get schema() {
        return this.context.schema;
    }
    get bindings() {
        return Array.from(this.bindingsByAction.values());
    }
    connectAction(action) {
        const binding = new $1e1b4d625d583414$var$Binding(this.context, action);
        this.bindingsByAction.set(action, binding);
        this.delegate.bindingConnected(binding);
    }
    disconnectAction(action) {
        const binding = this.bindingsByAction.get(action);
        if (binding) {
            this.bindingsByAction.delete(action);
            this.delegate.bindingDisconnected(binding);
        }
    }
    disconnectAllActions() {
        this.bindings.forEach((binding)=>this.delegate.bindingDisconnected(binding, true));
        this.bindingsByAction.clear();
    }
    parseValueForToken(token) {
        const action = $1e1b4d625d583414$var$Action.forToken(token, this.schema);
        if (action.identifier == this.identifier) return action;
    }
    elementMatchedValue(element, action) {
        this.connectAction(action);
    }
    elementUnmatchedValue(element, action) {
        this.disconnectAction(action);
    }
}
class $1e1b4d625d583414$var$ValueObserver {
    constructor(context, receiver){
        this.context = context;
        this.receiver = receiver;
        this.stringMapObserver = new $1e1b4d625d583414$export$da226bebbf7f6caa(this.element, this);
        this.valueDescriptorMap = this.controller.valueDescriptorMap;
    }
    start() {
        this.stringMapObserver.start();
        this.invokeChangedCallbacksForDefaultValues();
    }
    stop() {
        this.stringMapObserver.stop();
    }
    get element() {
        return this.context.element;
    }
    get controller() {
        return this.context.controller;
    }
    getStringMapKeyForAttribute(attributeName) {
        if (attributeName in this.valueDescriptorMap) return this.valueDescriptorMap[attributeName].name;
    }
    stringMapKeyAdded(key, attributeName) {
        const descriptor = this.valueDescriptorMap[attributeName];
        if (!this.hasValue(key)) this.invokeChangedCallback(key, descriptor.writer(this.receiver[key]), descriptor.writer(descriptor.defaultValue));
    }
    stringMapValueChanged(value, name, oldValue) {
        const descriptor = this.valueDescriptorNameMap[name];
        if (value === null) return;
        if (oldValue === null) oldValue = descriptor.writer(descriptor.defaultValue);
        this.invokeChangedCallback(name, value, oldValue);
    }
    stringMapKeyRemoved(key, attributeName, oldValue) {
        const descriptor = this.valueDescriptorNameMap[key];
        if (this.hasValue(key)) this.invokeChangedCallback(key, descriptor.writer(this.receiver[key]), oldValue);
        else this.invokeChangedCallback(key, descriptor.writer(descriptor.defaultValue), oldValue);
    }
    invokeChangedCallbacksForDefaultValues() {
        for (const { key: key, name: name, defaultValue: defaultValue, writer: writer } of this.valueDescriptors)if (defaultValue != undefined && !this.controller.data.has(key)) this.invokeChangedCallback(name, writer(defaultValue), undefined);
    }
    invokeChangedCallback(name, rawValue, rawOldValue) {
        const changedMethodName = `${name}Changed`;
        const changedMethod = this.receiver[changedMethodName];
        if (typeof changedMethod == "function") {
            const descriptor = this.valueDescriptorNameMap[name];
            try {
                const value = descriptor.reader(rawValue);
                let oldValue = rawOldValue;
                if (rawOldValue) oldValue = descriptor.reader(rawOldValue);
                changedMethod.call(this.receiver, value, oldValue);
            } catch (error) {
                if (error instanceof TypeError) error.message = `Stimulus Value "${this.context.identifier}.${descriptor.name}" - ${error.message}`;
                throw error;
            }
        }
    }
    get valueDescriptors() {
        const { valueDescriptorMap: valueDescriptorMap } = this;
        return Object.keys(valueDescriptorMap).map((key)=>valueDescriptorMap[key]);
    }
    get valueDescriptorNameMap() {
        const descriptors = {};
        Object.keys(this.valueDescriptorMap).forEach((key)=>{
            const descriptor = this.valueDescriptorMap[key];
            descriptors[descriptor.name] = descriptor;
        });
        return descriptors;
    }
    hasValue(attributeName) {
        const descriptor = this.valueDescriptorNameMap[attributeName];
        const hasMethodName = `has${$1e1b4d625d583414$var$capitalize(descriptor.name)}`;
        return this.receiver[hasMethodName];
    }
}
class $1e1b4d625d583414$var$TargetObserver {
    constructor(context, delegate){
        this.context = context;
        this.delegate = delegate;
        this.targetsByName = new $1e1b4d625d583414$export$8bd4ad37b76db6ba();
    }
    start() {
        if (!this.tokenListObserver) {
            this.tokenListObserver = new $1e1b4d625d583414$export$3aa21c2f03ef6b3b(this.element, this.attributeName, this);
            this.tokenListObserver.start();
        }
    }
    stop() {
        if (this.tokenListObserver) {
            this.disconnectAllTargets();
            this.tokenListObserver.stop();
            delete this.tokenListObserver;
        }
    }
    tokenMatched({ element: element, content: name }) {
        if (this.scope.containsElement(element)) this.connectTarget(element, name);
    }
    tokenUnmatched({ element: element, content: name }) {
        this.disconnectTarget(element, name);
    }
    connectTarget(element, name) {
        var _a;
        if (!this.targetsByName.has(name, element)) {
            this.targetsByName.add(name, element);
            (_a = this.tokenListObserver) === null || _a === void 0 || _a.pause(()=>this.delegate.targetConnected(element, name));
        }
    }
    disconnectTarget(element, name) {
        var _a;
        if (this.targetsByName.has(name, element)) {
            this.targetsByName.delete(name, element);
            (_a = this.tokenListObserver) === null || _a === void 0 || _a.pause(()=>this.delegate.targetDisconnected(element, name));
        }
    }
    disconnectAllTargets() {
        for (const name of this.targetsByName.keys)for (const element of this.targetsByName.getValuesForKey(name))this.disconnectTarget(element, name);
    }
    get attributeName() {
        return `data-${this.context.identifier}-target`;
    }
    get element() {
        return this.context.element;
    }
    get scope() {
        return this.context.scope;
    }
}
function $1e1b4d625d583414$var$readInheritableStaticArrayValues(constructor, propertyName) {
    const ancestors = $1e1b4d625d583414$var$getAncestorsForConstructor(constructor);
    return Array.from(ancestors.reduce((values, constructor)=>{
        $1e1b4d625d583414$var$getOwnStaticArrayValues(constructor, propertyName).forEach((name)=>values.add(name));
        return values;
    }, new Set()));
}
function $1e1b4d625d583414$var$readInheritableStaticObjectPairs(constructor, propertyName) {
    const ancestors = $1e1b4d625d583414$var$getAncestorsForConstructor(constructor);
    return ancestors.reduce((pairs, constructor)=>{
        pairs.push(...$1e1b4d625d583414$var$getOwnStaticObjectPairs(constructor, propertyName));
        return pairs;
    }, []);
}
function $1e1b4d625d583414$var$getAncestorsForConstructor(constructor) {
    const ancestors = [];
    while(constructor){
        ancestors.push(constructor);
        constructor = Object.getPrototypeOf(constructor);
    }
    return ancestors.reverse();
}
function $1e1b4d625d583414$var$getOwnStaticArrayValues(constructor, propertyName) {
    const definition = constructor[propertyName];
    return Array.isArray(definition) ? definition : [];
}
function $1e1b4d625d583414$var$getOwnStaticObjectPairs(constructor, propertyName) {
    const definition = constructor[propertyName];
    return definition ? Object.keys(definition).map((key)=>[
            key,
            definition[key]
        ]) : [];
}
class $1e1b4d625d583414$var$OutletObserver {
    constructor(context, delegate){
        this.started = false;
        this.context = context;
        this.delegate = delegate;
        this.outletsByName = new $1e1b4d625d583414$export$8bd4ad37b76db6ba();
        this.outletElementsByName = new $1e1b4d625d583414$export$8bd4ad37b76db6ba();
        this.selectorObserverMap = new Map();
        this.attributeObserverMap = new Map();
    }
    start() {
        if (!this.started) {
            this.outletDefinitions.forEach((outletName)=>{
                this.setupSelectorObserverForOutlet(outletName);
                this.setupAttributeObserverForOutlet(outletName);
            });
            this.started = true;
            this.dependentContexts.forEach((context)=>context.refresh());
        }
    }
    refresh() {
        this.selectorObserverMap.forEach((observer)=>observer.refresh());
        this.attributeObserverMap.forEach((observer)=>observer.refresh());
    }
    stop() {
        if (this.started) {
            this.started = false;
            this.disconnectAllOutlets();
            this.stopSelectorObservers();
            this.stopAttributeObservers();
        }
    }
    stopSelectorObservers() {
        if (this.selectorObserverMap.size > 0) {
            this.selectorObserverMap.forEach((observer)=>observer.stop());
            this.selectorObserverMap.clear();
        }
    }
    stopAttributeObservers() {
        if (this.attributeObserverMap.size > 0) {
            this.attributeObserverMap.forEach((observer)=>observer.stop());
            this.attributeObserverMap.clear();
        }
    }
    selectorMatched(element, _selector, { outletName: outletName }) {
        const outlet = this.getOutlet(element, outletName);
        if (outlet) this.connectOutlet(outlet, element, outletName);
    }
    selectorUnmatched(element, _selector, { outletName: outletName }) {
        const outlet = this.getOutletFromMap(element, outletName);
        if (outlet) this.disconnectOutlet(outlet, element, outletName);
    }
    selectorMatchElement(element, { outletName: outletName }) {
        const selector = this.selector(outletName);
        const hasOutlet = this.hasOutlet(element, outletName);
        const hasOutletController = element.matches(`[${this.schema.controllerAttribute}~=${outletName}]`);
        if (selector) return hasOutlet && hasOutletController && element.matches(selector);
        else return false;
    }
    elementMatchedAttribute(_element, attributeName) {
        const outletName = this.getOutletNameFromOutletAttributeName(attributeName);
        if (outletName) this.updateSelectorObserverForOutlet(outletName);
    }
    elementAttributeValueChanged(_element, attributeName) {
        const outletName = this.getOutletNameFromOutletAttributeName(attributeName);
        if (outletName) this.updateSelectorObserverForOutlet(outletName);
    }
    elementUnmatchedAttribute(_element, attributeName) {
        const outletName = this.getOutletNameFromOutletAttributeName(attributeName);
        if (outletName) this.updateSelectorObserverForOutlet(outletName);
    }
    connectOutlet(outlet, element, outletName) {
        var _a;
        if (!this.outletElementsByName.has(outletName, element)) {
            this.outletsByName.add(outletName, outlet);
            this.outletElementsByName.add(outletName, element);
            (_a = this.selectorObserverMap.get(outletName)) === null || _a === void 0 || _a.pause(()=>this.delegate.outletConnected(outlet, element, outletName));
        }
    }
    disconnectOutlet(outlet, element, outletName) {
        var _a;
        if (this.outletElementsByName.has(outletName, element)) {
            this.outletsByName.delete(outletName, outlet);
            this.outletElementsByName.delete(outletName, element);
            (_a = this.selectorObserverMap.get(outletName)) === null || _a === void 0 || _a.pause(()=>this.delegate.outletDisconnected(outlet, element, outletName));
        }
    }
    disconnectAllOutlets() {
        for (const outletName of this.outletElementsByName.keys){
            for (const element of this.outletElementsByName.getValuesForKey(outletName))for (const outlet of this.outletsByName.getValuesForKey(outletName))this.disconnectOutlet(outlet, element, outletName);
        }
    }
    updateSelectorObserverForOutlet(outletName) {
        const observer = this.selectorObserverMap.get(outletName);
        if (observer) observer.selector = this.selector(outletName);
    }
    setupSelectorObserverForOutlet(outletName) {
        const selector = this.selector(outletName);
        const selectorObserver = new $1e1b4d625d583414$export$116e0b48509995b(document.body, selector, this, {
            outletName: outletName
        });
        this.selectorObserverMap.set(outletName, selectorObserver);
        selectorObserver.start();
    }
    setupAttributeObserverForOutlet(outletName) {
        const attributeName = this.attributeNameForOutletName(outletName);
        const attributeObserver = new $1e1b4d625d583414$export$fe68319d413d05cb(this.scope.element, attributeName, this);
        this.attributeObserverMap.set(outletName, attributeObserver);
        attributeObserver.start();
    }
    selector(outletName) {
        return this.scope.outlets.getSelectorForOutletName(outletName);
    }
    attributeNameForOutletName(outletName) {
        return this.scope.schema.outletAttributeForScope(this.identifier, outletName);
    }
    getOutletNameFromOutletAttributeName(attributeName) {
        return this.outletDefinitions.find((outletName)=>this.attributeNameForOutletName(outletName) === attributeName);
    }
    get outletDependencies() {
        const dependencies = new $1e1b4d625d583414$export$8bd4ad37b76db6ba();
        this.router.modules.forEach((module)=>{
            const constructor = module.definition.controllerConstructor;
            const outlets = $1e1b4d625d583414$var$readInheritableStaticArrayValues(constructor, "outlets");
            outlets.forEach((outlet)=>dependencies.add(outlet, module.identifier));
        });
        return dependencies;
    }
    get outletDefinitions() {
        return this.outletDependencies.getKeysForValue(this.identifier);
    }
    get dependentControllerIdentifiers() {
        return this.outletDependencies.getValuesForKey(this.identifier);
    }
    get dependentContexts() {
        const identifiers = this.dependentControllerIdentifiers;
        return this.router.contexts.filter((context)=>identifiers.includes(context.identifier));
    }
    hasOutlet(element, outletName) {
        return !!this.getOutlet(element, outletName) || !!this.getOutletFromMap(element, outletName);
    }
    getOutlet(element, outletName) {
        return this.application.getControllerForElementAndIdentifier(element, outletName);
    }
    getOutletFromMap(element, outletName) {
        return this.outletsByName.getValuesForKey(outletName).find((outlet)=>outlet.element === element);
    }
    get scope() {
        return this.context.scope;
    }
    get schema() {
        return this.context.schema;
    }
    get identifier() {
        return this.context.identifier;
    }
    get application() {
        return this.context.application;
    }
    get router() {
        return this.application.router;
    }
}
class $1e1b4d625d583414$export$841858b892ce1f4c {
    constructor(module, scope){
        this.logDebugActivity = (functionName, detail = {})=>{
            const { identifier: identifier, controller: controller, element: element } = this;
            detail = Object.assign({
                identifier: identifier,
                controller: controller,
                element: element
            }, detail);
            this.application.logDebugActivity(this.identifier, functionName, detail);
        };
        this.module = module;
        this.scope = scope;
        this.controller = new module.controllerConstructor(this);
        this.bindingObserver = new $1e1b4d625d583414$var$BindingObserver(this, this.dispatcher);
        this.valueObserver = new $1e1b4d625d583414$var$ValueObserver(this, this.controller);
        this.targetObserver = new $1e1b4d625d583414$var$TargetObserver(this, this);
        this.outletObserver = new $1e1b4d625d583414$var$OutletObserver(this, this);
        try {
            this.controller.initialize();
            this.logDebugActivity("initialize");
        } catch (error) {
            this.handleError(error, "initializing controller");
        }
    }
    connect() {
        this.bindingObserver.start();
        this.valueObserver.start();
        this.targetObserver.start();
        this.outletObserver.start();
        try {
            this.controller.connect();
            this.logDebugActivity("connect");
        } catch (error) {
            this.handleError(error, "connecting controller");
        }
    }
    refresh() {
        this.outletObserver.refresh();
    }
    disconnect() {
        try {
            this.controller.disconnect();
            this.logDebugActivity("disconnect");
        } catch (error) {
            this.handleError(error, "disconnecting controller");
        }
        this.outletObserver.stop();
        this.targetObserver.stop();
        this.valueObserver.stop();
        this.bindingObserver.stop();
    }
    get application() {
        return this.module.application;
    }
    get identifier() {
        return this.module.identifier;
    }
    get schema() {
        return this.application.schema;
    }
    get dispatcher() {
        return this.application.dispatcher;
    }
    get element() {
        return this.scope.element;
    }
    get parentElement() {
        return this.element.parentElement;
    }
    handleError(error, message, detail = {}) {
        const { identifier: identifier, controller: controller, element: element } = this;
        detail = Object.assign({
            identifier: identifier,
            controller: controller,
            element: element
        }, detail);
        this.application.handleError(error, `Error ${message}`, detail);
    }
    targetConnected(element, name) {
        this.invokeControllerMethod(`${name}TargetConnected`, element);
    }
    targetDisconnected(element, name) {
        this.invokeControllerMethod(`${name}TargetDisconnected`, element);
    }
    outletConnected(outlet, element, name) {
        this.invokeControllerMethod(`${$1e1b4d625d583414$var$namespaceCamelize(name)}OutletConnected`, outlet, element);
    }
    outletDisconnected(outlet, element, name) {
        this.invokeControllerMethod(`${$1e1b4d625d583414$var$namespaceCamelize(name)}OutletDisconnected`, outlet, element);
    }
    invokeControllerMethod(methodName, ...args) {
        const controller = this.controller;
        if (typeof controller[methodName] == "function") controller[methodName](...args);
    }
}
function $1e1b4d625d583414$var$bless(constructor) {
    return $1e1b4d625d583414$var$shadow(constructor, $1e1b4d625d583414$var$getBlessedProperties(constructor));
}
function $1e1b4d625d583414$var$shadow(constructor, properties) {
    const shadowConstructor = $1e1b4d625d583414$var$extend(constructor);
    const shadowProperties = $1e1b4d625d583414$var$getShadowProperties(constructor.prototype, properties);
    Object.defineProperties(shadowConstructor.prototype, shadowProperties);
    return shadowConstructor;
}
function $1e1b4d625d583414$var$getBlessedProperties(constructor) {
    const blessings = $1e1b4d625d583414$var$readInheritableStaticArrayValues(constructor, "blessings");
    return blessings.reduce((blessedProperties, blessing)=>{
        const properties = blessing(constructor);
        for(const key in properties){
            const descriptor = blessedProperties[key] || {};
            blessedProperties[key] = Object.assign(descriptor, properties[key]);
        }
        return blessedProperties;
    }, {});
}
function $1e1b4d625d583414$var$getShadowProperties(prototype, properties) {
    return $1e1b4d625d583414$var$getOwnKeys(properties).reduce((shadowProperties, key)=>{
        const descriptor = $1e1b4d625d583414$var$getShadowedDescriptor(prototype, properties, key);
        if (descriptor) Object.assign(shadowProperties, {
            [key]: descriptor
        });
        return shadowProperties;
    }, {});
}
function $1e1b4d625d583414$var$getShadowedDescriptor(prototype, properties, key) {
    const shadowingDescriptor = Object.getOwnPropertyDescriptor(prototype, key);
    const shadowedByValue = shadowingDescriptor && "value" in shadowingDescriptor;
    if (!shadowedByValue) {
        const descriptor = Object.getOwnPropertyDescriptor(properties, key).value;
        if (shadowingDescriptor) {
            descriptor.get = shadowingDescriptor.get || descriptor.get;
            descriptor.set = shadowingDescriptor.set || descriptor.set;
        }
        return descriptor;
    }
}
const $1e1b4d625d583414$var$getOwnKeys = (()=>{
    if (typeof Object.getOwnPropertySymbols == "function") return (object)=>[
            ...Object.getOwnPropertyNames(object),
            ...Object.getOwnPropertySymbols(object)
        ];
    else return Object.getOwnPropertyNames;
})();
const $1e1b4d625d583414$var$extend = (()=>{
    function extendWithReflect(constructor) {
        function extended() {
            return Reflect.construct(constructor, arguments, new.target);
        }
        extended.prototype = Object.create(constructor.prototype, {
            constructor: {
                value: extended
            }
        });
        Reflect.setPrototypeOf(extended, constructor);
        return extended;
    }
    function testReflectExtension() {
        const a = function() {
            this.a.call(this);
        };
        const b = extendWithReflect(a);
        b.prototype.a = function() {};
        return new b();
    }
    try {
        testReflectExtension();
        return extendWithReflect;
    } catch (error) {
        return (constructor)=>class extended extends constructor {
            };
    }
})();
function $1e1b4d625d583414$var$blessDefinition(definition) {
    return {
        identifier: definition.identifier,
        controllerConstructor: $1e1b4d625d583414$var$bless(definition.controllerConstructor)
    };
}
class $1e1b4d625d583414$var$Module {
    constructor(application, definition){
        this.application = application;
        this.definition = $1e1b4d625d583414$var$blessDefinition(definition);
        this.contextsByScope = new WeakMap();
        this.connectedContexts = new Set();
    }
    get identifier() {
        return this.definition.identifier;
    }
    get controllerConstructor() {
        return this.definition.controllerConstructor;
    }
    get contexts() {
        return Array.from(this.connectedContexts);
    }
    connectContextForScope(scope) {
        const context = this.fetchContextForScope(scope);
        this.connectedContexts.add(context);
        context.connect();
    }
    disconnectContextForScope(scope) {
        const context = this.contextsByScope.get(scope);
        if (context) {
            this.connectedContexts.delete(context);
            context.disconnect();
        }
    }
    fetchContextForScope(scope) {
        let context = this.contextsByScope.get(scope);
        if (!context) {
            context = new $1e1b4d625d583414$export$841858b892ce1f4c(this, scope);
            this.contextsByScope.set(scope, context);
        }
        return context;
    }
}
class $1e1b4d625d583414$var$ClassMap {
    constructor(scope){
        this.scope = scope;
    }
    has(name) {
        return this.data.has(this.getDataKey(name));
    }
    get(name) {
        return this.getAll(name)[0];
    }
    getAll(name) {
        const tokenString = this.data.get(this.getDataKey(name)) || "";
        return $1e1b4d625d583414$var$tokenize(tokenString);
    }
    getAttributeName(name) {
        return this.data.getAttributeNameForKey(this.getDataKey(name));
    }
    getDataKey(name) {
        return `${name}-class`;
    }
    get data() {
        return this.scope.data;
    }
}
class $1e1b4d625d583414$var$DataMap {
    constructor(scope){
        this.scope = scope;
    }
    get element() {
        return this.scope.element;
    }
    get identifier() {
        return this.scope.identifier;
    }
    get(key) {
        const name = this.getAttributeNameForKey(key);
        return this.element.getAttribute(name);
    }
    set(key, value) {
        const name = this.getAttributeNameForKey(key);
        this.element.setAttribute(name, value);
        return this.get(key);
    }
    has(key) {
        const name = this.getAttributeNameForKey(key);
        return this.element.hasAttribute(name);
    }
    delete(key) {
        if (this.has(key)) {
            const name = this.getAttributeNameForKey(key);
            this.element.removeAttribute(name);
            return true;
        } else return false;
    }
    getAttributeNameForKey(key) {
        return `data-${this.identifier}-${$1e1b4d625d583414$var$dasherize(key)}`;
    }
}
class $1e1b4d625d583414$var$Guide {
    constructor(logger){
        this.warnedKeysByObject = new WeakMap();
        this.logger = logger;
    }
    warn(object, key, message) {
        let warnedKeys = this.warnedKeysByObject.get(object);
        if (!warnedKeys) {
            warnedKeys = new Set();
            this.warnedKeysByObject.set(object, warnedKeys);
        }
        if (!warnedKeys.has(key)) {
            warnedKeys.add(key);
            this.logger.warn(message, object);
        }
    }
}
function $1e1b4d625d583414$var$attributeValueContainsToken(attributeName, token) {
    return `[${attributeName}~="${token}"]`;
}
class $1e1b4d625d583414$var$TargetSet {
    constructor(scope){
        this.scope = scope;
    }
    get element() {
        return this.scope.element;
    }
    get identifier() {
        return this.scope.identifier;
    }
    get schema() {
        return this.scope.schema;
    }
    has(targetName) {
        return this.find(targetName) != null;
    }
    find(...targetNames) {
        return targetNames.reduce((target, targetName)=>target || this.findTarget(targetName) || this.findLegacyTarget(targetName), undefined);
    }
    findAll(...targetNames) {
        return targetNames.reduce((targets, targetName)=>[
                ...targets,
                ...this.findAllTargets(targetName),
                ...this.findAllLegacyTargets(targetName)
            ], []);
    }
    findTarget(targetName) {
        const selector = this.getSelectorForTargetName(targetName);
        return this.scope.findElement(selector);
    }
    findAllTargets(targetName) {
        const selector = this.getSelectorForTargetName(targetName);
        return this.scope.findAllElements(selector);
    }
    getSelectorForTargetName(targetName) {
        const attributeName = this.schema.targetAttributeForScope(this.identifier);
        return $1e1b4d625d583414$var$attributeValueContainsToken(attributeName, targetName);
    }
    findLegacyTarget(targetName) {
        const selector = this.getLegacySelectorForTargetName(targetName);
        return this.deprecate(this.scope.findElement(selector), targetName);
    }
    findAllLegacyTargets(targetName) {
        const selector = this.getLegacySelectorForTargetName(targetName);
        return this.scope.findAllElements(selector).map((element)=>this.deprecate(element, targetName));
    }
    getLegacySelectorForTargetName(targetName) {
        const targetDescriptor = `${this.identifier}.${targetName}`;
        return $1e1b4d625d583414$var$attributeValueContainsToken(this.schema.targetAttribute, targetDescriptor);
    }
    deprecate(element, targetName) {
        if (element) {
            const { identifier: identifier } = this;
            const attributeName = this.schema.targetAttribute;
            const revisedAttributeName = this.schema.targetAttributeForScope(identifier);
            this.guide.warn(element, `target:${targetName}`, `Please replace ${attributeName}="${identifier}.${targetName}" with ${revisedAttributeName}="${targetName}". ` + `The ${attributeName} attribute is deprecated and will be removed in a future version of Stimulus.`);
        }
        return element;
    }
    get guide() {
        return this.scope.guide;
    }
}
class $1e1b4d625d583414$var$OutletSet {
    constructor(scope, controllerElement){
        this.scope = scope;
        this.controllerElement = controllerElement;
    }
    get element() {
        return this.scope.element;
    }
    get identifier() {
        return this.scope.identifier;
    }
    get schema() {
        return this.scope.schema;
    }
    has(outletName) {
        return this.find(outletName) != null;
    }
    find(...outletNames) {
        return outletNames.reduce((outlet, outletName)=>outlet || this.findOutlet(outletName), undefined);
    }
    findAll(...outletNames) {
        return outletNames.reduce((outlets, outletName)=>[
                ...outlets,
                ...this.findAllOutlets(outletName)
            ], []);
    }
    getSelectorForOutletName(outletName) {
        const attributeName = this.schema.outletAttributeForScope(this.identifier, outletName);
        return this.controllerElement.getAttribute(attributeName);
    }
    findOutlet(outletName) {
        const selector = this.getSelectorForOutletName(outletName);
        if (selector) return this.findElement(selector, outletName);
    }
    findAllOutlets(outletName) {
        const selector = this.getSelectorForOutletName(outletName);
        return selector ? this.findAllElements(selector, outletName) : [];
    }
    findElement(selector, outletName) {
        const elements = this.scope.queryElements(selector);
        return elements.filter((element)=>this.matchesElement(element, selector, outletName))[0];
    }
    findAllElements(selector, outletName) {
        const elements = this.scope.queryElements(selector);
        return elements.filter((element)=>this.matchesElement(element, selector, outletName));
    }
    matchesElement(element, selector, outletName) {
        const controllerAttribute = element.getAttribute(this.scope.schema.controllerAttribute) || "";
        return element.matches(selector) && controllerAttribute.split(" ").includes(outletName);
    }
}
class $1e1b4d625d583414$var$Scope {
    constructor(schema, element, identifier, logger){
        this.targets = new $1e1b4d625d583414$var$TargetSet(this);
        this.classes = new $1e1b4d625d583414$var$ClassMap(this);
        this.data = new $1e1b4d625d583414$var$DataMap(this);
        this.containsElement = (element)=>{
            return element.closest(this.controllerSelector) === this.element;
        };
        this.schema = schema;
        this.element = element;
        this.identifier = identifier;
        this.guide = new $1e1b4d625d583414$var$Guide(logger);
        this.outlets = new $1e1b4d625d583414$var$OutletSet(this.documentScope, element);
    }
    findElement(selector) {
        return this.element.matches(selector) ? this.element : this.queryElements(selector).find(this.containsElement);
    }
    findAllElements(selector) {
        return [
            ...this.element.matches(selector) ? [
                this.element
            ] : [],
            ...this.queryElements(selector).filter(this.containsElement)
        ];
    }
    queryElements(selector) {
        return Array.from(this.element.querySelectorAll(selector));
    }
    get controllerSelector() {
        return $1e1b4d625d583414$var$attributeValueContainsToken(this.schema.controllerAttribute, this.identifier);
    }
    get isDocumentScope() {
        return this.element === document.documentElement;
    }
    get documentScope() {
        return this.isDocumentScope ? this : new $1e1b4d625d583414$var$Scope(this.schema, document.documentElement, this.identifier, this.guide.logger);
    }
}
class $1e1b4d625d583414$var$ScopeObserver {
    constructor(element, schema, delegate){
        this.element = element;
        this.schema = schema;
        this.delegate = delegate;
        this.valueListObserver = new $1e1b4d625d583414$export$d27fa4c7330a452e(this.element, this.controllerAttribute, this);
        this.scopesByIdentifierByElement = new WeakMap();
        this.scopeReferenceCounts = new WeakMap();
    }
    start() {
        this.valueListObserver.start();
    }
    stop() {
        this.valueListObserver.stop();
    }
    get controllerAttribute() {
        return this.schema.controllerAttribute;
    }
    parseValueForToken(token) {
        const { element: element, content: identifier } = token;
        return this.parseValueForElementAndIdentifier(element, identifier);
    }
    parseValueForElementAndIdentifier(element, identifier) {
        const scopesByIdentifier = this.fetchScopesByIdentifierForElement(element);
        let scope = scopesByIdentifier.get(identifier);
        if (!scope) {
            scope = this.delegate.createScopeForElementAndIdentifier(element, identifier);
            scopesByIdentifier.set(identifier, scope);
        }
        return scope;
    }
    elementMatchedValue(element, value) {
        const referenceCount = (this.scopeReferenceCounts.get(value) || 0) + 1;
        this.scopeReferenceCounts.set(value, referenceCount);
        if (referenceCount == 1) this.delegate.scopeConnected(value);
    }
    elementUnmatchedValue(element, value) {
        const referenceCount = this.scopeReferenceCounts.get(value);
        if (referenceCount) {
            this.scopeReferenceCounts.set(value, referenceCount - 1);
            if (referenceCount == 1) this.delegate.scopeDisconnected(value);
        }
    }
    fetchScopesByIdentifierForElement(element) {
        let scopesByIdentifier = this.scopesByIdentifierByElement.get(element);
        if (!scopesByIdentifier) {
            scopesByIdentifier = new Map();
            this.scopesByIdentifierByElement.set(element, scopesByIdentifier);
        }
        return scopesByIdentifier;
    }
}
class $1e1b4d625d583414$var$Router {
    constructor(application){
        this.application = application;
        this.scopeObserver = new $1e1b4d625d583414$var$ScopeObserver(this.element, this.schema, this);
        this.scopesByIdentifier = new $1e1b4d625d583414$export$8bd4ad37b76db6ba();
        this.modulesByIdentifier = new Map();
    }
    get element() {
        return this.application.element;
    }
    get schema() {
        return this.application.schema;
    }
    get logger() {
        return this.application.logger;
    }
    get controllerAttribute() {
        return this.schema.controllerAttribute;
    }
    get modules() {
        return Array.from(this.modulesByIdentifier.values());
    }
    get contexts() {
        return this.modules.reduce((contexts, module)=>contexts.concat(module.contexts), []);
    }
    start() {
        this.scopeObserver.start();
    }
    stop() {
        this.scopeObserver.stop();
    }
    loadDefinition(definition) {
        this.unloadIdentifier(definition.identifier);
        const module = new $1e1b4d625d583414$var$Module(this.application, definition);
        this.connectModule(module);
        const afterLoad = definition.controllerConstructor.afterLoad;
        if (afterLoad) afterLoad.call(definition.controllerConstructor, definition.identifier, this.application);
    }
    unloadIdentifier(identifier) {
        const module = this.modulesByIdentifier.get(identifier);
        if (module) this.disconnectModule(module);
    }
    getContextForElementAndIdentifier(element, identifier) {
        const module = this.modulesByIdentifier.get(identifier);
        if (module) return module.contexts.find((context)=>context.element == element);
    }
    proposeToConnectScopeForElementAndIdentifier(element, identifier) {
        const scope = this.scopeObserver.parseValueForElementAndIdentifier(element, identifier);
        if (scope) this.scopeObserver.elementMatchedValue(scope.element, scope);
        else console.error(`Couldn't find or create scope for identifier: "${identifier}" and element:`, element);
    }
    handleError(error, message, detail) {
        this.application.handleError(error, message, detail);
    }
    createScopeForElementAndIdentifier(element, identifier) {
        return new $1e1b4d625d583414$var$Scope(this.schema, element, identifier, this.logger);
    }
    scopeConnected(scope) {
        this.scopesByIdentifier.add(scope.identifier, scope);
        const module = this.modulesByIdentifier.get(scope.identifier);
        if (module) module.connectContextForScope(scope);
    }
    scopeDisconnected(scope) {
        this.scopesByIdentifier.delete(scope.identifier, scope);
        const module = this.modulesByIdentifier.get(scope.identifier);
        if (module) module.disconnectContextForScope(scope);
    }
    connectModule(module) {
        this.modulesByIdentifier.set(module.identifier, module);
        const scopes = this.scopesByIdentifier.getValuesForKey(module.identifier);
        scopes.forEach((scope)=>module.connectContextForScope(scope));
    }
    disconnectModule(module) {
        this.modulesByIdentifier.delete(module.identifier);
        const scopes = this.scopesByIdentifier.getValuesForKey(module.identifier);
        scopes.forEach((scope)=>module.disconnectContextForScope(scope));
    }
}
const $1e1b4d625d583414$export$1db618b7b2275ea1 = {
    controllerAttribute: "data-controller",
    actionAttribute: "data-action",
    targetAttribute: "data-target",
    targetAttributeForScope: (identifier)=>`data-${identifier}-target`,
    outletAttributeForScope: (identifier, outlet)=>`data-${identifier}-${outlet}-outlet`,
    keyMappings: Object.assign(Object.assign({
        enter: "Enter",
        tab: "Tab",
        esc: "Escape",
        space: " ",
        up: "ArrowUp",
        down: "ArrowDown",
        left: "ArrowLeft",
        right: "ArrowRight",
        home: "Home",
        end: "End",
        page_up: "PageUp",
        page_down: "PageDown"
    }, $1e1b4d625d583414$var$objectFromEntries("abcdefghijklmnopqrstuvwxyz".split("").map((c)=>[
            c,
            c
        ]))), $1e1b4d625d583414$var$objectFromEntries("0123456789".split("").map((n)=>[
            n,
            n
        ])))
};
function $1e1b4d625d583414$var$objectFromEntries(array) {
    return array.reduce((memo, [k, v])=>Object.assign(Object.assign({}, memo), {
            [k]: v
        }), {});
}
class $1e1b4d625d583414$export$16975c34e60e1e61 {
    constructor(element = document.documentElement, schema = $1e1b4d625d583414$export$1db618b7b2275ea1){
        this.logger = console;
        this.debug = false;
        this.logDebugActivity = (identifier, functionName, detail = {})=>{
            if (this.debug) this.logFormattedMessage(identifier, functionName, detail);
        };
        this.element = element;
        this.schema = schema;
        this.dispatcher = new $1e1b4d625d583414$var$Dispatcher(this);
        this.router = new $1e1b4d625d583414$var$Router(this);
        this.actionDescriptorFilters = Object.assign({}, $1e1b4d625d583414$var$defaultActionDescriptorFilters);
    }
    static start(element, schema) {
        const application = new this(element, schema);
        application.start();
        return application;
    }
    async start() {
        await $1e1b4d625d583414$var$domReady();
        this.logDebugActivity("application", "starting");
        this.dispatcher.start();
        this.router.start();
        this.logDebugActivity("application", "start");
    }
    stop() {
        this.logDebugActivity("application", "stopping");
        this.dispatcher.stop();
        this.router.stop();
        this.logDebugActivity("application", "stop");
    }
    register(identifier, controllerConstructor) {
        this.load({
            identifier: identifier,
            controllerConstructor: controllerConstructor
        });
    }
    registerActionOption(name, filter) {
        this.actionDescriptorFilters[name] = filter;
    }
    load(head, ...rest) {
        const definitions = Array.isArray(head) ? head : [
            head,
            ...rest
        ];
        definitions.forEach((definition)=>{
            if (definition.controllerConstructor.shouldLoad) this.router.loadDefinition(definition);
        });
    }
    unload(head, ...rest) {
        const identifiers = Array.isArray(head) ? head : [
            head,
            ...rest
        ];
        identifiers.forEach((identifier)=>this.router.unloadIdentifier(identifier));
    }
    get controllers() {
        return this.router.contexts.map((context)=>context.controller);
    }
    getControllerForElementAndIdentifier(element, identifier) {
        const context = this.router.getContextForElementAndIdentifier(element, identifier);
        return context ? context.controller : null;
    }
    handleError(error, message, detail) {
        var _a;
        this.logger.error(`%s\n\n%o\n\n%o`, message, error, detail);
        (_a = window.onerror) === null || _a === void 0 || _a.call(window, message, "", 0, 0, error);
    }
    logFormattedMessage(identifier, functionName, detail = {}) {
        detail = Object.assign({
            application: this
        }, detail);
        this.logger.groupCollapsed(`${identifier} #${functionName}`);
        this.logger.log("details:", Object.assign({}, detail));
        this.logger.groupEnd();
    }
}
function $1e1b4d625d583414$var$domReady() {
    return new Promise((resolve)=>{
        if (document.readyState == "loading") document.addEventListener("DOMContentLoaded", ()=>resolve());
        else resolve();
    });
}
function $1e1b4d625d583414$var$ClassPropertiesBlessing(constructor) {
    const classes = $1e1b4d625d583414$var$readInheritableStaticArrayValues(constructor, "classes");
    return classes.reduce((properties, classDefinition)=>{
        return Object.assign(properties, $1e1b4d625d583414$var$propertiesForClassDefinition(classDefinition));
    }, {});
}
function $1e1b4d625d583414$var$propertiesForClassDefinition(key) {
    return {
        [`${key}Class`]: {
            get () {
                const { classes: classes } = this;
                if (classes.has(key)) return classes.get(key);
                else {
                    const attribute = classes.getAttributeName(key);
                    throw new Error(`Missing attribute "${attribute}"`);
                }
            }
        },
        [`${key}Classes`]: {
            get () {
                return this.classes.getAll(key);
            }
        },
        [`has${$1e1b4d625d583414$var$capitalize(key)}Class`]: {
            get () {
                return this.classes.has(key);
            }
        }
    };
}
function $1e1b4d625d583414$var$OutletPropertiesBlessing(constructor) {
    const outlets = $1e1b4d625d583414$var$readInheritableStaticArrayValues(constructor, "outlets");
    return outlets.reduce((properties, outletDefinition)=>{
        return Object.assign(properties, $1e1b4d625d583414$var$propertiesForOutletDefinition(outletDefinition));
    }, {});
}
function $1e1b4d625d583414$var$getOutletController(controller, element, identifier) {
    return controller.application.getControllerForElementAndIdentifier(element, identifier);
}
function $1e1b4d625d583414$var$getControllerAndEnsureConnectedScope(controller, element, outletName) {
    let outletController = $1e1b4d625d583414$var$getOutletController(controller, element, outletName);
    if (outletController) return outletController;
    controller.application.router.proposeToConnectScopeForElementAndIdentifier(element, outletName);
    outletController = $1e1b4d625d583414$var$getOutletController(controller, element, outletName);
    if (outletController) return outletController;
}
function $1e1b4d625d583414$var$propertiesForOutletDefinition(name) {
    const camelizedName = $1e1b4d625d583414$var$namespaceCamelize(name);
    return {
        [`${camelizedName}Outlet`]: {
            get () {
                const outletElement = this.outlets.find(name);
                const selector = this.outlets.getSelectorForOutletName(name);
                if (outletElement) {
                    const outletController = $1e1b4d625d583414$var$getControllerAndEnsureConnectedScope(this, outletElement, name);
                    if (outletController) return outletController;
                    throw new Error(`The provided outlet element is missing an outlet controller "${name}" instance for host controller "${this.identifier}"`);
                }
                throw new Error(`Missing outlet element "${name}" for host controller "${this.identifier}". Stimulus couldn't find a matching outlet element using selector "${selector}".`);
            }
        },
        [`${camelizedName}Outlets`]: {
            get () {
                const outlets = this.outlets.findAll(name);
                if (outlets.length > 0) return outlets.map((outletElement)=>{
                    const outletController = $1e1b4d625d583414$var$getControllerAndEnsureConnectedScope(this, outletElement, name);
                    if (outletController) return outletController;
                    console.warn(`The provided outlet element is missing an outlet controller "${name}" instance for host controller "${this.identifier}"`, outletElement);
                }).filter((controller)=>controller);
                return [];
            }
        },
        [`${camelizedName}OutletElement`]: {
            get () {
                const outletElement = this.outlets.find(name);
                const selector = this.outlets.getSelectorForOutletName(name);
                if (outletElement) return outletElement;
                else throw new Error(`Missing outlet element "${name}" for host controller "${this.identifier}". Stimulus couldn't find a matching outlet element using selector "${selector}".`);
            }
        },
        [`${camelizedName}OutletElements`]: {
            get () {
                return this.outlets.findAll(name);
            }
        },
        [`has${$1e1b4d625d583414$var$capitalize(camelizedName)}Outlet`]: {
            get () {
                return this.outlets.has(name);
            }
        }
    };
}
function $1e1b4d625d583414$var$TargetPropertiesBlessing(constructor) {
    const targets = $1e1b4d625d583414$var$readInheritableStaticArrayValues(constructor, "targets");
    return targets.reduce((properties, targetDefinition)=>{
        return Object.assign(properties, $1e1b4d625d583414$var$propertiesForTargetDefinition(targetDefinition));
    }, {});
}
function $1e1b4d625d583414$var$propertiesForTargetDefinition(name) {
    return {
        [`${name}Target`]: {
            get () {
                const target = this.targets.find(name);
                if (target) return target;
                else throw new Error(`Missing target element "${name}" for "${this.identifier}" controller`);
            }
        },
        [`${name}Targets`]: {
            get () {
                return this.targets.findAll(name);
            }
        },
        [`has${$1e1b4d625d583414$var$capitalize(name)}Target`]: {
            get () {
                return this.targets.has(name);
            }
        }
    };
}
function $1e1b4d625d583414$var$ValuePropertiesBlessing(constructor) {
    const valueDefinitionPairs = $1e1b4d625d583414$var$readInheritableStaticObjectPairs(constructor, "values");
    const propertyDescriptorMap = {
        valueDescriptorMap: {
            get () {
                return valueDefinitionPairs.reduce((result, valueDefinitionPair)=>{
                    const valueDescriptor = $1e1b4d625d583414$var$parseValueDefinitionPair(valueDefinitionPair, this.identifier);
                    const attributeName = this.data.getAttributeNameForKey(valueDescriptor.key);
                    return Object.assign(result, {
                        [attributeName]: valueDescriptor
                    });
                }, {});
            }
        }
    };
    return valueDefinitionPairs.reduce((properties, valueDefinitionPair)=>{
        return Object.assign(properties, $1e1b4d625d583414$var$propertiesForValueDefinitionPair(valueDefinitionPair));
    }, propertyDescriptorMap);
}
function $1e1b4d625d583414$var$propertiesForValueDefinitionPair(valueDefinitionPair, controller) {
    const definition = $1e1b4d625d583414$var$parseValueDefinitionPair(valueDefinitionPair, controller);
    const { key: key, name: name, reader: read, writer: write } = definition;
    return {
        [name]: {
            get () {
                const value = this.data.get(key);
                if (value !== null) return read(value);
                else return definition.defaultValue;
            },
            set (value) {
                if (value === undefined) this.data.delete(key);
                else this.data.set(key, write(value));
            }
        },
        [`has${$1e1b4d625d583414$var$capitalize(name)}`]: {
            get () {
                return this.data.has(key) || definition.hasCustomDefaultValue;
            }
        }
    };
}
function $1e1b4d625d583414$var$parseValueDefinitionPair([token, typeDefinition], controller) {
    return $1e1b4d625d583414$var$valueDescriptorForTokenAndTypeDefinition({
        controller: controller,
        token: token,
        typeDefinition: typeDefinition
    });
}
function $1e1b4d625d583414$var$parseValueTypeConstant(constant) {
    switch(constant){
        case Array:
            return "array";
        case Boolean:
            return "boolean";
        case Number:
            return "number";
        case Object:
            return "object";
        case String:
            return "string";
    }
}
function $1e1b4d625d583414$var$parseValueTypeDefault(defaultValue) {
    switch(typeof defaultValue){
        case "boolean":
            return "boolean";
        case "number":
            return "number";
        case "string":
            return "string";
    }
    if (Array.isArray(defaultValue)) return "array";
    if (Object.prototype.toString.call(defaultValue) === "[object Object]") return "object";
}
function $1e1b4d625d583414$var$parseValueTypeObject(payload) {
    const { controller: controller, token: token, typeObject: typeObject } = payload;
    const hasType = $1e1b4d625d583414$var$isSomething(typeObject.type);
    const hasDefault = $1e1b4d625d583414$var$isSomething(typeObject.default);
    const fullObject = hasType && hasDefault;
    const onlyType = hasType && !hasDefault;
    const onlyDefault = !hasType && hasDefault;
    const typeFromObject = $1e1b4d625d583414$var$parseValueTypeConstant(typeObject.type);
    const typeFromDefaultValue = $1e1b4d625d583414$var$parseValueTypeDefault(payload.typeObject.default);
    if (onlyType) return typeFromObject;
    if (onlyDefault) return typeFromDefaultValue;
    if (typeFromObject !== typeFromDefaultValue) {
        const propertyPath = controller ? `${controller}.${token}` : token;
        throw new Error(`The specified default value for the Stimulus Value "${propertyPath}" must match the defined type "${typeFromObject}". The provided default value of "${typeObject.default}" is of type "${typeFromDefaultValue}".`);
    }
    if (fullObject) return typeFromObject;
}
function $1e1b4d625d583414$var$parseValueTypeDefinition(payload) {
    const { controller: controller, token: token, typeDefinition: typeDefinition } = payload;
    const typeObject = {
        controller: controller,
        token: token,
        typeObject: typeDefinition
    };
    const typeFromObject = $1e1b4d625d583414$var$parseValueTypeObject(typeObject);
    const typeFromDefaultValue = $1e1b4d625d583414$var$parseValueTypeDefault(typeDefinition);
    const typeFromConstant = $1e1b4d625d583414$var$parseValueTypeConstant(typeDefinition);
    const type = typeFromObject || typeFromDefaultValue || typeFromConstant;
    if (type) return type;
    const propertyPath = controller ? `${controller}.${typeDefinition}` : token;
    throw new Error(`Unknown value type "${propertyPath}" for "${token}" value`);
}
function $1e1b4d625d583414$var$defaultValueForDefinition(typeDefinition) {
    const constant = $1e1b4d625d583414$var$parseValueTypeConstant(typeDefinition);
    if (constant) return $1e1b4d625d583414$var$defaultValuesByType[constant];
    const hasDefault = $1e1b4d625d583414$var$hasProperty(typeDefinition, "default");
    const hasType = $1e1b4d625d583414$var$hasProperty(typeDefinition, "type");
    const typeObject = typeDefinition;
    if (hasDefault) return typeObject.default;
    if (hasType) {
        const { type: type } = typeObject;
        const constantFromType = $1e1b4d625d583414$var$parseValueTypeConstant(type);
        if (constantFromType) return $1e1b4d625d583414$var$defaultValuesByType[constantFromType];
    }
    return typeDefinition;
}
function $1e1b4d625d583414$var$valueDescriptorForTokenAndTypeDefinition(payload) {
    const { token: token, typeDefinition: typeDefinition } = payload;
    const key = `${$1e1b4d625d583414$var$dasherize(token)}-value`;
    const type = $1e1b4d625d583414$var$parseValueTypeDefinition(payload);
    return {
        type: type,
        key: key,
        name: $1e1b4d625d583414$var$camelize(key),
        get defaultValue () {
            return $1e1b4d625d583414$var$defaultValueForDefinition(typeDefinition);
        },
        get hasCustomDefaultValue () {
            return $1e1b4d625d583414$var$parseValueTypeDefault(typeDefinition) !== undefined;
        },
        reader: $1e1b4d625d583414$var$readers[type],
        writer: $1e1b4d625d583414$var$writers[type] || $1e1b4d625d583414$var$writers.default
    };
}
const $1e1b4d625d583414$var$defaultValuesByType = {
    get array () {
        return [];
    },
    boolean: false,
    number: 0,
    get object () {
        return {};
    },
    string: ""
};
const $1e1b4d625d583414$var$readers = {
    array (value) {
        const array = JSON.parse(value);
        if (!Array.isArray(array)) throw new TypeError(`expected value of type "array" but instead got value "${value}" of type "${$1e1b4d625d583414$var$parseValueTypeDefault(array)}"`);
        return array;
    },
    boolean (value) {
        return !(value == "0" || String(value).toLowerCase() == "false");
    },
    number (value) {
        return Number(value.replace(/_/g, ""));
    },
    object (value) {
        const object = JSON.parse(value);
        if (object === null || typeof object != "object" || Array.isArray(object)) throw new TypeError(`expected value of type "object" but instead got value "${value}" of type "${$1e1b4d625d583414$var$parseValueTypeDefault(object)}"`);
        return object;
    },
    string (value) {
        return value;
    }
};
const $1e1b4d625d583414$var$writers = {
    default: $1e1b4d625d583414$var$writeString,
    array: $1e1b4d625d583414$var$writeJSON,
    object: $1e1b4d625d583414$var$writeJSON
};
function $1e1b4d625d583414$var$writeJSON(value) {
    return JSON.stringify(value);
}
function $1e1b4d625d583414$var$writeString(value) {
    return `${value}`;
}
class $1e1b4d625d583414$export$bd0bf19f25da8474 {
    constructor(context){
        this.context = context;
    }
    static get shouldLoad() {
        return true;
    }
    static afterLoad(_identifier, _application) {
        return;
    }
    get application() {
        return this.context.application;
    }
    get scope() {
        return this.context.scope;
    }
    get element() {
        return this.scope.element;
    }
    get identifier() {
        return this.scope.identifier;
    }
    get targets() {
        return this.scope.targets;
    }
    get outlets() {
        return this.scope.outlets;
    }
    get classes() {
        return this.scope.classes;
    }
    get data() {
        return this.scope.data;
    }
    initialize() {}
    connect() {}
    disconnect() {}
    dispatch(eventName, { target: target = this.element, detail: detail = {}, prefix: prefix = this.identifier, bubbles: bubbles = true, cancelable: cancelable = true } = {}) {
        const type = prefix ? `${prefix}:${eventName}` : eventName;
        const event = new CustomEvent(type, {
            detail: detail,
            bubbles: bubbles,
            cancelable: cancelable
        });
        target.dispatchEvent(event);
        return event;
    }
}
$1e1b4d625d583414$export$bd0bf19f25da8474.blessings = [
    $1e1b4d625d583414$var$ClassPropertiesBlessing,
    $1e1b4d625d583414$var$TargetPropertiesBlessing,
    $1e1b4d625d583414$var$ValuePropertiesBlessing,
    $1e1b4d625d583414$var$OutletPropertiesBlessing
];
$1e1b4d625d583414$export$bd0bf19f25da8474.targets = [];
$1e1b4d625d583414$export$bd0bf19f25da8474.outlets = [];
$1e1b4d625d583414$export$bd0bf19f25da8474.values = {};


/*
Turbo 7.3.0
Copyright © 2023 37signals LLC
 */ (function() {
    if (window.Reflect === undefined || window.customElements === undefined || window.customElements.polyfillWrapFlushCallback) return;
    const BuiltInHTMLElement = HTMLElement;
    const wrapperForTheName = {
        HTMLElement: function HTMLElement1() {
            return Reflect.construct(BuiltInHTMLElement, [], this.constructor);
        }
    };
    window.HTMLElement = wrapperForTheName["HTMLElement"];
    HTMLElement.prototype = BuiltInHTMLElement.prototype;
    HTMLElement.prototype.constructor = HTMLElement;
    Object.setPrototypeOf(HTMLElement, BuiltInHTMLElement);
})();
/**
 * The MIT License (MIT)
 * 
 * Copyright (c) 2019 Javan Makhmali
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ (function(prototype) {
    if (typeof prototype.requestSubmit == "function") return;
    prototype.requestSubmit = function(submitter) {
        if (submitter) {
            validateSubmitter(submitter, this);
            submitter.click();
        } else {
            submitter = document.createElement("input");
            submitter.type = "submit";
            submitter.hidden = true;
            this.appendChild(submitter);
            submitter.click();
            this.removeChild(submitter);
        }
    };
    function validateSubmitter(submitter, form) {
        submitter instanceof HTMLElement || raise(TypeError, "parameter 1 is not of type 'HTMLElement'");
        submitter.type == "submit" || raise(TypeError, "The specified element is not a submit button");
        submitter.form == form || raise(DOMException, "The specified element is not owned by this form element", "NotFoundError");
    }
    function raise(errorConstructor, message, name) {
        throw new errorConstructor("Failed to execute 'requestSubmit' on 'HTMLFormElement': " + message + ".", name);
    }
})(HTMLFormElement.prototype);
const $dae3d0e46d061380$var$submittersByForm = new WeakMap();
function $dae3d0e46d061380$var$findSubmitterFromClickTarget(target) {
    const element = target instanceof Element ? target : target instanceof Node ? target.parentElement : null;
    const candidate = element ? element.closest("input, button") : null;
    return (candidate === null || candidate === void 0 ? void 0 : candidate.type) == "submit" ? candidate : null;
}
function $dae3d0e46d061380$var$clickCaptured(event) {
    const submitter = $dae3d0e46d061380$var$findSubmitterFromClickTarget(event.target);
    if (submitter && submitter.form) $dae3d0e46d061380$var$submittersByForm.set(submitter.form, submitter);
}
(function() {
    if ("submitter" in Event.prototype) return;
    let prototype = window.Event.prototype;
    if ("SubmitEvent" in window && /Apple Computer/.test(navigator.vendor)) prototype = window.SubmitEvent.prototype;
    else if ("SubmitEvent" in window) return;
    addEventListener("click", $dae3d0e46d061380$var$clickCaptured, true);
    Object.defineProperty(prototype, "submitter", {
        get () {
            if (this.type == "submit" && this.target instanceof HTMLFormElement) return $dae3d0e46d061380$var$submittersByForm.get(this.target);
        }
    });
})();
var $dae3d0e46d061380$export$65f98fefe20dbcb6;
(function(FrameLoadingStyle) {
    FrameLoadingStyle["eager"] = "eager";
    FrameLoadingStyle["lazy"] = "lazy";
})($dae3d0e46d061380$export$65f98fefe20dbcb6 || ($dae3d0e46d061380$export$65f98fefe20dbcb6 = {}));
class $dae3d0e46d061380$export$f464a8f0ffa32c44 extends HTMLElement {
    static get observedAttributes() {
        return [
            "disabled",
            "complete",
            "loading",
            "src"
        ];
    }
    constructor(){
        super();
        this.loaded = Promise.resolve();
        this.delegate = new $dae3d0e46d061380$export$f464a8f0ffa32c44.delegateConstructor(this);
    }
    connectedCallback() {
        this.delegate.connect();
    }
    disconnectedCallback() {
        this.delegate.disconnect();
    }
    reload() {
        return this.delegate.sourceURLReloaded();
    }
    attributeChangedCallback(name) {
        if (name == "loading") this.delegate.loadingStyleChanged();
        else if (name == "complete") this.delegate.completeChanged();
        else if (name == "src") this.delegate.sourceURLChanged();
        else this.delegate.disabledChanged();
    }
    get src() {
        return this.getAttribute("src");
    }
    set src(value) {
        if (value) this.setAttribute("src", value);
        else this.removeAttribute("src");
    }
    get loading() {
        return $dae3d0e46d061380$var$frameLoadingStyleFromString(this.getAttribute("loading") || "");
    }
    set loading(value) {
        if (value) this.setAttribute("loading", value);
        else this.removeAttribute("loading");
    }
    get disabled() {
        return this.hasAttribute("disabled");
    }
    set disabled(value) {
        if (value) this.setAttribute("disabled", "");
        else this.removeAttribute("disabled");
    }
    get autoscroll() {
        return this.hasAttribute("autoscroll");
    }
    set autoscroll(value) {
        if (value) this.setAttribute("autoscroll", "");
        else this.removeAttribute("autoscroll");
    }
    get complete() {
        return !this.delegate.isLoading;
    }
    get isActive() {
        return this.ownerDocument === document && !this.isPreview;
    }
    get isPreview() {
        var _a, _b;
        return (_b = (_a = this.ownerDocument) === null || _a === void 0 ? void 0 : _a.documentElement) === null || _b === void 0 ? void 0 : _b.hasAttribute("data-turbo-preview");
    }
}
function $dae3d0e46d061380$var$frameLoadingStyleFromString(style) {
    switch(style.toLowerCase()){
        case "lazy":
            return $dae3d0e46d061380$export$65f98fefe20dbcb6.lazy;
        default:
            return $dae3d0e46d061380$export$65f98fefe20dbcb6.eager;
    }
}
function $dae3d0e46d061380$var$expandURL(locatable) {
    return new URL(locatable.toString(), document.baseURI);
}
function $dae3d0e46d061380$var$getAnchor(url) {
    let anchorMatch;
    if (url.hash) return url.hash.slice(1);
    else if (anchorMatch = url.href.match(/#(.*)$/)) return anchorMatch[1];
}
function $dae3d0e46d061380$var$getAction(form, submitter) {
    const action = (submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("formaction")) || form.getAttribute("action") || form.action;
    return $dae3d0e46d061380$var$expandURL(action);
}
function $dae3d0e46d061380$var$getExtension(url) {
    return ($dae3d0e46d061380$var$getLastPathComponent(url).match(/\.[^.]*$/) || [])[0] || "";
}
function $dae3d0e46d061380$var$isHTML(url) {
    return !!$dae3d0e46d061380$var$getExtension(url).match(/^(?:|\.(?:htm|html|xhtml|php))$/);
}
function $dae3d0e46d061380$var$isPrefixedBy(baseURL, url) {
    const prefix = $dae3d0e46d061380$var$getPrefix(url);
    return baseURL.href === $dae3d0e46d061380$var$expandURL(prefix).href || baseURL.href.startsWith(prefix);
}
function $dae3d0e46d061380$var$locationIsVisitable(location1, rootLocation) {
    return $dae3d0e46d061380$var$isPrefixedBy(location1, rootLocation) && $dae3d0e46d061380$var$isHTML(location1);
}
function $dae3d0e46d061380$var$getRequestURL(url) {
    const anchor = $dae3d0e46d061380$var$getAnchor(url);
    return anchor != null ? url.href.slice(0, -(anchor.length + 1)) : url.href;
}
function $dae3d0e46d061380$var$toCacheKey(url) {
    return $dae3d0e46d061380$var$getRequestURL(url);
}
function $dae3d0e46d061380$var$urlsAreEqual(left, right) {
    return $dae3d0e46d061380$var$expandURL(left).href == $dae3d0e46d061380$var$expandURL(right).href;
}
function $dae3d0e46d061380$var$getPathComponents(url) {
    return url.pathname.split("/").slice(1);
}
function $dae3d0e46d061380$var$getLastPathComponent(url) {
    return $dae3d0e46d061380$var$getPathComponents(url).slice(-1)[0];
}
function $dae3d0e46d061380$var$getPrefix(url) {
    return $dae3d0e46d061380$var$addTrailingSlash(url.origin + url.pathname);
}
function $dae3d0e46d061380$var$addTrailingSlash(value) {
    return value.endsWith("/") ? value : value + "/";
}
class $dae3d0e46d061380$var$FetchResponse {
    constructor(response){
        this.response = response;
    }
    get succeeded() {
        return this.response.ok;
    }
    get failed() {
        return !this.succeeded;
    }
    get clientError() {
        return this.statusCode >= 400 && this.statusCode <= 499;
    }
    get serverError() {
        return this.statusCode >= 500 && this.statusCode <= 599;
    }
    get redirected() {
        return this.response.redirected;
    }
    get location() {
        return $dae3d0e46d061380$var$expandURL(this.response.url);
    }
    get isHTML() {
        return this.contentType && this.contentType.match(/^(?:text\/([^\s;,]+\b)?html|application\/xhtml\+xml)\b/);
    }
    get statusCode() {
        return this.response.status;
    }
    get contentType() {
        return this.header("Content-Type");
    }
    get responseText() {
        return this.response.clone().text();
    }
    get responseHTML() {
        if (this.isHTML) return this.response.clone().text();
        else return Promise.resolve(undefined);
    }
    header(name) {
        return this.response.headers.get(name);
    }
}
function $dae3d0e46d061380$var$activateScriptElement(element) {
    if (element.getAttribute("data-turbo-eval") == "false") return element;
    else {
        const createdScriptElement = document.createElement("script");
        const cspNonce = $dae3d0e46d061380$var$getMetaContent("csp-nonce");
        if (cspNonce) createdScriptElement.nonce = cspNonce;
        createdScriptElement.textContent = element.textContent;
        createdScriptElement.async = false;
        $dae3d0e46d061380$var$copyElementAttributes(createdScriptElement, element);
        return createdScriptElement;
    }
}
function $dae3d0e46d061380$var$copyElementAttributes(destinationElement, sourceElement) {
    for (const { name: name, value: value } of sourceElement.attributes)destinationElement.setAttribute(name, value);
}
function $dae3d0e46d061380$var$createDocumentFragment(html) {
    const template = document.createElement("template");
    template.innerHTML = html;
    return template.content;
}
function $dae3d0e46d061380$var$dispatch(eventName, { target: target, cancelable: cancelable, detail: detail } = {}) {
    const event = new CustomEvent(eventName, {
        cancelable: cancelable,
        bubbles: true,
        composed: true,
        detail: detail
    });
    if (target && target.isConnected) target.dispatchEvent(event);
    else document.documentElement.dispatchEvent(event);
    return event;
}
function $dae3d0e46d061380$var$nextAnimationFrame() {
    return new Promise((resolve)=>requestAnimationFrame(()=>resolve()));
}
function $dae3d0e46d061380$var$nextEventLoopTick() {
    return new Promise((resolve)=>setTimeout(()=>resolve(), 0));
}
function $dae3d0e46d061380$var$nextMicrotask() {
    return Promise.resolve();
}
function $dae3d0e46d061380$var$parseHTMLDocument(html = "") {
    return new DOMParser().parseFromString(html, "text/html");
}
function $dae3d0e46d061380$var$unindent(strings, ...values) {
    const lines = $dae3d0e46d061380$var$interpolate(strings, values).replace(/^\n/, "").split("\n");
    const match = lines[0].match(/^\s+/);
    const indent = match ? match[0].length : 0;
    return lines.map((line)=>line.slice(indent)).join("\n");
}
function $dae3d0e46d061380$var$interpolate(strings, values) {
    return strings.reduce((result, string, i)=>{
        const value = values[i] == undefined ? "" : values[i];
        return result + string + value;
    }, "");
}
function $dae3d0e46d061380$var$uuid() {
    return Array.from({
        length: 36
    }).map((_, i)=>{
        if (i == 8 || i == 13 || i == 18 || i == 23) return "-";
        else if (i == 14) return "4";
        else if (i == 19) return (Math.floor(Math.random() * 4) + 8).toString(16);
        else return Math.floor(Math.random() * 15).toString(16);
    }).join("");
}
function $dae3d0e46d061380$var$getAttribute(attributeName, ...elements) {
    for (const value of elements.map((element)=>element === null || element === void 0 ? void 0 : element.getAttribute(attributeName))){
        if (typeof value == "string") return value;
    }
    return null;
}
function $dae3d0e46d061380$var$hasAttribute(attributeName, ...elements) {
    return elements.some((element)=>element && element.hasAttribute(attributeName));
}
function $dae3d0e46d061380$var$markAsBusy(...elements) {
    for (const element of elements){
        if (element.localName == "turbo-frame") element.setAttribute("busy", "");
        element.setAttribute("aria-busy", "true");
    }
}
function $dae3d0e46d061380$var$clearBusyState(...elements) {
    for (const element of elements){
        if (element.localName == "turbo-frame") element.removeAttribute("busy");
        element.removeAttribute("aria-busy");
    }
}
function $dae3d0e46d061380$var$waitForLoad(element, timeoutInMilliseconds = 2000) {
    return new Promise((resolve)=>{
        const onComplete = ()=>{
            element.removeEventListener("error", onComplete);
            element.removeEventListener("load", onComplete);
            resolve();
        };
        element.addEventListener("load", onComplete, {
            once: true
        });
        element.addEventListener("error", onComplete, {
            once: true
        });
        setTimeout(resolve, timeoutInMilliseconds);
    });
}
function $dae3d0e46d061380$var$getHistoryMethodForAction(action) {
    switch(action){
        case "replace":
            return history.replaceState;
        case "advance":
        case "restore":
            return history.pushState;
    }
}
function $dae3d0e46d061380$var$isAction(action) {
    return action == "advance" || action == "replace" || action == "restore";
}
function $dae3d0e46d061380$var$getVisitAction(...elements) {
    const action = $dae3d0e46d061380$var$getAttribute("data-turbo-action", ...elements);
    return $dae3d0e46d061380$var$isAction(action) ? action : null;
}
function $dae3d0e46d061380$var$getMetaElement(name) {
    return document.querySelector(`meta[name="${name}"]`);
}
function $dae3d0e46d061380$var$getMetaContent(name) {
    const element = $dae3d0e46d061380$var$getMetaElement(name);
    return element && element.content;
}
function $dae3d0e46d061380$var$setMetaContent(name, content) {
    let element = $dae3d0e46d061380$var$getMetaElement(name);
    if (!element) {
        element = document.createElement("meta");
        element.setAttribute("name", name);
        document.head.appendChild(element);
    }
    element.setAttribute("content", content);
    return element;
}
function $dae3d0e46d061380$var$findClosestRecursively(element, selector) {
    var _a;
    if (element instanceof Element) return element.closest(selector) || $dae3d0e46d061380$var$findClosestRecursively(element.assignedSlot || ((_a = element.getRootNode()) === null || _a === void 0 ? void 0 : _a.host), selector);
}
var $dae3d0e46d061380$var$FetchMethod;
(function(FetchMethod) {
    FetchMethod[FetchMethod["get"] = 0] = "get";
    FetchMethod[FetchMethod["post"] = 1] = "post";
    FetchMethod[FetchMethod["put"] = 2] = "put";
    FetchMethod[FetchMethod["patch"] = 3] = "patch";
    FetchMethod[FetchMethod["delete"] = 4] = "delete";
})($dae3d0e46d061380$var$FetchMethod || ($dae3d0e46d061380$var$FetchMethod = {}));
function $dae3d0e46d061380$var$fetchMethodFromString(method) {
    switch(method.toLowerCase()){
        case "get":
            return $dae3d0e46d061380$var$FetchMethod.get;
        case "post":
            return $dae3d0e46d061380$var$FetchMethod.post;
        case "put":
            return $dae3d0e46d061380$var$FetchMethod.put;
        case "patch":
            return $dae3d0e46d061380$var$FetchMethod.patch;
        case "delete":
            return $dae3d0e46d061380$var$FetchMethod.delete;
    }
}
class $dae3d0e46d061380$var$FetchRequest {
    constructor(delegate, method, location1, body = new URLSearchParams(), target = null){
        this.abortController = new AbortController();
        this.resolveRequestPromise = (_value)=>{};
        this.delegate = delegate;
        this.method = method;
        this.headers = this.defaultHeaders;
        this.body = body;
        this.url = location1;
        this.target = target;
    }
    get location() {
        return this.url;
    }
    get params() {
        return this.url.searchParams;
    }
    get entries() {
        return this.body ? Array.from(this.body.entries()) : [];
    }
    cancel() {
        this.abortController.abort();
    }
    async perform() {
        const { fetchOptions: fetchOptions } = this;
        this.delegate.prepareRequest(this);
        await this.allowRequestToBeIntercepted(fetchOptions);
        try {
            this.delegate.requestStarted(this);
            const response = await fetch(this.url.href, fetchOptions);
            return await this.receive(response);
        } catch (error) {
            if (error.name !== "AbortError") {
                if (this.willDelegateErrorHandling(error)) this.delegate.requestErrored(this, error);
                throw error;
            }
        } finally{
            this.delegate.requestFinished(this);
        }
    }
    async receive(response) {
        const fetchResponse = new $dae3d0e46d061380$var$FetchResponse(response);
        const event = $dae3d0e46d061380$var$dispatch("turbo:before-fetch-response", {
            cancelable: true,
            detail: {
                fetchResponse: fetchResponse
            },
            target: this.target
        });
        if (event.defaultPrevented) this.delegate.requestPreventedHandlingResponse(this, fetchResponse);
        else if (fetchResponse.succeeded) this.delegate.requestSucceededWithResponse(this, fetchResponse);
        else this.delegate.requestFailedWithResponse(this, fetchResponse);
        return fetchResponse;
    }
    get fetchOptions() {
        var _a;
        return {
            method: $dae3d0e46d061380$var$FetchMethod[this.method].toUpperCase(),
            credentials: "same-origin",
            headers: this.headers,
            redirect: "follow",
            body: this.isSafe ? null : this.body,
            signal: this.abortSignal,
            referrer: (_a = this.delegate.referrer) === null || _a === void 0 ? void 0 : _a.href
        };
    }
    get defaultHeaders() {
        return {
            Accept: "text/html, application/xhtml+xml"
        };
    }
    get isSafe() {
        return this.method === $dae3d0e46d061380$var$FetchMethod.get;
    }
    get abortSignal() {
        return this.abortController.signal;
    }
    acceptResponseType(mimeType) {
        this.headers["Accept"] = [
            mimeType,
            this.headers["Accept"]
        ].join(", ");
    }
    async allowRequestToBeIntercepted(fetchOptions) {
        const requestInterception = new Promise((resolve)=>this.resolveRequestPromise = resolve);
        const event = $dae3d0e46d061380$var$dispatch("turbo:before-fetch-request", {
            cancelable: true,
            detail: {
                fetchOptions: fetchOptions,
                url: this.url,
                resume: this.resolveRequestPromise
            },
            target: this.target
        });
        if (event.defaultPrevented) await requestInterception;
    }
    willDelegateErrorHandling(error) {
        const event = $dae3d0e46d061380$var$dispatch("turbo:fetch-request-error", {
            target: this.target,
            cancelable: true,
            detail: {
                request: this,
                error: error
            }
        });
        return !event.defaultPrevented;
    }
}
class $dae3d0e46d061380$var$AppearanceObserver {
    constructor(delegate, element){
        this.started = false;
        this.intersect = (entries)=>{
            const lastEntry = entries.slice(-1)[0];
            if (lastEntry === null || lastEntry === void 0 ? void 0 : lastEntry.isIntersecting) this.delegate.elementAppearedInViewport(this.element);
        };
        this.delegate = delegate;
        this.element = element;
        this.intersectionObserver = new IntersectionObserver(this.intersect);
    }
    start() {
        if (!this.started) {
            this.started = true;
            this.intersectionObserver.observe(this.element);
        }
    }
    stop() {
        if (this.started) {
            this.started = false;
            this.intersectionObserver.unobserve(this.element);
        }
    }
}
class $dae3d0e46d061380$var$StreamMessage {
    static wrap(message) {
        if (typeof message == "string") return new this($dae3d0e46d061380$var$createDocumentFragment(message));
        else return message;
    }
    constructor(fragment){
        this.fragment = $dae3d0e46d061380$var$importStreamElements(fragment);
    }
}
$dae3d0e46d061380$var$StreamMessage.contentType = "text/vnd.turbo-stream.html";
function $dae3d0e46d061380$var$importStreamElements(fragment) {
    for (const element of fragment.querySelectorAll("turbo-stream")){
        const streamElement = document.importNode(element, true);
        for (const inertScriptElement of streamElement.templateElement.content.querySelectorAll("script"))inertScriptElement.replaceWith($dae3d0e46d061380$var$activateScriptElement(inertScriptElement));
        element.replaceWith(streamElement);
    }
    return fragment;
}
var $dae3d0e46d061380$var$FormSubmissionState;
(function(FormSubmissionState) {
    FormSubmissionState[FormSubmissionState["initialized"] = 0] = "initialized";
    FormSubmissionState[FormSubmissionState["requesting"] = 1] = "requesting";
    FormSubmissionState[FormSubmissionState["waiting"] = 2] = "waiting";
    FormSubmissionState[FormSubmissionState["receiving"] = 3] = "receiving";
    FormSubmissionState[FormSubmissionState["stopping"] = 4] = "stopping";
    FormSubmissionState[FormSubmissionState["stopped"] = 5] = "stopped";
})($dae3d0e46d061380$var$FormSubmissionState || ($dae3d0e46d061380$var$FormSubmissionState = {}));
var $dae3d0e46d061380$var$FormEnctype;
(function(FormEnctype) {
    FormEnctype["urlEncoded"] = "application/x-www-form-urlencoded";
    FormEnctype["multipart"] = "multipart/form-data";
    FormEnctype["plain"] = "text/plain";
})($dae3d0e46d061380$var$FormEnctype || ($dae3d0e46d061380$var$FormEnctype = {}));
function $dae3d0e46d061380$var$formEnctypeFromString(encoding) {
    switch(encoding.toLowerCase()){
        case $dae3d0e46d061380$var$FormEnctype.multipart:
            return $dae3d0e46d061380$var$FormEnctype.multipart;
        case $dae3d0e46d061380$var$FormEnctype.plain:
            return $dae3d0e46d061380$var$FormEnctype.plain;
        default:
            return $dae3d0e46d061380$var$FormEnctype.urlEncoded;
    }
}
class $dae3d0e46d061380$var$FormSubmission {
    static confirmMethod(message, _element, _submitter) {
        return Promise.resolve(confirm(message));
    }
    constructor(delegate, formElement, submitter, mustRedirect = false){
        this.state = $dae3d0e46d061380$var$FormSubmissionState.initialized;
        this.delegate = delegate;
        this.formElement = formElement;
        this.submitter = submitter;
        this.formData = $dae3d0e46d061380$var$buildFormData(formElement, submitter);
        this.location = $dae3d0e46d061380$var$expandURL(this.action);
        if (this.method == $dae3d0e46d061380$var$FetchMethod.get) $dae3d0e46d061380$var$mergeFormDataEntries(this.location, [
            ...this.body.entries()
        ]);
        this.fetchRequest = new $dae3d0e46d061380$var$FetchRequest(this, this.method, this.location, this.body, this.formElement);
        this.mustRedirect = mustRedirect;
    }
    get method() {
        var _a;
        const method = ((_a = this.submitter) === null || _a === void 0 ? void 0 : _a.getAttribute("formmethod")) || this.formElement.getAttribute("method") || "";
        return $dae3d0e46d061380$var$fetchMethodFromString(method.toLowerCase()) || $dae3d0e46d061380$var$FetchMethod.get;
    }
    get action() {
        var _a;
        const formElementAction = typeof this.formElement.action === "string" ? this.formElement.action : null;
        if ((_a = this.submitter) === null || _a === void 0 ? void 0 : _a.hasAttribute("formaction")) return this.submitter.getAttribute("formaction") || "";
        else return this.formElement.getAttribute("action") || formElementAction || "";
    }
    get body() {
        if (this.enctype == $dae3d0e46d061380$var$FormEnctype.urlEncoded || this.method == $dae3d0e46d061380$var$FetchMethod.get) return new URLSearchParams(this.stringFormData);
        else return this.formData;
    }
    get enctype() {
        var _a;
        return $dae3d0e46d061380$var$formEnctypeFromString(((_a = this.submitter) === null || _a === void 0 ? void 0 : _a.getAttribute("formenctype")) || this.formElement.enctype);
    }
    get isSafe() {
        return this.fetchRequest.isSafe;
    }
    get stringFormData() {
        return [
            ...this.formData
        ].reduce((entries, [name, value])=>{
            return entries.concat(typeof value == "string" ? [
                [
                    name,
                    value
                ]
            ] : []);
        }, []);
    }
    async start() {
        const { initialized: initialized, requesting: requesting } = $dae3d0e46d061380$var$FormSubmissionState;
        const confirmationMessage = $dae3d0e46d061380$var$getAttribute("data-turbo-confirm", this.submitter, this.formElement);
        if (typeof confirmationMessage === "string") {
            const answer = await $dae3d0e46d061380$var$FormSubmission.confirmMethod(confirmationMessage, this.formElement, this.submitter);
            if (!answer) return;
        }
        if (this.state == initialized) {
            this.state = requesting;
            return this.fetchRequest.perform();
        }
    }
    stop() {
        const { stopping: stopping, stopped: stopped } = $dae3d0e46d061380$var$FormSubmissionState;
        if (this.state != stopping && this.state != stopped) {
            this.state = stopping;
            this.fetchRequest.cancel();
            return true;
        }
    }
    prepareRequest(request) {
        if (!request.isSafe) {
            const token = $dae3d0e46d061380$var$getCookieValue($dae3d0e46d061380$var$getMetaContent("csrf-param")) || $dae3d0e46d061380$var$getMetaContent("csrf-token");
            if (token) request.headers["X-CSRF-Token"] = token;
        }
        if (this.requestAcceptsTurboStreamResponse(request)) request.acceptResponseType($dae3d0e46d061380$var$StreamMessage.contentType);
    }
    requestStarted(_request) {
        var _a;
        this.state = $dae3d0e46d061380$var$FormSubmissionState.waiting;
        (_a = this.submitter) === null || _a === void 0 || _a.setAttribute("disabled", "");
        this.setSubmitsWith();
        $dae3d0e46d061380$var$dispatch("turbo:submit-start", {
            target: this.formElement,
            detail: {
                formSubmission: this
            }
        });
        this.delegate.formSubmissionStarted(this);
    }
    requestPreventedHandlingResponse(request, response) {
        this.result = {
            success: response.succeeded,
            fetchResponse: response
        };
    }
    requestSucceededWithResponse(request, response) {
        if (response.clientError || response.serverError) this.delegate.formSubmissionFailedWithResponse(this, response);
        else if (this.requestMustRedirect(request) && $dae3d0e46d061380$var$responseSucceededWithoutRedirect(response)) {
            const error = new Error("Form responses must redirect to another location");
            this.delegate.formSubmissionErrored(this, error);
        } else {
            this.state = $dae3d0e46d061380$var$FormSubmissionState.receiving;
            this.result = {
                success: true,
                fetchResponse: response
            };
            this.delegate.formSubmissionSucceededWithResponse(this, response);
        }
    }
    requestFailedWithResponse(request, response) {
        this.result = {
            success: false,
            fetchResponse: response
        };
        this.delegate.formSubmissionFailedWithResponse(this, response);
    }
    requestErrored(request, error) {
        this.result = {
            success: false,
            error: error
        };
        this.delegate.formSubmissionErrored(this, error);
    }
    requestFinished(_request) {
        var _a;
        this.state = $dae3d0e46d061380$var$FormSubmissionState.stopped;
        (_a = this.submitter) === null || _a === void 0 || _a.removeAttribute("disabled");
        this.resetSubmitterText();
        $dae3d0e46d061380$var$dispatch("turbo:submit-end", {
            target: this.formElement,
            detail: Object.assign({
                formSubmission: this
            }, this.result)
        });
        this.delegate.formSubmissionFinished(this);
    }
    setSubmitsWith() {
        if (!this.submitter || !this.submitsWith) return;
        if (this.submitter.matches("button")) {
            this.originalSubmitText = this.submitter.innerHTML;
            this.submitter.innerHTML = this.submitsWith;
        } else if (this.submitter.matches("input")) {
            const input = this.submitter;
            this.originalSubmitText = input.value;
            input.value = this.submitsWith;
        }
    }
    resetSubmitterText() {
        if (!this.submitter || !this.originalSubmitText) return;
        if (this.submitter.matches("button")) this.submitter.innerHTML = this.originalSubmitText;
        else if (this.submitter.matches("input")) {
            const input = this.submitter;
            input.value = this.originalSubmitText;
        }
    }
    requestMustRedirect(request) {
        return !request.isSafe && this.mustRedirect;
    }
    requestAcceptsTurboStreamResponse(request) {
        return !request.isSafe || $dae3d0e46d061380$var$hasAttribute("data-turbo-stream", this.submitter, this.formElement);
    }
    get submitsWith() {
        var _a;
        return (_a = this.submitter) === null || _a === void 0 ? void 0 : _a.getAttribute("data-turbo-submits-with");
    }
}
function $dae3d0e46d061380$var$buildFormData(formElement, submitter) {
    const formData = new FormData(formElement);
    const name = submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("name");
    const value = submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("value");
    if (name) formData.append(name, value || "");
    return formData;
}
function $dae3d0e46d061380$var$getCookieValue(cookieName) {
    if (cookieName != null) {
        const cookies = document.cookie ? document.cookie.split("; ") : [];
        const cookie = cookies.find((cookie)=>cookie.startsWith(cookieName));
        if (cookie) {
            const value = cookie.split("=").slice(1).join("=");
            return value ? decodeURIComponent(value) : undefined;
        }
    }
}
function $dae3d0e46d061380$var$responseSucceededWithoutRedirect(response) {
    return response.statusCode == 200 && !response.redirected;
}
function $dae3d0e46d061380$var$mergeFormDataEntries(url, entries) {
    const searchParams = new URLSearchParams();
    for (const [name, value] of entries){
        if (value instanceof File) continue;
        searchParams.append(name, value);
    }
    url.search = searchParams.toString();
    return url;
}
class $dae3d0e46d061380$var$Snapshot {
    constructor(element){
        this.element = element;
    }
    get activeElement() {
        return this.element.ownerDocument.activeElement;
    }
    get children() {
        return [
            ...this.element.children
        ];
    }
    hasAnchor(anchor) {
        return this.getElementForAnchor(anchor) != null;
    }
    getElementForAnchor(anchor) {
        return anchor ? this.element.querySelector(`[id='${anchor}'], a[name='${anchor}']`) : null;
    }
    get isConnected() {
        return this.element.isConnected;
    }
    get firstAutofocusableElement() {
        const inertDisabledOrHidden = "[inert], :disabled, [hidden], details:not([open]), dialog:not([open])";
        for (const element of this.element.querySelectorAll("[autofocus]")){
            if (element.closest(inertDisabledOrHidden) == null) return element;
            else continue;
        }
        return null;
    }
    get permanentElements() {
        return $dae3d0e46d061380$var$queryPermanentElementsAll(this.element);
    }
    getPermanentElementById(id) {
        return $dae3d0e46d061380$var$getPermanentElementById(this.element, id);
    }
    getPermanentElementMapForSnapshot(snapshot) {
        const permanentElementMap = {};
        for (const currentPermanentElement of this.permanentElements){
            const { id: id } = currentPermanentElement;
            const newPermanentElement = snapshot.getPermanentElementById(id);
            if (newPermanentElement) permanentElementMap[id] = [
                currentPermanentElement,
                newPermanentElement
            ];
        }
        return permanentElementMap;
    }
}
function $dae3d0e46d061380$var$getPermanentElementById(node, id) {
    return node.querySelector(`#${id}[data-turbo-permanent]`);
}
function $dae3d0e46d061380$var$queryPermanentElementsAll(node) {
    return node.querySelectorAll("[id][data-turbo-permanent]");
}
class $dae3d0e46d061380$var$FormSubmitObserver {
    constructor(delegate, eventTarget){
        this.started = false;
        this.submitCaptured = ()=>{
            this.eventTarget.removeEventListener("submit", this.submitBubbled, false);
            this.eventTarget.addEventListener("submit", this.submitBubbled, false);
        };
        this.submitBubbled = (event)=>{
            if (!event.defaultPrevented) {
                const form = event.target instanceof HTMLFormElement ? event.target : undefined;
                const submitter = event.submitter || undefined;
                if (form && $dae3d0e46d061380$var$submissionDoesNotDismissDialog(form, submitter) && $dae3d0e46d061380$var$submissionDoesNotTargetIFrame(form, submitter) && this.delegate.willSubmitForm(form, submitter)) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    this.delegate.formSubmitted(form, submitter);
                }
            }
        };
        this.delegate = delegate;
        this.eventTarget = eventTarget;
    }
    start() {
        if (!this.started) {
            this.eventTarget.addEventListener("submit", this.submitCaptured, true);
            this.started = true;
        }
    }
    stop() {
        if (this.started) {
            this.eventTarget.removeEventListener("submit", this.submitCaptured, true);
            this.started = false;
        }
    }
}
function $dae3d0e46d061380$var$submissionDoesNotDismissDialog(form, submitter) {
    const method = (submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("formmethod")) || form.getAttribute("method");
    return method != "dialog";
}
function $dae3d0e46d061380$var$submissionDoesNotTargetIFrame(form, submitter) {
    if ((submitter === null || submitter === void 0 ? void 0 : submitter.hasAttribute("formtarget")) || form.hasAttribute("target")) {
        const target = (submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("formtarget")) || form.target;
        for (const element of document.getElementsByName(target)){
            if (element instanceof HTMLIFrameElement) return false;
        }
        return true;
    } else return true;
}
class $dae3d0e46d061380$var$View {
    constructor(delegate, element){
        this.resolveRenderPromise = (_value)=>{};
        this.resolveInterceptionPromise = (_value)=>{};
        this.delegate = delegate;
        this.element = element;
    }
    scrollToAnchor(anchor) {
        const element = this.snapshot.getElementForAnchor(anchor);
        if (element) {
            this.scrollToElement(element);
            this.focusElement(element);
        } else this.scrollToPosition({
            x: 0,
            y: 0
        });
    }
    scrollToAnchorFromLocation(location1) {
        this.scrollToAnchor($dae3d0e46d061380$var$getAnchor(location1));
    }
    scrollToElement(element) {
        element.scrollIntoView();
    }
    focusElement(element) {
        if (element instanceof HTMLElement) {
            if (element.hasAttribute("tabindex")) element.focus();
            else {
                element.setAttribute("tabindex", "-1");
                element.focus();
                element.removeAttribute("tabindex");
            }
        }
    }
    scrollToPosition({ x: x, y: y }) {
        this.scrollRoot.scrollTo(x, y);
    }
    scrollToTop() {
        this.scrollToPosition({
            x: 0,
            y: 0
        });
    }
    get scrollRoot() {
        return window;
    }
    async render(renderer) {
        const { isPreview: isPreview, shouldRender: shouldRender, newSnapshot: snapshot } = renderer;
        if (shouldRender) try {
            this.renderPromise = new Promise((resolve)=>this.resolveRenderPromise = resolve);
            this.renderer = renderer;
            await this.prepareToRenderSnapshot(renderer);
            const renderInterception = new Promise((resolve)=>this.resolveInterceptionPromise = resolve);
            const options = {
                resume: this.resolveInterceptionPromise,
                render: this.renderer.renderElement
            };
            const immediateRender = this.delegate.allowsImmediateRender(snapshot, options);
            if (!immediateRender) await renderInterception;
            await this.renderSnapshot(renderer);
            this.delegate.viewRenderedSnapshot(snapshot, isPreview);
            this.delegate.preloadOnLoadLinksForView(this.element);
            this.finishRenderingSnapshot(renderer);
        } finally{
            delete this.renderer;
            this.resolveRenderPromise(undefined);
            delete this.renderPromise;
        }
        else this.invalidate(renderer.reloadReason);
    }
    invalidate(reason) {
        this.delegate.viewInvalidated(reason);
    }
    async prepareToRenderSnapshot(renderer) {
        this.markAsPreview(renderer.isPreview);
        await renderer.prepareToRender();
    }
    markAsPreview(isPreview) {
        if (isPreview) this.element.setAttribute("data-turbo-preview", "");
        else this.element.removeAttribute("data-turbo-preview");
    }
    async renderSnapshot(renderer) {
        await renderer.render();
    }
    finishRenderingSnapshot(renderer) {
        renderer.finishRendering();
    }
}
class $dae3d0e46d061380$var$FrameView extends $dae3d0e46d061380$var$View {
    missing() {
        this.element.innerHTML = `<strong class="turbo-frame-error">Content missing</strong>`;
    }
    get snapshot() {
        return new $dae3d0e46d061380$var$Snapshot(this.element);
    }
}
class $dae3d0e46d061380$var$LinkInterceptor {
    constructor(delegate, element){
        this.clickBubbled = (event)=>{
            if (this.respondsToEventTarget(event.target)) this.clickEvent = event;
            else delete this.clickEvent;
        };
        this.linkClicked = (event)=>{
            if (this.clickEvent && this.respondsToEventTarget(event.target) && event.target instanceof Element) {
                if (this.delegate.shouldInterceptLinkClick(event.target, event.detail.url, event.detail.originalEvent)) {
                    this.clickEvent.preventDefault();
                    event.preventDefault();
                    this.delegate.linkClickIntercepted(event.target, event.detail.url, event.detail.originalEvent);
                }
            }
            delete this.clickEvent;
        };
        this.willVisit = (_event)=>{
            delete this.clickEvent;
        };
        this.delegate = delegate;
        this.element = element;
    }
    start() {
        this.element.addEventListener("click", this.clickBubbled);
        document.addEventListener("turbo:click", this.linkClicked);
        document.addEventListener("turbo:before-visit", this.willVisit);
    }
    stop() {
        this.element.removeEventListener("click", this.clickBubbled);
        document.removeEventListener("turbo:click", this.linkClicked);
        document.removeEventListener("turbo:before-visit", this.willVisit);
    }
    respondsToEventTarget(target) {
        const element = target instanceof Element ? target : target instanceof Node ? target.parentElement : null;
        return element && element.closest("turbo-frame, html") == this.element;
    }
}
class $dae3d0e46d061380$var$LinkClickObserver {
    constructor(delegate, eventTarget){
        this.started = false;
        this.clickCaptured = ()=>{
            this.eventTarget.removeEventListener("click", this.clickBubbled, false);
            this.eventTarget.addEventListener("click", this.clickBubbled, false);
        };
        this.clickBubbled = (event)=>{
            if (event instanceof MouseEvent && this.clickEventIsSignificant(event)) {
                const target = event.composedPath && event.composedPath()[0] || event.target;
                const link = this.findLinkFromClickTarget(target);
                if (link && $dae3d0e46d061380$var$doesNotTargetIFrame(link)) {
                    const location1 = this.getLocationForLink(link);
                    if (this.delegate.willFollowLinkToLocation(link, location1, event)) {
                        event.preventDefault();
                        this.delegate.followedLinkToLocation(link, location1);
                    }
                }
            }
        };
        this.delegate = delegate;
        this.eventTarget = eventTarget;
    }
    start() {
        if (!this.started) {
            this.eventTarget.addEventListener("click", this.clickCaptured, true);
            this.started = true;
        }
    }
    stop() {
        if (this.started) {
            this.eventTarget.removeEventListener("click", this.clickCaptured, true);
            this.started = false;
        }
    }
    clickEventIsSignificant(event) {
        return !(event.target && event.target.isContentEditable || event.defaultPrevented || event.which > 1 || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey);
    }
    findLinkFromClickTarget(target) {
        return $dae3d0e46d061380$var$findClosestRecursively(target, "a[href]:not([target^=_]):not([download])");
    }
    getLocationForLink(link) {
        return $dae3d0e46d061380$var$expandURL(link.getAttribute("href") || "");
    }
}
function $dae3d0e46d061380$var$doesNotTargetIFrame(anchor) {
    if (anchor.hasAttribute("target")) {
        for (const element of document.getElementsByName(anchor.target)){
            if (element instanceof HTMLIFrameElement) return false;
        }
        return true;
    } else return true;
}
class $dae3d0e46d061380$var$FormLinkClickObserver {
    constructor(delegate, element){
        this.delegate = delegate;
        this.linkInterceptor = new $dae3d0e46d061380$var$LinkClickObserver(this, element);
    }
    start() {
        this.linkInterceptor.start();
    }
    stop() {
        this.linkInterceptor.stop();
    }
    willFollowLinkToLocation(link, location1, originalEvent) {
        return this.delegate.willSubmitFormLinkToLocation(link, location1, originalEvent) && link.hasAttribute("data-turbo-method");
    }
    followedLinkToLocation(link, location1) {
        const form = document.createElement("form");
        const type = "hidden";
        for (const [name, value] of location1.searchParams)form.append(Object.assign(document.createElement("input"), {
            type: type,
            name: name,
            value: value
        }));
        const action = Object.assign(location1, {
            search: ""
        });
        form.setAttribute("data-turbo", "true");
        form.setAttribute("action", action.href);
        form.setAttribute("hidden", "");
        const method = link.getAttribute("data-turbo-method");
        if (method) form.setAttribute("method", method);
        const turboFrame = link.getAttribute("data-turbo-frame");
        if (turboFrame) form.setAttribute("data-turbo-frame", turboFrame);
        const turboAction = $dae3d0e46d061380$var$getVisitAction(link);
        if (turboAction) form.setAttribute("data-turbo-action", turboAction);
        const turboConfirm = link.getAttribute("data-turbo-confirm");
        if (turboConfirm) form.setAttribute("data-turbo-confirm", turboConfirm);
        const turboStream = link.hasAttribute("data-turbo-stream");
        if (turboStream) form.setAttribute("data-turbo-stream", "");
        this.delegate.submittedFormLinkToLocation(link, location1, form);
        document.body.appendChild(form);
        form.addEventListener("turbo:submit-end", ()=>form.remove(), {
            once: true
        });
        requestAnimationFrame(()=>form.requestSubmit());
    }
}
class $dae3d0e46d061380$var$Bardo {
    static async preservingPermanentElements(delegate, permanentElementMap, callback) {
        const bardo = new this(delegate, permanentElementMap);
        bardo.enter();
        await callback();
        bardo.leave();
    }
    constructor(delegate, permanentElementMap){
        this.delegate = delegate;
        this.permanentElementMap = permanentElementMap;
    }
    enter() {
        for(const id in this.permanentElementMap){
            const [currentPermanentElement, newPermanentElement] = this.permanentElementMap[id];
            this.delegate.enteringBardo(currentPermanentElement, newPermanentElement);
            this.replaceNewPermanentElementWithPlaceholder(newPermanentElement);
        }
    }
    leave() {
        for(const id in this.permanentElementMap){
            const [currentPermanentElement] = this.permanentElementMap[id];
            this.replaceCurrentPermanentElementWithClone(currentPermanentElement);
            this.replacePlaceholderWithPermanentElement(currentPermanentElement);
            this.delegate.leavingBardo(currentPermanentElement);
        }
    }
    replaceNewPermanentElementWithPlaceholder(permanentElement) {
        const placeholder = $dae3d0e46d061380$var$createPlaceholderForPermanentElement(permanentElement);
        permanentElement.replaceWith(placeholder);
    }
    replaceCurrentPermanentElementWithClone(permanentElement) {
        const clone = permanentElement.cloneNode(true);
        permanentElement.replaceWith(clone);
    }
    replacePlaceholderWithPermanentElement(permanentElement) {
        const placeholder = this.getPlaceholderById(permanentElement.id);
        placeholder === null || placeholder === void 0 || placeholder.replaceWith(permanentElement);
    }
    getPlaceholderById(id) {
        return this.placeholders.find((element)=>element.content == id);
    }
    get placeholders() {
        return [
            ...document.querySelectorAll("meta[name=turbo-permanent-placeholder][content]")
        ];
    }
}
function $dae3d0e46d061380$var$createPlaceholderForPermanentElement(permanentElement) {
    const element = document.createElement("meta");
    element.setAttribute("name", "turbo-permanent-placeholder");
    element.setAttribute("content", permanentElement.id);
    return element;
}
class $dae3d0e46d061380$var$Renderer {
    constructor(currentSnapshot, newSnapshot, renderElement, isPreview, willRender = true){
        this.activeElement = null;
        this.currentSnapshot = currentSnapshot;
        this.newSnapshot = newSnapshot;
        this.isPreview = isPreview;
        this.willRender = willRender;
        this.renderElement = renderElement;
        this.promise = new Promise((resolve, reject)=>this.resolvingFunctions = {
                resolve: resolve,
                reject: reject
            });
    }
    get shouldRender() {
        return true;
    }
    get reloadReason() {
        return;
    }
    prepareToRender() {
        return;
    }
    finishRendering() {
        if (this.resolvingFunctions) {
            this.resolvingFunctions.resolve();
            delete this.resolvingFunctions;
        }
    }
    async preservingPermanentElements(callback) {
        await $dae3d0e46d061380$var$Bardo.preservingPermanentElements(this, this.permanentElementMap, callback);
    }
    focusFirstAutofocusableElement() {
        const element = this.connectedSnapshot.firstAutofocusableElement;
        if ($dae3d0e46d061380$var$elementIsFocusable(element)) element.focus();
    }
    enteringBardo(currentPermanentElement) {
        if (this.activeElement) return;
        if (currentPermanentElement.contains(this.currentSnapshot.activeElement)) this.activeElement = this.currentSnapshot.activeElement;
    }
    leavingBardo(currentPermanentElement) {
        if (currentPermanentElement.contains(this.activeElement) && this.activeElement instanceof HTMLElement) {
            this.activeElement.focus();
            this.activeElement = null;
        }
    }
    get connectedSnapshot() {
        return this.newSnapshot.isConnected ? this.newSnapshot : this.currentSnapshot;
    }
    get currentElement() {
        return this.currentSnapshot.element;
    }
    get newElement() {
        return this.newSnapshot.element;
    }
    get permanentElementMap() {
        return this.currentSnapshot.getPermanentElementMapForSnapshot(this.newSnapshot);
    }
}
function $dae3d0e46d061380$var$elementIsFocusable(element) {
    return element && typeof element.focus == "function";
}
class $dae3d0e46d061380$export$f09c4165d16bb2b7 extends $dae3d0e46d061380$var$Renderer {
    static renderElement(currentElement, newElement) {
        var _a;
        const destinationRange = document.createRange();
        destinationRange.selectNodeContents(currentElement);
        destinationRange.deleteContents();
        const frameElement = newElement;
        const sourceRange = (_a = frameElement.ownerDocument) === null || _a === void 0 ? void 0 : _a.createRange();
        if (sourceRange) {
            sourceRange.selectNodeContents(frameElement);
            currentElement.appendChild(sourceRange.extractContents());
        }
    }
    constructor(delegate, currentSnapshot, newSnapshot, renderElement, isPreview, willRender = true){
        super(currentSnapshot, newSnapshot, renderElement, isPreview, willRender);
        this.delegate = delegate;
    }
    get shouldRender() {
        return true;
    }
    async render() {
        await $dae3d0e46d061380$var$nextAnimationFrame();
        this.preservingPermanentElements(()=>{
            this.loadFrameElement();
        });
        this.scrollFrameIntoView();
        await $dae3d0e46d061380$var$nextAnimationFrame();
        this.focusFirstAutofocusableElement();
        await $dae3d0e46d061380$var$nextAnimationFrame();
        this.activateScriptElements();
    }
    loadFrameElement() {
        this.delegate.willRenderFrame(this.currentElement, this.newElement);
        this.renderElement(this.currentElement, this.newElement);
    }
    scrollFrameIntoView() {
        if (this.currentElement.autoscroll || this.newElement.autoscroll) {
            const element = this.currentElement.firstElementChild;
            const block = $dae3d0e46d061380$var$readScrollLogicalPosition(this.currentElement.getAttribute("data-autoscroll-block"), "end");
            const behavior = $dae3d0e46d061380$var$readScrollBehavior(this.currentElement.getAttribute("data-autoscroll-behavior"), "auto");
            if (element) {
                element.scrollIntoView({
                    block: block,
                    behavior: behavior
                });
                return true;
            }
        }
        return false;
    }
    activateScriptElements() {
        for (const inertScriptElement of this.newScriptElements){
            const activatedScriptElement = $dae3d0e46d061380$var$activateScriptElement(inertScriptElement);
            inertScriptElement.replaceWith(activatedScriptElement);
        }
    }
    get newScriptElements() {
        return this.currentElement.querySelectorAll("script");
    }
}
function $dae3d0e46d061380$var$readScrollLogicalPosition(value, defaultValue) {
    if (value == "end" || value == "start" || value == "center" || value == "nearest") return value;
    else return defaultValue;
}
function $dae3d0e46d061380$var$readScrollBehavior(value, defaultValue) {
    if (value == "auto" || value == "smooth") return value;
    else return defaultValue;
}
class $dae3d0e46d061380$var$ProgressBar {
    static get defaultCSS() {
        return $dae3d0e46d061380$var$unindent`
      .turbo-progress-bar {
        position: fixed;
        display: block;
        top: 0;
        left: 0;
        height: 3px;
        background: #0076ff;
        z-index: 2147483647;
        transition:
          width ${$dae3d0e46d061380$var$ProgressBar.animationDuration}ms ease-out,
          opacity ${$dae3d0e46d061380$var$ProgressBar.animationDuration / 2}ms ${$dae3d0e46d061380$var$ProgressBar.animationDuration / 2}ms ease-in;
        transform: translate3d(0, 0, 0);
      }
    `;
    }
    constructor(){
        this.hiding = false;
        this.value = 0;
        this.visible = false;
        this.trickle = ()=>{
            this.setValue(this.value + Math.random() / 100);
        };
        this.stylesheetElement = this.createStylesheetElement();
        this.progressElement = this.createProgressElement();
        this.installStylesheetElement();
        this.setValue(0);
    }
    show() {
        if (!this.visible) {
            this.visible = true;
            this.installProgressElement();
            this.startTrickling();
        }
    }
    hide() {
        if (this.visible && !this.hiding) {
            this.hiding = true;
            this.fadeProgressElement(()=>{
                this.uninstallProgressElement();
                this.stopTrickling();
                this.visible = false;
                this.hiding = false;
            });
        }
    }
    setValue(value) {
        this.value = value;
        this.refresh();
    }
    installStylesheetElement() {
        document.head.insertBefore(this.stylesheetElement, document.head.firstChild);
    }
    installProgressElement() {
        this.progressElement.style.width = "0";
        this.progressElement.style.opacity = "1";
        document.documentElement.insertBefore(this.progressElement, document.body);
        this.refresh();
    }
    fadeProgressElement(callback) {
        this.progressElement.style.opacity = "0";
        setTimeout(callback, $dae3d0e46d061380$var$ProgressBar.animationDuration * 1.5);
    }
    uninstallProgressElement() {
        if (this.progressElement.parentNode) document.documentElement.removeChild(this.progressElement);
    }
    startTrickling() {
        if (!this.trickleInterval) this.trickleInterval = window.setInterval(this.trickle, $dae3d0e46d061380$var$ProgressBar.animationDuration);
    }
    stopTrickling() {
        window.clearInterval(this.trickleInterval);
        delete this.trickleInterval;
    }
    refresh() {
        requestAnimationFrame(()=>{
            this.progressElement.style.width = `${10 + this.value * 90}%`;
        });
    }
    createStylesheetElement() {
        const element = document.createElement("style");
        element.type = "text/css";
        element.textContent = $dae3d0e46d061380$var$ProgressBar.defaultCSS;
        if (this.cspNonce) element.nonce = this.cspNonce;
        return element;
    }
    createProgressElement() {
        const element = document.createElement("div");
        element.className = "turbo-progress-bar";
        return element;
    }
    get cspNonce() {
        return $dae3d0e46d061380$var$getMetaContent("csp-nonce");
    }
}
$dae3d0e46d061380$var$ProgressBar.animationDuration = 300;
class $dae3d0e46d061380$var$HeadSnapshot extends $dae3d0e46d061380$var$Snapshot {
    constructor(){
        super(...arguments);
        this.detailsByOuterHTML = this.children.filter((element)=>!$dae3d0e46d061380$var$elementIsNoscript(element)).map((element)=>$dae3d0e46d061380$var$elementWithoutNonce(element)).reduce((result, element)=>{
            const { outerHTML: outerHTML } = element;
            const details = outerHTML in result ? result[outerHTML] : {
                type: $dae3d0e46d061380$var$elementType(element),
                tracked: $dae3d0e46d061380$var$elementIsTracked(element),
                elements: []
            };
            return Object.assign(Object.assign({}, result), {
                [outerHTML]: Object.assign(Object.assign({}, details), {
                    elements: [
                        ...details.elements,
                        element
                    ]
                })
            });
        }, {});
    }
    get trackedElementSignature() {
        return Object.keys(this.detailsByOuterHTML).filter((outerHTML)=>this.detailsByOuterHTML[outerHTML].tracked).join("");
    }
    getScriptElementsNotInSnapshot(snapshot) {
        return this.getElementsMatchingTypeNotInSnapshot("script", snapshot);
    }
    getStylesheetElementsNotInSnapshot(snapshot) {
        return this.getElementsMatchingTypeNotInSnapshot("stylesheet", snapshot);
    }
    getElementsMatchingTypeNotInSnapshot(matchedType, snapshot) {
        return Object.keys(this.detailsByOuterHTML).filter((outerHTML)=>!(outerHTML in snapshot.detailsByOuterHTML)).map((outerHTML)=>this.detailsByOuterHTML[outerHTML]).filter(({ type: type })=>type == matchedType).map(({ elements: [element] })=>element);
    }
    get provisionalElements() {
        return Object.keys(this.detailsByOuterHTML).reduce((result, outerHTML)=>{
            const { type: type, tracked: tracked, elements: elements } = this.detailsByOuterHTML[outerHTML];
            if (type == null && !tracked) return [
                ...result,
                ...elements
            ];
            else if (elements.length > 1) return [
                ...result,
                ...elements.slice(1)
            ];
            else return result;
        }, []);
    }
    getMetaValue(name) {
        const element = this.findMetaElementByName(name);
        return element ? element.getAttribute("content") : null;
    }
    findMetaElementByName(name) {
        return Object.keys(this.detailsByOuterHTML).reduce((result, outerHTML)=>{
            const { elements: [element] } = this.detailsByOuterHTML[outerHTML];
            return $dae3d0e46d061380$var$elementIsMetaElementWithName(element, name) ? element : result;
        }, undefined);
    }
}
function $dae3d0e46d061380$var$elementType(element) {
    if ($dae3d0e46d061380$var$elementIsScript(element)) return "script";
    else if ($dae3d0e46d061380$var$elementIsStylesheet(element)) return "stylesheet";
}
function $dae3d0e46d061380$var$elementIsTracked(element) {
    return element.getAttribute("data-turbo-track") == "reload";
}
function $dae3d0e46d061380$var$elementIsScript(element) {
    const tagName = element.localName;
    return tagName == "script";
}
function $dae3d0e46d061380$var$elementIsNoscript(element) {
    const tagName = element.localName;
    return tagName == "noscript";
}
function $dae3d0e46d061380$var$elementIsStylesheet(element) {
    const tagName = element.localName;
    return tagName == "style" || tagName == "link" && element.getAttribute("rel") == "stylesheet";
}
function $dae3d0e46d061380$var$elementIsMetaElementWithName(element, name) {
    const tagName = element.localName;
    return tagName == "meta" && element.getAttribute("name") == name;
}
function $dae3d0e46d061380$var$elementWithoutNonce(element) {
    if (element.hasAttribute("nonce")) element.setAttribute("nonce", "");
    return element;
}
class $dae3d0e46d061380$export$4f11b95e473fd113 extends $dae3d0e46d061380$var$Snapshot {
    static fromHTMLString(html = "") {
        return this.fromDocument($dae3d0e46d061380$var$parseHTMLDocument(html));
    }
    static fromElement(element) {
        return this.fromDocument(element.ownerDocument);
    }
    static fromDocument({ head: head, body: body }) {
        return new this(body, new $dae3d0e46d061380$var$HeadSnapshot(head));
    }
    constructor(element, headSnapshot){
        super(element);
        this.headSnapshot = headSnapshot;
    }
    clone() {
        const clonedElement = this.element.cloneNode(true);
        const selectElements = this.element.querySelectorAll("select");
        const clonedSelectElements = clonedElement.querySelectorAll("select");
        for (const [index, source] of selectElements.entries()){
            const clone = clonedSelectElements[index];
            for (const option of clone.selectedOptions)option.selected = false;
            for (const option of source.selectedOptions)clone.options[option.index].selected = true;
        }
        for (const clonedPasswordInput of clonedElement.querySelectorAll('input[type="password"]'))clonedPasswordInput.value = "";
        return new $dae3d0e46d061380$export$4f11b95e473fd113(clonedElement, this.headSnapshot);
    }
    get headElement() {
        return this.headSnapshot.element;
    }
    get rootLocation() {
        var _a;
        const root = (_a = this.getSetting("root")) !== null && _a !== void 0 ? _a : "/";
        return $dae3d0e46d061380$var$expandURL(root);
    }
    get cacheControlValue() {
        return this.getSetting("cache-control");
    }
    get isPreviewable() {
        return this.cacheControlValue != "no-preview";
    }
    get isCacheable() {
        return this.cacheControlValue != "no-cache";
    }
    get isVisitable() {
        return this.getSetting("visit-control") != "reload";
    }
    getSetting(name) {
        return this.headSnapshot.getMetaValue(`turbo-${name}`);
    }
}
var $dae3d0e46d061380$var$TimingMetric;
(function(TimingMetric) {
    TimingMetric["visitStart"] = "visitStart";
    TimingMetric["requestStart"] = "requestStart";
    TimingMetric["requestEnd"] = "requestEnd";
    TimingMetric["visitEnd"] = "visitEnd";
})($dae3d0e46d061380$var$TimingMetric || ($dae3d0e46d061380$var$TimingMetric = {}));
var $dae3d0e46d061380$var$VisitState;
(function(VisitState) {
    VisitState["initialized"] = "initialized";
    VisitState["started"] = "started";
    VisitState["canceled"] = "canceled";
    VisitState["failed"] = "failed";
    VisitState["completed"] = "completed";
})($dae3d0e46d061380$var$VisitState || ($dae3d0e46d061380$var$VisitState = {}));
const $dae3d0e46d061380$var$defaultOptions = {
    action: "advance",
    historyChanged: false,
    visitCachedSnapshot: ()=>{},
    willRender: true,
    updateHistory: true,
    shouldCacheSnapshot: true,
    acceptsStreamResponse: false
};
var $dae3d0e46d061380$var$SystemStatusCode;
(function(SystemStatusCode) {
    SystemStatusCode[SystemStatusCode["networkFailure"] = 0] = "networkFailure";
    SystemStatusCode[SystemStatusCode["timeoutFailure"] = -1] = "timeoutFailure";
    SystemStatusCode[SystemStatusCode["contentTypeMismatch"] = -2] = "contentTypeMismatch";
})($dae3d0e46d061380$var$SystemStatusCode || ($dae3d0e46d061380$var$SystemStatusCode = {}));
class $dae3d0e46d061380$var$Visit {
    constructor(delegate, location1, restorationIdentifier, options = {}){
        this.identifier = $dae3d0e46d061380$var$uuid();
        this.timingMetrics = {};
        this.followedRedirect = false;
        this.historyChanged = false;
        this.scrolled = false;
        this.shouldCacheSnapshot = true;
        this.acceptsStreamResponse = false;
        this.snapshotCached = false;
        this.state = $dae3d0e46d061380$var$VisitState.initialized;
        this.delegate = delegate;
        this.location = location1;
        this.restorationIdentifier = restorationIdentifier || $dae3d0e46d061380$var$uuid();
        const { action: action, historyChanged: historyChanged, referrer: referrer, snapshot: snapshot, snapshotHTML: snapshotHTML, response: response, visitCachedSnapshot: visitCachedSnapshot, willRender: willRender, updateHistory: updateHistory, shouldCacheSnapshot: shouldCacheSnapshot, acceptsStreamResponse: acceptsStreamResponse } = Object.assign(Object.assign({}, $dae3d0e46d061380$var$defaultOptions), options);
        this.action = action;
        this.historyChanged = historyChanged;
        this.referrer = referrer;
        this.snapshot = snapshot;
        this.snapshotHTML = snapshotHTML;
        this.response = response;
        this.isSamePage = this.delegate.locationWithActionIsSamePage(this.location, this.action);
        this.visitCachedSnapshot = visitCachedSnapshot;
        this.willRender = willRender;
        this.updateHistory = updateHistory;
        this.scrolled = !willRender;
        this.shouldCacheSnapshot = shouldCacheSnapshot;
        this.acceptsStreamResponse = acceptsStreamResponse;
    }
    get adapter() {
        return this.delegate.adapter;
    }
    get view() {
        return this.delegate.view;
    }
    get history() {
        return this.delegate.history;
    }
    get restorationData() {
        return this.history.getRestorationDataForIdentifier(this.restorationIdentifier);
    }
    get silent() {
        return this.isSamePage;
    }
    start() {
        if (this.state == $dae3d0e46d061380$var$VisitState.initialized) {
            this.recordTimingMetric($dae3d0e46d061380$var$TimingMetric.visitStart);
            this.state = $dae3d0e46d061380$var$VisitState.started;
            this.adapter.visitStarted(this);
            this.delegate.visitStarted(this);
        }
    }
    cancel() {
        if (this.state == $dae3d0e46d061380$var$VisitState.started) {
            if (this.request) this.request.cancel();
            this.cancelRender();
            this.state = $dae3d0e46d061380$var$VisitState.canceled;
        }
    }
    complete() {
        if (this.state == $dae3d0e46d061380$var$VisitState.started) {
            this.recordTimingMetric($dae3d0e46d061380$var$TimingMetric.visitEnd);
            this.state = $dae3d0e46d061380$var$VisitState.completed;
            this.followRedirect();
            if (!this.followedRedirect) {
                this.adapter.visitCompleted(this);
                this.delegate.visitCompleted(this);
            }
        }
    }
    fail() {
        if (this.state == $dae3d0e46d061380$var$VisitState.started) {
            this.state = $dae3d0e46d061380$var$VisitState.failed;
            this.adapter.visitFailed(this);
        }
    }
    changeHistory() {
        var _a;
        if (!this.historyChanged && this.updateHistory) {
            const actionForHistory = this.location.href === ((_a = this.referrer) === null || _a === void 0 ? void 0 : _a.href) ? "replace" : this.action;
            const method = $dae3d0e46d061380$var$getHistoryMethodForAction(actionForHistory);
            this.history.update(method, this.location, this.restorationIdentifier);
            this.historyChanged = true;
        }
    }
    issueRequest() {
        if (this.hasPreloadedResponse()) this.simulateRequest();
        else if (this.shouldIssueRequest() && !this.request) {
            this.request = new $dae3d0e46d061380$var$FetchRequest(this, $dae3d0e46d061380$var$FetchMethod.get, this.location);
            this.request.perform();
        }
    }
    simulateRequest() {
        if (this.response) {
            this.startRequest();
            this.recordResponse();
            this.finishRequest();
        }
    }
    startRequest() {
        this.recordTimingMetric($dae3d0e46d061380$var$TimingMetric.requestStart);
        this.adapter.visitRequestStarted(this);
    }
    recordResponse(response = this.response) {
        this.response = response;
        if (response) {
            const { statusCode: statusCode } = response;
            if ($dae3d0e46d061380$var$isSuccessful(statusCode)) this.adapter.visitRequestCompleted(this);
            else this.adapter.visitRequestFailedWithStatusCode(this, statusCode);
        }
    }
    finishRequest() {
        this.recordTimingMetric($dae3d0e46d061380$var$TimingMetric.requestEnd);
        this.adapter.visitRequestFinished(this);
    }
    loadResponse() {
        if (this.response) {
            const { statusCode: statusCode, responseHTML: responseHTML } = this.response;
            this.render(async ()=>{
                if (this.shouldCacheSnapshot) this.cacheSnapshot();
                if (this.view.renderPromise) await this.view.renderPromise;
                if ($dae3d0e46d061380$var$isSuccessful(statusCode) && responseHTML != null) {
                    await this.view.renderPage($dae3d0e46d061380$export$4f11b95e473fd113.fromHTMLString(responseHTML), false, this.willRender, this);
                    this.performScroll();
                    this.adapter.visitRendered(this);
                    this.complete();
                } else {
                    await this.view.renderError($dae3d0e46d061380$export$4f11b95e473fd113.fromHTMLString(responseHTML), this);
                    this.adapter.visitRendered(this);
                    this.fail();
                }
            });
        }
    }
    getCachedSnapshot() {
        const snapshot = this.view.getCachedSnapshotForLocation(this.location) || this.getPreloadedSnapshot();
        if (snapshot && (!$dae3d0e46d061380$var$getAnchor(this.location) || snapshot.hasAnchor($dae3d0e46d061380$var$getAnchor(this.location)))) {
            if (this.action == "restore" || snapshot.isPreviewable) return snapshot;
        }
    }
    getPreloadedSnapshot() {
        if (this.snapshotHTML) return $dae3d0e46d061380$export$4f11b95e473fd113.fromHTMLString(this.snapshotHTML);
    }
    hasCachedSnapshot() {
        return this.getCachedSnapshot() != null;
    }
    loadCachedSnapshot() {
        const snapshot = this.getCachedSnapshot();
        if (snapshot) {
            const isPreview = this.shouldIssueRequest();
            this.render(async ()=>{
                this.cacheSnapshot();
                if (this.isSamePage) this.adapter.visitRendered(this);
                else {
                    if (this.view.renderPromise) await this.view.renderPromise;
                    await this.view.renderPage(snapshot, isPreview, this.willRender, this);
                    this.performScroll();
                    this.adapter.visitRendered(this);
                    if (!isPreview) this.complete();
                }
            });
        }
    }
    followRedirect() {
        var _a;
        if (this.redirectedToLocation && !this.followedRedirect && ((_a = this.response) === null || _a === void 0 ? void 0 : _a.redirected)) {
            this.adapter.visitProposedToLocation(this.redirectedToLocation, {
                action: "replace",
                response: this.response,
                shouldCacheSnapshot: false,
                willRender: false
            });
            this.followedRedirect = true;
        }
    }
    goToSamePageAnchor() {
        if (this.isSamePage) this.render(async ()=>{
            this.cacheSnapshot();
            this.performScroll();
            this.changeHistory();
            this.adapter.visitRendered(this);
        });
    }
    prepareRequest(request) {
        if (this.acceptsStreamResponse) request.acceptResponseType($dae3d0e46d061380$var$StreamMessage.contentType);
    }
    requestStarted() {
        this.startRequest();
    }
    requestPreventedHandlingResponse(_request, _response) {}
    async requestSucceededWithResponse(request, response) {
        const responseHTML = await response.responseHTML;
        const { redirected: redirected, statusCode: statusCode } = response;
        if (responseHTML == undefined) this.recordResponse({
            statusCode: $dae3d0e46d061380$var$SystemStatusCode.contentTypeMismatch,
            redirected: redirected
        });
        else {
            this.redirectedToLocation = response.redirected ? response.location : undefined;
            this.recordResponse({
                statusCode: statusCode,
                responseHTML: responseHTML,
                redirected: redirected
            });
        }
    }
    async requestFailedWithResponse(request, response) {
        const responseHTML = await response.responseHTML;
        const { redirected: redirected, statusCode: statusCode } = response;
        if (responseHTML == undefined) this.recordResponse({
            statusCode: $dae3d0e46d061380$var$SystemStatusCode.contentTypeMismatch,
            redirected: redirected
        });
        else this.recordResponse({
            statusCode: statusCode,
            responseHTML: responseHTML,
            redirected: redirected
        });
    }
    requestErrored(_request, _error) {
        this.recordResponse({
            statusCode: $dae3d0e46d061380$var$SystemStatusCode.networkFailure,
            redirected: false
        });
    }
    requestFinished() {
        this.finishRequest();
    }
    performScroll() {
        if (!this.scrolled && !this.view.forceReloaded) {
            if (this.action == "restore") this.scrollToRestoredPosition() || this.scrollToAnchor() || this.view.scrollToTop();
            else this.scrollToAnchor() || this.view.scrollToTop();
            if (this.isSamePage) this.delegate.visitScrolledToSamePageLocation(this.view.lastRenderedLocation, this.location);
            this.scrolled = true;
        }
    }
    scrollToRestoredPosition() {
        const { scrollPosition: scrollPosition } = this.restorationData;
        if (scrollPosition) {
            this.view.scrollToPosition(scrollPosition);
            return true;
        }
    }
    scrollToAnchor() {
        const anchor = $dae3d0e46d061380$var$getAnchor(this.location);
        if (anchor != null) {
            this.view.scrollToAnchor(anchor);
            return true;
        }
    }
    recordTimingMetric(metric) {
        this.timingMetrics[metric] = new Date().getTime();
    }
    getTimingMetrics() {
        return Object.assign({}, this.timingMetrics);
    }
    getHistoryMethodForAction(action) {
        switch(action){
            case "replace":
                return history.replaceState;
            case "advance":
            case "restore":
                return history.pushState;
        }
    }
    hasPreloadedResponse() {
        return typeof this.response == "object";
    }
    shouldIssueRequest() {
        if (this.isSamePage) return false;
        else if (this.action == "restore") return !this.hasCachedSnapshot();
        else return this.willRender;
    }
    cacheSnapshot() {
        if (!this.snapshotCached) {
            this.view.cacheSnapshot(this.snapshot).then((snapshot)=>snapshot && this.visitCachedSnapshot(snapshot));
            this.snapshotCached = true;
        }
    }
    async render(callback) {
        this.cancelRender();
        await new Promise((resolve)=>{
            this.frame = requestAnimationFrame(()=>resolve());
        });
        await callback();
        delete this.frame;
    }
    cancelRender() {
        if (this.frame) {
            cancelAnimationFrame(this.frame);
            delete this.frame;
        }
    }
}
function $dae3d0e46d061380$var$isSuccessful(statusCode) {
    return statusCode >= 200 && statusCode < 300;
}
class $dae3d0e46d061380$var$BrowserAdapter {
    constructor(session){
        this.progressBar = new $dae3d0e46d061380$var$ProgressBar();
        this.showProgressBar = ()=>{
            this.progressBar.show();
        };
        this.session = session;
    }
    visitProposedToLocation(location1, options) {
        this.navigator.startVisit(location1, (options === null || options === void 0 ? void 0 : options.restorationIdentifier) || $dae3d0e46d061380$var$uuid(), options);
    }
    visitStarted(visit) {
        this.location = visit.location;
        visit.loadCachedSnapshot();
        visit.issueRequest();
        visit.goToSamePageAnchor();
    }
    visitRequestStarted(visit) {
        this.progressBar.setValue(0);
        if (visit.hasCachedSnapshot() || visit.action != "restore") this.showVisitProgressBarAfterDelay();
        else this.showProgressBar();
    }
    visitRequestCompleted(visit) {
        visit.loadResponse();
    }
    visitRequestFailedWithStatusCode(visit, statusCode) {
        switch(statusCode){
            case $dae3d0e46d061380$var$SystemStatusCode.networkFailure:
            case $dae3d0e46d061380$var$SystemStatusCode.timeoutFailure:
            case $dae3d0e46d061380$var$SystemStatusCode.contentTypeMismatch:
                return this.reload({
                    reason: "request_failed",
                    context: {
                        statusCode: statusCode
                    }
                });
            default:
                return visit.loadResponse();
        }
    }
    visitRequestFinished(_visit) {
        this.progressBar.setValue(1);
        this.hideVisitProgressBar();
    }
    visitCompleted(_visit) {}
    pageInvalidated(reason) {
        this.reload(reason);
    }
    visitFailed(_visit) {}
    visitRendered(_visit) {}
    formSubmissionStarted(_formSubmission) {
        this.progressBar.setValue(0);
        this.showFormProgressBarAfterDelay();
    }
    formSubmissionFinished(_formSubmission) {
        this.progressBar.setValue(1);
        this.hideFormProgressBar();
    }
    showVisitProgressBarAfterDelay() {
        this.visitProgressBarTimeout = window.setTimeout(this.showProgressBar, this.session.progressBarDelay);
    }
    hideVisitProgressBar() {
        this.progressBar.hide();
        if (this.visitProgressBarTimeout != null) {
            window.clearTimeout(this.visitProgressBarTimeout);
            delete this.visitProgressBarTimeout;
        }
    }
    showFormProgressBarAfterDelay() {
        if (this.formProgressBarTimeout == null) this.formProgressBarTimeout = window.setTimeout(this.showProgressBar, this.session.progressBarDelay);
    }
    hideFormProgressBar() {
        this.progressBar.hide();
        if (this.formProgressBarTimeout != null) {
            window.clearTimeout(this.formProgressBarTimeout);
            delete this.formProgressBarTimeout;
        }
    }
    reload(reason) {
        var _a;
        $dae3d0e46d061380$var$dispatch("turbo:reload", {
            detail: reason
        });
        window.location.href = ((_a = this.location) === null || _a === void 0 ? void 0 : _a.toString()) || window.location.href;
    }
    get navigator() {
        return this.session.navigator;
    }
}
class $dae3d0e46d061380$var$CacheObserver {
    constructor(){
        this.selector = "[data-turbo-temporary]";
        this.deprecatedSelector = "[data-turbo-cache=false]";
        this.started = false;
        this.removeTemporaryElements = (_event)=>{
            for (const element of this.temporaryElements)element.remove();
        };
    }
    start() {
        if (!this.started) {
            this.started = true;
            addEventListener("turbo:before-cache", this.removeTemporaryElements, false);
        }
    }
    stop() {
        if (this.started) {
            this.started = false;
            removeEventListener("turbo:before-cache", this.removeTemporaryElements, false);
        }
    }
    get temporaryElements() {
        return [
            ...document.querySelectorAll(this.selector),
            ...this.temporaryElementsWithDeprecation
        ];
    }
    get temporaryElementsWithDeprecation() {
        const elements = document.querySelectorAll(this.deprecatedSelector);
        if (elements.length) console.warn(`The ${this.deprecatedSelector} selector is deprecated and will be removed in a future version. Use ${this.selector} instead.`);
        return [
            ...elements
        ];
    }
}
class $dae3d0e46d061380$var$FrameRedirector {
    constructor(session, element){
        this.session = session;
        this.element = element;
        this.linkInterceptor = new $dae3d0e46d061380$var$LinkInterceptor(this, element);
        this.formSubmitObserver = new $dae3d0e46d061380$var$FormSubmitObserver(this, element);
    }
    start() {
        this.linkInterceptor.start();
        this.formSubmitObserver.start();
    }
    stop() {
        this.linkInterceptor.stop();
        this.formSubmitObserver.stop();
    }
    shouldInterceptLinkClick(element, _location, _event) {
        return this.shouldRedirect(element);
    }
    linkClickIntercepted(element, url, event) {
        const frame = this.findFrameElement(element);
        if (frame) frame.delegate.linkClickIntercepted(element, url, event);
    }
    willSubmitForm(element, submitter) {
        return element.closest("turbo-frame") == null && this.shouldSubmit(element, submitter) && this.shouldRedirect(element, submitter);
    }
    formSubmitted(element, submitter) {
        const frame = this.findFrameElement(element, submitter);
        if (frame) frame.delegate.formSubmitted(element, submitter);
    }
    shouldSubmit(form, submitter) {
        var _a;
        const action = $dae3d0e46d061380$var$getAction(form, submitter);
        const meta = this.element.ownerDocument.querySelector(`meta[name="turbo-root"]`);
        const rootLocation = $dae3d0e46d061380$var$expandURL((_a = meta === null || meta === void 0 ? void 0 : meta.content) !== null && _a !== void 0 ? _a : "/");
        return this.shouldRedirect(form, submitter) && $dae3d0e46d061380$var$locationIsVisitable(action, rootLocation);
    }
    shouldRedirect(element, submitter) {
        const isNavigatable = element instanceof HTMLFormElement ? this.session.submissionIsNavigatable(element, submitter) : this.session.elementIsNavigatable(element);
        if (isNavigatable) {
            const frame = this.findFrameElement(element, submitter);
            return frame ? frame != element.closest("turbo-frame") : false;
        } else return false;
    }
    findFrameElement(element, submitter) {
        const id = (submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("data-turbo-frame")) || element.getAttribute("data-turbo-frame");
        if (id && id != "_top") {
            const frame = this.element.querySelector(`#${id}:not([disabled])`);
            if (frame instanceof $dae3d0e46d061380$export$f464a8f0ffa32c44) return frame;
        }
    }
}
class $dae3d0e46d061380$var$History {
    constructor(delegate){
        this.restorationIdentifier = $dae3d0e46d061380$var$uuid();
        this.restorationData = {};
        this.started = false;
        this.pageLoaded = false;
        this.onPopState = (event)=>{
            if (this.shouldHandlePopState()) {
                const { turbo: turbo } = event.state || {};
                if (turbo) {
                    this.location = new URL(window.location.href);
                    const { restorationIdentifier: restorationIdentifier } = turbo;
                    this.restorationIdentifier = restorationIdentifier;
                    this.delegate.historyPoppedToLocationWithRestorationIdentifier(this.location, restorationIdentifier);
                }
            }
        };
        this.onPageLoad = async (_event)=>{
            await $dae3d0e46d061380$var$nextMicrotask();
            this.pageLoaded = true;
        };
        this.delegate = delegate;
    }
    start() {
        if (!this.started) {
            addEventListener("popstate", this.onPopState, false);
            addEventListener("load", this.onPageLoad, false);
            this.started = true;
            this.replace(new URL(window.location.href));
        }
    }
    stop() {
        if (this.started) {
            removeEventListener("popstate", this.onPopState, false);
            removeEventListener("load", this.onPageLoad, false);
            this.started = false;
        }
    }
    push(location1, restorationIdentifier) {
        this.update(history.pushState, location1, restorationIdentifier);
    }
    replace(location1, restorationIdentifier) {
        this.update(history.replaceState, location1, restorationIdentifier);
    }
    update(method, location1, restorationIdentifier = $dae3d0e46d061380$var$uuid()) {
        const state = {
            turbo: {
                restorationIdentifier: restorationIdentifier
            }
        };
        method.call(history, state, "", location1.href);
        this.location = location1;
        this.restorationIdentifier = restorationIdentifier;
    }
    getRestorationDataForIdentifier(restorationIdentifier) {
        return this.restorationData[restorationIdentifier] || {};
    }
    updateRestorationData(additionalData) {
        const { restorationIdentifier: restorationIdentifier } = this;
        const restorationData = this.restorationData[restorationIdentifier];
        this.restorationData[restorationIdentifier] = Object.assign(Object.assign({}, restorationData), additionalData);
    }
    assumeControlOfScrollRestoration() {
        var _a;
        if (!this.previousScrollRestoration) {
            this.previousScrollRestoration = (_a = history.scrollRestoration) !== null && _a !== void 0 ? _a : "auto";
            history.scrollRestoration = "manual";
        }
    }
    relinquishControlOfScrollRestoration() {
        if (this.previousScrollRestoration) {
            history.scrollRestoration = this.previousScrollRestoration;
            delete this.previousScrollRestoration;
        }
    }
    shouldHandlePopState() {
        return this.pageIsLoaded();
    }
    pageIsLoaded() {
        return this.pageLoaded || document.readyState == "complete";
    }
}
class $dae3d0e46d061380$var$Navigator {
    constructor(delegate){
        this.delegate = delegate;
    }
    proposeVisit(location1, options = {}) {
        if (this.delegate.allowsVisitingLocationWithAction(location1, options.action)) {
            if ($dae3d0e46d061380$var$locationIsVisitable(location1, this.view.snapshot.rootLocation)) this.delegate.visitProposedToLocation(location1, options);
            else window.location.href = location1.toString();
        }
    }
    startVisit(locatable, restorationIdentifier, options = {}) {
        this.stop();
        this.currentVisit = new $dae3d0e46d061380$var$Visit(this, $dae3d0e46d061380$var$expandURL(locatable), restorationIdentifier, Object.assign({
            referrer: this.location
        }, options));
        this.currentVisit.start();
    }
    submitForm(form, submitter) {
        this.stop();
        this.formSubmission = new $dae3d0e46d061380$var$FormSubmission(this, form, submitter, true);
        this.formSubmission.start();
    }
    stop() {
        if (this.formSubmission) {
            this.formSubmission.stop();
            delete this.formSubmission;
        }
        if (this.currentVisit) {
            this.currentVisit.cancel();
            delete this.currentVisit;
        }
    }
    get adapter() {
        return this.delegate.adapter;
    }
    get view() {
        return this.delegate.view;
    }
    get history() {
        return this.delegate.history;
    }
    formSubmissionStarted(formSubmission) {
        if (typeof this.adapter.formSubmissionStarted === "function") this.adapter.formSubmissionStarted(formSubmission);
    }
    async formSubmissionSucceededWithResponse(formSubmission, fetchResponse) {
        if (formSubmission == this.formSubmission) {
            const responseHTML = await fetchResponse.responseHTML;
            if (responseHTML) {
                const shouldCacheSnapshot = formSubmission.isSafe;
                if (!shouldCacheSnapshot) this.view.clearSnapshotCache();
                const { statusCode: statusCode, redirected: redirected } = fetchResponse;
                const action = this.getActionForFormSubmission(formSubmission);
                const visitOptions = {
                    action: action,
                    shouldCacheSnapshot: shouldCacheSnapshot,
                    response: {
                        statusCode: statusCode,
                        responseHTML: responseHTML,
                        redirected: redirected
                    }
                };
                this.proposeVisit(fetchResponse.location, visitOptions);
            }
        }
    }
    async formSubmissionFailedWithResponse(formSubmission, fetchResponse) {
        const responseHTML = await fetchResponse.responseHTML;
        if (responseHTML) {
            const snapshot = $dae3d0e46d061380$export$4f11b95e473fd113.fromHTMLString(responseHTML);
            if (fetchResponse.serverError) await this.view.renderError(snapshot, this.currentVisit);
            else await this.view.renderPage(snapshot, false, true, this.currentVisit);
            this.view.scrollToTop();
            this.view.clearSnapshotCache();
        }
    }
    formSubmissionErrored(formSubmission, error) {
        console.error(error);
    }
    formSubmissionFinished(formSubmission) {
        if (typeof this.adapter.formSubmissionFinished === "function") this.adapter.formSubmissionFinished(formSubmission);
    }
    visitStarted(visit) {
        this.delegate.visitStarted(visit);
    }
    visitCompleted(visit) {
        this.delegate.visitCompleted(visit);
    }
    locationWithActionIsSamePage(location1, action) {
        const anchor = $dae3d0e46d061380$var$getAnchor(location1);
        const currentAnchor = $dae3d0e46d061380$var$getAnchor(this.view.lastRenderedLocation);
        const isRestorationToTop = action === "restore" && typeof anchor === "undefined";
        return action !== "replace" && $dae3d0e46d061380$var$getRequestURL(location1) === $dae3d0e46d061380$var$getRequestURL(this.view.lastRenderedLocation) && (isRestorationToTop || anchor != null && anchor !== currentAnchor);
    }
    visitScrolledToSamePageLocation(oldURL, newURL) {
        this.delegate.visitScrolledToSamePageLocation(oldURL, newURL);
    }
    get location() {
        return this.history.location;
    }
    get restorationIdentifier() {
        return this.history.restorationIdentifier;
    }
    getActionForFormSubmission({ submitter: submitter, formElement: formElement }) {
        return $dae3d0e46d061380$var$getVisitAction(submitter, formElement) || "advance";
    }
}
var $dae3d0e46d061380$var$PageStage;
(function(PageStage) {
    PageStage[PageStage["initial"] = 0] = "initial";
    PageStage[PageStage["loading"] = 1] = "loading";
    PageStage[PageStage["interactive"] = 2] = "interactive";
    PageStage[PageStage["complete"] = 3] = "complete";
})($dae3d0e46d061380$var$PageStage || ($dae3d0e46d061380$var$PageStage = {}));
class $dae3d0e46d061380$var$PageObserver {
    constructor(delegate){
        this.stage = $dae3d0e46d061380$var$PageStage.initial;
        this.started = false;
        this.interpretReadyState = ()=>{
            const { readyState: readyState } = this;
            if (readyState == "interactive") this.pageIsInteractive();
            else if (readyState == "complete") this.pageIsComplete();
        };
        this.pageWillUnload = ()=>{
            this.delegate.pageWillUnload();
        };
        this.delegate = delegate;
    }
    start() {
        if (!this.started) {
            if (this.stage == $dae3d0e46d061380$var$PageStage.initial) this.stage = $dae3d0e46d061380$var$PageStage.loading;
            document.addEventListener("readystatechange", this.interpretReadyState, false);
            addEventListener("pagehide", this.pageWillUnload, false);
            this.started = true;
        }
    }
    stop() {
        if (this.started) {
            document.removeEventListener("readystatechange", this.interpretReadyState, false);
            removeEventListener("pagehide", this.pageWillUnload, false);
            this.started = false;
        }
    }
    pageIsInteractive() {
        if (this.stage == $dae3d0e46d061380$var$PageStage.loading) {
            this.stage = $dae3d0e46d061380$var$PageStage.interactive;
            this.delegate.pageBecameInteractive();
        }
    }
    pageIsComplete() {
        this.pageIsInteractive();
        if (this.stage == $dae3d0e46d061380$var$PageStage.interactive) {
            this.stage = $dae3d0e46d061380$var$PageStage.complete;
            this.delegate.pageLoaded();
        }
    }
    get readyState() {
        return document.readyState;
    }
}
class $dae3d0e46d061380$var$ScrollObserver {
    constructor(delegate){
        this.started = false;
        this.onScroll = ()=>{
            this.updatePosition({
                x: window.pageXOffset,
                y: window.pageYOffset
            });
        };
        this.delegate = delegate;
    }
    start() {
        if (!this.started) {
            addEventListener("scroll", this.onScroll, false);
            this.onScroll();
            this.started = true;
        }
    }
    stop() {
        if (this.started) {
            removeEventListener("scroll", this.onScroll, false);
            this.started = false;
        }
    }
    updatePosition(position) {
        this.delegate.scrollPositionChanged(position);
    }
}
class $dae3d0e46d061380$var$StreamMessageRenderer {
    render({ fragment: fragment }) {
        $dae3d0e46d061380$var$Bardo.preservingPermanentElements(this, $dae3d0e46d061380$var$getPermanentElementMapForFragment(fragment), ()=>document.documentElement.appendChild(fragment));
    }
    enteringBardo(currentPermanentElement, newPermanentElement) {
        newPermanentElement.replaceWith(currentPermanentElement.cloneNode(true));
    }
    leavingBardo() {}
}
function $dae3d0e46d061380$var$getPermanentElementMapForFragment(fragment) {
    const permanentElementsInDocument = $dae3d0e46d061380$var$queryPermanentElementsAll(document.documentElement);
    const permanentElementMap = {};
    for (const permanentElementInDocument of permanentElementsInDocument){
        const { id: id } = permanentElementInDocument;
        for (const streamElement of fragment.querySelectorAll("turbo-stream")){
            const elementInStream = $dae3d0e46d061380$var$getPermanentElementById(streamElement.templateElement.content, id);
            if (elementInStream) permanentElementMap[id] = [
                permanentElementInDocument,
                elementInStream
            ];
        }
    }
    return permanentElementMap;
}
class $dae3d0e46d061380$var$StreamObserver {
    constructor(delegate){
        this.sources = new Set();
        this.started = false;
        this.inspectFetchResponse = (event)=>{
            const response = $dae3d0e46d061380$var$fetchResponseFromEvent(event);
            if (response && $dae3d0e46d061380$var$fetchResponseIsStream(response)) {
                event.preventDefault();
                this.receiveMessageResponse(response);
            }
        };
        this.receiveMessageEvent = (event)=>{
            if (this.started && typeof event.data == "string") this.receiveMessageHTML(event.data);
        };
        this.delegate = delegate;
    }
    start() {
        if (!this.started) {
            this.started = true;
            addEventListener("turbo:before-fetch-response", this.inspectFetchResponse, false);
        }
    }
    stop() {
        if (this.started) {
            this.started = false;
            removeEventListener("turbo:before-fetch-response", this.inspectFetchResponse, false);
        }
    }
    connectStreamSource(source) {
        if (!this.streamSourceIsConnected(source)) {
            this.sources.add(source);
            source.addEventListener("message", this.receiveMessageEvent, false);
        }
    }
    disconnectStreamSource(source) {
        if (this.streamSourceIsConnected(source)) {
            this.sources.delete(source);
            source.removeEventListener("message", this.receiveMessageEvent, false);
        }
    }
    streamSourceIsConnected(source) {
        return this.sources.has(source);
    }
    async receiveMessageResponse(response) {
        const html = await response.responseHTML;
        if (html) this.receiveMessageHTML(html);
    }
    receiveMessageHTML(html) {
        this.delegate.receivedMessageFromStream($dae3d0e46d061380$var$StreamMessage.wrap(html));
    }
}
function $dae3d0e46d061380$var$fetchResponseFromEvent(event) {
    var _a;
    const fetchResponse = (_a = event.detail) === null || _a === void 0 ? void 0 : _a.fetchResponse;
    if (fetchResponse instanceof $dae3d0e46d061380$var$FetchResponse) return fetchResponse;
}
function $dae3d0e46d061380$var$fetchResponseIsStream(response) {
    var _a;
    const contentType = (_a = response.contentType) !== null && _a !== void 0 ? _a : "";
    return contentType.startsWith($dae3d0e46d061380$var$StreamMessage.contentType);
}
class $dae3d0e46d061380$var$ErrorRenderer extends $dae3d0e46d061380$var$Renderer {
    static renderElement(currentElement, newElement) {
        const { documentElement: documentElement, body: body } = document;
        documentElement.replaceChild(newElement, body);
    }
    async render() {
        this.replaceHeadAndBody();
        this.activateScriptElements();
    }
    replaceHeadAndBody() {
        const { documentElement: documentElement, head: head } = document;
        documentElement.replaceChild(this.newHead, head);
        this.renderElement(this.currentElement, this.newElement);
    }
    activateScriptElements() {
        for (const replaceableElement of this.scriptElements){
            const parentNode = replaceableElement.parentNode;
            if (parentNode) {
                const element = $dae3d0e46d061380$var$activateScriptElement(replaceableElement);
                parentNode.replaceChild(element, replaceableElement);
            }
        }
    }
    get newHead() {
        return this.newSnapshot.headSnapshot.element;
    }
    get scriptElements() {
        return document.documentElement.querySelectorAll("script");
    }
}
class $dae3d0e46d061380$export$ac9642242cf7b3ce extends $dae3d0e46d061380$var$Renderer {
    static renderElement(currentElement, newElement) {
        if (document.body && newElement instanceof HTMLBodyElement) document.body.replaceWith(newElement);
        else document.documentElement.appendChild(newElement);
    }
    get shouldRender() {
        return this.newSnapshot.isVisitable && this.trackedElementsAreIdentical;
    }
    get reloadReason() {
        if (!this.newSnapshot.isVisitable) return {
            reason: "turbo_visit_control_is_reload"
        };
        if (!this.trackedElementsAreIdentical) return {
            reason: "tracked_element_mismatch"
        };
    }
    async prepareToRender() {
        await this.mergeHead();
    }
    async render() {
        if (this.willRender) await this.replaceBody();
    }
    finishRendering() {
        super.finishRendering();
        if (!this.isPreview) this.focusFirstAutofocusableElement();
    }
    get currentHeadSnapshot() {
        return this.currentSnapshot.headSnapshot;
    }
    get newHeadSnapshot() {
        return this.newSnapshot.headSnapshot;
    }
    get newElement() {
        return this.newSnapshot.element;
    }
    async mergeHead() {
        const mergedHeadElements = this.mergeProvisionalElements();
        const newStylesheetElements = this.copyNewHeadStylesheetElements();
        this.copyNewHeadScriptElements();
        await mergedHeadElements;
        await newStylesheetElements;
    }
    async replaceBody() {
        await this.preservingPermanentElements(async ()=>{
            this.activateNewBody();
            await this.assignNewBody();
        });
    }
    get trackedElementsAreIdentical() {
        return this.currentHeadSnapshot.trackedElementSignature == this.newHeadSnapshot.trackedElementSignature;
    }
    async copyNewHeadStylesheetElements() {
        const loadingElements = [];
        for (const element of this.newHeadStylesheetElements){
            loadingElements.push($dae3d0e46d061380$var$waitForLoad(element));
            document.head.appendChild(element);
        }
        await Promise.all(loadingElements);
    }
    copyNewHeadScriptElements() {
        for (const element of this.newHeadScriptElements)document.head.appendChild($dae3d0e46d061380$var$activateScriptElement(element));
    }
    async mergeProvisionalElements() {
        const newHeadElements = [
            ...this.newHeadProvisionalElements
        ];
        for (const element of this.currentHeadProvisionalElements)if (!this.isCurrentElementInElementList(element, newHeadElements)) document.head.removeChild(element);
        for (const element of newHeadElements)document.head.appendChild(element);
    }
    isCurrentElementInElementList(element, elementList) {
        for (const [index, newElement] of elementList.entries()){
            if (element.tagName == "TITLE") {
                if (newElement.tagName != "TITLE") continue;
                if (element.innerHTML == newElement.innerHTML) {
                    elementList.splice(index, 1);
                    return true;
                }
            }
            if (newElement.isEqualNode(element)) {
                elementList.splice(index, 1);
                return true;
            }
        }
        return false;
    }
    removeCurrentHeadProvisionalElements() {
        for (const element of this.currentHeadProvisionalElements)document.head.removeChild(element);
    }
    copyNewHeadProvisionalElements() {
        for (const element of this.newHeadProvisionalElements)document.head.appendChild(element);
    }
    activateNewBody() {
        document.adoptNode(this.newElement);
        this.activateNewBodyScriptElements();
    }
    activateNewBodyScriptElements() {
        for (const inertScriptElement of this.newBodyScriptElements){
            const activatedScriptElement = $dae3d0e46d061380$var$activateScriptElement(inertScriptElement);
            inertScriptElement.replaceWith(activatedScriptElement);
        }
    }
    async assignNewBody() {
        await this.renderElement(this.currentElement, this.newElement);
    }
    get newHeadStylesheetElements() {
        return this.newHeadSnapshot.getStylesheetElementsNotInSnapshot(this.currentHeadSnapshot);
    }
    get newHeadScriptElements() {
        return this.newHeadSnapshot.getScriptElementsNotInSnapshot(this.currentHeadSnapshot);
    }
    get currentHeadProvisionalElements() {
        return this.currentHeadSnapshot.provisionalElements;
    }
    get newHeadProvisionalElements() {
        return this.newHeadSnapshot.provisionalElements;
    }
    get newBodyScriptElements() {
        return this.newElement.querySelectorAll("script");
    }
}
class $dae3d0e46d061380$var$SnapshotCache {
    constructor(size){
        this.keys = [];
        this.snapshots = {};
        this.size = size;
    }
    has(location1) {
        return $dae3d0e46d061380$var$toCacheKey(location1) in this.snapshots;
    }
    get(location1) {
        if (this.has(location1)) {
            const snapshot = this.read(location1);
            this.touch(location1);
            return snapshot;
        }
    }
    put(location1, snapshot) {
        this.write(location1, snapshot);
        this.touch(location1);
        return snapshot;
    }
    clear() {
        this.snapshots = {};
    }
    read(location1) {
        return this.snapshots[$dae3d0e46d061380$var$toCacheKey(location1)];
    }
    write(location1, snapshot) {
        this.snapshots[$dae3d0e46d061380$var$toCacheKey(location1)] = snapshot;
    }
    touch(location1) {
        const key = $dae3d0e46d061380$var$toCacheKey(location1);
        const index = this.keys.indexOf(key);
        if (index > -1) this.keys.splice(index, 1);
        this.keys.unshift(key);
        this.trim();
    }
    trim() {
        for (const key of this.keys.splice(this.size))delete this.snapshots[key];
    }
}
class $dae3d0e46d061380$var$PageView extends $dae3d0e46d061380$var$View {
    constructor(){
        super(...arguments);
        this.snapshotCache = new $dae3d0e46d061380$var$SnapshotCache(10);
        this.lastRenderedLocation = new URL(location.href);
        this.forceReloaded = false;
    }
    renderPage(snapshot, isPreview = false, willRender = true, visit) {
        const renderer = new $dae3d0e46d061380$export$ac9642242cf7b3ce(this.snapshot, snapshot, $dae3d0e46d061380$export$ac9642242cf7b3ce.renderElement, isPreview, willRender);
        if (!renderer.shouldRender) this.forceReloaded = true;
        else visit === null || visit === void 0 || visit.changeHistory();
        return this.render(renderer);
    }
    renderError(snapshot, visit) {
        visit === null || visit === void 0 || visit.changeHistory();
        const renderer = new $dae3d0e46d061380$var$ErrorRenderer(this.snapshot, snapshot, $dae3d0e46d061380$var$ErrorRenderer.renderElement, false);
        return this.render(renderer);
    }
    clearSnapshotCache() {
        this.snapshotCache.clear();
    }
    async cacheSnapshot(snapshot = this.snapshot) {
        if (snapshot.isCacheable) {
            this.delegate.viewWillCacheSnapshot();
            const { lastRenderedLocation: location1 } = this;
            await $dae3d0e46d061380$var$nextEventLoopTick();
            const cachedSnapshot = snapshot.clone();
            this.snapshotCache.put(location1, cachedSnapshot);
            return cachedSnapshot;
        }
    }
    getCachedSnapshotForLocation(location1) {
        return this.snapshotCache.get(location1);
    }
    get snapshot() {
        return $dae3d0e46d061380$export$4f11b95e473fd113.fromElement(this.element);
    }
}
class $dae3d0e46d061380$var$Preloader {
    constructor(delegate){
        this.selector = "a[data-turbo-preload]";
        this.delegate = delegate;
    }
    get snapshotCache() {
        return this.delegate.navigator.view.snapshotCache;
    }
    start() {
        if (document.readyState === "loading") return document.addEventListener("DOMContentLoaded", ()=>{
            this.preloadOnLoadLinksForView(document.body);
        });
        else this.preloadOnLoadLinksForView(document.body);
    }
    preloadOnLoadLinksForView(element) {
        for (const link of element.querySelectorAll(this.selector))this.preloadURL(link);
    }
    async preloadURL(link) {
        const location1 = new URL(link.href);
        if (this.snapshotCache.has(location1)) return;
        try {
            const response = await fetch(location1.toString(), {
                headers: {
                    "VND.PREFETCH": "true",
                    Accept: "text/html"
                }
            });
            const responseText = await response.text();
            const snapshot = $dae3d0e46d061380$export$4f11b95e473fd113.fromHTMLString(responseText);
            this.snapshotCache.put(location1, snapshot);
        } catch (_) {}
    }
}
class $dae3d0e46d061380$var$Session {
    constructor(){
        this.navigator = new $dae3d0e46d061380$var$Navigator(this);
        this.history = new $dae3d0e46d061380$var$History(this);
        this.preloader = new $dae3d0e46d061380$var$Preloader(this);
        this.view = new $dae3d0e46d061380$var$PageView(this, document.documentElement);
        this.adapter = new $dae3d0e46d061380$var$BrowserAdapter(this);
        this.pageObserver = new $dae3d0e46d061380$var$PageObserver(this);
        this.cacheObserver = new $dae3d0e46d061380$var$CacheObserver();
        this.linkClickObserver = new $dae3d0e46d061380$var$LinkClickObserver(this, window);
        this.formSubmitObserver = new $dae3d0e46d061380$var$FormSubmitObserver(this, document);
        this.scrollObserver = new $dae3d0e46d061380$var$ScrollObserver(this);
        this.streamObserver = new $dae3d0e46d061380$var$StreamObserver(this);
        this.formLinkClickObserver = new $dae3d0e46d061380$var$FormLinkClickObserver(this, document.documentElement);
        this.frameRedirector = new $dae3d0e46d061380$var$FrameRedirector(this, document.documentElement);
        this.streamMessageRenderer = new $dae3d0e46d061380$var$StreamMessageRenderer();
        this.drive = true;
        this.enabled = true;
        this.progressBarDelay = 500;
        this.started = false;
        this.formMode = "on";
    }
    start() {
        if (!this.started) {
            this.pageObserver.start();
            this.cacheObserver.start();
            this.formLinkClickObserver.start();
            this.linkClickObserver.start();
            this.formSubmitObserver.start();
            this.scrollObserver.start();
            this.streamObserver.start();
            this.frameRedirector.start();
            this.history.start();
            this.preloader.start();
            this.started = true;
            this.enabled = true;
        }
    }
    disable() {
        this.enabled = false;
    }
    stop() {
        if (this.started) {
            this.pageObserver.stop();
            this.cacheObserver.stop();
            this.formLinkClickObserver.stop();
            this.linkClickObserver.stop();
            this.formSubmitObserver.stop();
            this.scrollObserver.stop();
            this.streamObserver.stop();
            this.frameRedirector.stop();
            this.history.stop();
            this.started = false;
        }
    }
    registerAdapter(adapter) {
        this.adapter = adapter;
    }
    visit(location1, options = {}) {
        const frameElement = options.frame ? document.getElementById(options.frame) : null;
        if (frameElement instanceof $dae3d0e46d061380$export$f464a8f0ffa32c44) {
            frameElement.src = location1.toString();
            frameElement.loaded;
        } else this.navigator.proposeVisit($dae3d0e46d061380$var$expandURL(location1), options);
    }
    connectStreamSource(source) {
        this.streamObserver.connectStreamSource(source);
    }
    disconnectStreamSource(source) {
        this.streamObserver.disconnectStreamSource(source);
    }
    renderStreamMessage(message) {
        this.streamMessageRenderer.render($dae3d0e46d061380$var$StreamMessage.wrap(message));
    }
    clearCache() {
        this.view.clearSnapshotCache();
    }
    setProgressBarDelay(delay) {
        this.progressBarDelay = delay;
    }
    setFormMode(mode) {
        this.formMode = mode;
    }
    get location() {
        return this.history.location;
    }
    get restorationIdentifier() {
        return this.history.restorationIdentifier;
    }
    historyPoppedToLocationWithRestorationIdentifier(location1, restorationIdentifier) {
        if (this.enabled) this.navigator.startVisit(location1, restorationIdentifier, {
            action: "restore",
            historyChanged: true
        });
        else this.adapter.pageInvalidated({
            reason: "turbo_disabled"
        });
    }
    scrollPositionChanged(position) {
        this.history.updateRestorationData({
            scrollPosition: position
        });
    }
    willSubmitFormLinkToLocation(link, location1) {
        return this.elementIsNavigatable(link) && $dae3d0e46d061380$var$locationIsVisitable(location1, this.snapshot.rootLocation);
    }
    submittedFormLinkToLocation() {}
    willFollowLinkToLocation(link, location1, event) {
        return this.elementIsNavigatable(link) && $dae3d0e46d061380$var$locationIsVisitable(location1, this.snapshot.rootLocation) && this.applicationAllowsFollowingLinkToLocation(link, location1, event);
    }
    followedLinkToLocation(link, location1) {
        const action = this.getActionForLink(link);
        const acceptsStreamResponse = link.hasAttribute("data-turbo-stream");
        this.visit(location1.href, {
            action: action,
            acceptsStreamResponse: acceptsStreamResponse
        });
    }
    allowsVisitingLocationWithAction(location1, action) {
        return this.locationWithActionIsSamePage(location1, action) || this.applicationAllowsVisitingLocation(location1);
    }
    visitProposedToLocation(location1, options) {
        $dae3d0e46d061380$var$extendURLWithDeprecatedProperties(location1);
        this.adapter.visitProposedToLocation(location1, options);
    }
    visitStarted(visit) {
        if (!visit.acceptsStreamResponse) $dae3d0e46d061380$var$markAsBusy(document.documentElement);
        $dae3d0e46d061380$var$extendURLWithDeprecatedProperties(visit.location);
        if (!visit.silent) this.notifyApplicationAfterVisitingLocation(visit.location, visit.action);
    }
    visitCompleted(visit) {
        $dae3d0e46d061380$var$clearBusyState(document.documentElement);
        this.notifyApplicationAfterPageLoad(visit.getTimingMetrics());
    }
    locationWithActionIsSamePage(location1, action) {
        return this.navigator.locationWithActionIsSamePage(location1, action);
    }
    visitScrolledToSamePageLocation(oldURL, newURL) {
        this.notifyApplicationAfterVisitingSamePageLocation(oldURL, newURL);
    }
    willSubmitForm(form, submitter) {
        const action = $dae3d0e46d061380$var$getAction(form, submitter);
        return this.submissionIsNavigatable(form, submitter) && $dae3d0e46d061380$var$locationIsVisitable($dae3d0e46d061380$var$expandURL(action), this.snapshot.rootLocation);
    }
    formSubmitted(form, submitter) {
        this.navigator.submitForm(form, submitter);
    }
    pageBecameInteractive() {
        this.view.lastRenderedLocation = this.location;
        this.notifyApplicationAfterPageLoad();
    }
    pageLoaded() {
        this.history.assumeControlOfScrollRestoration();
    }
    pageWillUnload() {
        this.history.relinquishControlOfScrollRestoration();
    }
    receivedMessageFromStream(message) {
        this.renderStreamMessage(message);
    }
    viewWillCacheSnapshot() {
        var _a;
        if (!((_a = this.navigator.currentVisit) === null || _a === void 0 ? void 0 : _a.silent)) this.notifyApplicationBeforeCachingSnapshot();
    }
    allowsImmediateRender({ element: element }, options) {
        const event = this.notifyApplicationBeforeRender(element, options);
        const { defaultPrevented: defaultPrevented, detail: { render: render } } = event;
        if (this.view.renderer && render) this.view.renderer.renderElement = render;
        return !defaultPrevented;
    }
    viewRenderedSnapshot(_snapshot, _isPreview) {
        this.view.lastRenderedLocation = this.history.location;
        this.notifyApplicationAfterRender();
    }
    preloadOnLoadLinksForView(element) {
        this.preloader.preloadOnLoadLinksForView(element);
    }
    viewInvalidated(reason) {
        this.adapter.pageInvalidated(reason);
    }
    frameLoaded(frame) {
        this.notifyApplicationAfterFrameLoad(frame);
    }
    frameRendered(fetchResponse, frame) {
        this.notifyApplicationAfterFrameRender(fetchResponse, frame);
    }
    applicationAllowsFollowingLinkToLocation(link, location1, ev) {
        const event = this.notifyApplicationAfterClickingLinkToLocation(link, location1, ev);
        return !event.defaultPrevented;
    }
    applicationAllowsVisitingLocation(location1) {
        const event = this.notifyApplicationBeforeVisitingLocation(location1);
        return !event.defaultPrevented;
    }
    notifyApplicationAfterClickingLinkToLocation(link, location1, event) {
        return $dae3d0e46d061380$var$dispatch("turbo:click", {
            target: link,
            detail: {
                url: location1.href,
                originalEvent: event
            },
            cancelable: true
        });
    }
    notifyApplicationBeforeVisitingLocation(location1) {
        return $dae3d0e46d061380$var$dispatch("turbo:before-visit", {
            detail: {
                url: location1.href
            },
            cancelable: true
        });
    }
    notifyApplicationAfterVisitingLocation(location1, action) {
        return $dae3d0e46d061380$var$dispatch("turbo:visit", {
            detail: {
                url: location1.href,
                action: action
            }
        });
    }
    notifyApplicationBeforeCachingSnapshot() {
        return $dae3d0e46d061380$var$dispatch("turbo:before-cache");
    }
    notifyApplicationBeforeRender(newBody, options) {
        return $dae3d0e46d061380$var$dispatch("turbo:before-render", {
            detail: Object.assign({
                newBody: newBody
            }, options),
            cancelable: true
        });
    }
    notifyApplicationAfterRender() {
        return $dae3d0e46d061380$var$dispatch("turbo:render");
    }
    notifyApplicationAfterPageLoad(timing = {}) {
        return $dae3d0e46d061380$var$dispatch("turbo:load", {
            detail: {
                url: this.location.href,
                timing: timing
            }
        });
    }
    notifyApplicationAfterVisitingSamePageLocation(oldURL, newURL) {
        dispatchEvent(new HashChangeEvent("hashchange", {
            oldURL: oldURL.toString(),
            newURL: newURL.toString()
        }));
    }
    notifyApplicationAfterFrameLoad(frame) {
        return $dae3d0e46d061380$var$dispatch("turbo:frame-load", {
            target: frame
        });
    }
    notifyApplicationAfterFrameRender(fetchResponse, frame) {
        return $dae3d0e46d061380$var$dispatch("turbo:frame-render", {
            detail: {
                fetchResponse: fetchResponse
            },
            target: frame,
            cancelable: true
        });
    }
    submissionIsNavigatable(form, submitter) {
        if (this.formMode == "off") return false;
        else {
            const submitterIsNavigatable = submitter ? this.elementIsNavigatable(submitter) : true;
            if (this.formMode == "optin") return submitterIsNavigatable && form.closest('[data-turbo="true"]') != null;
            else return submitterIsNavigatable && this.elementIsNavigatable(form);
        }
    }
    elementIsNavigatable(element) {
        const container = $dae3d0e46d061380$var$findClosestRecursively(element, "[data-turbo]");
        const withinFrame = $dae3d0e46d061380$var$findClosestRecursively(element, "turbo-frame");
        if (this.drive || withinFrame) {
            if (container) return container.getAttribute("data-turbo") != "false";
            else return true;
        } else {
            if (container) return container.getAttribute("data-turbo") == "true";
            else return false;
        }
    }
    getActionForLink(link) {
        return $dae3d0e46d061380$var$getVisitAction(link) || "advance";
    }
    get snapshot() {
        return this.view.snapshot;
    }
}
function $dae3d0e46d061380$var$extendURLWithDeprecatedProperties(url) {
    Object.defineProperties(url, $dae3d0e46d061380$var$deprecatedLocationPropertyDescriptors);
}
const $dae3d0e46d061380$var$deprecatedLocationPropertyDescriptors = {
    absoluteURL: {
        get () {
            return this.toString();
        }
    }
};
class $dae3d0e46d061380$var$Cache {
    constructor(session){
        this.session = session;
    }
    clear() {
        this.session.clearCache();
    }
    resetCacheControl() {
        this.setCacheControl("");
    }
    exemptPageFromCache() {
        this.setCacheControl("no-cache");
    }
    exemptPageFromPreview() {
        this.setCacheControl("no-preview");
    }
    setCacheControl(value) {
        $dae3d0e46d061380$var$setMetaContent("turbo-cache-control", value);
    }
}
const $dae3d0e46d061380$export$1b814a67c3a57eeb = {
    after () {
        this.targetElements.forEach((e)=>{
            var _a;
            return (_a = e.parentElement) === null || _a === void 0 ? void 0 : _a.insertBefore(this.templateContent, e.nextSibling);
        });
    },
    append () {
        this.removeDuplicateTargetChildren();
        this.targetElements.forEach((e)=>e.append(this.templateContent));
    },
    before () {
        this.targetElements.forEach((e)=>{
            var _a;
            return (_a = e.parentElement) === null || _a === void 0 ? void 0 : _a.insertBefore(this.templateContent, e);
        });
    },
    prepend () {
        this.removeDuplicateTargetChildren();
        this.targetElements.forEach((e)=>e.prepend(this.templateContent));
    },
    remove () {
        this.targetElements.forEach((e)=>e.remove());
    },
    replace () {
        this.targetElements.forEach((e)=>e.replaceWith(this.templateContent));
    },
    update () {
        this.targetElements.forEach((targetElement)=>{
            targetElement.innerHTML = "";
            targetElement.append(this.templateContent);
        });
    }
};
const $dae3d0e46d061380$export$55427e926be628d4 = new $dae3d0e46d061380$var$Session();
const $dae3d0e46d061380$export$69a3209f1a06c04d = new $dae3d0e46d061380$var$Cache($dae3d0e46d061380$export$55427e926be628d4);
const { navigator: $dae3d0e46d061380$export$ec7c8efa7f5790ae } = $dae3d0e46d061380$export$55427e926be628d4;
function $dae3d0e46d061380$export$b3571188c770cc5a() {
    $dae3d0e46d061380$export$55427e926be628d4.start();
}
function $dae3d0e46d061380$export$ddf4d3602a252674(adapter) {
    $dae3d0e46d061380$export$55427e926be628d4.registerAdapter(adapter);
}
function $dae3d0e46d061380$export$bf638b60ea8b89b7(location1, options) {
    $dae3d0e46d061380$export$55427e926be628d4.visit(location1, options);
}
function $dae3d0e46d061380$export$83667c2845c80463(source) {
    $dae3d0e46d061380$export$55427e926be628d4.connectStreamSource(source);
}
function $dae3d0e46d061380$export$26c56c74e3b67c59(source) {
    $dae3d0e46d061380$export$55427e926be628d4.disconnectStreamSource(source);
}
function $dae3d0e46d061380$export$ebdee272e46e11d9(message) {
    $dae3d0e46d061380$export$55427e926be628d4.renderStreamMessage(message);
}
function $dae3d0e46d061380$export$d2adf65b87e47523() {
    console.warn("Please replace `Turbo.clearCache()` with `Turbo.cache.clear()`. The top-level function is deprecated and will be removed in a future version of Turbo.`");
    $dae3d0e46d061380$export$55427e926be628d4.clearCache();
}
function $dae3d0e46d061380$export$ddcc6947144c476c(delay) {
    $dae3d0e46d061380$export$55427e926be628d4.setProgressBarDelay(delay);
}
function $dae3d0e46d061380$export$4696f1315e6aae7c(confirmMethod) {
    $dae3d0e46d061380$var$FormSubmission.confirmMethod = confirmMethod;
}
function $dae3d0e46d061380$export$a94cfbb71d90abbd(mode) {
    $dae3d0e46d061380$export$55427e926be628d4.setFormMode(mode);
}
var $dae3d0e46d061380$var$Turbo = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    navigator: $dae3d0e46d061380$export$ec7c8efa7f5790ae,
    session: $dae3d0e46d061380$export$55427e926be628d4,
    cache: $dae3d0e46d061380$export$69a3209f1a06c04d,
    PageRenderer: $dae3d0e46d061380$export$ac9642242cf7b3ce,
    PageSnapshot: $dae3d0e46d061380$export$4f11b95e473fd113,
    FrameRenderer: $dae3d0e46d061380$export$f09c4165d16bb2b7,
    start: $dae3d0e46d061380$export$b3571188c770cc5a,
    registerAdapter: $dae3d0e46d061380$export$ddf4d3602a252674,
    visit: $dae3d0e46d061380$export$bf638b60ea8b89b7,
    connectStreamSource: $dae3d0e46d061380$export$83667c2845c80463,
    disconnectStreamSource: $dae3d0e46d061380$export$26c56c74e3b67c59,
    renderStreamMessage: $dae3d0e46d061380$export$ebdee272e46e11d9,
    clearCache: $dae3d0e46d061380$export$d2adf65b87e47523,
    setProgressBarDelay: $dae3d0e46d061380$export$ddcc6947144c476c,
    setConfirmMethod: $dae3d0e46d061380$export$4696f1315e6aae7c,
    setFormMode: $dae3d0e46d061380$export$a94cfbb71d90abbd,
    StreamActions: $dae3d0e46d061380$export$1b814a67c3a57eeb
});
class $dae3d0e46d061380$var$TurboFrameMissingError extends Error {
}
class $dae3d0e46d061380$var$FrameController {
    constructor(element){
        this.fetchResponseLoaded = (_fetchResponse)=>{};
        this.currentFetchRequest = null;
        this.resolveVisitPromise = ()=>{};
        this.connected = false;
        this.hasBeenLoaded = false;
        this.ignoredAttributes = new Set();
        this.action = null;
        this.visitCachedSnapshot = ({ element: element })=>{
            const frame = element.querySelector("#" + this.element.id);
            if (frame && this.previousFrameElement) frame.replaceChildren(...this.previousFrameElement.children);
            delete this.previousFrameElement;
        };
        this.element = element;
        this.view = new $dae3d0e46d061380$var$FrameView(this, this.element);
        this.appearanceObserver = new $dae3d0e46d061380$var$AppearanceObserver(this, this.element);
        this.formLinkClickObserver = new $dae3d0e46d061380$var$FormLinkClickObserver(this, this.element);
        this.linkInterceptor = new $dae3d0e46d061380$var$LinkInterceptor(this, this.element);
        this.restorationIdentifier = $dae3d0e46d061380$var$uuid();
        this.formSubmitObserver = new $dae3d0e46d061380$var$FormSubmitObserver(this, this.element);
    }
    connect() {
        if (!this.connected) {
            this.connected = true;
            if (this.loadingStyle == $dae3d0e46d061380$export$65f98fefe20dbcb6.lazy) this.appearanceObserver.start();
            else this.loadSourceURL();
            this.formLinkClickObserver.start();
            this.linkInterceptor.start();
            this.formSubmitObserver.start();
        }
    }
    disconnect() {
        if (this.connected) {
            this.connected = false;
            this.appearanceObserver.stop();
            this.formLinkClickObserver.stop();
            this.linkInterceptor.stop();
            this.formSubmitObserver.stop();
        }
    }
    disabledChanged() {
        if (this.loadingStyle == $dae3d0e46d061380$export$65f98fefe20dbcb6.eager) this.loadSourceURL();
    }
    sourceURLChanged() {
        if (this.isIgnoringChangesTo("src")) return;
        if (this.element.isConnected) this.complete = false;
        if (this.loadingStyle == $dae3d0e46d061380$export$65f98fefe20dbcb6.eager || this.hasBeenLoaded) this.loadSourceURL();
    }
    sourceURLReloaded() {
        const { src: src } = this.element;
        this.ignoringChangesToAttribute("complete", ()=>{
            this.element.removeAttribute("complete");
        });
        this.element.src = null;
        this.element.src = src;
        return this.element.loaded;
    }
    completeChanged() {
        if (this.isIgnoringChangesTo("complete")) return;
        this.loadSourceURL();
    }
    loadingStyleChanged() {
        if (this.loadingStyle == $dae3d0e46d061380$export$65f98fefe20dbcb6.lazy) this.appearanceObserver.start();
        else {
            this.appearanceObserver.stop();
            this.loadSourceURL();
        }
    }
    async loadSourceURL() {
        if (this.enabled && this.isActive && !this.complete && this.sourceURL) {
            this.element.loaded = this.visit($dae3d0e46d061380$var$expandURL(this.sourceURL));
            this.appearanceObserver.stop();
            await this.element.loaded;
            this.hasBeenLoaded = true;
        }
    }
    async loadResponse(fetchResponse) {
        if (fetchResponse.redirected || fetchResponse.succeeded && fetchResponse.isHTML) this.sourceURL = fetchResponse.response.url;
        try {
            const html = await fetchResponse.responseHTML;
            if (html) {
                const document1 = $dae3d0e46d061380$var$parseHTMLDocument(html);
                const pageSnapshot = $dae3d0e46d061380$export$4f11b95e473fd113.fromDocument(document1);
                if (pageSnapshot.isVisitable) await this.loadFrameResponse(fetchResponse, document1);
                else await this.handleUnvisitableFrameResponse(fetchResponse);
            }
        } finally{
            this.fetchResponseLoaded = ()=>{};
        }
    }
    elementAppearedInViewport(element) {
        this.proposeVisitIfNavigatedWithAction(element, element);
        this.loadSourceURL();
    }
    willSubmitFormLinkToLocation(link) {
        return this.shouldInterceptNavigation(link);
    }
    submittedFormLinkToLocation(link, _location, form) {
        const frame = this.findFrameElement(link);
        if (frame) form.setAttribute("data-turbo-frame", frame.id);
    }
    shouldInterceptLinkClick(element, _location, _event) {
        return this.shouldInterceptNavigation(element);
    }
    linkClickIntercepted(element, location1) {
        this.navigateFrame(element, location1);
    }
    willSubmitForm(element, submitter) {
        return element.closest("turbo-frame") == this.element && this.shouldInterceptNavigation(element, submitter);
    }
    formSubmitted(element, submitter) {
        if (this.formSubmission) this.formSubmission.stop();
        this.formSubmission = new $dae3d0e46d061380$var$FormSubmission(this, element, submitter);
        const { fetchRequest: fetchRequest } = this.formSubmission;
        this.prepareRequest(fetchRequest);
        this.formSubmission.start();
    }
    prepareRequest(request) {
        var _a;
        request.headers["Turbo-Frame"] = this.id;
        if ((_a = this.currentNavigationElement) === null || _a === void 0 ? void 0 : _a.hasAttribute("data-turbo-stream")) request.acceptResponseType($dae3d0e46d061380$var$StreamMessage.contentType);
    }
    requestStarted(_request) {
        $dae3d0e46d061380$var$markAsBusy(this.element);
    }
    requestPreventedHandlingResponse(_request, _response) {
        this.resolveVisitPromise();
    }
    async requestSucceededWithResponse(request, response) {
        await this.loadResponse(response);
        this.resolveVisitPromise();
    }
    async requestFailedWithResponse(request, response) {
        await this.loadResponse(response);
        this.resolveVisitPromise();
    }
    requestErrored(request, error) {
        console.error(error);
        this.resolveVisitPromise();
    }
    requestFinished(_request) {
        $dae3d0e46d061380$var$clearBusyState(this.element);
    }
    formSubmissionStarted({ formElement: formElement }) {
        $dae3d0e46d061380$var$markAsBusy(formElement, this.findFrameElement(formElement));
    }
    formSubmissionSucceededWithResponse(formSubmission, response) {
        const frame = this.findFrameElement(formSubmission.formElement, formSubmission.submitter);
        frame.delegate.proposeVisitIfNavigatedWithAction(frame, formSubmission.formElement, formSubmission.submitter);
        frame.delegate.loadResponse(response);
        if (!formSubmission.isSafe) $dae3d0e46d061380$export$55427e926be628d4.clearCache();
    }
    formSubmissionFailedWithResponse(formSubmission, fetchResponse) {
        this.element.delegate.loadResponse(fetchResponse);
        $dae3d0e46d061380$export$55427e926be628d4.clearCache();
    }
    formSubmissionErrored(formSubmission, error) {
        console.error(error);
    }
    formSubmissionFinished({ formElement: formElement }) {
        $dae3d0e46d061380$var$clearBusyState(formElement, this.findFrameElement(formElement));
    }
    allowsImmediateRender({ element: newFrame }, options) {
        const event = $dae3d0e46d061380$var$dispatch("turbo:before-frame-render", {
            target: this.element,
            detail: Object.assign({
                newFrame: newFrame
            }, options),
            cancelable: true
        });
        const { defaultPrevented: defaultPrevented, detail: { render: render } } = event;
        if (this.view.renderer && render) this.view.renderer.renderElement = render;
        return !defaultPrevented;
    }
    viewRenderedSnapshot(_snapshot, _isPreview) {}
    preloadOnLoadLinksForView(element) {
        $dae3d0e46d061380$export$55427e926be628d4.preloadOnLoadLinksForView(element);
    }
    viewInvalidated() {}
    willRenderFrame(currentElement, _newElement) {
        this.previousFrameElement = currentElement.cloneNode(true);
    }
    async loadFrameResponse(fetchResponse, document1) {
        const newFrameElement = await this.extractForeignFrameElement(document1.body);
        if (newFrameElement) {
            const snapshot = new $dae3d0e46d061380$var$Snapshot(newFrameElement);
            const renderer = new $dae3d0e46d061380$export$f09c4165d16bb2b7(this, this.view.snapshot, snapshot, $dae3d0e46d061380$export$f09c4165d16bb2b7.renderElement, false, false);
            if (this.view.renderPromise) await this.view.renderPromise;
            this.changeHistory();
            await this.view.render(renderer);
            this.complete = true;
            $dae3d0e46d061380$export$55427e926be628d4.frameRendered(fetchResponse, this.element);
            $dae3d0e46d061380$export$55427e926be628d4.frameLoaded(this.element);
            this.fetchResponseLoaded(fetchResponse);
        } else if (this.willHandleFrameMissingFromResponse(fetchResponse)) this.handleFrameMissingFromResponse(fetchResponse);
    }
    async visit(url) {
        var _a;
        const request = new $dae3d0e46d061380$var$FetchRequest(this, $dae3d0e46d061380$var$FetchMethod.get, url, new URLSearchParams(), this.element);
        (_a = this.currentFetchRequest) === null || _a === void 0 || _a.cancel();
        this.currentFetchRequest = request;
        return new Promise((resolve)=>{
            this.resolveVisitPromise = ()=>{
                this.resolveVisitPromise = ()=>{};
                this.currentFetchRequest = null;
                resolve();
            };
            request.perform();
        });
    }
    navigateFrame(element, url, submitter) {
        const frame = this.findFrameElement(element, submitter);
        frame.delegate.proposeVisitIfNavigatedWithAction(frame, element, submitter);
        this.withCurrentNavigationElement(element, ()=>{
            frame.src = url;
        });
    }
    proposeVisitIfNavigatedWithAction(frame, element, submitter) {
        this.action = $dae3d0e46d061380$var$getVisitAction(submitter, element, frame);
        if (this.action) {
            const pageSnapshot = $dae3d0e46d061380$export$4f11b95e473fd113.fromElement(frame).clone();
            const { visitCachedSnapshot: visitCachedSnapshot } = frame.delegate;
            frame.delegate.fetchResponseLoaded = (fetchResponse)=>{
                if (frame.src) {
                    const { statusCode: statusCode, redirected: redirected } = fetchResponse;
                    const responseHTML = frame.ownerDocument.documentElement.outerHTML;
                    const response = {
                        statusCode: statusCode,
                        redirected: redirected,
                        responseHTML: responseHTML
                    };
                    const options = {
                        response: response,
                        visitCachedSnapshot: visitCachedSnapshot,
                        willRender: false,
                        updateHistory: false,
                        restorationIdentifier: this.restorationIdentifier,
                        snapshot: pageSnapshot
                    };
                    if (this.action) options.action = this.action;
                    $dae3d0e46d061380$export$55427e926be628d4.visit(frame.src, options);
                }
            };
        }
    }
    changeHistory() {
        if (this.action) {
            const method = $dae3d0e46d061380$var$getHistoryMethodForAction(this.action);
            $dae3d0e46d061380$export$55427e926be628d4.history.update(method, $dae3d0e46d061380$var$expandURL(this.element.src || ""), this.restorationIdentifier);
        }
    }
    async handleUnvisitableFrameResponse(fetchResponse) {
        console.warn(`The response (${fetchResponse.statusCode}) from <turbo-frame id="${this.element.id}"> is performing a full page visit due to turbo-visit-control.`);
        await this.visitResponse(fetchResponse.response);
    }
    willHandleFrameMissingFromResponse(fetchResponse) {
        this.element.setAttribute("complete", "");
        const response = fetchResponse.response;
        const visit = async (url, options = {})=>{
            if (url instanceof Response) this.visitResponse(url);
            else $dae3d0e46d061380$export$55427e926be628d4.visit(url, options);
        };
        const event = $dae3d0e46d061380$var$dispatch("turbo:frame-missing", {
            target: this.element,
            detail: {
                response: response,
                visit: visit
            },
            cancelable: true
        });
        return !event.defaultPrevented;
    }
    handleFrameMissingFromResponse(fetchResponse) {
        this.view.missing();
        this.throwFrameMissingError(fetchResponse);
    }
    throwFrameMissingError(fetchResponse) {
        const message = `The response (${fetchResponse.statusCode}) did not contain the expected <turbo-frame id="${this.element.id}"> and will be ignored. To perform a full page visit instead, set turbo-visit-control to reload.`;
        throw new $dae3d0e46d061380$var$TurboFrameMissingError(message);
    }
    async visitResponse(response) {
        const wrapped = new $dae3d0e46d061380$var$FetchResponse(response);
        const responseHTML = await wrapped.responseHTML;
        const { location: location1, redirected: redirected, statusCode: statusCode } = wrapped;
        return $dae3d0e46d061380$export$55427e926be628d4.visit(location1, {
            response: {
                redirected: redirected,
                statusCode: statusCode,
                responseHTML: responseHTML
            }
        });
    }
    findFrameElement(element, submitter) {
        var _a;
        const id = $dae3d0e46d061380$var$getAttribute("data-turbo-frame", submitter, element) || this.element.getAttribute("target");
        return (_a = $dae3d0e46d061380$var$getFrameElementById(id)) !== null && _a !== void 0 ? _a : this.element;
    }
    async extractForeignFrameElement(container) {
        let element;
        const id = CSS.escape(this.id);
        try {
            element = $dae3d0e46d061380$var$activateElement(container.querySelector(`turbo-frame#${id}`), this.sourceURL);
            if (element) return element;
            element = $dae3d0e46d061380$var$activateElement(container.querySelector(`turbo-frame[src][recurse~=${id}]`), this.sourceURL);
            if (element) {
                await element.loaded;
                return await this.extractForeignFrameElement(element);
            }
        } catch (error) {
            console.error(error);
            return new $dae3d0e46d061380$export$f464a8f0ffa32c44();
        }
        return null;
    }
    formActionIsVisitable(form, submitter) {
        const action = $dae3d0e46d061380$var$getAction(form, submitter);
        return $dae3d0e46d061380$var$locationIsVisitable($dae3d0e46d061380$var$expandURL(action), this.rootLocation);
    }
    shouldInterceptNavigation(element, submitter) {
        const id = $dae3d0e46d061380$var$getAttribute("data-turbo-frame", submitter, element) || this.element.getAttribute("target");
        if (element instanceof HTMLFormElement && !this.formActionIsVisitable(element, submitter)) return false;
        if (!this.enabled || id == "_top") return false;
        if (id) {
            const frameElement = $dae3d0e46d061380$var$getFrameElementById(id);
            if (frameElement) return !frameElement.disabled;
        }
        if (!$dae3d0e46d061380$export$55427e926be628d4.elementIsNavigatable(element)) return false;
        if (submitter && !$dae3d0e46d061380$export$55427e926be628d4.elementIsNavigatable(submitter)) return false;
        return true;
    }
    get id() {
        return this.element.id;
    }
    get enabled() {
        return !this.element.disabled;
    }
    get sourceURL() {
        if (this.element.src) return this.element.src;
    }
    set sourceURL(sourceURL) {
        this.ignoringChangesToAttribute("src", ()=>{
            this.element.src = sourceURL !== null && sourceURL !== void 0 ? sourceURL : null;
        });
    }
    get loadingStyle() {
        return this.element.loading;
    }
    get isLoading() {
        return this.formSubmission !== undefined || this.resolveVisitPromise() !== undefined;
    }
    get complete() {
        return this.element.hasAttribute("complete");
    }
    set complete(value) {
        this.ignoringChangesToAttribute("complete", ()=>{
            if (value) this.element.setAttribute("complete", "");
            else this.element.removeAttribute("complete");
        });
    }
    get isActive() {
        return this.element.isActive && this.connected;
    }
    get rootLocation() {
        var _a;
        const meta = this.element.ownerDocument.querySelector(`meta[name="turbo-root"]`);
        const root = (_a = meta === null || meta === void 0 ? void 0 : meta.content) !== null && _a !== void 0 ? _a : "/";
        return $dae3d0e46d061380$var$expandURL(root);
    }
    isIgnoringChangesTo(attributeName) {
        return this.ignoredAttributes.has(attributeName);
    }
    ignoringChangesToAttribute(attributeName, callback) {
        this.ignoredAttributes.add(attributeName);
        callback();
        this.ignoredAttributes.delete(attributeName);
    }
    withCurrentNavigationElement(element, callback) {
        this.currentNavigationElement = element;
        callback();
        delete this.currentNavigationElement;
    }
}
function $dae3d0e46d061380$var$getFrameElementById(id) {
    if (id != null) {
        const element = document.getElementById(id);
        if (element instanceof $dae3d0e46d061380$export$f464a8f0ffa32c44) return element;
    }
}
function $dae3d0e46d061380$var$activateElement(element, currentURL) {
    if (element) {
        const src = element.getAttribute("src");
        if (src != null && currentURL != null && $dae3d0e46d061380$var$urlsAreEqual(src, currentURL)) throw new Error(`Matching <turbo-frame id="${element.id}"> element has a source URL which references itself`);
        if (element.ownerDocument !== document) element = document.importNode(element, true);
        if (element instanceof $dae3d0e46d061380$export$f464a8f0ffa32c44) {
            element.connectedCallback();
            element.disconnectedCallback();
            return element;
        }
    }
}
class $dae3d0e46d061380$export$144d499d37929ea8 extends HTMLElement {
    static async renderElement(newElement) {
        await newElement.performAction();
    }
    async connectedCallback() {
        try {
            await this.render();
        } catch (error) {
            console.error(error);
        } finally{
            this.disconnect();
        }
    }
    async render() {
        var _a;
        return (_a = this.renderPromise) !== null && _a !== void 0 ? _a : this.renderPromise = (async ()=>{
            const event = this.beforeRenderEvent;
            if (this.dispatchEvent(event)) {
                await $dae3d0e46d061380$var$nextAnimationFrame();
                await event.detail.render(this);
            }
        })();
    }
    disconnect() {
        try {
            this.remove();
        } catch (_a) {}
    }
    removeDuplicateTargetChildren() {
        this.duplicateChildren.forEach((c)=>c.remove());
    }
    get duplicateChildren() {
        var _a;
        const existingChildren = this.targetElements.flatMap((e)=>[
                ...e.children
            ]).filter((c)=>!!c.id);
        const newChildrenIds = [
            ...((_a = this.templateContent) === null || _a === void 0 ? void 0 : _a.children) || []
        ].filter((c)=>!!c.id).map((c)=>c.id);
        return existingChildren.filter((c)=>newChildrenIds.includes(c.id));
    }
    get performAction() {
        if (this.action) {
            const actionFunction = $dae3d0e46d061380$export$1b814a67c3a57eeb[this.action];
            if (actionFunction) return actionFunction;
            this.raise("unknown action");
        }
        this.raise("action attribute is missing");
    }
    get targetElements() {
        if (this.target) return this.targetElementsById;
        else if (this.targets) return this.targetElementsByQuery;
        else this.raise("target or targets attribute is missing");
    }
    get templateContent() {
        return this.templateElement.content.cloneNode(true);
    }
    get templateElement() {
        if (this.firstElementChild === null) {
            const template = this.ownerDocument.createElement("template");
            this.appendChild(template);
            return template;
        } else if (this.firstElementChild instanceof HTMLTemplateElement) return this.firstElementChild;
        this.raise("first child element must be a <template> element");
    }
    get action() {
        return this.getAttribute("action");
    }
    get target() {
        return this.getAttribute("target");
    }
    get targets() {
        return this.getAttribute("targets");
    }
    raise(message) {
        throw new Error(`${this.description}: ${message}`);
    }
    get description() {
        var _a, _b;
        return (_b = ((_a = this.outerHTML.match(/<[^>]+>/)) !== null && _a !== void 0 ? _a : [])[0]) !== null && _b !== void 0 ? _b : "<turbo-stream>";
    }
    get beforeRenderEvent() {
        return new CustomEvent("turbo:before-stream-render", {
            bubbles: true,
            cancelable: true,
            detail: {
                newStream: this,
                render: $dae3d0e46d061380$export$144d499d37929ea8.renderElement
            }
        });
    }
    get targetElementsById() {
        var _a;
        const element = (_a = this.ownerDocument) === null || _a === void 0 ? void 0 : _a.getElementById(this.target);
        if (element !== null) return [
            element
        ];
        else return [];
    }
    get targetElementsByQuery() {
        var _a;
        const elements = (_a = this.ownerDocument) === null || _a === void 0 ? void 0 : _a.querySelectorAll(this.targets);
        if (elements.length !== 0) return Array.prototype.slice.call(elements);
        else return [];
    }
}
class $dae3d0e46d061380$export$e87d51a4385a3903 extends HTMLElement {
    constructor(){
        super(...arguments);
        this.streamSource = null;
    }
    connectedCallback() {
        this.streamSource = this.src.match(/^ws{1,2}:/) ? new WebSocket(this.src) : new EventSource(this.src);
        $dae3d0e46d061380$export$83667c2845c80463(this.streamSource);
    }
    disconnectedCallback() {
        if (this.streamSource) $dae3d0e46d061380$export$26c56c74e3b67c59(this.streamSource);
    }
    get src() {
        return this.getAttribute("src") || "";
    }
}
$dae3d0e46d061380$export$f464a8f0ffa32c44.delegateConstructor = $dae3d0e46d061380$var$FrameController;
if (customElements.get("turbo-frame") === undefined) customElements.define("turbo-frame", $dae3d0e46d061380$export$f464a8f0ffa32c44);
if (customElements.get("turbo-stream") === undefined) customElements.define("turbo-stream", $dae3d0e46d061380$export$144d499d37929ea8);
if (customElements.get("turbo-stream-source") === undefined) customElements.define("turbo-stream-source", $dae3d0e46d061380$export$e87d51a4385a3903);
(()=>{
    let element = document.currentScript;
    if (!element) return;
    if (element.hasAttribute("data-turbo-suppress-warning")) return;
    element = element.parentElement;
    while(element){
        if (element == document.body) return console.warn($dae3d0e46d061380$var$unindent`
        You are loading Turbo from a <script> element inside the <body> element. This is probably not what you meant to do!

        Load your application’s JavaScript bundle inside the <head> element instead. <script> elements in <body> are evaluated with each page change.

        For more information, see: https://turbo.hotwired.dev/handbook/building#working-with-script-elements

        ——
        Suppress this warning by adding a "data-turbo-suppress-warning" attribute to: %s
      `, element.outerHTML);
        element = element.parentElement;
    }
})();
window.Turbo = $dae3d0e46d061380$var$Turbo;
$dae3d0e46d061380$export$b3571188c770cc5a();



var $gztBd = parcelRequire("gztBd");

var $6cwj6 = parcelRequire("6cwj6");
var $6cwj6 = parcelRequire("6cwj6");
parcelRequire("2ktyf");
var $7htw4 = parcelRequire("7htw4");
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $f06facd2a983bb77$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;


function $ec20e29fc539f943$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $f06facd2a983bb77$export$48a8984ec0bf2e44) (0, $7htw4.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        // eslint-disable-next-line no-console
        console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
    var hub = (0, $6cwj6.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) scope.update(options.initialScope);
    var client = new clientClass(options);
    hub.bindClient(client);
}

var $4a8e49c5cea1e330$exports = {};

$parcel$export($4a8e49c5cea1e330$exports, "FunctionToString", () => $009f5c88bbd2ff13$export$da4704525c20ae79);
$parcel$export($4a8e49c5cea1e330$exports, "InboundFilters", () => $7074340826553a9d$export$2ffbb5359dcc6be4);
parcelRequire("2ktyf");
var $bP4Y8 = parcelRequire("bP4Y8");
var $009f5c88bbd2ff13$var$originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ var $009f5c88bbd2ff13$export$da4704525c20ae79 = /** @class */ function() {
    function FunctionToString() {
        /**
         * @inheritDoc
         */ this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */ FunctionToString.prototype.setupOnce = function() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        $009f5c88bbd2ff13$var$originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var context = (0, $bP4Y8.getOriginalFunction)(this) || this;
            return $009f5c88bbd2ff13$var$originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */ FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}();



var $gztBd = parcelRequire("gztBd");
parcelRequire("2ktyf");
var $HgoiY = parcelRequire("HgoiY");
var $jP2vU = parcelRequire("jP2vU");
var $7htw4 = parcelRequire("7htw4");

// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var $7074340826553a9d$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
/** Inbound filters configurable by the user */ var $7074340826553a9d$export$2ffbb5359dcc6be4 = /** @class */ function() {
    function InboundFilters(_options) {
        if (_options === void 0) _options = {};
        this._options = _options;
        /**
         * @inheritDoc
         */ this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */ InboundFilters.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var hub = getCurrentHub();
            if (hub) {
                var self_1 = hub.getIntegration(InboundFilters);
                if (self_1) {
                    var client = hub.getClient();
                    var clientOptions = client ? client.getOptions() : {};
                    var options = $7074340826553a9d$export$6620a151868b99aa(self_1._options, clientOptions);
                    return $7074340826553a9d$export$3c6361fddf6cd929(event, options) ? null : event;
                }
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}();
function $7074340826553a9d$export$6620a151868b99aa(internalOptions, clientOptions) {
    if (internalOptions === void 0) internalOptions = {};
    if (clientOptions === void 0) clientOptions = {};
    return {
        allowUrls: (0, $gztBd.__spread)(internalOptions.whitelistUrls || [], internalOptions.allowUrls || [], clientOptions.whitelistUrls || [], clientOptions.allowUrls || []),
        denyUrls: (0, $gztBd.__spread)(internalOptions.blacklistUrls || [], internalOptions.denyUrls || [], clientOptions.blacklistUrls || [], clientOptions.denyUrls || []),
        ignoreErrors: (0, $gztBd.__spread)(internalOptions.ignoreErrors || [], clientOptions.ignoreErrors || [], $7074340826553a9d$var$DEFAULT_IGNORE_ERRORS),
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $7074340826553a9d$export$3c6361fddf6cd929(event, options) {
    if (options.ignoreInternal && $7074340826553a9d$var$_isSentryError(event)) {
        (0, $f06facd2a983bb77$export$48a8984ec0bf2e44) && (0, $7htw4.logger).warn("Event dropped due to being internal Sentry Error.\nEvent: " + (0, $HgoiY.getEventDescription)(event));
        return true;
    }
    if ($7074340826553a9d$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $f06facd2a983bb77$export$48a8984ec0bf2e44) && (0, $7htw4.logger).warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + (0, $HgoiY.getEventDescription)(event));
        return true;
    }
    if ($7074340826553a9d$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $f06facd2a983bb77$export$48a8984ec0bf2e44) && (0, $7htw4.logger).warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + (0, $HgoiY.getEventDescription)(event) + ".\nUrl: " + $7074340826553a9d$var$_getEventFilterUrl(event));
        return true;
    }
    if (!$7074340826553a9d$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $f06facd2a983bb77$export$48a8984ec0bf2e44) && (0, $7htw4.logger).warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + (0, $HgoiY.getEventDescription)(event) + ".\nUrl: " + $7074340826553a9d$var$_getEventFilterUrl(event));
        return true;
    }
    return false;
}
function $7074340826553a9d$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors || !ignoreErrors.length) return false;
    return $7074340826553a9d$var$_getPossibleEventMessages(event).some(function(message) {
        return ignoreErrors.some(function(pattern) {
            return (0, $jP2vU.isMatchingPattern)(message, pattern);
        });
    });
}
function $7074340826553a9d$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    var url = $7074340826553a9d$var$_getEventFilterUrl(event);
    return !url ? false : denyUrls.some(function(pattern) {
        return (0, $jP2vU.isMatchingPattern)(url, pattern);
    });
}
function $7074340826553a9d$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    var url = $7074340826553a9d$var$_getEventFilterUrl(event);
    return !url ? true : allowUrls.some(function(pattern) {
        return (0, $jP2vU.isMatchingPattern)(url, pattern);
    });
}
function $7074340826553a9d$var$_getPossibleEventMessages(event) {
    if (event.message) return [
        event.message
    ];
    if (event.exception) try {
        var _a = event.exception.values && event.exception.values[0] || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
        return [
            "" + value,
            type + ": " + value
        ];
    } catch (oO) {
        (0, $f06facd2a983bb77$export$48a8984ec0bf2e44) && (0, $7htw4.logger).error("Cannot extract message for event " + (0, $HgoiY.getEventDescription)(event));
        return [];
    }
    return [];
}
function $7074340826553a9d$var$_isSentryError(event) {
    try {
        // @ts-ignore can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $7074340826553a9d$var$_getLastValidUrl(frames) {
    if (frames === void 0) frames = [];
    for(var i = frames.length - 1; i >= 0; i--){
        var frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $7074340826553a9d$var$_getEventFilterUrl(event) {
    try {
        if (event.stacktrace) return $7074340826553a9d$var$_getLastValidUrl(event.stacktrace.frames);
        var frames_1;
        try {
            // @ts-ignore we only care about frames if the whole thing here is defined
            frames_1 = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames_1 ? $7074340826553a9d$var$_getLastValidUrl(frames_1) : null;
    } catch (oO) {
        (0, $f06facd2a983bb77$export$48a8984ec0bf2e44) && (0, $7htw4.logger).error("Cannot extract url for event " + (0, $HgoiY.getEventDescription)(event));
        return null;
    }
}




parcelRequire("2ktyf");
var $lDX8u = parcelRequire("lDX8u");
var $1SlwS = parcelRequire("1SlwS");
var $7htw4 = parcelRequire("7htw4");
var $i7ar8 = parcelRequire("i7ar8");

var $gztBd = parcelRequire("gztBd");

var $gztBd = parcelRequire("gztBd");

var $ka93y = parcelRequire("ka93y");
parcelRequire("2ktyf");
var $HgoiY = parcelRequire("HgoiY");
var $cQg0t = parcelRequire("cQg0t");
var $5QZE4 = parcelRequire("5QZE4");
var $7htw4 = parcelRequire("7htw4");
var $UMf0P = parcelRequire("UMf0P");
var $jn5uz = parcelRequire("jn5uz");
var $i7ar8 = parcelRequire("i7ar8");
var $h5dmQ = parcelRequire("h5dmQ");
var $jP2vU = parcelRequire("jP2vU");


var $gztBd = parcelRequire("gztBd");

var $ka93y = parcelRequire("ka93y");
var $6cwj6 = parcelRequire("6cwj6");
parcelRequire("2ktyf");
var $bP4Y8 = parcelRequire("bP4Y8");
var $7htw4 = parcelRequire("7htw4");

var $73f29a8c00de1619$export$b14a8888f80a0b3e = [];
/**
 * @private
 */ function $73f29a8c00de1619$var$filterDuplicates(integrations) {
    return integrations.reduce(function(acc, integrations) {
        if (acc.every(function(accIntegration) {
            return integrations.name !== accIntegration.name;
        })) acc.push(integrations);
        return acc;
    }, []);
}
function $73f29a8c00de1619$export$68bc4c01ab8ae766(options) {
    var defaultIntegrations = options.defaultIntegrations && (0, $gztBd.__spread)(options.defaultIntegrations) || [];
    var userIntegrations = options.integrations;
    var integrations = (0, $gztBd.__spread)($73f29a8c00de1619$var$filterDuplicates(defaultIntegrations));
    if (Array.isArray(userIntegrations)) // Filter out integrations that are also included in user options
    integrations = (0, $gztBd.__spread)(integrations.filter(function(integrations) {
        return userIntegrations.every(function(userIntegration) {
            return userIntegration.name !== integrations.name;
        });
    }), $73f29a8c00de1619$var$filterDuplicates(userIntegrations));
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(integrations);
        integrations = Array.isArray(integrations) ? integrations : [
            integrations
        ];
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function(i) {
        return i.name;
    });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) integrations.push.apply(integrations, (0, $gztBd.__spread)(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    return integrations;
}
function $73f29a8c00de1619$export$e7390a03b70a6f2f(integration) {
    if ($73f29a8c00de1619$export$b14a8888f80a0b3e.indexOf(integration.name) !== -1) return;
    integration.setupOnce((0, $ka93y.addGlobalEventProcessor), (0, $6cwj6.getCurrentHub));
    $73f29a8c00de1619$export$b14a8888f80a0b3e.push(integration.name);
    (0, $f06facd2a983bb77$export$48a8984ec0bf2e44) && (0, $7htw4.logger).log("Integration installed: " + integration.name);
}
function $73f29a8c00de1619$export$51abed9797baa598(options) {
    var integrations = {};
    $73f29a8c00de1619$export$68bc4c01ab8ae766(options).forEach(function(integration) {
        integrations[integration.name] = integration;
        $73f29a8c00de1619$export$e7390a03b70a6f2f(integration);
    });
    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
    // considered a member of the index the way the actual integrations are
    (0, $bP4Y8.addNonEnumerableProperty)(integrations, 'initialized', true);
    return integrations;
}


var $640fc7d84f5323a0$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */ var $640fc7d84f5323a0$export$4f22f74eddb7716a = /** @class */ function() {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */ function BaseClient(backendClass, options) {
        /** Array of used integrations. */ this._integrations = {};
        /** Number of calls being processed */ this._numProcessing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) this._dsn = (0, $UMf0P.makeDsn)(options.dsn);
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function(exception, hint, scope) {
        var _this = this;
        // ensure we haven't captured this very object before
        if ((0, $HgoiY.checkOrSetAlreadyCaught)(exception)) {
            (0, $f06facd2a983bb77$export$48a8984ec0bf2e44) && (0, $7htw4.logger).log($640fc7d84f5323a0$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._getBackend().eventFromException(exception, hint).then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureMessage = function(message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = (0, $5QZE4.isPrimitive)(message) ? this._getBackend().eventFromMessage(String(message), level, hint) : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent.then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureEvent = function(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $HgoiY.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $f06facd2a983bb77$export$48a8984ec0bf2e44) && (0, $7htw4.logger).log($640fc7d84f5323a0$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureSession = function(session) {
        if (!this._isEnabled()) {
            (0, $f06facd2a983bb77$export$48a8984ec0bf2e44) && (0, $7htw4.logger).warn('SDK not enabled, will not capture session.');
            return;
        }
        if (!(typeof session.release === 'string')) (0, $f06facd2a983bb77$export$48a8984ec0bf2e44) && (0, $7htw4.logger).warn('Discarded session because of missing or non-string release');
        else {
            this._sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            session.update({
                init: false
            });
        }
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getDsn = function() {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getOptions = function() {
        return this._options;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getTransport = function() {
        return this._getBackend().getTransport();
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.flush = function(timeout) {
        var _this = this;
        return this._isClientDoneProcessing(timeout).then(function(clientFinished) {
            return _this.getTransport().close(timeout).then(function(transportFlushed) {
                return clientFinished && transportFlushed;
            });
        });
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.close = function(timeout) {
        var _this = this;
        return this.flush(timeout).then(function(result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */ BaseClient.prototype.setupIntegrations = function() {
        if (this._isEnabled() && !this._integrations.initialized) this._integrations = (0, $73f29a8c00de1619$export$51abed9797baa598)(this._options);
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getIntegration = function(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $f06facd2a983bb77$export$48a8984ec0bf2e44) && (0, $7htw4.logger).warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */ BaseClient.prototype._updateSessionFromEvent = function(session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for(var exceptions_1 = (0, $gztBd.__values)(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()){
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        var sessionNonTerminal = session.status === 'ok';
        var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            session.update((0, $gztBd.__assign)((0, $gztBd.__assign)({}, crashed && {
                status: 'crashed'
            }), {
                errors: session.errors || Number(errored || crashed)
            }));
            this.captureSession(session);
        }
    };
    /** Deliver captured session to Sentry */ BaseClient.prototype._sendSession = function(session) {
        this._getBackend().sendSession(session);
    };
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */ BaseClient.prototype._isClientDoneProcessing = function(timeout) {
        var _this = this;
        return new (0, $i7ar8.SyncPromise)(function(resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function() {
                if (_this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */ BaseClient.prototype._getBackend = function() {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */ BaseClient.prototype._isEnabled = function() {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */ BaseClient.prototype._prepareEvent = function(event, scope, hint) {
        var _this = this;
        var _a = this.getOptions(), _b = _a.normalizeDepth, normalizeDepth = _b === void 0 ? 3 : _b, _c = _a.normalizeMaxBreadth, normalizeMaxBreadth = _c === void 0 ? 1000 : _c;
        var prepared = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, event), {
            event_id: event.event_id || (hint && hint.event_id ? hint.event_id : (0, $HgoiY.uuid4)()),
            timestamp: event.timestamp || (0, $cQg0t.dateTimestampInSeconds)()
        });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) finalScope = (0, $ka93y.Scope).clone(finalScope).update(hint.captureContext);
        // We prepare the result here with a resolved Event.
        var result = (0, $i7ar8.resolvedSyncPromise)(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint);
        return result.then(function(evt) {
            if (evt) // TODO this is more of the hack trying to solve https://github.com/getsentry/sentry-javascript/issues/2809
            // it is only attached as extra data to the event if the event somehow skips being normalized
            evt.sdkProcessingMetadata = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, evt.sdkProcessingMetadata), {
                normalizeDepth: (0, $jn5uz.normalize)(normalizeDepth) + " (" + typeof normalizeDepth + ")"
            });
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return _this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */ BaseClient.prototype._normalizeEvent = function(event, depth, maxBreadth) {
        if (!event) return null;
        var normalized = (0, $gztBd.__assign)((0, $gztBd.__assign)((0, $gztBd.__assign)((0, $gztBd.__assign)((0, $gztBd.__assign)({}, event), event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function(b) {
                return (0, $gztBd.__assign)((0, $gztBd.__assign)({}, b), b.data && {
                    data: (0, $jn5uz.normalize)(b.data, depth, maxBreadth)
                });
            })
        }), event.user && {
            user: (0, $jn5uz.normalize)(event.user, depth, maxBreadth)
        }), event.contexts && {
            contexts: (0, $jn5uz.normalize)(event.contexts, depth, maxBreadth)
        }), event.extra && {
            extra: (0, $jn5uz.normalize)(event.extra, depth, maxBreadth)
        });
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        normalized.contexts.trace = event.contexts.trace;
        normalized.sdkProcessingMetadata = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, normalized.sdkProcessingMetadata), {
            baseClientNormalized: true
        });
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */ BaseClient.prototype._applyClientOptions = function(event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) event.environment = 'environment' in options ? environment : 'production';
        if (event.release === undefined && release !== undefined) event.release = release;
        if (event.dist === undefined && dist !== undefined) event.dist = dist;
        if (event.message) event.message = (0, $jP2vU.truncate)(event.message, maxValueLength);
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) exception.value = (0, $jP2vU.truncate)(exception.value, maxValueLength);
        var request = event.request;
        if (request && request.url) request.url = (0, $jP2vU.truncate)(request.url, maxValueLength);
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */ BaseClient.prototype._applyIntegrationsMetadata = function(event) {
        var integrationsArray = Object.keys(this._integrations);
        if (integrationsArray.length > 0) {
            event.sdk = event.sdk || {};
            event.sdk.integrations = (0, $gztBd.__spread)(event.sdk.integrations || [], integrationsArray);
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */ BaseClient.prototype._sendEvent = function(event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */ BaseClient.prototype._captureEvent = function(event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function(finalEvent) {
            return finalEvent.event_id;
        }, function(reason) {
            (0, $f06facd2a983bb77$export$48a8984ec0bf2e44) && (0, $7htw4.logger).error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */ BaseClient.prototype._processEvent = function(event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        var transport = this.getTransport();
        function recordLostEvent(outcome, category) {
            if (transport.recordLostEvent) transport.recordLostEvent(outcome, category);
        }
        if (!this._isEnabled()) return (0, $i7ar8.rejectedSyncPromise)(new (0, $h5dmQ.SentryError)('SDK not enabled, will not capture event.'));
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            recordLostEvent('sample_rate', 'event');
            return (0, $i7ar8.rejectedSyncPromise)(new (0, $h5dmQ.SentryError)("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint).then(function(prepared) {
            if (prepared === null) {
                recordLostEvent('event_processor', event.type || 'event');
                throw new (0, $h5dmQ.SentryError)('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) return prepared;
            var beforeSendResult = beforeSend(prepared, hint);
            return $640fc7d84f5323a0$var$_ensureBeforeSendRv(beforeSendResult);
        }).then(function(processedEvent) {
            if (processedEvent === null) {
                recordLostEvent('before_send', event.type || 'event');
                throw new (0, $h5dmQ.SentryError)('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) _this._updateSessionFromEvent(session, processedEvent);
            _this._sendEvent(processedEvent);
            return processedEvent;
        }).then(null, function(reason) {
            if (reason instanceof (0, $h5dmQ.SentryError)) throw reason;
            _this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $h5dmQ.SentryError)("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */ BaseClient.prototype._process = function(promise) {
        var _this = this;
        this._numProcessing += 1;
        promise.then(function(value) {
            _this._numProcessing -= 1;
            return value;
        }, function(reason) {
            _this._numProcessing -= 1;
            return reason;
        });
    };
    return BaseClient;
}();
/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */ function $640fc7d84f5323a0$var$_ensureBeforeSendRv(rv) {
    var nullErr = '`beforeSend` method has to return `null` or a valid event.';
    if ((0, $5QZE4.isThenable)(rv)) return rv.then(function(event) {
        if (!((0, $5QZE4.isPlainObject)(event) || event === null)) throw new (0, $h5dmQ.SentryError)(nullErr);
        return event;
    }, function(e) {
        throw new (0, $h5dmQ.SentryError)("beforeSend rejected with " + e);
    });
    else if (!((0, $5QZE4.isPlainObject)(rv) || rv === null)) throw new (0, $h5dmQ.SentryError)(nullErr);
    return rv;
}

var $8663cc950bc5605c$export$31499a9cd224b78c = '6.19.7';


parcelRequire("2ktyf");
var $1SlwS = parcelRequire("1SlwS");
var $7htw4 = parcelRequire("7htw4");

var $gztBd = parcelRequire("gztBd");

var $gztBd = parcelRequire("gztBd");
parcelRequire("2ktyf");
var $7htw4 = parcelRequire("7htw4");
var $h5dmQ = parcelRequire("h5dmQ");
parcelRequire("2ktyf");
var $UMf0P = parcelRequire("UMf0P");
var $bP4Y8 = parcelRequire("bP4Y8");
var $da298c0570fc4a2c$var$SENTRY_API_VERSION = '7';
/**
 * Helper class to provide urls, headers and metadata that can be used to form
 * different types of requests to Sentry endpoints.
 * Supports both envelopes and regular event requests.
 *
 * @deprecated Please use APIDetails
 **/ var $da298c0570fc4a2c$export$2c4e825dc9120f87 = /** @class */ function() {
    /** Create a new instance of API */ function API(dsn, metadata, tunnel) {
        if (metadata === void 0) metadata = {};
        this.dsn = dsn;
        this._dsnObject = (0, $UMf0P.makeDsn)(dsn);
        this.metadata = metadata;
        this._tunnel = tunnel;
    }
    /** Returns the Dsn object. */ API.prototype.getDsn = function() {
        return this._dsnObject;
    };
    /** Does this transport force envelopes? */ API.prototype.forceEnvelope = function() {
        return !!this._tunnel;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */ API.prototype.getBaseApiEndpoint = function() {
        return $da298c0570fc4a2c$var$getBaseApiEndpoint(this._dsnObject);
    };
    /** Returns the store endpoint URL. */ API.prototype.getStoreEndpoint = function() {
        return $da298c0570fc4a2c$var$getStoreEndpoint(this._dsnObject);
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getStoreEndpointWithUrlEncodedAuth = function() {
        return $da298c0570fc4a2c$export$c1677e22ac2217a5(this._dsnObject);
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function() {
        return $da298c0570fc4a2c$export$9964600bfe84e6a3(this._dsnObject, this._tunnel);
    };
    return API;
}();
function $da298c0570fc4a2c$export$ad00a06efb2a29cb(dsn, metadata, tunnel) {
    return {
        initDsn: dsn,
        metadata: metadata || {},
        dsn: (0, $UMf0P.makeDsn)(dsn),
        tunnel: tunnel
    };
}
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $da298c0570fc4a2c$var$getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? dsn.protocol + ":" : '';
    var port = dsn.port ? ":" + dsn.port : '';
    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
}
/** Returns the ingest API endpoint for target. */ function $da298c0570fc4a2c$var$_getIngestEndpoint(dsn, target) {
    return "" + $da298c0570fc4a2c$var$getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $da298c0570fc4a2c$var$_encodedAuth(dsn) {
    return (0, $bP4Y8.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $da298c0570fc4a2c$var$SENTRY_API_VERSION
    });
}
/** Returns the store endpoint URL. */ function $da298c0570fc4a2c$var$getStoreEndpoint(dsn) {
    return $da298c0570fc4a2c$var$_getIngestEndpoint(dsn, 'store');
}
function $da298c0570fc4a2c$export$c1677e22ac2217a5(dsn) {
    return $da298c0570fc4a2c$var$getStoreEndpoint(dsn) + "?" + $da298c0570fc4a2c$var$_encodedAuth(dsn);
}
/** Returns the envelope endpoint URL. */ function $da298c0570fc4a2c$var$_getEnvelopeEndpoint(dsn) {
    return $da298c0570fc4a2c$var$_getIngestEndpoint(dsn, 'envelope');
}
function $da298c0570fc4a2c$export$9964600bfe84e6a3(dsn, tunnel) {
    return tunnel ? tunnel : $da298c0570fc4a2c$var$_getEnvelopeEndpoint(dsn) + "?" + $da298c0570fc4a2c$var$_encodedAuth(dsn);
}
function $da298c0570fc4a2c$export$1e4d4724de7b199e(dsn, clientName, clientVersion) {
    // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
    var header = [
        "Sentry sentry_version=" + $da298c0570fc4a2c$var$SENTRY_API_VERSION
    ];
    header.push("sentry_client=" + clientName + "/" + clientVersion);
    header.push("sentry_key=" + dsn.publicKey);
    if (dsn.pass) header.push("sentry_secret=" + dsn.pass);
    return {
        'Content-Type': 'application/json',
        'X-Sentry-Auth': header.join(', ')
    };
}
function $da298c0570fc4a2c$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    var dsn = (0, $UMf0P.makeDsn)(dsnLike);
    var endpoint = $da298c0570fc4a2c$var$getBaseApiEndpoint(dsn) + "embed/error-page/";
    var encodedOptions = "dsn=" + (0, $UMf0P.dsnToString)(dsn);
    for(var key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'user') {
            if (!dialogOptions.user) continue;
            if (dialogOptions.user.name) encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
            if (dialogOptions.user.email) encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
        } else encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
    }
    return endpoint + "?" + encodedOptions;
}




var $gztBd = parcelRequire("gztBd");
parcelRequire("2ktyf");
var $jCHqX = parcelRequire("jCHqX");
var $UMf0P = parcelRequire("UMf0P");
var $jn5uz = parcelRequire("jn5uz");

/** Extract sdk info from from the API metadata */ function $541725032c9b1421$var$getSdkMetadataForEnvelopeHeader(api) {
    if (!api.metadata || !api.metadata.sdk) return;
    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
    return {
        name: name,
        version: version
    };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $541725032c9b1421$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0, $gztBd.__spread)(event.sdk.integrations || [], sdkInfo.integrations || []);
    event.sdk.packages = (0, $gztBd.__spread)(event.sdk.packages || [], sdkInfo.packages || []);
    return event;
}
function $541725032c9b1421$export$124b03c077baa2f3(session, api) {
    var sdkInfo = $541725032c9b1421$var$getSdkMetadataForEnvelopeHeader(api);
    var envelopeHeaders = (0, $gztBd.__assign)((0, $gztBd.__assign)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $UMf0P.dsnToString)(api.dsn)
    });
    // I know this is hacky but we don't want to add `sessions` to request type since it's never rate limited
    var type = 'aggregates' in session ? 'sessions' : 'session';
    // TODO (v7) Have to cast type because envelope items do not accept a `SentryRequestType`
    var envelopeItem = [
        {
            type: type
        },
        session
    ];
    var envelope = (0, $jCHqX.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
    return [
        envelope,
        type
    ];
}
function $541725032c9b1421$export$977ee6eda1884ec3(session, api) {
    var _a = (0, $gztBd.__read)($541725032c9b1421$export$124b03c077baa2f3(session, api), 2), envelope = _a[0], type = _a[1];
    return {
        body: (0, $jCHqX.serializeEnvelope)(envelope),
        type: type,
        url: (0, $da298c0570fc4a2c$export$9964600bfe84e6a3)(api.dsn, api.tunnel)
    };
}
function $541725032c9b1421$export$c31057337a18010f(event, api) {
    var sdkInfo = $541725032c9b1421$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $541725032c9b1421$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var envelopeHeaders = (0, $gztBd.__assign)((0, $gztBd.__assign)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $UMf0P.dsnToString)(api.dsn)
    });
    var eventItem = [
        {
            type: eventType,
            sample_rates: [
                {
                    id: samplingMethod,
                    rate: sampleRate
                }
            ]
        },
        event
    ];
    return (0, $jCHqX.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
function $541725032c9b1421$export$2006389de558b996(event, api) {
    var sdkInfo = $541725032c9b1421$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var useEnvelope = eventType === 'transaction' || !!api.tunnel;
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $541725032c9b1421$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var body;
    try {
        // 99.9% of events should get through just fine - no change in behavior for them
        body = JSON.stringify(event);
    } catch (err) {
        // Record data about the error without replacing original event data, then force renormalization
        event.tags.JSONStringifyError = true;
        event.extra.JSONStringifyError = err;
        try {
            body = JSON.stringify((0, $jn5uz.normalize)(event));
        } catch (newErr) {
            // At this point even renormalization hasn't worked, meaning something about the event data has gone very wrong.
            // Time to cut our losses and record only the new error. With luck, even in the problematic cases we're trying to
            // debug with this hack, we won't ever land here.
            var innerErr = newErr;
            body = JSON.stringify({
                message: 'JSON.stringify error after renormalization',
                // setting `extra: { innerErr }` here for some reason results in an empty object, so unpack manually
                extra: {
                    message: innerErr.message,
                    stack: innerErr.stack
                }
            });
        }
    }
    var req = {
        // this is the relevant line of code before the hack was added, to make it easy to undo said hack once we've solved
        // the mystery
        // body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
        body: body,
        type: eventType,
        url: useEnvelope ? (0, $da298c0570fc4a2c$export$9964600bfe84e6a3)(api.dsn, api.tunnel) : (0, $da298c0570fc4a2c$export$c1677e22ac2217a5)(api.dsn)
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = (0, $gztBd.__assign)((0, $gztBd.__assign)({
            event_id: event.event_id,
            sent_at: new Date().toISOString()
        }, sdkInfo && {
            sdk: sdkInfo
        }), !!api.tunnel && {
            dsn: (0, $UMf0P.dsnToString)(api.dsn)
        });
        var eventItem = [
            {
                type: eventType,
                sample_rates: [
                    {
                        id: samplingMethod,
                        rate: sampleRate
                    }
                ]
            },
            req.body
        ];
        var envelope = (0, $jCHqX.createEnvelope)(envelopeHeaders, [
            eventItem
        ]);
        req.body = (0, $jCHqX.serializeEnvelope)(envelope);
    }
    return req;
}


parcelRequire("2ktyf");
var $i7ar8 = parcelRequire("i7ar8");
/** Noop transport */ var $eef66c0973aef092$export$6f2767450ea1346c = /** @class */ function() {
    function NoopTransport() {}
    /**
     * @inheritDoc
     */ NoopTransport.prototype.sendEvent = function(_) {
        return (0, $i7ar8.resolvedSyncPromise)({
            reason: 'NoopTransport: Event has been skipped because no Dsn is configured.',
            status: 'skipped'
        });
    };
    /**
     * @inheritDoc
     */ NoopTransport.prototype.close = function(_) {
        return (0, $i7ar8.resolvedSyncPromise)(true);
    };
    return NoopTransport;
}();


/**
 * This is the base implemention of a Backend.
 * @hidden
 */ var $51dcb78cd4b05e42$export$8f43a53a38d7e95f = /** @class */ function() {
    /** Creates a new backend instance. */ function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) (0, $f06facd2a983bb77$export$48a8984ec0bf2e44) && (0, $7htw4.logger).warn('No DSN provided, backend will not do anything.');
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function(_exception, _hint) {
        throw new (0, $h5dmQ.SentryError)('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.eventFromMessage = function(_message, _level, _hint) {
        throw new (0, $h5dmQ.SentryError)('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendEvent = function(event) {
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $da298c0570fc4a2c$export$ad00a06efb2a29cb)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var env = (0, $541725032c9b1421$export$c31057337a18010f)(event, api);
            this._newTransport.send(env).then(null, function(reason) {
                (0, $f06facd2a983bb77$export$48a8984ec0bf2e44) && (0, $7htw4.logger).error('Error while sending event:', reason);
            });
        } else this._transport.sendEvent(event).then(null, function(reason) {
            (0, $f06facd2a983bb77$export$48a8984ec0bf2e44) && (0, $7htw4.logger).error('Error while sending event:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendSession = function(session) {
        if (!this._transport.sendSession) {
            (0, $f06facd2a983bb77$export$48a8984ec0bf2e44) && (0, $7htw4.logger).warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $da298c0570fc4a2c$export$ad00a06efb2a29cb)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var _a = (0, $gztBd.__read)((0, $541725032c9b1421$export$124b03c077baa2f3)(session, api), 1), env = _a[0];
            this._newTransport.send(env).then(null, function(reason) {
                (0, $f06facd2a983bb77$export$48a8984ec0bf2e44) && (0, $7htw4.logger).error('Error while sending session:', reason);
            });
        } else this._transport.sendSession(session).then(null, function(reason) {
            (0, $f06facd2a983bb77$export$48a8984ec0bf2e44) && (0, $7htw4.logger).error('Error while sending session:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.getTransport = function() {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */ BaseBackend.prototype._setupTransport = function() {
        return new (0, $eef66c0973aef092$export$6f2767450ea1346c)();
    };
    return BaseBackend;
}();



var $9lo5J = parcelRequire("9lo5J");
parcelRequire("2ktyf");
var $8PJbC = parcelRequire("8PJbC");

var $gztBd = parcelRequire("gztBd");

var $9lo5J = parcelRequire("9lo5J");
parcelRequire("2ktyf");
var $HgoiY = parcelRequire("HgoiY");
var $6Iopj = parcelRequire("6Iopj");
var $bP4Y8 = parcelRequire("bP4Y8");
var $5QZE4 = parcelRequire("5QZE4");
var $jn5uz = parcelRequire("jn5uz");
var $i7ar8 = parcelRequire("i7ar8");

var $gztBd = parcelRequire("gztBd");
// global reference to slice
var $8b14e65fd7f0660b$var$UNKNOWN_FUNCTION = '?';
var $8b14e65fd7f0660b$var$OPERA10_PRIORITY = 10;
var $8b14e65fd7f0660b$var$OPERA11_PRIORITY = 20;
var $8b14e65fd7f0660b$var$CHROME_PRIORITY = 30;
var $8b14e65fd7f0660b$var$WINJS_PRIORITY = 40;
var $8b14e65fd7f0660b$var$GECKO_PRIORITY = 50;
function $8b14e65fd7f0660b$var$createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var $8b14e65fd7f0660b$var$chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var $8b14e65fd7f0660b$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var $8b14e65fd7f0660b$var$chrome = function(line) {
    var parts = $8b14e65fd7f0660b$var$chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = $8b14e65fd7f0660b$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = (0, $gztBd.__read)($8b14e65fd7f0660b$var$extractSafariExtensionDetails(parts[1] || $8b14e65fd7f0660b$var$UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return $8b14e65fd7f0660b$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var $8b14e65fd7f0660b$export$c693d9295441d8f9 = [
    $8b14e65fd7f0660b$var$CHROME_PRIORITY,
    $8b14e65fd7f0660b$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var $8b14e65fd7f0660b$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var $8b14e65fd7f0660b$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $8b14e65fd7f0660b$var$gecko = function(line) {
    var _a;
    var parts = $8b14e65fd7f0660b$var$geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = $8b14e65fd7f0660b$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || $8b14e65fd7f0660b$var$UNKNOWN_FUNCTION;
        _a = (0, $gztBd.__read)($8b14e65fd7f0660b$var$extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return $8b14e65fd7f0660b$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var $8b14e65fd7f0660b$export$c9ddf1e2b5d48bff = [
    $8b14e65fd7f0660b$var$GECKO_PRIORITY,
    $8b14e65fd7f0660b$var$gecko
];
var $8b14e65fd7f0660b$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $8b14e65fd7f0660b$var$winjs = function(line) {
    var parts = $8b14e65fd7f0660b$var$winjsRegex.exec(line);
    return parts ? $8b14e65fd7f0660b$var$createFrame(parts[2], parts[1] || $8b14e65fd7f0660b$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
var $8b14e65fd7f0660b$export$b6d155d85c1dcba5 = [
    $8b14e65fd7f0660b$var$WINJS_PRIORITY,
    $8b14e65fd7f0660b$var$winjs
];
var $8b14e65fd7f0660b$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var $8b14e65fd7f0660b$var$opera10 = function(line) {
    var parts = $8b14e65fd7f0660b$var$opera10Regex.exec(line);
    return parts ? $8b14e65fd7f0660b$var$createFrame(parts[2], parts[3] || $8b14e65fd7f0660b$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var $8b14e65fd7f0660b$export$966ec832d9699d6 = [
    $8b14e65fd7f0660b$var$OPERA10_PRIORITY,
    $8b14e65fd7f0660b$var$opera10
];
var $8b14e65fd7f0660b$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var $8b14e65fd7f0660b$var$opera11 = function(line) {
    var parts = $8b14e65fd7f0660b$var$opera11Regex.exec(line);
    return parts ? $8b14e65fd7f0660b$var$createFrame(parts[5], parts[3] || parts[4] || $8b14e65fd7f0660b$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var $8b14e65fd7f0660b$export$989a1824b4734ce6 = [
    $8b14e65fd7f0660b$var$OPERA11_PRIORITY,
    $8b14e65fd7f0660b$var$opera11
];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var $8b14e65fd7f0660b$var$extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $8b14e65fd7f0660b$var$UNKNOWN_FUNCTION,
        isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename
    ] : [
        func,
        filename
    ];
};


function $36956b5a37b0d668$export$a6c2d27607295951(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = $36956b5a37b0d668$export$d478b2c12fbcfdda(ex);
    var exception = {
        type: ex && ex.name,
        value: $36956b5a37b0d668$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $36956b5a37b0d668$export$a6a5dd73e489caf(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: (0, $5QZE4.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + (0, $bP4Y8.extractExceptionKeysForMessage)(exception)
                }
            ]
        },
        extra: {
            __serialized__: (0, $jn5uz.normalizeToSize)(exception)
        }
    };
    if (syntheticException) {
        var frames_1 = $36956b5a37b0d668$export$d478b2c12fbcfdda(syntheticException);
        if (frames_1.length) event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
function $36956b5a37b0d668$export$73fbea5a0a5234af(ex) {
    return {
        exception: {
            values: [
                $36956b5a37b0d668$export$a6c2d27607295951(ex)
            ]
        }
    };
}
function $36956b5a37b0d668$export$d478b2c12fbcfdda(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = $36956b5a37b0d668$var$getPopSize(ex);
    try {
        return (0, $6Iopj.createStackParser)((0, $8b14e65fd7f0660b$export$966ec832d9699d6), (0, $8b14e65fd7f0660b$export$989a1824b4734ce6), (0, $8b14e65fd7f0660b$export$c693d9295441d8f9), (0, $8b14e65fd7f0660b$export$b6d155d85c1dcba5), (0, $8b14e65fd7f0660b$export$c9ddf1e2b5d48bff))(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var $36956b5a37b0d668$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $36956b5a37b0d668$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($36956b5a37b0d668$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $36956b5a37b0d668$var$extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
function $36956b5a37b0d668$export$ea3ec7e569b823fc(exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $36956b5a37b0d668$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace);
    (0, $HgoiY.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = (0, $9lo5J.Severity).Error;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $i7ar8.resolvedSyncPromise)(event);
}
function $36956b5a37b0d668$export$5425b53185d13d6c(message, level, hint, attachStacktrace) {
    if (level === void 0) level = (0, $9lo5J.Severity).Info;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $36956b5a37b0d668$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $i7ar8.resolvedSyncPromise)(event);
}
function $36956b5a37b0d668$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0, $5QZE4.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return $36956b5a37b0d668$export$73fbea5a0a5234af(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $5QZE4.isDOMError)(exception) || (0, $5QZE4.isDOMException)(exception)) {
        var domException = exception;
        if ('stack' in exception) event = $36956b5a37b0d668$export$73fbea5a0a5234af(exception);
        else {
            var name_1 = domException.name || ((0, $5QZE4.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = $36956b5a37b0d668$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
            (0, $HgoiY.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) event.tags = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, event.tags), {
            'DOMException.code': "" + domException.code
        });
        return event;
    }
    if ((0, $5QZE4.isError)(exception)) // we have a real Error object, do nothing
    return $36956b5a37b0d668$export$73fbea5a0a5234af(exception);
    if ((0, $5QZE4.isPlainObject)(exception) || (0, $5QZE4.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = $36956b5a37b0d668$export$a6a5dd73e489caf(objectException, syntheticException, isUnhandledRejection);
        (0, $HgoiY.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $36956b5a37b0d668$export$47d86ae4b3c9994(exception, syntheticException, attachStacktrace);
    (0, $HgoiY.addExceptionTypeValue)(event, "" + exception, undefined);
    (0, $HgoiY.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $36956b5a37b0d668$export$47d86ae4b3c9994(input, syntheticException, attachStacktrace) {
    var event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = $36956b5a37b0d668$export$d478b2c12fbcfdda(syntheticException);
        if (frames_2.length) event.stacktrace = {
            frames: frames_2
        };
    }
    return event;
}



var $gztBd = parcelRequire("gztBd");
parcelRequire("2ktyf");
var $h5dmQ = parcelRequire("h5dmQ");
var $8PJbC = parcelRequire("8PJbC");
var $i7ar8 = parcelRequire("i7ar8");

var $gztBd = parcelRequire("gztBd");

parcelRequire("2ktyf");
var $99zbJ = parcelRequire("99zbJ");
var $iCHNb = parcelRequire("iCHNb");
var $UMf0P = parcelRequire("UMf0P");
var $ew5rY = parcelRequire("ew5rY");
var $1SlwS = parcelRequire("1SlwS");
var $7htw4 = parcelRequire("7htw4");
var $bPACs = parcelRequire("bPACs");
var $jCHqX = parcelRequire("jCHqX");
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $77f6e199f1cbab61$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;


parcelRequire("2ktyf");
var $fYxH9 = parcelRequire("fYxH9");
var $1SlwS = parcelRequire("1SlwS");
var $8PJbC = parcelRequire("8PJbC");
var $7htw4 = parcelRequire("7htw4");

var $89ea36f69881f583$var$global = (0, $1SlwS.getGlobalObject)();
var $89ea36f69881f583$var$cachedFetchImpl;
function $89ea36f69881f583$export$8be2119ce08e3379() {
    if ($89ea36f69881f583$var$cachedFetchImpl) return $89ea36f69881f583$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $8PJbC.isNativeFetch)($89ea36f69881f583$var$global.fetch)) return $89ea36f69881f583$var$cachedFetchImpl = $89ea36f69881f583$var$global.fetch.bind($89ea36f69881f583$var$global);
    var document = $89ea36f69881f583$var$global.document;
    var fetchImpl = $89ea36f69881f583$var$global.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        var sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $77f6e199f1cbab61$export$48a8984ec0bf2e44) && (0, $7htw4.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $89ea36f69881f583$var$cachedFetchImpl = fetchImpl.bind($89ea36f69881f583$var$global);
/* eslint-enable @typescript-eslint/unbound-method */ }
function $89ea36f69881f583$export$84bb63b2c17ec44d(url, body) {
    var isRealNavigator = Object.prototype.toString.call($89ea36f69881f583$var$global && $89ea36f69881f583$var$global.navigator) === '[object Navigator]';
    var hasSendBeacon = isRealNavigator && typeof $89ea36f69881f583$var$global.navigator.sendBeacon === 'function';
    if (hasSendBeacon) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        var sendBeacon = $89ea36f69881f583$var$global.navigator.sendBeacon.bind($89ea36f69881f583$var$global.navigator);
        return sendBeacon(url, body);
    }
    if ((0, $8PJbC.supportsFetch)()) {
        var fetch_1 = $89ea36f69881f583$export$8be2119ce08e3379();
        return (0, $fYxH9.forget)(fetch_1(url, {
            body: body,
            method: 'POST',
            credentials: 'omit',
            keepalive: true
        }));
    }
}


function $7df43ab34a4b5f7f$var$requestTypeToCategory(ty) {
    var tyStr = ty;
    return tyStr === 'event' ? 'error' : tyStr;
}
var $7df43ab34a4b5f7f$var$global = (0, $1SlwS.getGlobalObject)();
/** Base Transport class implementation */ var $7df43ab34a4b5f7f$export$74b99d619e90f481 = /** @class */ function() {
    function BaseTransport(options) {
        var _this = this;
        this.options = options;
        /** A simple buffer holding all requests. */ this._buffer = (0, $bPACs.makePromiseBuffer)(30);
        /** Locks transport after receiving rate limits in a response */ this._rateLimits = {};
        this._outcomes = {};
        this._api = (0, $da298c0570fc4a2c$export$ad00a06efb2a29cb)(options.dsn, options._metadata, options.tunnel);
        // eslint-disable-next-line deprecation/deprecation
        this.url = (0, $da298c0570fc4a2c$export$c1677e22ac2217a5)(this._api.dsn);
        if (this.options.sendClientReports && $7df43ab34a4b5f7f$var$global.document) $7df43ab34a4b5f7f$var$global.document.addEventListener('visibilitychange', function() {
            if ($7df43ab34a4b5f7f$var$global.document.visibilityState === 'hidden') _this._flushOutcomes();
        });
    }
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendEvent = function(event) {
        return this._sendRequest((0, $541725032c9b1421$export$2006389de558b996)(event, this._api), event);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendSession = function(session) {
        return this._sendRequest((0, $541725032c9b1421$export$977ee6eda1884ec3)(session, this._api), session);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.close = function(timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.recordLostEvent = function(reason, category) {
        var _a;
        if (!this.options.sendClientReports) return;
        // We want to track each category (event, transaction, session) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        var key = $7df43ab34a4b5f7f$var$requestTypeToCategory(category) + ":" + reason;
        (0, $77f6e199f1cbab61$export$48a8984ec0bf2e44) && (0, $7htw4.logger).log("Adding outcome: " + key);
        this._outcomes[key] = (_a = this._outcomes[key], _a !== null && _a !== void 0 ? _a : 0) + 1;
    };
    /**
     * Send outcomes as an envelope
     */ BaseTransport.prototype._flushOutcomes = function() {
        if (!this.options.sendClientReports) return;
        var outcomes = this._outcomes;
        this._outcomes = {};
        // Nothing to send
        if (!Object.keys(outcomes).length) {
            (0, $77f6e199f1cbab61$export$48a8984ec0bf2e44) && (0, $7htw4.logger).log('No outcomes to flush');
            return;
        }
        (0, $77f6e199f1cbab61$export$48a8984ec0bf2e44) && (0, $7htw4.logger).log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
        var url = (0, $da298c0570fc4a2c$export$9964600bfe84e6a3)(this._api.dsn, this._api.tunnel);
        var discardedEvents = Object.keys(outcomes).map(function(key) {
            var _a = (0, $gztBd.__read)(key.split(':'), 2), category = _a[0], reason = _a[1];
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        // TODO: Improve types on discarded_events to get rid of cast
        });
        var envelope = (0, $99zbJ.createClientReportEnvelope)(discardedEvents, this._api.tunnel && (0, $UMf0P.dsnToString)(this._api.dsn));
        try {
            (0, $89ea36f69881f583$export$84bb63b2c17ec44d)(url, (0, $jCHqX.serializeEnvelope)(envelope));
        } catch (e) {
            (0, $77f6e199f1cbab61$export$48a8984ec0bf2e44) && (0, $7htw4.logger).error(e);
        }
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */ BaseTransport.prototype._handleResponse = function(_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = (0, $ew5rY.eventStatusFromHttpCode)(response.status);
        this._rateLimits = (0, $iCHNb.updateRateLimits)(this._rateLimits, headers);
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(requestType)) (0, $77f6e199f1cbab61$export$48a8984ec0bf2e44) && // eslint-disable-next-line deprecation/deprecation
        (0, $7htw4.logger).warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
        if (status === 'success') {
            resolve({
                status: status
            });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     *
     * @deprecated Please use `disabledUntil` from @sentry/utils
     */ BaseTransport.prototype._disabledUntil = function(requestType) {
        var category = $7df43ab34a4b5f7f$var$requestTypeToCategory(requestType);
        return new Date((0, $iCHNb.disabledUntil)(this._rateLimits, category));
    };
    /**
     * Checks if a category is rate limited
     *
     * @deprecated Please use `isRateLimited` from @sentry/utils
     */ BaseTransport.prototype._isRateLimited = function(requestType) {
        var category = $7df43ab34a4b5f7f$var$requestTypeToCategory(requestType);
        return (0, $iCHNb.isRateLimited)(this._rateLimits, category);
    };
    return BaseTransport;
}();



/** `fetch` based transport */ var $99d026d71c642708$export$2bdee3f9b92f4e82 = /** @class */ function(_super) {
    (0, $gztBd.__extends)(FetchTransport, _super);
    function FetchTransport(options, fetchImpl) {
        if (fetchImpl === void 0) fetchImpl = (0, $89ea36f69881f583$export$8be2119ce08e3379)();
        var _this = _super.call(this, options) || this;
        _this._fetch = fetchImpl;
        return _this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ FetchTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
            // (see https://caniuse.com/#feat=referrer-policy),
            // it doesn't. And it throws an exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (0, $8PJbC.supportsReferrerPolicy)() ? 'origin' : ''
        };
        if (this.options.fetchParameters !== undefined) Object.assign(options, this.options.fetchParameters);
        if (this.options.headers !== undefined) options.headers = this.options.headers;
        return this._buffer.add(function() {
            return new (0, $i7ar8.SyncPromise)(function(resolve, reject) {
                _this._fetch(sentryRequest.url, options).then(function(response) {
                    var headers = {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    };
                    _this._handleResponse({
                        requestType: sentryRequest.type,
                        response: response,
                        headers: headers,
                        resolve: resolve,
                        reject: reject
                    });
                }).catch(reject);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $h5dmQ.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return FetchTransport;
}((0, $7df43ab34a4b5f7f$export$74b99d619e90f481));


var $gztBd = parcelRequire("gztBd");
parcelRequire("2ktyf");
var $iCHNb = parcelRequire("iCHNb");
var $ew5rY = parcelRequire("ew5rY");
var $jCHqX = parcelRequire("jCHqX");
var $bPACs = parcelRequire("bPACs");
var $i7ar8 = parcelRequire("i7ar8");
var $e5443b9a37f1db5b$export$d8a725a7dce95622 = 'error';
var $e5443b9a37f1db5b$export$99adc6fe67a3c63e = 'transaction';
var $e5443b9a37f1db5b$export$9d7ad34f132fe68f = 'attachment';
var $e5443b9a37f1db5b$export$42d9e7b5fc564c45 = 'session';
var $e5443b9a37f1db5b$export$e515cf6dfd2f98b8 = 30;
function $e5443b9a37f1db5b$export$d09f50d9ab7f7b69(options, makeRequest, buffer) {
    if (buffer === void 0) buffer = (0, $bPACs.makePromiseBuffer)(options.bufferSize || $e5443b9a37f1db5b$export$e515cf6dfd2f98b8);
    var rateLimits = {};
    var flush = function(timeout) {
        return buffer.drain(timeout);
    };
    function send(envelope) {
        var envCategory = (0, $jCHqX.getEnvelopeType)(envelope);
        var category = envCategory === 'event' ? 'error' : envCategory;
        var request = {
            category: category,
            body: (0, $jCHqX.serializeEnvelope)(envelope)
        };
        // Don't add to buffer if transport is already rate-limited
        if ((0, $iCHNb.isRateLimited)(rateLimits, category)) return (0, $i7ar8.rejectedSyncPromise)({
            status: 'rate_limit',
            reason: $e5443b9a37f1db5b$var$getRateLimitReason(rateLimits, category)
        });
        var requestTask = function() {
            return makeRequest(request).then(function(_a) {
                var body = _a.body, headers = _a.headers, reason = _a.reason, statusCode = _a.statusCode;
                var status = (0, $ew5rY.eventStatusFromHttpCode)(statusCode);
                if (headers) rateLimits = (0, $iCHNb.updateRateLimits)(rateLimits, headers);
                if (status === 'success') return (0, $i7ar8.resolvedSyncPromise)({
                    status: status,
                    reason: reason
                });
                return (0, $i7ar8.rejectedSyncPromise)({
                    status: status,
                    reason: reason || body || (status === 'rate_limit' ? $e5443b9a37f1db5b$var$getRateLimitReason(rateLimits, category) : 'Unknown transport error')
                });
            });
        };
        return buffer.add(requestTask);
    }
    return {
        send: send,
        flush: flush
    };
}
function $e5443b9a37f1db5b$var$getRateLimitReason(rateLimits, category) {
    return "Too many " + category + " requests, backing off until: " + new Date((0, $iCHNb.disabledUntil)(rateLimits, category)).toISOString();
}



function $9e0e7096985e92fe$export$1c57e6bfd09bad13(options, nativeFetch) {
    if (nativeFetch === void 0) nativeFetch = (0, $89ea36f69881f583$export$8be2119ce08e3379)();
    function makeRequest(request) {
        var requestOptions = (0, $gztBd.__assign)({
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin'
        }, options.requestOptions);
        return nativeFetch(options.url, requestOptions).then(function(response) {
            return response.text().then(function(body) {
                return {
                    body: body,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    },
                    reason: response.statusText,
                    statusCode: response.status
                };
            });
        });
    }
    return (0, $e5443b9a37f1db5b$export$d09f50d9ab7f7b69)({
        bufferSize: options.bufferSize
    }, makeRequest);
}


parcelRequire("2ktyf");
var $i7ar8 = parcelRequire("i7ar8");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ var $010ec8854608929c$var$XHR_READYSTATE_DONE = 4;
function $010ec8854608929c$export$4c0ac1dd4bbf4921(options) {
    function makeRequest(request) {
        return new (0, $i7ar8.SyncPromise)(function(resolve, _reject) {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (xhr.readyState === $010ec8854608929c$var$XHR_READYSTATE_DONE) {
                    var response = {
                        body: xhr.response,
                        headers: {
                            'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': xhr.getResponseHeader('Retry-After')
                        },
                        reason: xhr.statusText,
                        statusCode: xhr.status
                    };
                    resolve(response);
                }
            };
            xhr.open('POST', options.url);
            for(var header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $e5443b9a37f1db5b$export$d09f50d9ab7f7b69)({
        bufferSize: options.bufferSize
    }, makeRequest);
}


var $gztBd = parcelRequire("gztBd");
parcelRequire("2ktyf");
var $h5dmQ = parcelRequire("h5dmQ");
var $i7ar8 = parcelRequire("i7ar8");

/** `XHR` based transport */ var $ca2901e77e0aacab$export$874a283af77e8e62 = /** @class */ function(_super) {
    (0, $gztBd.__extends)(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ XHRTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        return this._buffer.add(function() {
            return new (0, $i7ar8.SyncPromise)(function(resolve, reject) {
                var request = new XMLHttpRequest();
                request.onreadystatechange = function() {
                    if (request.readyState === 4) {
                        var headers = {
                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': request.getResponseHeader('Retry-After')
                        };
                        _this._handleResponse({
                            requestType: sentryRequest.type,
                            response: request,
                            headers: headers,
                            resolve: resolve,
                            reject: reject
                        });
                    }
                };
                request.open('POST', sentryRequest.url);
                for(var header in _this.options.headers)if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) request.setRequestHeader(header, _this.options.headers[header]);
                request.send(sentryRequest.body);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $h5dmQ.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return XHRTransport;
}((0, $7df43ab34a4b5f7f$export$74b99d619e90f481));


/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */ var $4912048faff85b48$export$2526e21aec9d0ce7 = /** @class */ function(_super) {
    (0, $gztBd.__extends)(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromException = function(exception, hint) {
        return (0, $36956b5a37b0d668$export$ea3ec7e569b823fc)(exception, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromMessage = function(message, level, hint) {
        if (level === void 0) level = (0, $9lo5J.Severity).Info;
        return (0, $36956b5a37b0d668$export$5425b53185d13d6c)(message, level, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype._setupTransport = function() {
        if (!this._options.dsn) // We return the noop transport here in case there is no Dsn.
        return _super.prototype._setupTransport.call(this);
        var transportOptions = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this._options.transportOptions), {
            dsn: this._options.dsn,
            tunnel: this._options.tunnel,
            sendClientReports: this._options.sendClientReports,
            _metadata: this._options._metadata
        });
        var api = (0, $da298c0570fc4a2c$export$ad00a06efb2a29cb)(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
        var url = (0, $da298c0570fc4a2c$export$9964600bfe84e6a3)(api.dsn, api.tunnel);
        if (this._options.transport) return new this._options.transport(transportOptions);
        if ((0, $8PJbC.supportsFetch)()) {
            var requestOptions = (0, $gztBd.__assign)({}, transportOptions.fetchParameters);
            this._newTransport = (0, $9e0e7096985e92fe$export$1c57e6bfd09bad13)({
                requestOptions: requestOptions,
                url: url
            });
            return new (0, $99d026d71c642708$export$2bdee3f9b92f4e82)(transportOptions);
        }
        this._newTransport = (0, $010ec8854608929c$export$4c0ac1dd4bbf4921)({
            url: url,
            headers: transportOptions.headers
        });
        return new (0, $ca2901e77e0aacab$export$874a283af77e8e62)(transportOptions);
    };
    return BrowserBackend;
}((0, $51dcb78cd4b05e42$export$8f43a53a38d7e95f));




var $gztBd = parcelRequire("gztBd");

var $gztBd = parcelRequire("gztBd");

var $6cwj6 = parcelRequire("6cwj6");
/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $725d9ec1d23925de$var$callOnHub(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var hub = (0, $6cwj6.getCurrentHub)();
    if (hub && hub[method]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return hub[method].apply(hub, (0, $gztBd.__spread)(args));
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
function $725d9ec1d23925de$export$f5282963edea4a68(exception, captureContext) {
    var syntheticException = new Error('Sentry syntheticException');
    return $725d9ec1d23925de$var$callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException
    });
}
function $725d9ec1d23925de$export$45654777c133ae80(message, captureContext) {
    var syntheticException = new Error(message);
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return $725d9ec1d23925de$var$callOnHub('captureMessage', message, level, (0, $gztBd.__assign)({
        originalException: message,
        syntheticException: syntheticException
    }, context));
}
function $725d9ec1d23925de$export$1462b974fdcf6ba2(event) {
    return $725d9ec1d23925de$var$callOnHub('captureEvent', event);
}
function $725d9ec1d23925de$export$99d44f04437e9cb8(callback) {
    $725d9ec1d23925de$var$callOnHub('configureScope', callback);
}
function $725d9ec1d23925de$export$efda9a273d7a036d(breadcrumb) {
    $725d9ec1d23925de$var$callOnHub('addBreadcrumb', breadcrumb);
}
function $725d9ec1d23925de$export$2f04de43fe27971a(name, context) {
    $725d9ec1d23925de$var$callOnHub('setContext', name, context);
}
function $725d9ec1d23925de$export$bb4922da0dd51b92(extras) {
    $725d9ec1d23925de$var$callOnHub('setExtras', extras);
}
function $725d9ec1d23925de$export$74a8fb34822092e6(tags) {
    $725d9ec1d23925de$var$callOnHub('setTags', tags);
}
function $725d9ec1d23925de$export$8e8e7789d42ed61d(key, extra) {
    $725d9ec1d23925de$var$callOnHub('setExtra', key, extra);
}
function $725d9ec1d23925de$export$a37d07ee78eb4569(key, value) {
    $725d9ec1d23925de$var$callOnHub('setTag', key, value);
}
function $725d9ec1d23925de$export$8b6bb3dd62a01be2(user) {
    $725d9ec1d23925de$var$callOnHub('setUser', user);
}
function $725d9ec1d23925de$export$ec58d9285c204497(callback) {
    $725d9ec1d23925de$var$callOnHub('withScope', callback);
}
function $725d9ec1d23925de$export$5b9bc6fc91daaf9f(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    $725d9ec1d23925de$var$callOnHub.apply(void 0, (0, $gztBd.__spread)([
        '_invokeClient',
        method
    ], args));
}
function $725d9ec1d23925de$export$e262da7ae6480481(context, customSamplingContext) {
    return $725d9ec1d23925de$var$callOnHub('startTransaction', (0, $gztBd.__assign)({}, context), customSamplingContext);
}


parcelRequire("2ktyf");
var $HgoiY = parcelRequire("HgoiY");
var $bP4Y8 = parcelRequire("bP4Y8");
var $1SlwS = parcelRequire("1SlwS");
var $7htw4 = parcelRequire("7htw4");

var $b69ee834d2d8bdf6$var$global = (0, $1SlwS.getGlobalObject)();
var $b69ee834d2d8bdf6$var$ignoreOnError = 0;
function $b69ee834d2d8bdf6$export$b79738ab10c590b2() {
    return $b69ee834d2d8bdf6$var$ignoreOnError > 0;
}
function $b69ee834d2d8bdf6$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $b69ee834d2d8bdf6$var$ignoreOnError += 1;
    setTimeout(function() {
        $b69ee834d2d8bdf6$var$ignoreOnError -= 1;
    });
}
function $b69ee834d2d8bdf6$export$4997ffc0176396a6(fn, options, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (options === void 0) options = {};
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $bP4Y8.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function(arg) {
                return $b69ee834d2d8bdf6$export$4997ffc0176396a6(arg, options);
            });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $b69ee834d2d8bdf6$export$1265a142ff5ba165();
            (0, $725d9ec1d23925de$export$ec58d9285c204497)(function(scope) {
                scope.addEventProcessor(function(event) {
                    if (options.mechanism) {
                        (0, $HgoiY.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $HgoiY.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, $725d9ec1d23925de$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $bP4Y8.markFunctionWrapped)(sentryWrapped, fn);
    (0, $bP4Y8.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get: function() {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}
function $b69ee834d2d8bdf6$export$deb9aac8ea0b576c(options) {
    if (options === void 0) options = {};
    if (!$b69ee834d2d8bdf6$var$global.document) return;
    if (!options.eventId) {
        (0, $77f6e199f1cbab61$export$48a8984ec0bf2e44) && (0, $7htw4.logger).error('Missing eventId option in showReportDialog call');
        return;
    }
    if (!options.dsn) {
        (0, $77f6e199f1cbab61$export$48a8984ec0bf2e44) && (0, $7htw4.logger).error('Missing dsn option in showReportDialog call');
        return;
    }
    var script = $b69ee834d2d8bdf6$var$global.document.createElement('script');
    script.async = true;
    script.src = (0, $da298c0570fc4a2c$export$671c7ed8e40a7a57)(options.dsn, options);
    if (options.onLoad) // eslint-disable-next-line @typescript-eslint/unbound-method
    script.onload = options.onLoad;
    var injectionPoint = $b69ee834d2d8bdf6$var$global.document.head || $b69ee834d2d8bdf6$var$global.document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
}



var $gztBd = parcelRequire("gztBd");

var $6cwj6 = parcelRequire("6cwj6");

var $9lo5J = parcelRequire("9lo5J");
parcelRequire("2ktyf");
var $lDX8u = parcelRequire("lDX8u");
var $HgoiY = parcelRequire("HgoiY");
var $1SlwS = parcelRequire("1SlwS");
var $eAaWR = parcelRequire("eAaWR");
var $jP2vU = parcelRequire("jP2vU");
var $gYqyD = parcelRequire("gYqyD");
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ var $355f8d9981d566ef$export$2dc68d50d56fbbd = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */ this.name = Breadcrumbs.id;
        this._options = (0, $gztBd.__assign)({
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true
        }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */ Breadcrumbs.prototype.addSentryBreadcrumb = function(event) {
        if (!this._options.sentry) return;
        (0, $6cwj6.getCurrentHub)().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: (0, $HgoiY.getEventDescription)(event)
        }, {
            event: event
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */ Breadcrumbs.prototype.setupOnce = function() {
        if (this._options.console) (0, $lDX8u.addInstrumentationHandler)('console', $355f8d9981d566ef$var$_consoleBreadcrumb);
        if (this._options.dom) (0, $lDX8u.addInstrumentationHandler)('dom', $355f8d9981d566ef$var$_domBreadcrumb(this._options.dom));
        if (this._options.xhr) (0, $lDX8u.addInstrumentationHandler)('xhr', $355f8d9981d566ef$var$_xhrBreadcrumb);
        if (this._options.fetch) (0, $lDX8u.addInstrumentationHandler)('fetch', $355f8d9981d566ef$var$_fetchBreadcrumb);
        if (this._options.history) (0, $lDX8u.addInstrumentationHandler)('history', $355f8d9981d566ef$var$_historyBreadcrumb);
    };
    /**
     * @inheritDoc
     */ Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}();
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $355f8d9981d566ef$var$_domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target ? (0, $eAaWR.htmlTreeAsString)(handlerData.event.target, keyAttrs) : (0, $eAaWR.htmlTreeAsString)(handlerData.event, keyAttrs);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        (0, $6cwj6.getCurrentHub)().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $355f8d9981d566ef$var$_consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console'
        },
        level: (0, $gYqyD.severityFromString)(handlerData.level),
        message: (0, $jP2vU.safeJoin)(handlerData.args, ' ')
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: " + ((0, $jP2vU.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert');
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, $6cwj6.getCurrentHub)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $355f8d9981d566ef$var$_xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) return;
        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
        (0, $6cwj6.getCurrentHub)().addBreadcrumb({
            category: 'xhr',
            data: {
                method: method,
                url: url,
                status_code: status_code
            },
            type: 'http'
        }, {
            xhr: handlerData.xhr,
            input: body
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $355f8d9981d566ef$var$_fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) (0, $6cwj6.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: handlerData.fetchData,
        level: (0, $9lo5J.Severity).Error,
        type: 'http'
    }, {
        data: handlerData.error,
        input: handlerData.args
    });
    else (0, $6cwj6.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: (0, $gztBd.__assign)((0, $gztBd.__assign)({}, handlerData.fetchData), {
            status_code: handlerData.response.status
        }),
        type: 'http'
    }, {
        input: handlerData.args,
        response: handlerData.response
    });
}
/**
 * Creates breadcrumbs from history API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $355f8d9981d566ef$var$_historyBreadcrumb(handlerData) {
    var global = (0, $1SlwS.getGlobalObject)();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = (0, $HgoiY.parseUrl)(global.location.href);
    var parsedFrom = (0, $HgoiY.parseUrl)(from);
    var parsedTo = (0, $HgoiY.parseUrl)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, $6cwj6.getCurrentHub)().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
}


/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ var $7b33da84303847bc$export$1df9218a526d318d = /** @class */ function(_super) {
    (0, $gztBd.__extends)(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */ function BrowserClient(options) {
        if (options === void 0) options = {};
        var _this = this;
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: 'npm:@sentry/browser',
                    version: (0, $8663cc950bc5605c$export$31499a9cd224b78c)
                }
            ],
            version: (0, $8663cc950bc5605c$export$31499a9cd224b78c)
        };
        _this = _super.call(this, (0, $4912048faff85b48$export$2526e21aec9d0ce7), options) || this;
        return _this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */ BrowserClient.prototype.showReportDialog = function(options) {
        if (options === void 0) options = {};
        // doesn't work without a document (React Native)
        var document = (0, $1SlwS.getGlobalObject)().document;
        if (!document) return;
        if (!this._isEnabled()) {
            (0, $77f6e199f1cbab61$export$48a8984ec0bf2e44) && (0, $7htw4.logger).error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        (0, $b69ee834d2d8bdf6$export$deb9aac8ea0b576c)((0, $gztBd.__assign)((0, $gztBd.__assign)({}, options), {
            dsn: options.dsn || this.getDsn()
        }));
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._prepareEvent = function(event, scope, hint) {
        event.platform = event.platform || 'javascript';
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._sendEvent = function(event) {
        var integration = this.getIntegration((0, $355f8d9981d566ef$export$2dc68d50d56fbbd));
        if (integration) integration.addSentryBreadcrumb(event);
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}((0, $640fc7d84f5323a0$export$4f22f74eddb7716a));




parcelRequire("2ktyf");
var $7htw4 = parcelRequire("7htw4");

/** Deduplication filter */ var $64a102a9031d7a8b$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($64a102a9031d7a8b$var$_shouldDropEvent(currentEvent, self._previousEvent)) {
                        (0, $77f6e199f1cbab61$export$48a8984ec0bf2e44) && (0, $7htw4.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
/** JSDoc */ function $64a102a9031d7a8b$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($64a102a9031d7a8b$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($64a102a9031d7a8b$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $64a102a9031d7a8b$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$64a102a9031d7a8b$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$64a102a9031d7a8b$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $64a102a9031d7a8b$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $64a102a9031d7a8b$var$_getExceptionFromEvent(previousEvent);
    var currentException = $64a102a9031d7a8b$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$64a102a9031d7a8b$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$64a102a9031d7a8b$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $64a102a9031d7a8b$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $64a102a9031d7a8b$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $64a102a9031d7a8b$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $64a102a9031d7a8b$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $64a102a9031d7a8b$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $64a102a9031d7a8b$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}


var $gztBd = parcelRequire("gztBd");

var $6cwj6 = parcelRequire("6cwj6");

var $9lo5J = parcelRequire("9lo5J");
parcelRequire("2ktyf");
var $HgoiY = parcelRequire("HgoiY");
var $lDX8u = parcelRequire("lDX8u");
var $eAaWR = parcelRequire("eAaWR");
var $5QZE4 = parcelRequire("5QZE4");
var $7htw4 = parcelRequire("7htw4");



/** Global handlers */ var $ed3134e690fd7f16$export$204155decbc90e5a = /** @class */ function() {
    /** JSDoc */ function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */ this.name = GlobalHandlers.id;
        /**
         * Stores references functions to installing handlers. Will set to undefined
         * after they have been run so that they are not used twice.
         */ this._installFunc = {
            onerror: $ed3134e690fd7f16$var$_installGlobalOnErrorHandler,
            onunhandledrejection: $ed3134e690fd7f16$var$_installGlobalOnUnhandledRejectionHandler
        };
        this._options = (0, $gztBd.__assign)({
            onerror: true,
            onunhandledrejection: true
        }, options);
    }
    /**
     * @inheritDoc
     */ GlobalHandlers.prototype.setupOnce = function() {
        Error.stackTraceLimit = 50;
        var options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for(var key in options){
            var installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                $ed3134e690fd7f16$var$globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    };
    /**
     * @inheritDoc
     */ GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}();
/** JSDoc */ function $ed3134e690fd7f16$var$_installGlobalOnErrorHandler() {
    (0, $lDX8u.addInstrumentationHandler)('error', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(data) {
        var _a = (0, $gztBd.__read)($ed3134e690fd7f16$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($ed3134e690fd7f16$export$204155decbc90e5a)) return;
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        if ((0, $b69ee834d2d8bdf6$export$b79738ab10c590b2)() || error && error.__sentry_own_request__) return;
        var event = error === undefined && (0, $5QZE4.isString)(msg) ? $ed3134e690fd7f16$var$_eventFromIncompleteOnError(msg, url, line, column) : $ed3134e690fd7f16$var$_enhanceEventWithInitialFrame((0, $36956b5a37b0d668$export$9dd56ed1ef0c3420)(error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = (0, $9lo5J.Severity).Error;
        $ed3134e690fd7f16$var$addMechanismAndCapture(hub, error, event, 'onerror');
    });
}
/** JSDoc */ function $ed3134e690fd7f16$var$_installGlobalOnUnhandledRejectionHandler() {
    (0, $lDX8u.addInstrumentationHandler)('unhandledrejection', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(e) {
        var _a = (0, $gztBd.__read)($ed3134e690fd7f16$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($ed3134e690fd7f16$export$204155decbc90e5a)) return;
        var error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ('reason' in e) error = e.reason;
            else if ('detail' in e && 'reason' in e.detail) error = e.detail.reason;
        } catch (_oO) {
        // no-empty
        }
        if ((0, $b69ee834d2d8bdf6$export$b79738ab10c590b2)() || error && error.__sentry_own_request__) return true;
        var event = (0, $5QZE4.isPrimitive)(error) ? $ed3134e690fd7f16$var$_eventFromRejectionWithPrimitive(error) : (0, $36956b5a37b0d668$export$9dd56ed1ef0c3420)(error, undefined, attachStacktrace, true);
        event.level = (0, $9lo5J.Severity).Error;
        $ed3134e690fd7f16$var$addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $ed3134e690fd7f16$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: " + String(reason)
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ed3134e690fd7f16$var$_eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = (0, $5QZE4.isErrorEvent)(msg) ? msg.message : msg;
    var name = 'Error';
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $ed3134e690fd7f16$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ed3134e690fd7f16$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = event.exception = event.exception || {};
    // event.exception.values
    var ev = e.values = e.values || [];
    // event.exception.values[0]
    var ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    var ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    var ev0sf = ev0s.frames = ev0s.frames || [];
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = (0, $5QZE4.isString)(url) && url.length > 0 ? url : (0, $eAaWR.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $ed3134e690fd7f16$var$globalHandlerLog(type) {
    (0, $77f6e199f1cbab61$export$48a8984ec0bf2e44) && (0, $7htw4.logger).log("Global Handler attached: " + type);
}
function $ed3134e690fd7f16$var$addMechanismAndCapture(hub, error, event, type) {
    (0, $HgoiY.addExceptionMechanism)(event, {
        handled: false,
        type: type
    });
    hub.captureEvent(event, {
        originalException: error
    });
}
function $ed3134e690fd7f16$var$getHubAndAttachStacktrace() {
    var hub = (0, $6cwj6.getCurrentHub)();
    var client = hub.getClient();
    var attachStacktrace = client && client.getOptions().attachStacktrace;
    return [
        hub,
        attachStacktrace
    ];
}


var $gztBd = parcelRequire("gztBd");

var $ka93y = parcelRequire("ka93y");
var $6cwj6 = parcelRequire("6cwj6");
parcelRequire("2ktyf");
var $5QZE4 = parcelRequire("5QZE4");

var $06bb7854fa0f7190$var$DEFAULT_KEY = 'cause';
var $06bb7854fa0f7190$var$DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ var $06bb7854fa0f7190$export$8d1e60aaf616fb4f = /** @class */ function() {
    /**
     * @inheritDoc
     */ function LinkedErrors(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = LinkedErrors.id;
        this._key = options.key || $06bb7854fa0f7190$var$DEFAULT_KEY;
        this._limit = options.limit || $06bb7854fa0f7190$var$DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */ LinkedErrors.prototype.setupOnce = function() {
        (0, $ka93y.addGlobalEventProcessor)(function(event, hint) {
            var self = (0, $6cwj6.getCurrentHub)().getIntegration(LinkedErrors);
            return self ? $06bb7854fa0f7190$export$7bd713d0612d8839(self._key, self._limit, event, hint) : event;
        });
    };
    /**
     * @inheritDoc
     */ LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}();
function $06bb7854fa0f7190$export$7bd713d0612d8839(key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $5QZE4.isInstanceOf)(hint.originalException, Error)) return event;
    var linkedErrors = $06bb7854fa0f7190$export$e4e3ecf6f8f76c75(limit, hint.originalException, key);
    event.exception.values = (0, $gztBd.__spread)(linkedErrors, event.exception.values);
    return event;
}
function $06bb7854fa0f7190$export$e4e3ecf6f8f76c75(limit, error, key, stack) {
    if (stack === void 0) stack = [];
    if (!(0, $5QZE4.isInstanceOf)(error[key], Error) || stack.length + 1 >= limit) return stack;
    var exception = (0, $36956b5a37b0d668$export$a6c2d27607295951)(error[key]);
    return $06bb7854fa0f7190$export$e4e3ecf6f8f76c75(limit, error[key], key, (0, $gztBd.__spread)([
        exception
    ], stack));
}


var $gztBd = parcelRequire("gztBd");
parcelRequire("2ktyf");
var $bP4Y8 = parcelRequire("bP4Y8");
var $6Iopj = parcelRequire("6Iopj");
var $1SlwS = parcelRequire("1SlwS");

var $82c2736be09e13bf$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ var $82c2736be09e13bf$export$f1a018517668e6d3 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function TryCatch(options) {
        /**
         * @inheritDoc
         */ this.name = TryCatch.id;
        this._options = (0, $gztBd.__assign)({
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true
        }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */ TryCatch.prototype.setupOnce = function() {
        var global = (0, $1SlwS.getGlobalObject)();
        if (this._options.setTimeout) (0, $bP4Y8.fill)(global, 'setTimeout', $82c2736be09e13bf$var$_wrapTimeFunction);
        if (this._options.setInterval) (0, $bP4Y8.fill)(global, 'setInterval', $82c2736be09e13bf$var$_wrapTimeFunction);
        if (this._options.requestAnimationFrame) (0, $bP4Y8.fill)(global, 'requestAnimationFrame', $82c2736be09e13bf$var$_wrapRAF);
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) (0, $bP4Y8.fill)(XMLHttpRequest.prototype, 'send', $82c2736be09e13bf$var$_wrapXHR);
        var eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $82c2736be09e13bf$var$DEFAULT_EVENT_TARGET;
            eventTarget.forEach($82c2736be09e13bf$var$_wrapEventTarget);
        }
    };
    /**
     * @inheritDoc
     */ TryCatch.id = 'TryCatch';
    return TryCatch;
}();
/** JSDoc */ function $82c2736be09e13bf$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var originalCallback = args[0];
        args[0] = (0, $b69ee834d2d8bdf6$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $6Iopj.getFunctionName)(original)
                },
                handled: true,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $82c2736be09e13bf$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $b69ee834d2d8bdf6$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $6Iopj.getFunctionName)(original)
                    },
                    handled: true,
                    type: 'instrument'
                }
            })
        ]);
    };
}
/** JSDoc */ function $82c2736be09e13bf$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach(function(prop) {
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $bP4Y8.fill)(xhr, prop, function(original) {
                var wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $6Iopj.getFunctionName)(original)
                        },
                        handled: true,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                var originalFunction = (0, $bP4Y8.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $6Iopj.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $b69ee834d2d8bdf6$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */ function $82c2736be09e13bf$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var global = (0, $1SlwS.getGlobalObject)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = global[target] && global[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $bP4Y8.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') fn.handleEvent = (0, $b69ee834d2d8bdf6$export$4997ffc0176396a6)(fn.handleEvent.bind(fn), {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $6Iopj.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $b69ee834d2d8bdf6$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $6Iopj.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $bP4Y8.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
             * There are 2 possible scenarios here:
             *
             * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
             * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
             * as a pass-through, and call original `removeEventListener` with it.
             *
             * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
             * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
             * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
             * in order for us to make a distinction between wrapped/non-wrapped functions possible.
             * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
             *
             * When someone adds a handler prior to initialization, and then do it again, but after,
             * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
             * to get rid of the initial handler and it'd stick there forever.
             */ var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}


var $gztBd = parcelRequire("gztBd");

var $ka93y = parcelRequire("ka93y");
var $6cwj6 = parcelRequire("6cwj6");
parcelRequire("2ktyf");
var $1SlwS = parcelRequire("1SlwS");
var $f0a889af4435e5cd$var$global = (0, $1SlwS.getGlobalObject)();
/** UserAgent */ var $f0a889af4435e5cd$export$5fba5e10934a4faf = /** @class */ function() {
    function UserAgent() {
        /**
         * @inheritDoc
         */ this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */ UserAgent.prototype.setupOnce = function() {
        (0, $ka93y.addGlobalEventProcessor)(function(event) {
            if ((0, $6cwj6.getCurrentHub)().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!$f0a889af4435e5cd$var$global.navigator && !$f0a889af4435e5cd$var$global.location && !$f0a889af4435e5cd$var$global.document) return event;
                // grab as much info as exists and add it to the event
                var url = event.request && event.request.url || $f0a889af4435e5cd$var$global.location && $f0a889af4435e5cd$var$global.location.href;
                var referrer = ($f0a889af4435e5cd$var$global.document || {}).referrer;
                var userAgent = ($f0a889af4435e5cd$var$global.navigator || {}).userAgent;
                var headers = (0, $gztBd.__assign)((0, $gztBd.__assign)((0, $gztBd.__assign)({}, event.request && event.request.headers), referrer && {
                    Referer: referrer
                }), userAgent && {
                    'User-Agent': userAgent
                });
                var request = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, url && {
                    url: url
                }), {
                    headers: headers
                });
                return (0, $gztBd.__assign)((0, $gztBd.__assign)({}, event), {
                    request: request
                });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ UserAgent.id = 'UserAgent';
    return UserAgent;
}();


var $3892e5b7960d5b8e$export$5ef831fccfce35e5 = [
    new (0, $4a8e49c5cea1e330$exports).InboundFilters(),
    new (0, $4a8e49c5cea1e330$exports).FunctionToString(),
    new (0, $82c2736be09e13bf$export$f1a018517668e6d3)(),
    new (0, $355f8d9981d566ef$export$2dc68d50d56fbbd)(),
    new (0, $ed3134e690fd7f16$export$204155decbc90e5a)(),
    new (0, $06bb7854fa0f7190$export$8d1e60aaf616fb4f)(),
    new (0, $64a102a9031d7a8b$export$688d98c249d31ad3)(),
    new (0, $f0a889af4435e5cd$export$5fba5e10934a4faf)()
];
function $3892e5b7960d5b8e$export$2cd8252107eb640b(options) {
    if (options === void 0) options = {};
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $3892e5b7960d5b8e$export$5ef831fccfce35e5;
    if (options.release === undefined) {
        var window_1 = (0, $1SlwS.getGlobalObject)();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) options.release = window_1.SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    (0, $ec20e29fc539f943$export$5333c3f1c58d9bc1)((0, $7b33da84303847bc$export$1df9218a526d318d), options);
    if (options.autoSessionTracking) $3892e5b7960d5b8e$var$startSessionTracking();
}
function $3892e5b7960d5b8e$export$3a8fd680da42627b(options) {
    if (options === void 0) options = {};
    var hub = (0, $6cwj6.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) options.user = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, scope.getUser()), options.user);
    if (!options.eventId) options.eventId = hub.lastEventId();
    var client = hub.getClient();
    if (client) client.showReportDialog(options);
}
function $3892e5b7960d5b8e$export$5d4e9fd7fac8e617() {
    return (0, $6cwj6.getCurrentHub)().lastEventId();
}
function $3892e5b7960d5b8e$export$a3f323d81eede727() {
// Noop
}
function $3892e5b7960d5b8e$export$4e4d8b287d028b6b(callback) {
    callback();
}
function $3892e5b7960d5b8e$export$4909b86c8034bf73(timeout) {
    var client = (0, $6cwj6.getCurrentHub)().getClient();
    if (client) return client.flush(timeout);
    (0, $77f6e199f1cbab61$export$48a8984ec0bf2e44) && (0, $7htw4.logger).warn('Cannot flush events. No client defined.');
    return (0, $i7ar8.resolvedSyncPromise)(false);
}
function $3892e5b7960d5b8e$export$8360e631d277ea4d(timeout) {
    var client = (0, $6cwj6.getCurrentHub)().getClient();
    if (client) return client.close(timeout);
    (0, $77f6e199f1cbab61$export$48a8984ec0bf2e44) && (0, $7htw4.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return (0, $i7ar8.resolvedSyncPromise)(false);
}
function $3892e5b7960d5b8e$export$4997ffc0176396a6(fn) {
    return (0, $b69ee834d2d8bdf6$export$4997ffc0176396a6)(fn)();
}
function $3892e5b7960d5b8e$var$startSessionOnHub(hub) {
    hub.startSession({
        ignoreDuration: true
    });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $3892e5b7960d5b8e$var$startSessionTracking() {
    var window = (0, $1SlwS.getGlobalObject)();
    var document = window.document;
    if (typeof document === 'undefined') {
        (0, $77f6e199f1cbab61$export$48a8984ec0bf2e44) && (0, $7htw4.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    var hub = (0, $6cwj6.getCurrentHub)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) return;
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    $3892e5b7960d5b8e$var$startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0, $lDX8u.addInstrumentationHandler)('history', function(_a) {
        var from = _a.from, to = _a.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) $3892e5b7960d5b8e$var$startSessionOnHub((0, $6cwj6.getCurrentHub)());
    });
}



var $3siHg = parcelRequire("3siHg");
var $06791d67b9ee3cd2$exports = {};

$parcel$export($06791d67b9ee3cd2$exports, "Express", () => $70b8dfe24d232ef4$export$6dafdd8fec05099d);
$parcel$export($06791d67b9ee3cd2$exports, "Postgres", () => $e53573a9efaf8d52$export$806ddb599177abc4);
$parcel$export($06791d67b9ee3cd2$exports, "Mysql", () => $825e0b9311f16533$export$a2cc26ff91a3f8ad);
$parcel$export($06791d67b9ee3cd2$exports, "Mongo", () => $d957ea5fd8df8e17$export$968aa4360b02a334);
$parcel$export($06791d67b9ee3cd2$exports, "BrowserTracing", () => $77b970860201ef91$export$46d3bbd0375f5fa4);

var $gztBd = parcelRequire("gztBd");
parcelRequire("2ktyf");
var $7htw4 = parcelRequire("7htw4");

var $2mkHy = parcelRequire("2mkHy");
/**
 * Express integration
 *
 * Provides an request and error handler for Express framework as well as tracing capabilities
 */ var $70b8dfe24d232ef4$export$6dafdd8fec05099d = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Express(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = Express.id;
        this._router = options.router || options.app;
        this._methods = (Array.isArray(options.methods) ? options.methods : []).concat('use');
    }
    /**
     * @inheritDoc
     */ Express.prototype.setupOnce = function() {
        if (!this._router) {
            (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).error('ExpressIntegration is missing an Express instance');
            return;
        }
        $70b8dfe24d232ef4$var$instrumentMiddlewares(this._router, this._methods);
    };
    /**
     * @inheritDoc
     */ Express.id = 'Express';
    return Express;
}();
/**
 * Wraps original middleware function in a tracing call, which stores the info about the call as a span,
 * and finishes it once the middleware is done invoking.
 *
 * Express middlewares have 3 various forms, thus we have to take care of all of them:
 * // sync
 * app.use(function (req, res) { ... })
 * // async
 * app.use(function (req, res, next) { ... })
 * // error handler
 * app.use(function (err, req, res, next) { ... })
 *
 * They all internally delegate to the `router[method]` of the given application instance.
 */ // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
function $70b8dfe24d232ef4$var$wrap(fn, method) {
    var arity = fn.length;
    switch(arity){
        case 2:
            return function(req, res) {
                var transaction = res.__sentry_transaction;
                if (transaction) {
                    var span_1 = transaction.startChild({
                        description: fn.name,
                        op: "express.middleware." + method
                    });
                    res.once('finish', function() {
                        span_1.finish();
                    });
                }
                return fn.call(this, req, res);
            };
        case 3:
            return function(req, res, next) {
                var _a;
                var transaction = res.__sentry_transaction;
                var span = (_a = transaction) === null || _a === void 0 ? void 0 : _a.startChild({
                    description: fn.name,
                    op: "express.middleware." + method
                });
                fn.call(this, req, res, function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var _a;
                    (_a = span) === null || _a === void 0 || _a.finish();
                    next.call.apply(next, (0, $gztBd.__spread)([
                        this
                    ], args));
                });
            };
        case 4:
            return function(err, req, res, next) {
                var _a;
                var transaction = res.__sentry_transaction;
                var span = (_a = transaction) === null || _a === void 0 ? void 0 : _a.startChild({
                    description: fn.name,
                    op: "express.middleware." + method
                });
                fn.call(this, err, req, res, function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var _a;
                    (_a = span) === null || _a === void 0 || _a.finish();
                    next.call.apply(next, (0, $gztBd.__spread)([
                        this
                    ], args));
                });
            };
        default:
            throw new Error("Express middleware takes 2-4 arguments. Got: " + arity);
    }
}
/**
 * Takes all the function arguments passed to the original `app` or `router` method, eg. `app.use` or `router.use`
 * and wraps every function, as well as array of functions with a call to our `wrap` method.
 * We have to take care of the arrays as well as iterate over all of the arguments,
 * as `app.use` can accept middlewares in few various forms.
 *
 * app.use([<path>], <fn>)
 * app.use([<path>], <fn>, ...<fn>)
 * app.use([<path>], ...<fn>[])
 */ function $70b8dfe24d232ef4$var$wrapMiddlewareArgs(args, method) {
    return args.map(function(arg) {
        if (typeof arg === 'function') return $70b8dfe24d232ef4$var$wrap(arg, method);
        if (Array.isArray(arg)) return arg.map(function(a) {
            if (typeof a === 'function') return $70b8dfe24d232ef4$var$wrap(a, method);
            return a;
        });
        return arg;
    });
}
/**
 * Patches original router to utilize our tracing functionality
 */ function $70b8dfe24d232ef4$var$patchMiddleware(router, method) {
    var originalCallback = router[method];
    router[method] = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return originalCallback.call.apply(originalCallback, (0, $gztBd.__spread)([
            this
        ], $70b8dfe24d232ef4$var$wrapMiddlewareArgs(args, method)));
    };
    return router;
}
/**
 * Patches original router methods
 */ function $70b8dfe24d232ef4$var$instrumentMiddlewares(router, methods) {
    if (methods === void 0) methods = [];
    methods.forEach(function(method) {
        return $70b8dfe24d232ef4$var$patchMiddleware(router, method);
    });
}


parcelRequire("2ktyf");
var $bP4Y8 = parcelRequire("bP4Y8");
var $5QZE4 = parcelRequire("5QZE4");
var $8upap = parcelRequire("8upap");
var $7htw4 = parcelRequire("7htw4");

var $2mkHy = parcelRequire("2mkHy");
/** Tracing integration for node-postgres package */ var $e53573a9efaf8d52$export$806ddb599177abc4 = /** @class */ function() {
    function Postgres(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = Postgres.id;
        this._usePgNative = !!options.usePgNative;
    }
    /**
     * @inheritDoc
     */ Postgres.prototype.setupOnce = function(_, getCurrentHub) {
        var _a;
        var pkg = (0, $8upap.loadModule)('pg');
        if (!pkg) {
            (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).error('Postgres Integration was unable to require `pg` package.');
            return;
        }
        if (this._usePgNative && !((_a = pkg.native) === null || _a === void 0 ? void 0 : _a.Client)) {
            (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).error("Postgres Integration was unable to access 'pg-native' bindings.");
            return;
        }
        var Client = (this._usePgNative ? pkg.native : pkg).Client;
        /**
         * function (query, callback) => void
         * function (query, params, callback) => void
         * function (query) => Promise
         * function (query, params) => Promise
         * function (pg.Cursor) => pg.Cursor
         */ (0, $bP4Y8.fill)(Client.prototype, 'query', function(orig) {
            return function(config, values, callback) {
                var _a, _b, _c;
                var scope = getCurrentHub().getScope();
                var parentSpan = (_a = scope) === null || _a === void 0 ? void 0 : _a.getSpan();
                var span = (_b = parentSpan) === null || _b === void 0 ? void 0 : _b.startChild({
                    description: typeof config === 'string' ? config : config.text,
                    op: 'db'
                });
                if (typeof callback === 'function') return orig.call(this, config, values, function(err, result) {
                    var _a;
                    (_a = span) === null || _a === void 0 || _a.finish();
                    callback(err, result);
                });
                if (typeof values === 'function') return orig.call(this, config, function(err, result) {
                    var _a;
                    (_a = span) === null || _a === void 0 || _a.finish();
                    values(err, result);
                });
                var rv = typeof values !== 'undefined' ? orig.call(this, config, values) : orig.call(this, config);
                if ((0, $5QZE4.isThenable)(rv)) return rv.then(function(res) {
                    var _a;
                    (_a = span) === null || _a === void 0 || _a.finish();
                    return res;
                });
                (_c = span) === null || _c === void 0 || _c.finish();
                return rv;
            };
        });
    };
    /**
     * @inheritDoc
     */ Postgres.id = 'Postgres';
    return Postgres;
}();


parcelRequire("2ktyf");
var $bP4Y8 = parcelRequire("bP4Y8");
var $8upap = parcelRequire("8upap");
var $7htw4 = parcelRequire("7htw4");

var $2mkHy = parcelRequire("2mkHy");
/** Tracing integration for node-mysql package */ var $825e0b9311f16533$export$a2cc26ff91a3f8ad = /** @class */ function() {
    function Mysql() {
        /**
         * @inheritDoc
         */ this.name = Mysql.id;
    }
    /**
     * @inheritDoc
     */ Mysql.prototype.setupOnce = function(_, getCurrentHub) {
        var pkg = (0, $8upap.loadModule)('mysql/lib/Connection.js');
        if (!pkg) {
            (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).error('Mysql Integration was unable to require `mysql` package.');
            return;
        }
        // The original function will have one of these signatures:
        //    function (callback) => void
        //    function (options, callback) => void
        //    function (options, values, callback) => void
        (0, $bP4Y8.fill)(pkg, 'createQuery', function(orig) {
            return function(options, values, callback) {
                var _a, _b;
                var scope = getCurrentHub().getScope();
                var parentSpan = (_a = scope) === null || _a === void 0 ? void 0 : _a.getSpan();
                var span = (_b = parentSpan) === null || _b === void 0 ? void 0 : _b.startChild({
                    description: typeof options === 'string' ? options : options.sql,
                    op: 'db'
                });
                if (typeof callback === 'function') return orig.call(this, options, values, function(err, result, fields) {
                    var _a;
                    (_a = span) === null || _a === void 0 || _a.finish();
                    callback(err, result, fields);
                });
                if (typeof values === 'function') return orig.call(this, options, function(err, result, fields) {
                    var _a;
                    (_a = span) === null || _a === void 0 || _a.finish();
                    values(err, result, fields);
                });
                return orig.call(this, options, values, callback);
            };
        });
    };
    /**
     * @inheritDoc
     */ Mysql.id = 'Mysql';
    return Mysql;
}();



var $gztBd = parcelRequire("gztBd");
parcelRequire("2ktyf");
var $bP4Y8 = parcelRequire("bP4Y8");
var $5QZE4 = parcelRequire("5QZE4");
var $8upap = parcelRequire("8upap");
var $7htw4 = parcelRequire("7htw4");

var $2mkHy = parcelRequire("2mkHy");
var $d957ea5fd8df8e17$var$OPERATIONS = [
    'aggregate',
    'bulkWrite',
    'countDocuments',
    'createIndex',
    'createIndexes',
    'deleteMany',
    'deleteOne',
    'distinct',
    'drop',
    'dropIndex',
    'dropIndexes',
    'estimatedDocumentCount',
    'find',
    'findOne',
    'findOneAndDelete',
    'findOneAndReplace',
    'findOneAndUpdate',
    'indexes',
    'indexExists',
    'indexInformation',
    'initializeOrderedBulkOp',
    'insertMany',
    'insertOne',
    'isCapped',
    'mapReduce',
    'options',
    'parallelCollectionScan',
    'rename',
    'replaceOne',
    'stats',
    'updateMany',
    'updateOne'
];
// All of the operations above take `options` and `callback` as their final parameters, but some of them
// take additional parameters as well. For those operations, this is a map of
// { <operation name>:  [<names of additional parameters>] }, as a way to know what to call the operation's
// positional arguments when we add them to the span's `data` object later
var $d957ea5fd8df8e17$var$OPERATION_SIGNATURES = {
    // aggregate intentionally not included because `pipeline` arguments are too complex to serialize well
    // see https://github.com/getsentry/sentry-javascript/pull/3102
    bulkWrite: [
        'operations'
    ],
    countDocuments: [
        'query'
    ],
    createIndex: [
        'fieldOrSpec'
    ],
    createIndexes: [
        'indexSpecs'
    ],
    deleteMany: [
        'filter'
    ],
    deleteOne: [
        'filter'
    ],
    distinct: [
        'key',
        'query'
    ],
    dropIndex: [
        'indexName'
    ],
    find: [
        'query'
    ],
    findOne: [
        'query'
    ],
    findOneAndDelete: [
        'filter'
    ],
    findOneAndReplace: [
        'filter',
        'replacement'
    ],
    findOneAndUpdate: [
        'filter',
        'update'
    ],
    indexExists: [
        'indexes'
    ],
    insertMany: [
        'docs'
    ],
    insertOne: [
        'doc'
    ],
    mapReduce: [
        'map',
        'reduce'
    ],
    rename: [
        'newName'
    ],
    replaceOne: [
        'filter',
        'doc'
    ],
    updateMany: [
        'filter',
        'update'
    ],
    updateOne: [
        'filter',
        'update'
    ]
};
/** Tracing integration for mongo package */ var $d957ea5fd8df8e17$export$968aa4360b02a334 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Mongo(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = Mongo.id;
        this._operations = Array.isArray(options.operations) ? options.operations : $d957ea5fd8df8e17$var$OPERATIONS;
        this._describeOperations = 'describeOperations' in options ? options.describeOperations : true;
        this._useMongoose = !!options.useMongoose;
    }
    /**
     * @inheritDoc
     */ Mongo.prototype.setupOnce = function(_, getCurrentHub) {
        var moduleName = this._useMongoose ? 'mongoose' : 'mongodb';
        var pkg = (0, $8upap.loadModule)(moduleName);
        if (!pkg) {
            (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).error("Mongo Integration was unable to require `" + moduleName + "` package.");
            return;
        }
        this._instrumentOperations(pkg.Collection, this._operations, getCurrentHub);
    };
    /**
     * Patches original collection methods
     */ Mongo.prototype._instrumentOperations = function(collection, operations, getCurrentHub) {
        var _this = this;
        operations.forEach(function(operation) {
            return _this._patchOperation(collection, operation, getCurrentHub);
        });
    };
    /**
     * Patches original collection to utilize our tracing functionality
     */ Mongo.prototype._patchOperation = function(collection, operation, getCurrentHub) {
        if (!(operation in collection.prototype)) return;
        var getSpanContext = this._getSpanContextFromOperationArguments.bind(this);
        (0, $bP4Y8.fill)(collection.prototype, operation, function(orig) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var _a, _b, _c, _d;
                var lastArg = args[args.length - 1];
                var scope = getCurrentHub().getScope();
                var parentSpan = (_a = scope) === null || _a === void 0 ? void 0 : _a.getSpan();
                // Check if the operation was passed a callback. (mapReduce requires a different check, as
                // its (non-callback) arguments can also be functions.)
                if (typeof lastArg !== 'function' || operation === 'mapReduce' && args.length === 2) {
                    var span_1 = (_b = parentSpan) === null || _b === void 0 ? void 0 : _b.startChild(getSpanContext(this, operation, args));
                    var maybePromise = orig.call.apply(orig, (0, $gztBd.__spread)([
                        this
                    ], args));
                    if ((0, $5QZE4.isThenable)(maybePromise)) return maybePromise.then(function(res) {
                        var _a;
                        (_a = span_1) === null || _a === void 0 || _a.finish();
                        return res;
                    });
                    else {
                        (_c = span_1) === null || _c === void 0 || _c.finish();
                        return maybePromise;
                    }
                }
                var span = (_d = parentSpan) === null || _d === void 0 ? void 0 : _d.startChild(getSpanContext(this, operation, args.slice(0, -1)));
                return orig.call.apply(orig, (0, $gztBd.__spread)([
                    this
                ], args.slice(0, -1), [
                    function(err, result) {
                        var _a;
                        (_a = span) === null || _a === void 0 || _a.finish();
                        lastArg(err, result);
                    }
                ]));
            };
        });
    };
    /**
     * Form a SpanContext based on the user input to a given operation.
     */ Mongo.prototype._getSpanContextFromOperationArguments = function(collection, operation, args) {
        var data = {
            collectionName: collection.collectionName,
            dbName: collection.dbName,
            namespace: collection.namespace
        };
        var spanContext = {
            op: 'db',
            description: operation,
            data: data
        };
        // If the operation takes no arguments besides `options` and `callback`, or if argument
        // collection is disabled for this operation, just return early.
        var signature = $d957ea5fd8df8e17$var$OPERATION_SIGNATURES[operation];
        var shouldDescribe = Array.isArray(this._describeOperations) ? this._describeOperations.includes(operation) : this._describeOperations;
        if (!signature || !shouldDescribe) return spanContext;
        try {
            // Special case for `mapReduce`, as the only one accepting functions as arguments.
            if (operation === 'mapReduce') {
                var _a = (0, $gztBd.__read)(args, 2), map = _a[0], reduce = _a[1];
                data[signature[0]] = typeof map === 'string' ? map : map.name || '<anonymous>';
                data[signature[1]] = typeof reduce === 'string' ? reduce : reduce.name || '<anonymous>';
            } else for(var i = 0; i < signature.length; i++)data[signature[i]] = JSON.stringify(args[i]);
        } catch (_oO) {
        // no-empty
        }
        return spanContext;
    };
    /**
     * @inheritDoc
     */ Mongo.id = 'Mongo';
    return Mongo;
}();



var $gztBd = parcelRequire("gztBd");
parcelRequire("2ktyf");
var $1SlwS = parcelRequire("1SlwS");
var $7htw4 = parcelRequire("7htw4");

var $2mkHy = parcelRequire("2mkHy");

var $3siHg = parcelRequire("3siHg");

var $kCOHN = parcelRequire("kCOHN");
parcelRequire("2ktyf");
var $lS7eK = parcelRequire("lS7eK");
var $b1qwm = parcelRequire("b1qwm");
parcelRequire("2ktyf");
var $1SlwS = parcelRequire("1SlwS");
var $7htw4 = parcelRequire("7htw4");

var $5kNcg = parcelRequire("5kNcg");

var $2mkHy = parcelRequire("2mkHy");

var $b1qwm = parcelRequire("b1qwm");
var $7bb15ea4ada198e4$var$global = (0, $1SlwS.getGlobalObject)();
function $7bb15ea4ada198e4$export$6f18f55521af71a1() {
    if ($7bb15ea4ada198e4$var$global && $7bb15ea4ada198e4$var$global.document) $7bb15ea4ada198e4$var$global.document.addEventListener('visibilitychange', function() {
        var activeTransaction = (0, $b1qwm.getActiveTransaction)();
        if ($7bb15ea4ada198e4$var$global.document.hidden && activeTransaction) {
            var statusType = 'cancelled';
            (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log("[Tracing] Transaction: " + statusType + " -> since tab moved to the background, op: " + activeTransaction.op);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!activeTransaction.status) activeTransaction.setStatus(statusType);
            activeTransaction.setTag('visibilitychange', 'document.hidden');
            activeTransaction.setTag((0, $5kNcg.FINISH_REASON_TAG), (0, $5kNcg.IDLE_TRANSACTION_FINISH_REASONS)[2]);
            activeTransaction.finish();
        }
    });
    else (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).warn('[Tracing] Could not set up background tab detection due to lack of global document');
}



var $gztBd = parcelRequire("gztBd");
parcelRequire("2ktyf");
var $cQg0t = parcelRequire("cQg0t");
var $1SlwS = parcelRequire("1SlwS");
var $eAaWR = parcelRequire("eAaWR");
var $8upap = parcelRequire("8upap");
var $7htw4 = parcelRequire("7htw4");

var $2mkHy = parcelRequire("2mkHy");

var $b1qwm = parcelRequire("b1qwm");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $dc4499eb109ed331$export$17679dccdd551979 = function(callback, metric, reportAllChanges) {
    var prevValue;
    return function(forceReport) {
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                metric.delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (metric.delta || prevValue === undefined) {
                    prevValue = metric.value;
                    callback(metric);
                }
            }
        }
    };
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ var $a8ac052ab297db84$export$407ea409d1f3b539 = function() {
    return "v2-" + Date.now() + "-" + (Math.floor(Math.random() * (9e12 - 1)) + 1e12);
};


var $db329d9cc2543112$export$3c29b44508a0612b = function(name, value) {
    return {
        name: name,
        value: value !== null && value !== void 0 ? value : -1,
        delta: 0,
        entries: [],
        id: (0, $a8ac052ab297db84$export$407ea409d1f3b539)()
    };
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ var $b6bd0c0ca205a2d9$export$d1203567a167490e = function(type, callback) {
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            // More extensive feature detect needed for Firefox due to:
            // https://github.com/GoogleChrome/web-vitals/issues/142
            if (type === 'first-input' && !('PerformanceEventTiming' in self)) return;
            var po = new PerformanceObserver(function(l) {
                return l.getEntries().map(callback);
            });
            po.observe({
                type: type,
                buffered: true
            });
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("2ktyf");
var $1SlwS = parcelRequire("1SlwS");
var $ff86837478f2cf04$export$91ec2be6fdd8f1b4 = function(cb, once) {
    var onHiddenOrPageHide = function(event) {
        if (event.type === 'pagehide' || (0, $1SlwS.getGlobalObject)().document.visibilityState === 'hidden') {
            cb(event);
            if (once) {
                removeEventListener('visibilitychange', onHiddenOrPageHide, true);
                removeEventListener('pagehide', onHiddenOrPageHide, true);
            }
        }
    };
    addEventListener('visibilitychange', onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    addEventListener('pagehide', onHiddenOrPageHide, true);
};


var $d59decabb17bc361$export$fc6227831ee7c7 = function(onReport, reportAllChanges) {
    var metric = (0, $db329d9cc2543112$export$3c29b44508a0612b)('CLS', 0);
    var report;
    var sessionValue = 0;
    var sessionEntries = [];
    var entryHandler = function(entry) {
        // Only count layout shifts without recent user input.
        // TODO: Figure out why entry can be undefined
        if (entry && !entry.hadRecentInput) {
            var firstSessionEntry = sessionEntries[0];
            var lastSessionEntry = sessionEntries[sessionEntries.length - 1];
            // If the entry occurred less than 1 second after the previous entry and
            // less than 5 seconds after the first entry in the session, include the
            // entry in the current session. Otherwise, start a new session.
            if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                sessionValue += entry.value;
                sessionEntries.push(entry);
            } else {
                sessionValue = entry.value;
                sessionEntries = [
                    entry
                ];
            }
            // If the current session value is larger than the current CLS value,
            // update CLS and the entries contributing to it.
            if (sessionValue > metric.value) {
                metric.value = sessionValue;
                metric.entries = sessionEntries;
                if (report) report();
            }
        }
    };
    var po = (0, $b6bd0c0ca205a2d9$export$d1203567a167490e)('layout-shift', entryHandler);
    if (po) {
        report = (0, $dc4499eb109ed331$export$17679dccdd551979)(onReport, metric, reportAllChanges);
        (0, $ff86837478f2cf04$export$91ec2be6fdd8f1b4)(function() {
            po.takeRecords().map(entryHandler);
            report(true);
        });
    }
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("2ktyf");
var $1SlwS = parcelRequire("1SlwS");

var $53776475df74ac8b$var$firstHiddenTime = -1;
var $53776475df74ac8b$var$initHiddenTime = function() {
    return (0, $1SlwS.getGlobalObject)().document.visibilityState === 'hidden' ? 0 : Infinity;
};
var $53776475df74ac8b$var$trackChanges = function() {
    // Update the time if/when the document becomes hidden.
    (0, $ff86837478f2cf04$export$91ec2be6fdd8f1b4)(function(_a) {
        var timeStamp = _a.timeStamp;
        $53776475df74ac8b$var$firstHiddenTime = timeStamp;
    }, true);
};
var $53776475df74ac8b$export$443f86b2c77012c4 = function() {
    if ($53776475df74ac8b$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $53776475df74ac8b$var$firstHiddenTime = $53776475df74ac8b$var$initHiddenTime();
        $53776475df74ac8b$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $53776475df74ac8b$var$firstHiddenTime;
        }
    };
};





var $82d09fc225c0569e$export$134ed2977d320dfd = function(onReport, reportAllChanges) {
    var visibilityWatcher = (0, $53776475df74ac8b$export$443f86b2c77012c4)();
    var metric = (0, $db329d9cc2543112$export$3c29b44508a0612b)('FID');
    var report;
    var entryHandler = function(entry) {
        // Only report if the page wasn't hidden prior to the first input.
        if (report && entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    var po = (0, $b6bd0c0ca205a2d9$export$d1203567a167490e)('first-input', entryHandler);
    if (po) {
        report = (0, $dc4499eb109ed331$export$17679dccdd551979)(onReport, metric, reportAllChanges);
        (0, $ff86837478f2cf04$export$91ec2be6fdd8f1b4)(function() {
            po.takeRecords().map(entryHandler);
            po.disconnect();
        }, true);
    }
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 




var $14f3407b833551b9$var$reportedMetricIDs = {};
var $14f3407b833551b9$export$da982ced0ff8a670 = function(onReport, reportAllChanges) {
    var visibilityWatcher = (0, $53776475df74ac8b$export$443f86b2c77012c4)();
    var metric = (0, $db329d9cc2543112$export$3c29b44508a0612b)('LCP');
    var report;
    var entryHandler = function(entry) {
        // The startTime attribute returns the value of the renderTime if it is not 0,
        // and the value of the loadTime otherwise.
        var value = entry.startTime;
        // If the page was hidden prior to paint time of the entry,
        // ignore it and mark the metric as final, otherwise add the entry.
        if (value < visibilityWatcher.firstHiddenTime) {
            metric.value = value;
            metric.entries.push(entry);
        }
        if (report) report();
    };
    var po = (0, $b6bd0c0ca205a2d9$export$d1203567a167490e)('largest-contentful-paint', entryHandler);
    if (po) {
        report = (0, $dc4499eb109ed331$export$17679dccdd551979)(onReport, metric, reportAllChanges);
        var stopListening_1 = function() {
            if (!$14f3407b833551b9$var$reportedMetricIDs[metric.id]) {
                po.takeRecords().map(entryHandler);
                po.disconnect();
                $14f3407b833551b9$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            'keydown',
            'click'
        ].forEach(function(type) {
            addEventListener(type, stopListening_1, {
                once: true,
                capture: true
            });
        });
        (0, $ff86837478f2cf04$export$91ec2be6fdd8f1b4)(stopListening_1, true);
    }
};



var $b58c9ec70e0dde38$var$global = (0, $1SlwS.getGlobalObject)();
/** Class tracking metrics  */ var $b58c9ec70e0dde38$export$8d26291c4fcc1971 = /** @class */ function() {
    function MetricsInstrumentation(_reportAllChanges) {
        if (_reportAllChanges === void 0) _reportAllChanges = false;
        this._reportAllChanges = _reportAllChanges;
        this._measurements = {};
        this._performanceCursor = 0;
        if (!(0, $8upap.isNodeEnv)() && $b58c9ec70e0dde38$var$global && $b58c9ec70e0dde38$var$global.performance && $b58c9ec70e0dde38$var$global.document) {
            if ($b58c9ec70e0dde38$var$global.performance.mark) $b58c9ec70e0dde38$var$global.performance.mark('sentry-tracing-init');
            this._trackCLS();
            this._trackLCP();
            this._trackFID();
        }
    }
    /** Add performance related spans to a transaction */ MetricsInstrumentation.prototype.addPerformanceEntries = function(transaction) {
        var _this = this;
        if (!$b58c9ec70e0dde38$var$global || !$b58c9ec70e0dde38$var$global.performance || !$b58c9ec70e0dde38$var$global.performance.getEntries || !(0, $cQg0t.browserPerformanceTimeOrigin)) // Gatekeeper if performance API not available
        return;
        (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log('[Tracing] Adding & adjusting spans using Performance API');
        var timeOrigin = (0, $b1qwm.msToSec)((0, $cQg0t.browserPerformanceTimeOrigin));
        var responseStartTimestamp;
        var requestStartTimestamp;
        $b58c9ec70e0dde38$var$global.performance.getEntries().slice(this._performanceCursor).forEach(function(entry) {
            var startTime = (0, $b1qwm.msToSec)(entry.startTime);
            var duration = (0, $b1qwm.msToSec)(entry.duration);
            if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) return;
            switch(entry.entryType){
                case 'navigation':
                    $b58c9ec70e0dde38$var$addNavigationSpans(transaction, entry, timeOrigin);
                    responseStartTimestamp = timeOrigin + (0, $b1qwm.msToSec)(entry.responseStart);
                    requestStartTimestamp = timeOrigin + (0, $b1qwm.msToSec)(entry.requestStart);
                    break;
                case 'mark':
                case 'paint':
                case 'measure':
                    var startTimestamp = $b58c9ec70e0dde38$var$addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    var firstHidden = (0, $53776475df74ac8b$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    var shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) {
                        (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log('[Measurements] Adding FP');
                        _this._measurements['fp'] = {
                            value: entry.startTime
                        };
                        _this._measurements['mark.fp'] = {
                            value: startTimestamp
                        };
                    }
                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
                        (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log('[Measurements] Adding FCP');
                        _this._measurements['fcp'] = {
                            value: entry.startTime
                        };
                        _this._measurements['mark.fcp'] = {
                            value: startTimestamp
                        };
                    }
                    break;
                case 'resource':
                    var resourceName = entry.name.replace($b58c9ec70e0dde38$var$global.location.origin, '');
                    $b58c9ec70e0dde38$export$c35d8cdf016ac02b(transaction, entry, resourceName, startTime, duration, timeOrigin);
                    break;
                default:
            }
        });
        this._performanceCursor = Math.max(performance.getEntries().length - 1, 0);
        this._trackNavigator(transaction);
        // Measurements are only available for pageload transactions
        if (transaction.op === 'pageload') {
            // normalize applicable web vital values to be relative to transaction.startTimestamp
            var timeOrigin_1 = (0, $b1qwm.msToSec)((0, $cQg0t.browserPerformanceTimeOrigin));
            // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
            // start of the response in milliseconds
            if (typeof responseStartTimestamp === 'number') {
                (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log('[Measurements] Adding TTFB');
                this._measurements['ttfb'] = {
                    value: (responseStartTimestamp - transaction.startTimestamp) * 1000
                };
                if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) // Capture the time spent making the request and receiving the first byte of the response.
                // This is the time between the start of the request and the start of the response in milliseconds.
                this._measurements['ttfb.requestTime'] = {
                    value: (responseStartTimestamp - requestStartTimestamp) * 1000
                };
            }
            [
                'fcp',
                'fp',
                'lcp'
            ].forEach(function(name) {
                if (!_this._measurements[name] || timeOrigin_1 >= transaction.startTimestamp) return;
                // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
                // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
                // to be adjusted to be relative to transaction.startTimestamp.
                var oldValue = _this._measurements[name].value;
                var measurementTimestamp = timeOrigin_1 + (0, $b1qwm.msToSec)(oldValue);
                // normalizedValue should be in milliseconds
                var normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
                var delta = normalizedValue - oldValue;
                (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log("[Measurements] Normalized " + name + " from " + oldValue + " to " + normalizedValue + " (" + delta + ")");
                _this._measurements[name].value = normalizedValue;
            });
            if (this._measurements['mark.fid'] && this._measurements['fid']) // create span for FID
            $b58c9ec70e0dde38$export$8bd469e1f37aa721(transaction, {
                description: 'first input delay',
                endTimestamp: this._measurements['mark.fid'].value + (0, $b1qwm.msToSec)(this._measurements['fid'].value),
                op: 'web.vitals',
                startTimestamp: this._measurements['mark.fid'].value
            });
            // If FCP is not recorded we should not record the cls value
            // according to the new definition of CLS.
            if (!('fcp' in this._measurements)) delete this._measurements.cls;
            transaction.setMeasurements(this._measurements);
            $b58c9ec70e0dde38$var$tagMetricInfo(transaction, this._lcpEntry, this._clsEntry);
            transaction.setTag('sentry_reportAllChanges', this._reportAllChanges);
        }
    };
    /**
     * Capture the information of the user agent.
     */ MetricsInstrumentation.prototype._trackNavigator = function(transaction) {
        var navigator = $b58c9ec70e0dde38$var$global.navigator;
        if (!navigator) return;
        // track network connectivity
        var connection = navigator.connection;
        if (connection) {
            if (connection.effectiveType) transaction.setTag('effectiveConnectionType', connection.effectiveType);
            if (connection.type) transaction.setTag('connectionType', connection.type);
            if ($b58c9ec70e0dde38$var$isMeasurementValue(connection.rtt)) this._measurements['connection.rtt'] = {
                value: connection.rtt
            };
            if ($b58c9ec70e0dde38$var$isMeasurementValue(connection.downlink)) this._measurements['connection.downlink'] = {
                value: connection.downlink
            };
        }
        if ($b58c9ec70e0dde38$var$isMeasurementValue(navigator.deviceMemory)) transaction.setTag('deviceMemory', String(navigator.deviceMemory));
        if ($b58c9ec70e0dde38$var$isMeasurementValue(navigator.hardwareConcurrency)) transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
    };
    /** Starts tracking the Cumulative Layout Shift on the current page. */ MetricsInstrumentation.prototype._trackCLS = function() {
        var _this = this;
        // See:
        // https://web.dev/evolving-cls/
        // https://web.dev/cls-web-tooling/
        (0, $d59decabb17bc361$export$fc6227831ee7c7)(function(metric) {
            var entry = metric.entries.pop();
            if (!entry) return;
            (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log('[Measurements] Adding CLS');
            _this._measurements['cls'] = {
                value: metric.value
            };
            _this._clsEntry = entry;
        });
    };
    /** Starts tracking the Largest Contentful Paint on the current page. */ MetricsInstrumentation.prototype._trackLCP = function() {
        var _this = this;
        (0, $14f3407b833551b9$export$da982ced0ff8a670)(function(metric) {
            var entry = metric.entries.pop();
            if (!entry) return;
            var timeOrigin = (0, $b1qwm.msToSec)((0, $cQg0t.browserPerformanceTimeOrigin));
            var startTime = (0, $b1qwm.msToSec)(entry.startTime);
            (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log('[Measurements] Adding LCP');
            _this._measurements['lcp'] = {
                value: metric.value
            };
            _this._measurements['mark.lcp'] = {
                value: timeOrigin + startTime
            };
            _this._lcpEntry = entry;
        }, this._reportAllChanges);
    };
    /** Starts tracking the First Input Delay on the current page. */ MetricsInstrumentation.prototype._trackFID = function() {
        var _this = this;
        (0, $82d09fc225c0569e$export$134ed2977d320dfd)(function(metric) {
            var entry = metric.entries.pop();
            if (!entry) return;
            var timeOrigin = (0, $b1qwm.msToSec)((0, $cQg0t.browserPerformanceTimeOrigin));
            var startTime = (0, $b1qwm.msToSec)(entry.startTime);
            (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log('[Measurements] Adding FID');
            _this._measurements['fid'] = {
                value: metric.value
            };
            _this._measurements['mark.fid'] = {
                value: timeOrigin + startTime
            };
        });
    };
    return MetricsInstrumentation;
}();
/** Instrument navigation entries */ function $b58c9ec70e0dde38$var$addNavigationSpans(transaction, entry, timeOrigin) {
    [
        'unloadEvent',
        'redirect',
        'domContentLoadedEvent',
        'loadEvent',
        'connect'
    ].forEach(function(event) {
        $b58c9ec70e0dde38$var$addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $b58c9ec70e0dde38$var$addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
    $b58c9ec70e0dde38$var$addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
    $b58c9ec70e0dde38$var$addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
    $b58c9ec70e0dde38$var$addRequest(transaction, entry, timeOrigin);
}
/** Create measure related spans */ function $b58c9ec70e0dde38$var$addMeasureSpans(transaction, entry, startTime, duration, timeOrigin) {
    var measureStartTimestamp = timeOrigin + startTime;
    var measureEndTimestamp = measureStartTimestamp + duration;
    $b58c9ec70e0dde38$export$8bd469e1f37aa721(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
function $b58c9ec70e0dde38$export$c35d8cdf016ac02b(transaction, entry, resourceName, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') return;
    var data = {};
    if ('transferSize' in entry) data['Transfer Size'] = entry.transferSize;
    if ('encodedBodySize' in entry) data['Encoded Body Size'] = entry.encodedBodySize;
    if ('decodedBodySize' in entry) data['Decoded Body Size'] = entry.decodedBodySize;
    var startTimestamp = timeOrigin + startTime;
    var endTimestamp = startTimestamp + duration;
    $b58c9ec70e0dde38$export$8bd469e1f37aa721(transaction, {
        description: resourceName,
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? "resource." + entry.initiatorType : 'resource',
        startTimestamp: startTimestamp,
        data: data
    });
}
/** Create performance navigation related spans */ function $b58c9ec70e0dde38$var$addPerformanceNavigationTiming(transaction, entry, event, timeOrigin, description, eventEnd) {
    var end = eventEnd ? entry[eventEnd] : entry[event + "End"];
    var start = entry[event + "Start"];
    if (!start || !end) return;
    $b58c9ec70e0dde38$export$8bd469e1f37aa721(transaction, {
        op: 'browser',
        description: description !== null && description !== void 0 ? description : event,
        startTimestamp: timeOrigin + (0, $b1qwm.msToSec)(start),
        endTimestamp: timeOrigin + (0, $b1qwm.msToSec)(end)
    });
}
/** Create request and response related spans */ function $b58c9ec70e0dde38$var$addRequest(transaction, entry, timeOrigin) {
    $b58c9ec70e0dde38$export$8bd469e1f37aa721(transaction, {
        op: 'browser',
        description: 'request',
        startTimestamp: timeOrigin + (0, $b1qwm.msToSec)(entry.requestStart),
        endTimestamp: timeOrigin + (0, $b1qwm.msToSec)(entry.responseEnd)
    });
    $b58c9ec70e0dde38$export$8bd469e1f37aa721(transaction, {
        op: 'browser',
        description: 'response',
        startTimestamp: timeOrigin + (0, $b1qwm.msToSec)(entry.responseStart),
        endTimestamp: timeOrigin + (0, $b1qwm.msToSec)(entry.responseEnd)
    });
}
function $b58c9ec70e0dde38$export$8bd469e1f37aa721(transaction, _a) {
    var startTimestamp = _a.startTimestamp, ctx = (0, $gztBd.__rest)(_a, [
        "startTimestamp"
    ]);
    if (startTimestamp && transaction.startTimestamp > startTimestamp) transaction.startTimestamp = startTimestamp;
    return transaction.startChild((0, $gztBd.__assign)({
        startTimestamp: startTimestamp
    }, ctx));
}
/**
 * Checks if a given value is a valid measurement value.
 */ function $b58c9ec70e0dde38$var$isMeasurementValue(value) {
    return typeof value === 'number' && isFinite(value);
}
/** Add LCP / CLS data to transaction to allow debugging */ function $b58c9ec70e0dde38$var$tagMetricInfo(transaction, lcpEntry, clsEntry) {
    if (lcpEntry) {
        (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log('[Measurements] Adding LCP Data');
        // Capture Properties of the LCP element that contributes to the LCP.
        if (lcpEntry.element) transaction.setTag('lcp.element', (0, $eAaWR.htmlTreeAsString)(lcpEntry.element));
        if (lcpEntry.id) transaction.setTag('lcp.id', lcpEntry.id);
        if (lcpEntry.url) // Trim URL to the first 200 characters.
        transaction.setTag('lcp.url', lcpEntry.url.trim().slice(0, 200));
        transaction.setTag('lcp.size', lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if (clsEntry && clsEntry.sources) {
        (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log('[Measurements] Adding CLS Data');
        clsEntry.sources.forEach(function(source, index) {
            return transaction.setTag("cls.source." + (index + 1), (0, $eAaWR.htmlTreeAsString)(source.node));
        });
    }
}



var $gztBd = parcelRequire("gztBd");
parcelRequire("2ktyf");
var $lDX8u = parcelRequire("lDX8u");
var $5QZE4 = parcelRequire("5QZE4");
var $jP2vU = parcelRequire("jP2vU");

var $b1qwm = parcelRequire("b1qwm");
var $f5ef6463cc20d051$export$55480f254af1dbc1 = [
    'localhost',
    /^\//
];
var $f5ef6463cc20d051$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    tracingOrigins: $f5ef6463cc20d051$export$55480f254af1dbc1
};
function $f5ef6463cc20d051$export$864489cb3478db3e(_options) {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    var _a = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, $f5ef6463cc20d051$export$cc17fb3c0bc95cd7), _options), traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
    // We should cache url -> decision so that we don't have to compute
    // regexp everytime we create a request.
    var urlMap = {};
    var defaultShouldCreateSpan = function(url) {
        if (urlMap[url]) return urlMap[url];
        var origins = tracingOrigins;
        urlMap[url] = origins.some(function(origin) {
            return (0, $jP2vU.isMatchingPattern)(url, origin);
        }) && !(0, $jP2vU.isMatchingPattern)(url, 'sentry_key');
        return urlMap[url];
    };
    // We want that our users don't have to re-implement shouldCreateSpanForRequest themselves
    // That's why we filter out already unwanted Spans from tracingOrigins
    var shouldCreateSpan = defaultShouldCreateSpan;
    if (typeof shouldCreateSpanForRequest === 'function') shouldCreateSpan = function(url) {
        return defaultShouldCreateSpan(url) && shouldCreateSpanForRequest(url);
    };
    var spans = {};
    if (traceFetch) (0, $lDX8u.addInstrumentationHandler)('fetch', function(handlerData) {
        $f5ef6463cc20d051$export$cd8846dd8ea4bd7a(handlerData, shouldCreateSpan, spans);
    });
    if (traceXHR) (0, $lDX8u.addInstrumentationHandler)('xhr', function(handlerData) {
        $f5ef6463cc20d051$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, spans);
    });
}
function $f5ef6463cc20d051$export$cd8846dd8ea4bd7a(handlerData, shouldCreateSpan, spans) {
    if (!(0, $b1qwm.hasTracingEnabled)() || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) return;
    if (handlerData.endTimestamp) {
        var spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        var span = spans[spanId];
        if (span) {
            if (handlerData.response) // TODO (kmclb) remove this once types PR goes through
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            span.setHttpStatus(handlerData.response.status);
            else if (handlerData.error) span.setStatus('internal_error');
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return;
    }
    var activeTransaction = (0, $b1qwm.getActiveTransaction)();
    if (activeTransaction) {
        var span = activeTransaction.startChild({
            data: (0, $gztBd.__assign)((0, $gztBd.__assign)({}, handlerData.fetchData), {
                type: 'fetch'
            }),
            description: handlerData.fetchData.method + " " + handlerData.fetchData.url,
            op: 'http.client'
        });
        handlerData.fetchData.__span = span.spanId;
        spans[span.spanId] = span;
        var request = handlerData.args[0] = handlerData.args[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var options = handlerData.args[1] = handlerData.args[1] || {};
        var headers = options.headers;
        if ((0, $5QZE4.isInstanceOf)(request, Request)) headers = request.headers;
        if (headers) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (typeof headers.append === 'function') // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            headers.append('sentry-trace', span.toTraceparent());
            else if (Array.isArray(headers)) headers = (0, $gztBd.__spread)(headers, [
                [
                    'sentry-trace',
                    span.toTraceparent()
                ]
            ]);
            else headers = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, headers), {
                'sentry-trace': span.toTraceparent()
            });
        } else headers = {
            'sentry-trace': span.toTraceparent()
        };
        options.headers = headers;
    }
}
function $f5ef6463cc20d051$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, spans) {
    if (!(0, $b1qwm.hasTracingEnabled)() || handlerData.xhr && handlerData.xhr.__sentry_own_request__ || !(handlerData.xhr && handlerData.xhr.__sentry_xhr__ && shouldCreateSpan(handlerData.xhr.__sentry_xhr__.url))) return;
    var xhr = handlerData.xhr.__sentry_xhr__;
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp) {
        var spanId = handlerData.xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        var span = spans[spanId];
        if (span) {
            span.setHttpStatus(xhr.status_code);
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return;
    }
    // if not, create a new span to track it
    var activeTransaction = (0, $b1qwm.getActiveTransaction)();
    if (activeTransaction) {
        var span = activeTransaction.startChild({
            data: (0, $gztBd.__assign)((0, $gztBd.__assign)({}, xhr.data), {
                type: 'xhr',
                method: xhr.method,
                url: xhr.url
            }),
            description: xhr.method + " " + xhr.url,
            op: 'http.client'
        });
        handlerData.xhr.__sentry_xhr_span_id__ = span.spanId;
        spans[handlerData.xhr.__sentry_xhr_span_id__] = span;
        if (handlerData.xhr.setRequestHeader) try {
            handlerData.xhr.setRequestHeader('sentry-trace', span.toTraceparent());
        } catch (_) {
        // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
        }
    }
}


parcelRequire("2ktyf");
var $lDX8u = parcelRequire("lDX8u");
var $1SlwS = parcelRequire("1SlwS");
var $7htw4 = parcelRequire("7htw4");

var $2mkHy = parcelRequire("2mkHy");
var $b358eaee6f87ea3d$var$global = (0, $1SlwS.getGlobalObject)();
function $b358eaee6f87ea3d$export$86649cc09fe75143(customStartTransaction, startTransactionOnPageLoad, startTransactionOnLocationChange) {
    if (startTransactionOnPageLoad === void 0) startTransactionOnPageLoad = true;
    if (startTransactionOnLocationChange === void 0) startTransactionOnLocationChange = true;
    if (!$b358eaee6f87ea3d$var$global || !$b358eaee6f87ea3d$var$global.location) {
        (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).warn('Could not initialize routing instrumentation due to invalid location');
        return;
    }
    var startingUrl = $b358eaee6f87ea3d$var$global.location.href;
    var activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: $b358eaee6f87ea3d$var$global.location.pathname,
        op: 'pageload'
    });
    if (startTransactionOnLocationChange) (0, $lDX8u.addInstrumentationHandler)('history', function(_a) {
        var to = _a.to, from = _a.from;
        /**
             * This early return is there to account for some cases where a navigation transaction starts right after
             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
             * create an uneccessary navigation transaction.
             *
             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
             * only be caused in certain development environments where the usage of a hot module reloader is causing
             * errors.
             */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log("[Tracing] Finishing current transaction with op: " + activeTransaction.op);
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.finish();
            }
            activeTransaction = customStartTransaction({
                name: $b358eaee6f87ea3d$var$global.location.pathname,
                op: 'navigation'
            });
        }
    });
}


var $77b970860201ef91$export$ec51320719fd8e96 = 600;
var $77b970860201ef91$var$DEFAULT_BROWSER_TRACING_OPTIONS = (0, $gztBd.__assign)({
    idleTimeout: (0, $kCOHN.DEFAULT_IDLE_TIMEOUT),
    markBackgroundTransactions: true,
    maxTransactionDuration: $77b970860201ef91$export$ec51320719fd8e96,
    routingInstrumentation: (0, $b358eaee6f87ea3d$export$86649cc09fe75143),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true
}, (0, $f5ef6463cc20d051$export$cc17fb3c0bc95cd7));
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */ var $77b970860201ef91$export$46d3bbd0375f5fa4 = /** @class */ function() {
    function BrowserTracing(_options) {
        /**
         * @inheritDoc
         */ this.name = BrowserTracing.id;
        /** Store configured idle timeout so that it can be added as a tag to transactions */ this._configuredIdleTimeout = undefined;
        var tracingOrigins = (0, $f5ef6463cc20d051$export$cc17fb3c0bc95cd7).tracingOrigins;
        // NOTE: Logger doesn't work in constructors, as it's initialized after integrations instances
        if (_options) {
            this._configuredIdleTimeout = _options.idleTimeout;
            if (_options.tracingOrigins && Array.isArray(_options.tracingOrigins) && _options.tracingOrigins.length !== 0) tracingOrigins = _options.tracingOrigins;
            else (0, $2mkHy.IS_DEBUG_BUILD) && (this._emitOptionsWarning = true);
        }
        this.options = (0, $gztBd.__assign)((0, $gztBd.__assign)((0, $gztBd.__assign)({}, $77b970860201ef91$var$DEFAULT_BROWSER_TRACING_OPTIONS), _options), {
            tracingOrigins: tracingOrigins
        });
        var _metricOptions = this.options._metricOptions;
        this._metrics = new (0, $b58c9ec70e0dde38$export$8d26291c4fcc1971)(_metricOptions && _metricOptions._reportAllChanges);
    }
    /**
     * @inheritDoc
     */ BrowserTracing.prototype.setupOnce = function(_, getCurrentHub) {
        var _this = this;
        this._getCurrentHub = getCurrentHub;
        if (this._emitOptionsWarning) {
            (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).warn('[Tracing] You need to define `tracingOrigins` in the options. Set an array of urls or patterns to trace.');
            (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).warn("[Tracing] We added a reasonable default for you: " + (0, $f5ef6463cc20d051$export$cc17fb3c0bc95cd7).tracingOrigins);
        }
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.options, instrumentRouting = _a.routingInstrumentation, startTransactionOnLocationChange = _a.startTransactionOnLocationChange, startTransactionOnPageLoad = _a.startTransactionOnPageLoad, markBackgroundTransactions = _a.markBackgroundTransactions, traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
        instrumentRouting(function(context) {
            return _this._createRouteTransaction(context);
        }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) (0, $7bb15ea4ada198e4$export$6f18f55521af71a1)();
        (0, $f5ef6463cc20d051$export$864489cb3478db3e)({
            traceFetch: traceFetch,
            traceXHR: traceXHR,
            tracingOrigins: tracingOrigins,
            shouldCreateSpanForRequest: shouldCreateSpanForRequest
        });
    };
    /** Create routing idle transaction. */ BrowserTracing.prototype._createRouteTransaction = function(context) {
        var _this = this;
        if (!this._getCurrentHub) {
            (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).warn("[Tracing] Did not create " + context.op + " transaction because _getCurrentHub is invalid.");
            return undefined;
        }
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.options, beforeNavigate = _a.beforeNavigate, idleTimeout = _a.idleTimeout, maxTransactionDuration = _a.maxTransactionDuration;
        var parentContextFromHeader = context.op === 'pageload' ? $77b970860201ef91$export$53cebc3a2ff13451() : undefined;
        var expandedContext = (0, $gztBd.__assign)((0, $gztBd.__assign)((0, $gztBd.__assign)({}, context), parentContextFromHeader), {
            trimEnd: true
        });
        var modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        var finalContext = modifiedContext === undefined ? (0, $gztBd.__assign)((0, $gztBd.__assign)({}, expandedContext), {
            sampled: false
        }) : modifiedContext;
        if (finalContext.sampled === false) (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log("[Tracing] Will not send " + finalContext.op + " transaction because of beforeNavigate.");
        (0, $2mkHy.IS_DEBUG_BUILD) && (0, $7htw4.logger).log("[Tracing] Starting " + finalContext.op + " transaction on scope");
        var hub = this._getCurrentHub();
        var location = (0, $1SlwS.getGlobalObject)().location;
        var idleTransaction = (0, $3siHg.startIdleTransaction)(hub, finalContext, idleTimeout, true, {
            location: location
        });
        idleTransaction.registerBeforeFinishCallback(function(transaction, endTimestamp) {
            _this._metrics.addPerformanceEntries(transaction);
            $77b970860201ef91$var$adjustTransactionDuration((0, $b1qwm.secToMs)(maxTransactionDuration), transaction, endTimestamp);
        });
        idleTransaction.setTag('idleTimeout', this._configuredIdleTimeout);
        return idleTransaction;
    };
    /**
     * @inheritDoc
     */ BrowserTracing.id = 'BrowserTracing';
    return BrowserTracing;
}();
function $77b970860201ef91$export$53cebc3a2ff13451() {
    var header = $77b970860201ef91$export$f147b32b03c9cf11('sentry-trace');
    if (header) return (0, $lS7eK.extractTraceparentData)(header);
    return undefined;
}
function $77b970860201ef91$export$f147b32b03c9cf11(metaName) {
    var el = (0, $1SlwS.getGlobalObject)().document.querySelector("meta[name=" + metaName + "]");
    return el ? el.getAttribute('content') : null;
}
/** Adjusts transaction value based on max transaction duration */ function $77b970860201ef91$var$adjustTransactionDuration(maxDuration, transaction, endTimestamp) {
    var diff = endTimestamp - transaction.startTimestamp;
    var isOutdatedTransaction = endTimestamp && (diff > maxDuration || diff < 0);
    if (isOutdatedTransaction) {
        transaction.setStatus('deadline_exceeded');
        transaction.setTag('maxTransactionDurationExceeded', 'true');
    }
}










// We are patching the global object with our hub extension methods
(0, $3siHg.addExtensionMethods)();


/*
 * The three Bootstrap JavaScript behaviours this app actually used: dropdown, tab and tooltip.
 *
 * Bootstrap's bundle is 80KB to provide seventeen components, of which the templates referenced
 * three, across fourteen elements. This is those three.
 *
 * Everything is delegated from `document` rather than instantiated per element. Bootstrap needed
 * an `initPopover()` / `initTooltips()` pair re-run on `turbo:frame-load`, and any element Turbo
 * swapped in between those calls stayed dead; delegation has no initialisation step to miss, so a
 * dropdown rendered into a frame five minutes from now works for the same reason one present at
 * parse time does.
 *
 * The attributes are `data-wp-*`, not `data-bs-*`. Leaving Bootstrap's names behind after deleting
 * Bootstrap would have left the next reader hunting for a dependency that is not there.
 */ const $54ecc3f76f39aa81$var$DROPDOWN_TOGGLE = '[data-wp-toggle="dropdown"]';
const $54ecc3f76f39aa81$var$TAB_TOGGLE = '[data-wp-toggle="tab"]';
const $54ecc3f76f39aa81$var$TOOLTIP = '[data-wp-toggle="tooltip"]';
const $54ecc3f76f39aa81$var$TOOLTIP_GAP = 8;
/** The element an event landed on, when it landed on an element at all. */ function $54ecc3f76f39aa81$var$elementOf(event) {
    return event.target instanceof Element ? event.target : null;
}
/* --------------------------------------------------------------------------- dropdown ---- */ function $54ecc3f76f39aa81$var$closeDropdowns(except) {
    document.querySelectorAll(".dropdown-menu.show").forEach((menu)=>{
        if (menu === except) return;
        menu.classList.remove("show");
        menu.closest(".dropdown")?.querySelector($54ecc3f76f39aa81$var$DROPDOWN_TOGGLE)?.setAttribute("aria-expanded", "false");
    });
}
function $54ecc3f76f39aa81$var$toggleDropdown(toggle) {
    const menu = toggle.closest(".dropdown")?.querySelector(".dropdown-menu");
    if (menu === null || menu === undefined) return;
    const open = !menu.classList.contains("show");
    /* Close the others first: two open menus overlapping is never what was wanted, and Bootstrap
       behaved the same way. */ $54ecc3f76f39aa81$var$closeDropdowns(menu);
    menu.classList.toggle("show", open);
    toggle.setAttribute("aria-expanded", String(open));
}
/* --------------------------------------------------------------------------- tabs -------- */ function $54ecc3f76f39aa81$var$activateTab(toggle) {
    const selector = toggle.dataset.wpTarget;
    const pane = selector === undefined || selector === "" ? null : document.querySelector(selector);
    if (pane === null) return;
    /* Scope to this tab list, so a page with two independent sets of tabs does not deactivate the
       other one. */ const list = toggle.closest('.nav, [role="tablist"]') ?? document;
    list.querySelectorAll($54ecc3f76f39aa81$var$TAB_TOGGLE).forEach((other)=>{
        other.classList.toggle("active", other === toggle);
        other.setAttribute("aria-selected", String(other === toggle));
    });
    /* The panes are the direct children of the pane's own container, expressed as a filter over
       `children` rather than as `:scope > .tab-pane`. Same set of elements, and it does not depend
       on a selector feature the test environment happens not to implement. */ Array.from(pane.parentElement?.children ?? []).filter((other)=>other.classList.contains("tab-pane")).forEach((other)=>{
        other.classList.toggle("active", other === pane);
    });
}
/* --------------------------------------------------------------------------- tooltip ----- */ let $54ecc3f76f39aa81$var$tooltipElement = null;
function $54ecc3f76f39aa81$var$hideTooltip() {
    $54ecc3f76f39aa81$var$tooltipElement?.remove();
    $54ecc3f76f39aa81$var$tooltipElement = null;
}
function $54ecc3f76f39aa81$var$showTooltip(target) {
    /* `title` would otherwise also render as the browser's own native tooltip, giving two. Moving
       it to a data attribute is how Bootstrap avoided that too. */ const text = target.dataset.wpTitle ?? target.getAttribute("title");
    if (text === null || text === "") return;
    if (target.hasAttribute("title")) {
        target.dataset.wpTitle = text;
        target.removeAttribute("title");
    }
    $54ecc3f76f39aa81$var$hideTooltip();
    const tooltip = document.createElement("div");
    tooltip.className = "wp-tooltip";
    tooltip.setAttribute("role", "tooltip");
    tooltip.textContent = text;
    document.body.appendChild(tooltip);
    $54ecc3f76f39aa81$var$tooltipElement = tooltip;
    /* Positioned after insertion, because the width is not knowable until it has been laid out.
       Clamped to the viewport so a tooltip on a right-edge element does not cause a horizontal
       scrollbar. */ const anchor = target.getBoundingClientRect();
    const tip = tooltip.getBoundingClientRect();
    const left = Math.min(Math.max($54ecc3f76f39aa81$var$TOOLTIP_GAP, anchor.left + anchor.width / 2 - tip.width / 2), document.documentElement.clientWidth - tip.width - $54ecc3f76f39aa81$var$TOOLTIP_GAP);
    const above = anchor.top - tip.height - $54ecc3f76f39aa81$var$TOOLTIP_GAP;
    tooltip.style.left = `${left + window.scrollX}px`;
    tooltip.style.top = `${(above < 0 ? anchor.bottom + $54ecc3f76f39aa81$var$TOOLTIP_GAP : above) + window.scrollY}px`;
}
function $54ecc3f76f39aa81$export$2e2bcd8739ae039() {
    document.addEventListener("click", (event)=>{
        const target = $54ecc3f76f39aa81$var$elementOf(event);
        if (target === null) return;
        const dropdown = target.closest($54ecc3f76f39aa81$var$DROPDOWN_TOGGLE);
        if (dropdown !== null) {
            event.preventDefault();
            $54ecc3f76f39aa81$var$toggleDropdown(dropdown);
            return;
        }
        const tab = target.closest($54ecc3f76f39aa81$var$TAB_TOGGLE);
        if (tab !== null) {
            event.preventDefault();
            $54ecc3f76f39aa81$var$activateTab(tab);
            return;
        }
        /* A click inside an open menu is a menu item being chosen, so it closes; a click anywhere
           else dismisses. Either way the menus go. */ $54ecc3f76f39aa81$var$closeDropdowns();
    });
    document.addEventListener("keydown", (event)=>{
        if (event.key === "Escape") {
            $54ecc3f76f39aa81$var$closeDropdowns();
            $54ecc3f76f39aa81$var$hideTooltip();
        }
    });
    /* `focusin`/`focusout` rather than `focus`/`blur`, which do not bubble and so cannot be
       delegated. This is what gives the tooltip keyboard parity. */ [
        "focusin",
        "mouseover"
    ].forEach((name)=>{
        document.addEventListener(name, (event)=>{
            const target = $54ecc3f76f39aa81$var$elementOf(event)?.closest($54ecc3f76f39aa81$var$TOOLTIP);
            if (target !== null && target !== undefined) $54ecc3f76f39aa81$var$showTooltip(target);
        });
    });
    [
        "focusout",
        "mouseout"
    ].forEach((name)=>{
        document.addEventListener(name, (event)=>{
            if ($54ecc3f76f39aa81$var$elementOf(event)?.closest($54ecc3f76f39aa81$var$TOOLTIP) != null) $54ecc3f76f39aa81$var$hideTooltip();
        });
    });
    /* A tooltip is positioned absolutely against the document, so anything that moves the page out
       from under it leaves it stranded. */ document.addEventListener("scroll", $54ecc3f76f39aa81$var$hideTooltip, {
        passive: true
    });
    document.addEventListener("turbo:before-render", ()=>{
        $54ecc3f76f39aa81$var$hideTooltip();
        $54ecc3f76f39aa81$var$closeDropdowns();
    });
}



/*
 * Which appearance the reader has chosen, and how it reaches the document.
 *
 * Three states, not a boolean. "Automatic" is a real choice and the default one: it is what
 * everybody gets until they say otherwise, and it has to keep following the device afterwards
 * rather than freezing to whatever the device happened to be on the day it was read.
 *
 * The whole mechanism is one attribute. `tokens.css` already defines light on `:root`, dark
 * inside `(prefers-color-scheme: dark)` guarded by `:not([data-theme="light"])`, and dark again
 * on an explicit `[data-theme="dark"]`. So:
 *
 *   - automatic -> no attribute at all, and the media query decides, live.
 *   - light     -> data-theme="light", which also disarms the media query's guard.
 *   - dark      -> data-theme="dark".
 *
 * Removing the attribute rather than writing `data-theme="auto"` is the point: there is no rule
 * for "auto" and there does not need to be one, because the absence of a choice is exactly what
 * the stylesheet already treats as "ask the device".
 *
 * The same three lines run twice: once from an inline script in <head> before the first paint,
 * and once from here when the sheet changes the answer. `fragment/head.html` carries that copy
 * and names this file; a module cannot do it, because by the time one has been fetched and
 * evaluated the page has already been painted in the wrong colour.
 */ const $ab81a50689a5f21f$export$3d787a857e4fea22 = "weplay.appearance";
/**
 * The same choice, where the server can see it.
 *
 * `localStorage` is the record; this is a copy of it for the one thing the stylesheet cannot do.
 * A `<picture>` can only ask `prefers-color-scheme`, which is the device and not this choice, so
 * an image that has a light and a dark version has no way to follow an explicit pick. The server
 * renders the right one instead, the way it already reads `TIMEZONE` to format a date.
 *
 * Only an explicit pick is written. "Automatic" removes it, because automatic IS
 * `prefers-color-scheme`: with no cookie the server falls back to the media query, which is the
 * correct answer for that case rather than a guess at it.
 */ const $ab81a50689a5f21f$var$APPEARANCE_COOKIE = "APPEARANCE";
const $ab81a50689a5f21f$var$APPEARANCES = [
    "auto",
    "light",
    "dark"
];
function $ab81a50689a5f21f$var$isAppearance(value) {
    return value !== null && $ab81a50689a5f21f$var$APPEARANCES.includes(value);
}
function $ab81a50689a5f21f$export$d9151f883b4a98dd() {
    try {
        const stored = window.localStorage.getItem($ab81a50689a5f21f$export$3d787a857e4fea22);
        return $ab81a50689a5f21f$var$isAppearance(stored) ? stored : "auto";
    } catch  {
        return "auto";
    }
}
function $ab81a50689a5f21f$export$61e237a4ac01285f(appearance) {
    $ab81a50689a5f21f$var$writeAppearanceCookie(appearance);
    try {
        if (appearance === "auto") {
            window.localStorage.removeItem($ab81a50689a5f21f$export$3d787a857e4fea22);
            return;
        }
        window.localStorage.setItem($ab81a50689a5f21f$export$3d787a857e4fea22, appearance);
    } catch  {
    /* A choice that cannot be stored still applies for this page, which is the useful half. */ }
}
function $ab81a50689a5f21f$export$4453f023a6e5ff53() {
    $ab81a50689a5f21f$var$writeAppearanceCookie($ab81a50689a5f21f$export$d9151f883b4a98dd());
}
/** Outside the `try` above: a cookie is not `localStorage` and does not throw where that does. */ function $ab81a50689a5f21f$var$writeAppearanceCookie(appearance) {
    const attributes = "path=/; SameSite=Strict; Secure";
    document.cookie = appearance === "auto" ? `${$ab81a50689a5f21f$var$APPEARANCE_COOKIE}=; Max-Age=0; ${attributes}` : `${$ab81a50689a5f21f$var$APPEARANCE_COOKIE}=${appearance}; Max-Age=31536000; ${attributes}`;
}
function $ab81a50689a5f21f$export$48c323151b232e54(appearance) {
    if (appearance === "auto") {
        delete document.documentElement.dataset.theme;
        return;
    }
    document.documentElement.dataset.theme = appearance;
}


class $54329b5e509ad2da$export$2e2bcd8739ae039 extends (0, $1e1b4d625d583414$export$bd0bf19f25da8474) {
    static{
        this.targets = [
            "select",
            "value"
        ];
    }
    connect() {
        /* The server reads the choice from a cookie to pick the right half of an image that has two.
       A reader who chose before that cookie existed has the choice in localStorage and nothing
       in the cookie, and would otherwise keep the wrong image until they touched this menu. */ (0, $ab81a50689a5f21f$export$4453f023a6e5ff53)();
        this.selectTarget.value = (0, $ab81a50689a5f21f$export$d9151f883b4a98dd)();
        this.render();
    }
    choose() {
        const appearance = this.selectTarget.value;
        (0, $ab81a50689a5f21f$export$61e237a4ac01285f)(appearance);
        (0, $ab81a50689a5f21f$export$48c323151b232e54)(appearance);
        this.render();
    }
    /**
   * The row's visible value, read off the chosen option's own text.
   *
   * Not from a map of names held here: the three are translated, and copy that lives in a
   * controller is copy no translator ever sees.
   */ render() {
        this.valueTarget.textContent = this.selectTarget.options[this.selectTarget.selectedIndex]?.text ?? "";
    }
}



var $18c4fa6e0dd314b9$exports = {};
/*!
 * Cropper.js v1.7.0
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2026-10-07T07:21:57.525Z
 */ (function(global, factory) {
    $18c4fa6e0dd314b9$exports = factory();
})($18c4fa6e0dd314b9$exports, function() {
    'use strict';
    function _arrayLikeToArray(r, a) {
        (null == a || a > r.length) && (a = r.length);
        for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
        return n;
    }
    function _arrayWithHoles(r) {
        if (Array.isArray(r)) return r;
    }
    function _arrayWithoutHoles(r) {
        if (Array.isArray(r)) return _arrayLikeToArray(r);
    }
    function _classCallCheck(a, n) {
        if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(e, r) {
        for(var t = 0; t < r.length; t++){
            var o = r[t];
            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
        }
    }
    function _createClass(e, r, t) {
        return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e;
    }
    function _defineProperty(e, r, t) {
        return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
            value: t,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[r] = t, e;
    }
    function _iterableToArray(r) {
        if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
    }
    function _iterableToArrayLimit(r, l) {
        var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (null != t) {
            var e, n, i, u, a = [], f = !0, o = !1;
            try {
                if (i = (t = t.call(r)).next, 0 === l) {
                    if (Object(t) !== t) return;
                    f = !1;
                } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
            } catch (r) {
                o = !0, n = r;
            } finally{
                try {
                    if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
                } finally{
                    if (o) throw n;
                }
            }
            return a;
        }
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function ownKeys(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r && (o = o.filter(function(r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
            })), t.push.apply(t, o);
        }
        return t;
    }
    function _objectSpread2(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
                _defineProperty(e, r, t[r]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
            });
        }
        return e;
    }
    function _slicedToArray(r, e) {
        return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
    }
    function _toConsumableArray(r) {
        return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
    }
    function _toPrimitive(t, r) {
        if ("object" != typeof t || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
            var i = e.call(t, r || "default");
            if ("object" != typeof i) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === r ? String : Number)(t);
    }
    function _toPropertyKey(t) {
        var i = _toPrimitive(t, "string");
        return "symbol" == typeof i ? i : i + "";
    }
    function _typeof(o) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, _typeof(o);
    }
    function _unsupportedIterableToArray(r, a) {
        if (r) {
            if ("string" == typeof r) return _arrayLikeToArray(r, a);
            var t = ({}).toString.call(r).slice(8, -1);
            return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
        }
    }
    var IS_BROWSER = typeof window !== 'undefined' && typeof window.document !== 'undefined';
    var WINDOW = IS_BROWSER ? window : {};
    var IS_TOUCH_DEVICE = IS_BROWSER && WINDOW.document.documentElement ? 'ontouchstart' in WINDOW.document.documentElement : false;
    var HAS_POINTER_EVENT = IS_BROWSER ? 'PointerEvent' in WINDOW : false;
    var NAMESPACE = 'cropper';
    // Actions
    var ACTION_ALL = 'all';
    var ACTION_CROP = 'crop';
    var ACTION_MOVE = 'move';
    var ACTION_ZOOM = 'zoom';
    var ACTION_EAST = 'e';
    var ACTION_WEST = 'w';
    var ACTION_SOUTH = 's';
    var ACTION_NORTH = 'n';
    var ACTION_NORTH_EAST = 'ne';
    var ACTION_NORTH_WEST = 'nw';
    var ACTION_SOUTH_EAST = 'se';
    var ACTION_SOUTH_WEST = 'sw';
    // Classes
    var CLASS_CROP = "".concat(NAMESPACE, "-crop");
    var CLASS_DISABLED = "".concat(NAMESPACE, "-disabled");
    var CLASS_HIDDEN = "".concat(NAMESPACE, "-hidden");
    var CLASS_HIDE = "".concat(NAMESPACE, "-hide");
    var CLASS_INVISIBLE = "".concat(NAMESPACE, "-invisible");
    var CLASS_MODAL = "".concat(NAMESPACE, "-modal");
    var CLASS_MOVE = "".concat(NAMESPACE, "-move");
    // Data keys
    var DATA_ACTION = "".concat(NAMESPACE, "Action");
    var DATA_PREVIEW = "".concat(NAMESPACE, "Preview");
    // Drag modes
    var DRAG_MODE_CROP = 'crop';
    var DRAG_MODE_MOVE = 'move';
    var DRAG_MODE_NONE = 'none';
    // Events
    var EVENT_BLUR = 'blur';
    var EVENT_CROP = 'crop';
    var EVENT_CROP_END = 'cropend';
    var EVENT_CROP_MOVE = 'cropmove';
    var EVENT_CROP_START = 'cropstart';
    var EVENT_DBLCLICK = 'dblclick';
    var EVENT_ERROR = 'error';
    var EVENT_TOUCH_START = IS_TOUCH_DEVICE ? 'touchstart' : 'mousedown';
    var EVENT_TOUCH_MOVE = IS_TOUCH_DEVICE ? 'touchmove' : 'mousemove';
    var EVENT_TOUCH_END = IS_TOUCH_DEVICE ? 'touchend touchcancel' : 'mouseup';
    var EVENT_POINTER_DOWN = HAS_POINTER_EVENT ? 'pointerdown' : EVENT_TOUCH_START;
    var EVENT_POINTER_MOVE = HAS_POINTER_EVENT ? 'pointermove' : EVENT_TOUCH_MOVE;
    var EVENT_POINTER_UP = HAS_POINTER_EVENT ? 'pointerup pointercancel' : EVENT_TOUCH_END;
    var EVENT_READY = 'ready';
    var EVENT_RESIZE = 'resize';
    var EVENT_WHEEL = 'wheel';
    var EVENT_ZOOM = 'zoom';
    // Mime types
    var MIME_TYPE_JPEG = 'image/jpeg';
    // RegExps
    var REGEXP_ACTIONS = /^(e|w|s|n|se|sw|ne|nw|all|crop|move|zoom)$/;
    var REGEXP_DATA_URL = /^data:/;
    var REGEXP_DATA_URL_JPEG = /^data:image\/jpeg;base64,/;
    var REGEXP_SPACES = /\s+/;
    var REGEXP_TAG_NAME = /^(img|canvas)$/i;
    // Misc
    // Inspired by the default width and height of a canvas element.
    var MIN_CONTAINER_WIDTH = 200;
    var MIN_CONTAINER_HEIGHT = 100;
    var DEFAULTS = {
        // Define the view mode of the cropper
        viewMode: 0,
        // 0, 1, 2, 3
        // Define the dragging mode of the cropper
        dragMode: DRAG_MODE_CROP,
        // 'crop', 'move' or 'none'
        // Define the initial aspect ratio of the crop box
        initialAspectRatio: NaN,
        // Define the aspect ratio of the crop box
        aspectRatio: NaN,
        // Define the border radius of the crop box
        borderRadius: 0,
        // An object with the previous cropping result data
        data: null,
        // A selector for adding extra containers to preview
        preview: '',
        // Re-render the cropper when resize the window
        responsive: true,
        // Restore the cropped area after resize the window
        restore: true,
        // Check if the current image is a cross-origin image
        checkCrossOrigin: true,
        // Check the current image's Exif Orientation information
        checkOrientation: true,
        // Show the black modal
        modal: true,
        // Show the dashed lines for guiding
        guides: true,
        // Show the center indicator for guiding
        center: true,
        // Show the white modal to highlight the crop box
        highlight: true,
        // Show the grid background
        background: true,
        // Enable to crop the image automatically when initialize
        autoCrop: true,
        // Define the percentage of automatic cropping area when initialized
        autoCropArea: 0.8,
        // Enable to move the image
        movable: true,
        // Enable to rotate the image
        rotatable: true,
        // Enable to scale the image
        scalable: true,
        // Enable to zoom the image
        zoomable: true,
        // Enable to zoom the image by dragging touch
        zoomOnTouch: true,
        // Enable to zoom the image by wheeling mouse
        zoomOnWheel: true,
        // Zoom the image around the center of the cropper
        zoomAroundCenter: false,
        // Define zoom ratio when zooming the image by mouse wheel
        wheelZoomRatio: 0.1,
        // Enable to move the crop box
        cropBoxMovable: true,
        // Define the crop box movement mode
        cropBoxMoveMode: 'cursor',
        // Enable to resize the crop box
        cropBoxResizable: true,
        // Keep the center of the crop box fixed when resizing
        cropBoxResizeAroundCenter: false,
        // Toggle drag mode between "crop" and "move" when click twice on the cropper
        toggleDragModeOnDblclick: true,
        // Size limitation
        minCanvasWidth: 0,
        minCanvasHeight: 0,
        minCropBoxWidth: 0,
        minCropBoxHeight: 0,
        minContainerWidth: MIN_CONTAINER_WIDTH,
        minContainerHeight: MIN_CONTAINER_HEIGHT,
        // Shortcuts of events
        ready: null,
        error: null,
        cropstart: null,
        cropmove: null,
        cropend: null,
        crop: null,
        zoom: null
    };
    var TEMPLATE = '<div class="cropper-container" touch-action="none"><div class="cropper-wrap-box"><div class="cropper-canvas"></div></div><div class="cropper-drag-box"></div><div class="cropper-crop-box"><span class="cropper-view-box"></span><span class="cropper-dashed dashed-h"></span><span class="cropper-dashed dashed-v"></span><span class="cropper-center"></span><span class="cropper-face"></span><span class="cropper-line line-e" data-cropper-action="e"></span><span class="cropper-line line-n" data-cropper-action="n"></span><span class="cropper-line line-w" data-cropper-action="w"></span><span class="cropper-line line-s" data-cropper-action="s"></span><span class="cropper-point point-e" data-cropper-action="e"></span><span class="cropper-point point-n" data-cropper-action="n"></span><span class="cropper-point point-w" data-cropper-action="w"></span><span class="cropper-point point-s" data-cropper-action="s"></span><span class="cropper-point point-ne" data-cropper-action="ne"></span><span class="cropper-point point-nw" data-cropper-action="nw"></span><span class="cropper-point point-sw" data-cropper-action="sw"></span><span class="cropper-point point-se" data-cropper-action="se"></span></div></div>';
    /**
   * Check if the given value is not a number.
   */ var isNaN = Number.isNaN || WINDOW.isNaN;
    /**
   * Check if the given value is a finite number.
   */ var isFinite = Number.isFinite || WINDOW.isFinite;
    /**
   * Check if the given value is a number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a number, else `false`.
   */ function isNumber(value) {
        return typeof value === 'number' && !isNaN(value);
    }
    /**
   * Check if the given value is a positive number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a positive number, else `false`.
   */ var isPositiveNumber = function isPositiveNumber(value) {
        return value > 0 && value < Infinity;
    };
    /**
   * Check if the given value is undefined.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is undefined, else `false`.
   */ function isUndefined(value) {
        return typeof value === 'undefined';
    }
    /**
   * Check if the given value is an object.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is an object, else `false`.
   */ function isObject(value) {
        return _typeof(value) === 'object' && value !== null;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
   * Check if the given value is a plain object.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a plain object, else `false`.
   */ function isPlainObject(value) {
        if (!isObject(value)) return false;
        try {
            var constructor = value.constructor;
            var prototype = constructor.prototype;
            return constructor && prototype && hasOwnProperty.call(prototype, 'isPrototypeOf');
        } catch (error) {
            return false;
        }
    }
    /**
   * Check if the given value is a function.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a function, else `false`.
   */ function isFunction(value) {
        return typeof value === 'function';
    }
    var slice = Array.prototype.slice;
    /**
   * Convert array-like or iterable object to an array.
   * @param {*} value - The value to convert.
   * @returns {Array} Returns a new array.
   */ function toArray(value) {
        return Array.from ? Array.from(value) : slice.call(value);
    }
    /**
   * Iterate the given data.
   * @param {*} data - The data to iterate.
   * @param {Function} callback - The process function for each element.
   * @returns {*} The original data.
   */ function forEach(data, callback) {
        if (data && isFunction(callback)) {
            if (Array.isArray(data) || isNumber(data.length)) toArray(data).forEach(function(value, key) {
                callback.call(data, value, key, data);
            });
            else if (isObject(data)) Object.keys(data).forEach(function(key) {
                callback.call(data, data[key], key, data);
            });
        }
        return data;
    }
    /**
   * Extend the given object.
   * @param {*} target - The target object to extend.
   * @param {*} args - The rest objects for merging to the target object.
   * @returns {Object} The extended object.
   */ var assign = Object.assign || function assign(target) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (isObject(target) && args.length > 0) args.forEach(function(arg) {
            if (isObject(arg)) Object.keys(arg).forEach(function(key) {
                target[key] = arg[key];
            });
        });
        return target;
    };
    var REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/;
    /**
   * Normalize decimal number.
   * Check out {@link https://0.30000000000000004.com/}
   * @param {number} value - The value to normalize.
   * @param {number} [times=100000000000] - The times for normalizing.
   * @returns {number} Returns the normalized number.
   */ function normalizeDecimalNumber(value) {
        var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000000000;
        return Math.abs(value) < 1 / times || REGEXP_DECIMALS.test(value) ? Math.round(value * times) / times : value;
    }
    var REGEXP_SUFFIX = /^width|height|left|top|marginLeft|marginTop$/;
    /**
   * Apply styles to the given element.
   * @param {Element} element - The target element.
   * @param {Object} styles - The styles for applying.
   */ function setStyle(element, styles) {
        var style = element.style;
        forEach(styles, function(value, property) {
            if (REGEXP_SUFFIX.test(property) && isNumber(value)) value = "".concat(value, "px");
            style[property] = value;
        });
    }
    /**
   * Check if the given element has a special class.
   * @param {Element} element - The element to check.
   * @param {string} value - The class to search.
   * @returns {boolean} Returns `true` if the special class was found.
   */ function hasClass(element, value) {
        return element.classList ? element.classList.contains(value) : element.className.split(REGEXP_SPACES).indexOf(value) > -1;
    }
    /**
   * Add classes to the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be added.
   */ function addClass(element, value) {
        if (!value) return;
        if (isNumber(element.length)) {
            forEach(element, function(elem) {
                addClass(elem, value);
            });
            return;
        }
        if (element.classList) {
            element.classList.add(value);
            return;
        }
        var className = element.className.trim();
        if (!className) element.className = value;
        else if (className.indexOf(value) < 0) element.className = "".concat(className, " ").concat(value);
    }
    /**
   * Remove classes from the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be removed.
   */ function removeClass(element, value) {
        if (!value) return;
        if (isNumber(element.length)) {
            forEach(element, function(elem) {
                removeClass(elem, value);
            });
            return;
        }
        if (element.classList) {
            element.classList.remove(value);
            return;
        }
        if (element.className.indexOf(value) >= 0) element.className = element.className.split(REGEXP_SPACES).filter(function(item) {
            return item && item !== value;
        }).join(' ');
    }
    /**
   * Add or remove classes from the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be toggled.
   * @param {boolean} added - Add only.
   */ function toggleClass(element, value, added) {
        if (!value) return;
        if (isNumber(element.length)) {
            forEach(element, function(elem) {
                toggleClass(elem, value, added);
            });
            return;
        }
        // IE10-11 doesn't support the second parameter of `classList.toggle`
        if (added) addClass(element, value);
        else removeClass(element, value);
    }
    var REGEXP_CAMEL_CASE = /([a-z\d])([A-Z])/g;
    /**
   * Transform the given string from camelCase to kebab-case
   * @param {string} value - The value to transform.
   * @returns {string} The transformed value.
   */ function toParamCase(value) {
        return typeof value === 'string' ? value.replace(REGEXP_CAMEL_CASE, '$1-$2').toLowerCase() : '';
    }
    /**
   * Get data from the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to get.
   * @returns {string} The data value.
   */ function getData(element, name) {
        if (isObject(element[name])) return element[name];
        if (element.dataset) return element.dataset[name];
        return element.getAttribute("data-".concat(toParamCase(name)));
    }
    /**
   * Set data to the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to set.
   * @param {string} data - The data value.
   */ function setData(element, name, data) {
        if (isObject(data)) element[name] = data;
        else if (element.dataset) element.dataset[name] = data;
        else element.setAttribute("data-".concat(toParamCase(name)), data);
    }
    /**
   * Remove data from the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to remove.
   */ function removeData(element, name) {
        if (isObject(element[name])) try {
            delete element[name];
        } catch (error) {
            element[name] = undefined;
        }
        else if (element.dataset) // #128 Safari doesn't allow deleting dataset properties
        try {
            delete element.dataset[name];
        } catch (error) {
            element.dataset[name] = undefined;
        }
        else element.removeAttribute("data-".concat(toParamCase(name)));
    }
    var onceSupported = function() {
        var supported = false;
        if (IS_BROWSER) {
            var once = false;
            var listener = function listener() {};
            var options = Object.defineProperty({}, 'once', {
                get: function get() {
                    supported = true;
                    return once;
                },
                /**
         * This setter can fix a `TypeError` in strict mode
         * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
         * @param {boolean} value - The value to set
         */ set: function set(value) {
                    once = value;
                }
            });
            WINDOW.addEventListener('test', listener, options);
            WINDOW.removeEventListener('test', listener, options);
        }
        return supported;
    }();
    /**
   * Remove event listener from the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Function} listener - The event listener.
   * @param {Object} options - The event options.
   */ function removeListener(element, type, listener) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (!element || !type || !isFunction(element.removeEventListener)) return;
        var handler = listener;
        type.trim().split(REGEXP_SPACES).forEach(function(event) {
            if (!onceSupported) {
                // eslint-disable-next-line no-underscore-dangle
                var listeners = element.__cropperListeners__ || {};
                if (listeners[event] && listeners[event][listener]) {
                    handler = listeners[event][listener];
                    delete listeners[event][listener];
                    if (Object.keys(listeners[event]).length === 0) delete listeners[event];
                    if (Object.keys(listeners).length === 0) // eslint-disable-next-line no-underscore-dangle
                    delete element.__cropperListeners__;
                }
            }
            element.removeEventListener(event, handler, options);
        });
    }
    /**
   * Add event listener to the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Function} listener - The event listener.
   * @param {Object} options - The event options.
   */ function addListener(element, type, listener) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (!element || !type || !isFunction(element.addEventListener) || !isFunction(listener)) return;
        var _handler = listener;
        type.trim().split(REGEXP_SPACES).forEach(function(event) {
            if (options.once && !onceSupported) {
                // eslint-disable-next-line no-underscore-dangle
                var listeners = element.__cropperListeners__ || {};
                _handler = function handler() {
                    if (listeners[event] && listeners[event][listener]) delete listeners[event][listener];
                    element.removeEventListener(event, _handler, options);
                    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                    listener.apply(element, args);
                };
                if (!listeners[event]) listeners[event] = {};
                if (listeners[event][listener]) element.removeEventListener(event, listeners[event][listener], options);
                listeners[event][listener] = _handler;
                // eslint-disable-next-line no-underscore-dangle
                element.__cropperListeners__ = listeners;
            }
            element.addEventListener(event, _handler, options);
        });
    }
    /**
   * Dispatch event on the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Object} data - The additional event data.
   * @returns {boolean} Indicate if the event is default prevented or not.
   */ function dispatchEvent(element, type, data) {
        if (!element || !type || !isFunction(element.dispatchEvent)) return false;
        var event;
        // Event and CustomEvent on IE9-11 are global objects, not constructors
        if (isFunction(Event) && isFunction(CustomEvent)) event = new CustomEvent(type, {
            detail: data,
            bubbles: true,
            cancelable: true
        });
        else if (isObject(document) && isFunction(document.createEvent)) {
            event = document.createEvent('CustomEvent');
            event.initCustomEvent(type, true, true, data);
        } else return false;
        return element.dispatchEvent(event);
    }
    /**
   * Get the offset based on the document.
   * @param {Element} element - The target element.
   * @returns {Object} The offset data.
   */ function getOffset(element) {
        if (!element || !isFunction(element.getBoundingClientRect)) return {
            left: 0,
            top: 0
        };
        var box = element.getBoundingClientRect();
        var _ref = document || {}, _ref$documentElement = _ref.documentElement, documentElement = _ref$documentElement === void 0 ? {} : _ref$documentElement;
        var pageXOffset = WINDOW.pageXOffset || 0;
        var pageYOffset = WINDOW.pageYOffset || 0;
        return {
            left: box.left + (pageXOffset - (documentElement.clientLeft || 0)),
            top: box.top + (pageYOffset - (documentElement.clientTop || 0))
        };
    }
    var location = WINDOW.location;
    var REGEXP_ORIGINS = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
    /**
   * Check if the given URL is a cross origin URL.
   * @param {string} url - The target URL.
   * @returns {boolean} Returns `true` if the given URL is a cross origin URL, else `false`.
   */ function isCrossOriginURL(url) {
        var parts = url.match(REGEXP_ORIGINS);
        return parts !== null && (parts[1] !== location.protocol || parts[2] !== location.hostname || parts[3] !== location.port);
    }
    /**
   * Add timestamp to the given URL.
   * @param {string} url - The target URL.
   * @returns {string} The result URL.
   */ function addTimestamp(url) {
        var hashIndex = url.indexOf('#');
        var hash = hashIndex >= 0 ? url.slice(hashIndex) : '';
        var baseUrl = hashIndex >= 0 ? url.slice(0, hashIndex) : url;
        var timestamp = "timestamp=".concat(new Date().getTime());
        return "".concat(baseUrl).concat(baseUrl.indexOf('?') === -1 ? '?' : '&').concat(timestamp).concat(hash);
    }
    /**
   * Get transforms based on the given object.
   * @param {Object} obj - The target object.
   * @returns {string} A string contains transform values.
   */ function getTransforms(_ref2) {
        var rotate = _ref2.rotate, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, translateX = _ref2.translateX, translateY = _ref2.translateY;
        var values = [];
        if (isNumber(translateX) && translateX !== 0) values.push("translateX(".concat(translateX, "px)"));
        if (isNumber(translateY) && translateY !== 0) values.push("translateY(".concat(translateY, "px)"));
        // Rotate should come first before scale to match orientation transform
        if (isNumber(rotate) && rotate !== 0) values.push("rotate(".concat(rotate, "deg)"));
        if (isNumber(scaleX) && scaleX !== 1) values.push("scaleX(".concat(scaleX, ")"));
        if (isNumber(scaleY) && scaleY !== 1) values.push("scaleY(".concat(scaleY, ")"));
        var transform = values.length ? values.join(' ') : 'none';
        return {
            WebkitTransform: transform,
            msTransform: transform,
            transform: transform
        };
    }
    /**
   * Get the max ratio of a group of pointers.
   * @param {string} pointers - The target pointers.
   * @returns {number} The result ratio.
   */ function getMaxZoomRatio(pointers) {
        var pointers2 = _objectSpread2({}, pointers);
        var maxRatio = 0;
        forEach(pointers, function(pointer, pointerId) {
            delete pointers2[pointerId];
            forEach(pointers2, function(pointer2) {
                var x1 = Math.abs(pointer.startX - pointer2.startX);
                var y1 = Math.abs(pointer.startY - pointer2.startY);
                var x2 = Math.abs(pointer.endX - pointer2.endX);
                var y2 = Math.abs(pointer.endY - pointer2.endY);
                var z1 = Math.sqrt(x1 * x1 + y1 * y1);
                var z2 = Math.sqrt(x2 * x2 + y2 * y2);
                if (!isFinite(z1) || !isFinite(z2) || z1 === 0 || z2 === z1) return;
                var ratio = (z2 - z1) / z1;
                if (isFinite(ratio) && Math.abs(ratio) > Math.abs(maxRatio)) maxRatio = ratio;
            });
        });
        return maxRatio;
    }
    /**
   * Get a pointer from an event object.
   * @param {Object} event - The target event object.
   * @param {boolean} endOnly - Indicates if only returns the end point coordinate or not.
   * @returns {Object} The result pointer contains start and/or end point coordinates.
   */ function getPointer(_ref3, endOnly) {
        var pageX = _ref3.pageX, pageY = _ref3.pageY;
        var end = {
            endX: pageX,
            endY: pageY
        };
        return endOnly ? end : _objectSpread2({
            startX: pageX,
            startY: pageY
        }, end);
    }
    /**
   * Get the center point coordinate of a group of pointers.
   * @param {Object} pointers - The target pointers.
   * @returns {Object} The center point coordinate.
   */ function getPointersCenter(pointers) {
        var pageX = 0;
        var pageY = 0;
        var count = 0;
        forEach(pointers, function(_ref4) {
            var startX = _ref4.startX, startY = _ref4.startY;
            pageX += startX;
            pageY += startY;
            count += 1;
        });
        pageX /= count;
        pageY /= count;
        return {
            pageX: pageX,
            pageY: pageY
        };
    }
    /**
   * Get the max sizes in a rectangle under the given aspect ratio.
   * @param {Object} data - The original sizes.
   * @param {string} [type='contain'] - The adjust type.
   * @returns {Object} The result sizes.
   */ function getAdjustedSizes(_ref5) {
        var aspectRatio = _ref5.aspectRatio, height = _ref5.height, width = _ref5.width;
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'contain';
        var isValidWidth = isPositiveNumber(width);
        var isValidHeight = isPositiveNumber(height);
        if (isValidWidth && isValidHeight) {
            var adjustedWidth = height * aspectRatio;
            if (type === 'contain' && adjustedWidth > width || type === 'cover' && adjustedWidth < width) height = width / aspectRatio;
            else width = height * aspectRatio;
        } else if (isValidWidth) height = width / aspectRatio;
        else if (isValidHeight) width = height * aspectRatio;
        return {
            width: width,
            height: height
        };
    }
    /**
   * Get the new sizes of a rectangle after rotated.
   * @param {Object} data - The original sizes.
   * @returns {Object} The result sizes.
   */ function getRotatedSizes(_ref6) {
        var width = _ref6.width, height = _ref6.height, degree = _ref6.degree;
        degree = Math.abs(degree) % 180;
        if (degree === 90) return {
            width: height,
            height: width
        };
        var arc = degree % 90 * Math.PI / 180;
        var sinArc = Math.sin(arc);
        var cosArc = Math.cos(arc);
        var newWidth = width * cosArc + height * sinArc;
        var newHeight = width * sinArc + height * cosArc;
        return degree > 90 ? {
            width: newHeight,
            height: newWidth
        } : {
            width: newWidth,
            height: newHeight
        };
    }
    /**
   * Get a canvas which draws the given image.
   * @param {HTMLImageElement} image - The image for drawing.
   * @param {Object} imageData - The image data.
   * @param {Object} canvasData - The canvas data.
   * @param {Object} options - The options.
   * @returns {HTMLCanvasElement} The result canvas.
   */ function getSourceCanvas(image, _ref7, _ref8, _ref9) {
        var imageAspectRatio = _ref7.aspectRatio, imageNaturalWidth = _ref7.naturalWidth, imageNaturalHeight = _ref7.naturalHeight, _ref7$rotate = _ref7.rotate, rotate = _ref7$rotate === void 0 ? 0 : _ref7$rotate, _ref7$scaleX = _ref7.scaleX, scaleX = _ref7$scaleX === void 0 ? 1 : _ref7$scaleX, _ref7$scaleY = _ref7.scaleY, scaleY = _ref7$scaleY === void 0 ? 1 : _ref7$scaleY;
        var aspectRatio = _ref8.aspectRatio, naturalWidth = _ref8.naturalWidth, naturalHeight = _ref8.naturalHeight;
        var _ref9$fillColor = _ref9.fillColor, fillColor = _ref9$fillColor === void 0 ? 'transparent' : _ref9$fillColor, _ref9$imageSmoothingE = _ref9.imageSmoothingEnabled, imageSmoothingEnabled = _ref9$imageSmoothingE === void 0 ? true : _ref9$imageSmoothingE, _ref9$imageSmoothingQ = _ref9.imageSmoothingQuality, imageSmoothingQuality = _ref9$imageSmoothingQ === void 0 ? 'low' : _ref9$imageSmoothingQ, _ref9$maxWidth = _ref9.maxWidth, maxWidth = _ref9$maxWidth === void 0 ? Infinity : _ref9$maxWidth, _ref9$maxHeight = _ref9.maxHeight, maxHeight = _ref9$maxHeight === void 0 ? Infinity : _ref9$maxHeight, _ref9$minWidth = _ref9.minWidth, minWidth = _ref9$minWidth === void 0 ? 0 : _ref9$minWidth, _ref9$minHeight = _ref9.minHeight, minHeight = _ref9$minHeight === void 0 ? 0 : _ref9$minHeight;
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        var maxSizes = getAdjustedSizes({
            aspectRatio: aspectRatio,
            width: maxWidth,
            height: maxHeight
        });
        var minSizes = getAdjustedSizes({
            aspectRatio: aspectRatio,
            width: minWidth,
            height: minHeight
        }, 'cover');
        var width = Math.min(maxSizes.width, Math.max(minSizes.width, naturalWidth));
        var height = Math.min(maxSizes.height, Math.max(minSizes.height, naturalHeight));
        // Note: should always use image's natural sizes for drawing as
        // imageData.naturalWidth === canvasData.naturalHeight when rotate % 180 === 90
        var destMaxSizes = getAdjustedSizes({
            aspectRatio: imageAspectRatio,
            width: maxWidth,
            height: maxHeight
        });
        var destMinSizes = getAdjustedSizes({
            aspectRatio: imageAspectRatio,
            width: minWidth,
            height: minHeight
        }, 'cover');
        var destWidth = Math.min(destMaxSizes.width, Math.max(destMinSizes.width, imageNaturalWidth));
        var destHeight = Math.min(destMaxSizes.height, Math.max(destMinSizes.height, imageNaturalHeight));
        var params = [
            -destWidth / 2,
            -destHeight / 2,
            destWidth,
            destHeight
        ];
        canvas.width = normalizeDecimalNumber(width);
        canvas.height = normalizeDecimalNumber(height);
        context.fillStyle = fillColor;
        context.fillRect(0, 0, width, height);
        context.save();
        context.translate(width / 2, height / 2);
        context.rotate(rotate * Math.PI / 180);
        context.scale(scaleX, scaleY);
        context.imageSmoothingEnabled = imageSmoothingEnabled;
        context.imageSmoothingQuality = imageSmoothingQuality;
        context.drawImage.apply(context, [
            image
        ].concat(_toConsumableArray(params.map(function(param) {
            return Math.floor(normalizeDecimalNumber(param));
        }))));
        context.restore();
        return canvas;
    }
    var fromCharCode = String.fromCharCode;
    /**
   * Get string from char code in data view.
   * @param {DataView} dataView - The data view for read.
   * @param {number} start - The start index.
   * @param {number} length - The read length.
   * @returns {string} The read result.
   */ function getStringFromCharCode(dataView, start, length) {
        var str = '';
        length += start;
        for(var i = start; i < length; i += 1)str += fromCharCode(dataView.getUint8(i));
        return str;
    }
    var REGEXP_DATA_URL_HEAD = /^data:.*,/;
    /**
   * Transform Data URL to array buffer.
   * @param {string} dataURL - The Data URL to transform.
   * @returns {ArrayBuffer} The result array buffer.
   */ function dataURLToArrayBuffer(dataURL) {
        var base64 = dataURL.replace(REGEXP_DATA_URL_HEAD, '');
        var binary = atob(base64);
        var arrayBuffer = new ArrayBuffer(binary.length);
        var uint8 = new Uint8Array(arrayBuffer);
        forEach(uint8, function(value, i) {
            uint8[i] = binary.charCodeAt(i);
        });
        return arrayBuffer;
    }
    /**
   * Transform array buffer to Data URL.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
   * @param {string} mimeType - The mime type of the Data URL.
   * @returns {string} The result Data URL.
   */ function arrayBufferToDataURL(arrayBuffer, mimeType) {
        var chunks = [];
        // Chunk Typed Array for better performance (#435)
        var chunkSize = 8192;
        var uint8 = new Uint8Array(arrayBuffer);
        while(uint8.length > 0){
            // XXX: Babel's `toConsumableArray` helper will throw error in IE or Safari 9
            // eslint-disable-next-line prefer-spread
            chunks.push(fromCharCode.apply(null, toArray(uint8.subarray(0, chunkSize))));
            uint8 = uint8.subarray(chunkSize);
        }
        return "data:".concat(mimeType, ";base64,").concat(btoa(chunks.join('')));
    }
    /**
   * Get orientation value from given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
   * @returns {number} The read orientation value.
   */ function resetAndGetOrientation(arrayBuffer) {
        var dataView = new DataView(arrayBuffer);
        var orientation;
        // Ignores range error when the image does not have correct Exif information
        try {
            var littleEndian;
            var app1Start;
            var ifdStart;
            // Only handle JPEG image (start by 0xFFD8)
            if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
                var length = dataView.byteLength;
                var offset = 2;
                while(offset + 1 < length){
                    if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
                        app1Start = offset;
                        break;
                    }
                    offset += 1;
                }
            }
            if (app1Start) {
                var exifIDCode = app1Start + 4;
                var tiffOffset = app1Start + 10;
                if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
                    var endianness = dataView.getUint16(tiffOffset);
                    littleEndian = endianness === 0x4949;
                    if (littleEndian || endianness === 0x4D4D /* bigEndian */ ) {
                        if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
                            var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);
                            if (firstIFDOffset >= 0x00000008) ifdStart = tiffOffset + firstIFDOffset;
                        }
                    }
                }
            }
            if (ifdStart) {
                var _length = dataView.getUint16(ifdStart, littleEndian);
                var _offset;
                var i;
                for(i = 0; i < _length; i += 1){
                    _offset = ifdStart + i * 12 + 2;
                    if (dataView.getUint16(_offset, littleEndian) === 0x0112 /* Orientation */ ) {
                        // 8 is the offset of the current tag's value
                        _offset += 8;
                        // Get the original orientation value
                        orientation = dataView.getUint16(_offset, littleEndian);
                        // Override the orientation with its default value
                        dataView.setUint16(_offset, 1, littleEndian);
                        break;
                    }
                }
            }
        } catch (error) {
            orientation = 1;
        }
        return orientation;
    }
    /**
   * Parse Exif Orientation value.
   * @param {number} orientation - The orientation to parse.
   * @returns {Object} The parsed result.
   */ function parseOrientation(orientation) {
        var rotate = 0;
        var scaleX = 1;
        var scaleY = 1;
        switch(orientation){
            // Flip horizontal
            case 2:
                scaleX = -1;
                break;
            // Rotate left 180°
            case 3:
                rotate = -180;
                break;
            // Flip vertical
            case 4:
                scaleY = -1;
                break;
            // Flip vertical and rotate right 90°
            case 5:
                rotate = 90;
                scaleY = -1;
                break;
            // Rotate right 90°
            case 6:
                rotate = 90;
                break;
            // Flip horizontal and rotate right 90°
            case 7:
                rotate = 90;
                scaleX = -1;
                break;
            // Rotate left 90°
            case 8:
                rotate = -90;
                break;
        }
        return {
            rotate: rotate,
            scaleX: scaleX,
            scaleY: scaleY
        };
    }
    var render = {
        render: function render() {
            this.initContainer();
            this.initCanvas();
            this.initCropBox();
            this.renderCanvas();
            if (this.cropped) this.renderCropBox();
        },
        initContainer: function initContainer() {
            var element = this.element, options = this.options, container = this.container, cropper = this.cropper;
            var minWidth = Number(options.minContainerWidth);
            var minHeight = Number(options.minContainerHeight);
            addClass(cropper, CLASS_HIDDEN);
            removeClass(element, CLASS_HIDDEN);
            var containerData = {
                width: Math.max(container.offsetWidth, minWidth >= 0 ? minWidth : MIN_CONTAINER_WIDTH),
                height: Math.max(container.offsetHeight, minHeight >= 0 ? minHeight : MIN_CONTAINER_HEIGHT)
            };
            this.containerData = containerData;
            setStyle(cropper, {
                width: containerData.width,
                height: containerData.height
            });
            addClass(element, CLASS_HIDDEN);
            removeClass(cropper, CLASS_HIDDEN);
        },
        // Canvas (image wrapper)
        initCanvas: function initCanvas() {
            var containerData = this.containerData, imageData = this.imageData;
            var viewMode = this.options.viewMode;
            var rotated = Math.abs(imageData.rotate) % 180 === 90;
            var naturalWidth = rotated ? imageData.naturalHeight : imageData.naturalWidth;
            var naturalHeight = rotated ? imageData.naturalWidth : imageData.naturalHeight;
            var aspectRatio = naturalWidth / naturalHeight;
            var canvasWidth = containerData.width;
            var canvasHeight = containerData.height;
            if (containerData.height * aspectRatio > containerData.width) {
                if (viewMode === 3) canvasWidth = containerData.height * aspectRatio;
                else canvasHeight = containerData.width / aspectRatio;
            } else if (viewMode === 3) canvasHeight = containerData.width / aspectRatio;
            else canvasWidth = containerData.height * aspectRatio;
            var canvasData = {
                aspectRatio: aspectRatio,
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight,
                width: canvasWidth,
                height: canvasHeight
            };
            this.canvasData = canvasData;
            this.limited = viewMode === 1 || viewMode === 2;
            this.limitCanvas(true, true);
            canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
            canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
            canvasData.left = (containerData.width - canvasData.width) / 2;
            canvasData.top = (containerData.height - canvasData.height) / 2;
            canvasData.oldLeft = canvasData.left;
            canvasData.oldTop = canvasData.top;
            this.initialCanvasData = assign({}, canvasData);
        },
        limitCanvas: function limitCanvas(sizeLimited, positionLimited) {
            var options = this.options, containerData = this.containerData, canvasData = this.canvasData, cropBoxData = this.cropBoxData;
            var viewMode = options.viewMode;
            var aspectRatio = canvasData.aspectRatio;
            var cropped = this.cropped && cropBoxData;
            if (sizeLimited) {
                var minCanvasWidth = Number(options.minCanvasWidth) || 0;
                var minCanvasHeight = Number(options.minCanvasHeight) || 0;
                if (viewMode > 1) {
                    minCanvasWidth = Math.max(minCanvasWidth, containerData.width);
                    minCanvasHeight = Math.max(minCanvasHeight, containerData.height);
                    if (viewMode === 3) {
                        if (minCanvasHeight * aspectRatio > minCanvasWidth) minCanvasWidth = minCanvasHeight * aspectRatio;
                        else minCanvasHeight = minCanvasWidth / aspectRatio;
                    }
                } else if (viewMode > 0) {
                    if (minCanvasWidth) minCanvasWidth = Math.max(minCanvasWidth, cropped ? cropBoxData.width : 0);
                    else if (minCanvasHeight) minCanvasHeight = Math.max(minCanvasHeight, cropped ? cropBoxData.height : 0);
                    else if (cropped) {
                        minCanvasWidth = cropBoxData.width;
                        minCanvasHeight = cropBoxData.height;
                        if (minCanvasHeight * aspectRatio > minCanvasWidth) minCanvasWidth = minCanvasHeight * aspectRatio;
                        else minCanvasHeight = minCanvasWidth / aspectRatio;
                    }
                }
                var _getAdjustedSizes = getAdjustedSizes({
                    aspectRatio: aspectRatio,
                    width: minCanvasWidth,
                    height: minCanvasHeight
                });
                minCanvasWidth = _getAdjustedSizes.width;
                minCanvasHeight = _getAdjustedSizes.height;
                canvasData.minWidth = minCanvasWidth;
                canvasData.minHeight = minCanvasHeight;
                canvasData.maxWidth = Infinity;
                canvasData.maxHeight = Infinity;
            }
            if (positionLimited) {
                if (viewMode > (cropped ? 0 : 1)) {
                    var newCanvasLeft = containerData.width - canvasData.width;
                    var newCanvasTop = containerData.height - canvasData.height;
                    canvasData.minLeft = Math.min(0, newCanvasLeft);
                    canvasData.minTop = Math.min(0, newCanvasTop);
                    canvasData.maxLeft = Math.max(0, newCanvasLeft);
                    canvasData.maxTop = Math.max(0, newCanvasTop);
                    if (cropped && this.limited) {
                        canvasData.minLeft = Math.min(cropBoxData.left, cropBoxData.left + (cropBoxData.width - canvasData.width));
                        canvasData.minTop = Math.min(cropBoxData.top, cropBoxData.top + (cropBoxData.height - canvasData.height));
                        canvasData.maxLeft = cropBoxData.left;
                        canvasData.maxTop = cropBoxData.top;
                        if (viewMode === 2) {
                            if (canvasData.width >= containerData.width) {
                                canvasData.minLeft = Math.min(0, newCanvasLeft);
                                canvasData.maxLeft = Math.max(0, newCanvasLeft);
                            }
                            if (canvasData.height >= containerData.height) {
                                canvasData.minTop = Math.min(0, newCanvasTop);
                                canvasData.maxTop = Math.max(0, newCanvasTop);
                            }
                        }
                    }
                } else {
                    canvasData.minLeft = -canvasData.width;
                    canvasData.minTop = -canvasData.height;
                    canvasData.maxLeft = containerData.width;
                    canvasData.maxTop = containerData.height;
                }
            }
        },
        renderCanvas: function renderCanvas(changed, transformed) {
            var canvasData = this.canvasData, imageData = this.imageData;
            if (transformed) {
                var _getRotatedSizes = getRotatedSizes({
                    width: imageData.naturalWidth * Math.abs(imageData.scaleX || 1),
                    height: imageData.naturalHeight * Math.abs(imageData.scaleY || 1),
                    degree: imageData.rotate || 0
                }), naturalWidth = _getRotatedSizes.width, naturalHeight = _getRotatedSizes.height;
                var width = canvasData.width * (naturalWidth / canvasData.naturalWidth);
                var height = canvasData.height * (naturalHeight / canvasData.naturalHeight);
                canvasData.left -= (width - canvasData.width) / 2;
                canvasData.top -= (height - canvasData.height) / 2;
                canvasData.width = width;
                canvasData.height = height;
                canvasData.aspectRatio = naturalWidth / naturalHeight;
                canvasData.naturalWidth = naturalWidth;
                canvasData.naturalHeight = naturalHeight;
                this.limitCanvas(true, false);
            }
            if (canvasData.width > canvasData.maxWidth || canvasData.width < canvasData.minWidth) canvasData.left = canvasData.oldLeft;
            if (canvasData.height > canvasData.maxHeight || canvasData.height < canvasData.minHeight) canvasData.top = canvasData.oldTop;
            canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
            canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
            this.limitCanvas(false, true);
            canvasData.left = Math.min(Math.max(canvasData.left, canvasData.minLeft), canvasData.maxLeft);
            canvasData.top = Math.min(Math.max(canvasData.top, canvasData.minTop), canvasData.maxTop);
            canvasData.oldLeft = canvasData.left;
            canvasData.oldTop = canvasData.top;
            setStyle(this.canvas, assign({
                width: canvasData.width,
                height: canvasData.height
            }, getTransforms({
                translateX: canvasData.left,
                translateY: canvasData.top
            })));
            this.renderImage(changed);
            if (this.cropped && this.limited) this.limitCropBox(true, true);
        },
        renderImage: function renderImage(changed) {
            var canvasData = this.canvasData, imageData = this.imageData;
            var width = imageData.naturalWidth * (canvasData.width / canvasData.naturalWidth);
            var height = imageData.naturalHeight * (canvasData.height / canvasData.naturalHeight);
            assign(imageData, {
                width: width,
                height: height,
                left: (canvasData.width - width) / 2,
                top: (canvasData.height - height) / 2
            });
            setStyle(this.image, assign({
                width: imageData.width,
                height: imageData.height
            }, getTransforms(assign({
                translateX: imageData.left,
                translateY: imageData.top
            }, imageData))));
            if (changed) this.output();
        },
        initCropBox: function initCropBox() {
            var options = this.options, canvasData = this.canvasData;
            var aspectRatio = options.aspectRatio || options.initialAspectRatio;
            var autoCropArea = Number(options.autoCropArea) || 0.8;
            var cropBoxData = {
                width: canvasData.width,
                height: canvasData.height
            };
            if (aspectRatio) {
                if (canvasData.height * aspectRatio > canvasData.width) cropBoxData.height = cropBoxData.width / aspectRatio;
                else cropBoxData.width = cropBoxData.height * aspectRatio;
            }
            this.cropBoxData = cropBoxData;
            this.limitCropBox(true, true);
            // Initialize auto crop area
            cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
            cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight);
            // The width/height of auto crop area must large than "minWidth/Height"
            cropBoxData.width = Math.max(cropBoxData.minWidth, cropBoxData.width * autoCropArea);
            cropBoxData.height = Math.max(cropBoxData.minHeight, cropBoxData.height * autoCropArea);
            cropBoxData.left = canvasData.left + (canvasData.width - cropBoxData.width) / 2;
            cropBoxData.top = canvasData.top + (canvasData.height - cropBoxData.height) / 2;
            cropBoxData.oldLeft = cropBoxData.left;
            cropBoxData.oldTop = cropBoxData.top;
            this.initialCropBoxData = assign({}, cropBoxData);
        },
        limitCropBox: function limitCropBox(sizeLimited, positionLimited) {
            var options = this.options, containerData = this.containerData, canvasData = this.canvasData, cropBoxData = this.cropBoxData, limited = this.limited;
            var aspectRatio = options.aspectRatio;
            if (sizeLimited) {
                var minCropBoxWidth = Number(options.minCropBoxWidth) || 0;
                var minCropBoxHeight = Number(options.minCropBoxHeight) || 0;
                var maxCropBoxWidth = limited ? Math.min(containerData.width, canvasData.width, canvasData.width + canvasData.left, containerData.width - canvasData.left) : containerData.width;
                var maxCropBoxHeight = limited ? Math.min(containerData.height, canvasData.height, canvasData.height + canvasData.top, containerData.height - canvasData.top) : containerData.height;
                // The min/maxCropBoxWidth/Height must be less than container's width/height
                minCropBoxWidth = Math.min(minCropBoxWidth, containerData.width);
                minCropBoxHeight = Math.min(minCropBoxHeight, containerData.height);
                if (aspectRatio) {
                    if (minCropBoxWidth && minCropBoxHeight) {
                        if (minCropBoxHeight * aspectRatio > minCropBoxWidth) minCropBoxHeight = minCropBoxWidth / aspectRatio;
                        else minCropBoxWidth = minCropBoxHeight * aspectRatio;
                    } else if (minCropBoxWidth) minCropBoxHeight = minCropBoxWidth / aspectRatio;
                    else if (minCropBoxHeight) minCropBoxWidth = minCropBoxHeight * aspectRatio;
                    if (maxCropBoxHeight * aspectRatio > maxCropBoxWidth) maxCropBoxHeight = maxCropBoxWidth / aspectRatio;
                    else maxCropBoxWidth = maxCropBoxHeight * aspectRatio;
                }
                // The minWidth/Height must be less than maxWidth/Height
                cropBoxData.minWidth = Math.min(minCropBoxWidth, maxCropBoxWidth);
                cropBoxData.minHeight = Math.min(minCropBoxHeight, maxCropBoxHeight);
                cropBoxData.maxWidth = maxCropBoxWidth;
                cropBoxData.maxHeight = maxCropBoxHeight;
            }
            if (positionLimited) {
                if (limited) {
                    cropBoxData.minLeft = Math.max(0, canvasData.left);
                    cropBoxData.minTop = Math.max(0, canvasData.top);
                    cropBoxData.maxLeft = Math.min(containerData.width, canvasData.left + canvasData.width) - cropBoxData.width;
                    cropBoxData.maxTop = Math.min(containerData.height, canvasData.top + canvasData.height) - cropBoxData.height;
                } else {
                    cropBoxData.minLeft = 0;
                    cropBoxData.minTop = 0;
                    cropBoxData.maxLeft = containerData.width - cropBoxData.width;
                    cropBoxData.maxTop = containerData.height - cropBoxData.height;
                }
            }
        },
        renderCropBox: function renderCropBox() {
            var options = this.options, containerData = this.containerData, cropBoxData = this.cropBoxData;
            if (cropBoxData.width > cropBoxData.maxWidth || cropBoxData.width < cropBoxData.minWidth) cropBoxData.left = cropBoxData.oldLeft;
            if (cropBoxData.height > cropBoxData.maxHeight || cropBoxData.height < cropBoxData.minHeight) cropBoxData.top = cropBoxData.oldTop;
            cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
            cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight);
            this.limitCropBox(false, true);
            cropBoxData.left = Math.min(Math.max(cropBoxData.left, cropBoxData.minLeft), cropBoxData.maxLeft);
            cropBoxData.top = Math.min(Math.max(cropBoxData.top, cropBoxData.minTop), cropBoxData.maxTop);
            cropBoxData.oldLeft = cropBoxData.left;
            cropBoxData.oldTop = cropBoxData.top;
            if (options.movable && options.cropBoxMovable) // Turn to move the canvas when the crop box is equal to the container
            setData(this.face, DATA_ACTION, cropBoxData.width >= containerData.width && cropBoxData.height >= containerData.height ? ACTION_MOVE : ACTION_ALL);
            setStyle(this.cropBox, assign({
                width: cropBoxData.width,
                height: cropBoxData.height,
                borderRadius: options.borderRadius
            }, getTransforms({
                translateX: cropBoxData.left,
                translateY: cropBoxData.top
            })));
            if (this.cropped && this.limited) this.limitCanvas(true, true);
            if (!this.disabled) this.output();
        },
        output: function output() {
            this.preview();
            dispatchEvent(this.element, EVENT_CROP, this.getData());
        }
    };
    var preview = {
        initPreview: function initPreview() {
            var element = this.element, crossOrigin = this.crossOrigin;
            var preview = this.options.preview;
            var url = crossOrigin ? this.crossOriginUrl : this.url;
            var alt = element.alt || 'The image to preview';
            var image = document.createElement('img');
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = url;
            image.alt = alt;
            this.viewBox.appendChild(image);
            this.viewBoxImage = image;
            if (!preview) return;
            var previews = preview;
            if (typeof preview === 'string') previews = element.ownerDocument.querySelectorAll(preview);
            else if (preview.querySelector) previews = [
                preview
            ];
            this.previews = previews;
            forEach(previews, function(el) {
                var img = document.createElement('img');
                // Save the original size for recover
                setData(el, DATA_PREVIEW, {
                    width: el.offsetWidth,
                    height: el.offsetHeight,
                    html: el.innerHTML
                });
                if (crossOrigin) img.crossOrigin = crossOrigin;
                img.src = url;
                img.alt = alt;
                /**
         * Override img element styles
         * Add `display:block` to avoid margin top issue
         * Add `height:auto` to override `height` attribute on IE8
         * (Occur only when margin-top <= -height)
         */ img.style.cssText = "display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;";
                el.innerHTML = '';
                el.appendChild(img);
            });
        },
        resetPreview: function resetPreview() {
            forEach(this.previews, function(element) {
                var data = getData(element, DATA_PREVIEW);
                setStyle(element, {
                    width: data.width,
                    height: data.height
                });
                element.innerHTML = data.html;
                removeData(element, DATA_PREVIEW);
            });
        },
        preview: function preview() {
            var imageData = this.imageData, canvasData = this.canvasData, cropBoxData = this.cropBoxData;
            var cropBoxWidth = cropBoxData.width, cropBoxHeight = cropBoxData.height;
            var width = imageData.width, height = imageData.height;
            var left = cropBoxData.left - canvasData.left - imageData.left;
            var top = cropBoxData.top - canvasData.top - imageData.top;
            if (!this.cropped || this.disabled) return;
            setStyle(this.viewBoxImage, assign({
                width: width,
                height: height
            }, getTransforms(assign({
                translateX: -left,
                translateY: -top
            }, imageData))));
            forEach(this.previews, function(element) {
                var data = getData(element, DATA_PREVIEW);
                var originalWidth = data.width;
                var originalHeight = data.height;
                var newWidth = originalWidth;
                var newHeight = originalHeight;
                var ratio = 1;
                if (cropBoxWidth) {
                    ratio = originalWidth / cropBoxWidth;
                    newHeight = cropBoxHeight * ratio;
                }
                if (cropBoxHeight && newHeight > originalHeight) {
                    ratio = originalHeight / cropBoxHeight;
                    newWidth = cropBoxWidth * ratio;
                    newHeight = originalHeight;
                }
                setStyle(element, {
                    width: newWidth,
                    height: newHeight
                });
                setStyle(element.getElementsByTagName('img')[0], assign({
                    width: width * ratio,
                    height: height * ratio
                }, getTransforms(assign({
                    translateX: -left * ratio,
                    translateY: -top * ratio
                }, imageData))));
            });
        }
    };
    var events = {
        bind: function bind() {
            var element = this.element, options = this.options, cropper = this.cropper;
            if (isFunction(options.cropstart)) addListener(element, EVENT_CROP_START, options.cropstart);
            if (isFunction(options.cropmove)) addListener(element, EVENT_CROP_MOVE, options.cropmove);
            if (isFunction(options.cropend)) addListener(element, EVENT_CROP_END, options.cropend);
            if (isFunction(options.crop)) addListener(element, EVENT_CROP, options.crop);
            if (isFunction(options.zoom)) addListener(element, EVENT_ZOOM, options.zoom);
            addListener(cropper, EVENT_POINTER_DOWN, this.onCropStart = this.cropStart.bind(this));
            if (options.zoomable && options.zoomOnWheel) addListener(cropper, EVENT_WHEEL, this.onWheel = this.wheel.bind(this), {
                passive: false,
                capture: true
            });
            if (options.toggleDragModeOnDblclick) addListener(cropper, EVENT_DBLCLICK, this.onDblclick = this.dblclick.bind(this));
            addListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove = this.cropMove.bind(this));
            addListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd = this.cropEnd.bind(this));
            addListener(element.ownerDocument.defaultView, EVENT_BLUR, this.onCropBlur = this.cropEnd.bind(this));
            if (options.responsive) addListener(window, EVENT_RESIZE, this.onResize = this.resize.bind(this));
        },
        unbind: function unbind() {
            var element = this.element, options = this.options, cropper = this.cropper;
            if (isFunction(options.cropstart)) removeListener(element, EVENT_CROP_START, options.cropstart);
            if (isFunction(options.cropmove)) removeListener(element, EVENT_CROP_MOVE, options.cropmove);
            if (isFunction(options.cropend)) removeListener(element, EVENT_CROP_END, options.cropend);
            if (isFunction(options.crop)) removeListener(element, EVENT_CROP, options.crop);
            if (isFunction(options.zoom)) removeListener(element, EVENT_ZOOM, options.zoom);
            removeListener(cropper, EVENT_POINTER_DOWN, this.onCropStart);
            if (options.zoomable && options.zoomOnWheel) removeListener(cropper, EVENT_WHEEL, this.onWheel, {
                passive: false,
                capture: true
            });
            if (options.toggleDragModeOnDblclick) removeListener(cropper, EVENT_DBLCLICK, this.onDblclick);
            removeListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove);
            removeListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd);
            removeListener(element.ownerDocument.defaultView, EVENT_BLUR, this.onCropBlur);
            if (options.responsive) removeListener(window, EVENT_RESIZE, this.onResize);
        }
    };
    var BORDER_RADIUS_CORNER_FACTOR = 0.5522848;
    function expandBorderRadiusValues(values) {
        if (values.length === 1) return [
            values[0],
            values[0],
            values[0],
            values[0]
        ];
        if (values.length === 2) return [
            values[0],
            values[1],
            values[0],
            values[1]
        ];
        if (values.length === 3) return [
            values[0],
            values[1],
            values[2],
            values[1]
        ];
        return values.slice(0, 4);
    }
    function parseBorderRadiusValues(value, size, scale) {
        return value.trim().split(/\s+/).map(function(part) {
            var number = Number.parseFloat(part);
            if (part.endsWith('%')) return number * size / 100;
            return (number || 0) * scale;
        });
    }
    function getBorderRadii(borderRadius, width, height, scale) {
        var value = String(borderRadius || 0).trim();
        var parts = value.split('/');
        var horizontal = expandBorderRadiusValues(parseBorderRadiusValues(parts[0], width, scale));
        var vertical = expandBorderRadiusValues(parseBorderRadiusValues(parts[1] || parts[0], height, scale));
        var radii = [
            {
                x: horizontal[0],
                y: vertical[0]
            },
            {
                x: horizontal[1],
                y: vertical[1]
            },
            {
                x: horizontal[2],
                y: vertical[2]
            },
            {
                x: horizontal[3],
                y: vertical[3]
            }
        ];
        var radiusScale = Math.min(1, width / (radii[0].x + radii[1].x || 1), width / (radii[3].x + radii[2].x || 1), height / (radii[0].y + radii[3].y || 1), height / (radii[1].y + radii[2].y || 1));
        return radii.map(function(_ref) {
            var x = _ref.x, y = _ref.y;
            return {
                x: x * radiusScale,
                y: y * radiusScale
            };
        });
    }
    function drawRoundedRect(context, width, height, borderRadius, scale) {
        var _getBorderRadii = getBorderRadii(borderRadius, width, height, scale), _getBorderRadii2 = _slicedToArray(_getBorderRadii, 4), topLeft = _getBorderRadii2[0], topRight = _getBorderRadii2[1], bottomRight = _getBorderRadii2[2], bottomLeft = _getBorderRadii2[3];
        var factor = BORDER_RADIUS_CORNER_FACTOR;
        context.beginPath();
        context.moveTo(topLeft.x, 0);
        context.lineTo(width - topRight.x, 0);
        context.bezierCurveTo(width - topRight.x + topRight.x * factor, 0, width, topRight.y - topRight.y * factor, width, topRight.y);
        context.lineTo(width, height - bottomRight.y);
        context.bezierCurveTo(width, height - bottomRight.y + bottomRight.y * factor, width - bottomRight.x + bottomRight.x * factor, height, width - bottomRight.x, height);
        context.lineTo(bottomLeft.x, height);
        context.bezierCurveTo(bottomLeft.x - bottomLeft.x * factor, height, 0, height - bottomLeft.y + bottomLeft.y * factor, 0, height - bottomLeft.y);
        context.lineTo(0, topLeft.y);
        context.bezierCurveTo(0, topLeft.y - topLeft.y * factor, topLeft.x - topLeft.x * factor, 0, topLeft.x, 0);
        context.closePath();
        context.fill();
    }
    function _zoomTo(ratio, pivot, originalEvent) {
        var options = this.options, canvasData = this.canvasData, containerData = this.containerData;
        var width = canvasData.width, height = canvasData.height, naturalWidth = canvasData.naturalWidth, naturalHeight = canvasData.naturalHeight;
        ratio = Number(ratio);
        if (ratio >= 0 && this.ready && !this.disabled && options.zoomable) {
            var newWidth = naturalWidth * ratio;
            var newHeight = naturalHeight * ratio;
            if (dispatchEvent(this.element, EVENT_ZOOM, {
                ratio: ratio,
                oldRatio: width / naturalWidth,
                originalEvent: originalEvent
            }) === false) return this;
            if (isPlainObject(pivot) && isNumber(pivot.x) && isNumber(pivot.y)) {
                canvasData.left -= (newWidth - width) * ((pivot.x - canvasData.left) / width);
                canvasData.top -= (newHeight - height) * ((pivot.y - canvasData.top) / height);
            } else if (options.zoomAroundCenter) {
                var centerX = containerData.width / 2;
                var centerY = containerData.height / 2;
                canvasData.left -= (newWidth - width) * ((centerX - canvasData.left) / width);
                canvasData.top -= (newHeight - height) * ((centerY - canvasData.top) / height);
            } else if (originalEvent) {
                var pointers = this.pointers;
                var offset = getOffset(this.cropper);
                var center = pointers && Object.keys(pointers).length ? getPointersCenter(pointers) : {
                    pageX: originalEvent.pageX,
                    pageY: originalEvent.pageY
                };
                // Zoom from the triggering point of the event
                canvasData.left -= (newWidth - width) * ((center.pageX - offset.left - canvasData.left) / width);
                canvasData.top -= (newHeight - height) * ((center.pageY - offset.top - canvasData.top) / height);
            } else {
                // Zoom from the center of the canvas
                canvasData.left -= (newWidth - width) / 2;
                canvasData.top -= (newHeight - height) / 2;
            }
            canvasData.width = newWidth;
            canvasData.height = newHeight;
            this.renderCanvas(true);
        }
        return this;
    }
    function _zoom(ratio, originalEvent) {
        var canvasData = this.canvasData;
        ratio = Number(ratio);
        if (ratio < 0) ratio = 1 / (1 - ratio);
        else ratio = 1 + ratio;
        return _zoomTo.call(this, canvasData.width * ratio / canvasData.naturalWidth, null, originalEvent);
    }
    function zoomWithEvent(ratio, originalEvent) {
        return _zoom.call(this, ratio, originalEvent);
    }
    var methods = {
        // Show the crop box manually
        crop: function crop() {
            if (this.ready && !this.cropped && !this.disabled) {
                this.cropped = true;
                this.limitCropBox(true, true);
                if (this.options.modal) addClass(this.dragBox, CLASS_MODAL);
                removeClass(this.cropBox, CLASS_HIDDEN);
                this.setCropBoxData(this.initialCropBoxData);
            }
            return this;
        },
        // Reset the image and crop box to their initial states
        reset: function reset() {
            if (this.ready && !this.disabled) {
                this.imageData = assign({}, this.initialImageData);
                this.canvasData = assign({}, this.initialCanvasData);
                this.cropBoxData = assign({}, this.initialCropBoxData);
                this.renderCanvas();
                if (this.cropped) this.renderCropBox();
            }
            return this;
        },
        // Clear the crop box
        clear: function clear() {
            if (this.cropped && !this.disabled) {
                assign(this.cropBoxData, {
                    left: 0,
                    top: 0,
                    width: 0,
                    height: 0
                });
                this.cropped = false;
                this.renderCropBox();
                this.limitCanvas(true, true);
                // Render canvas after crop box rendered
                this.renderCanvas();
                removeClass(this.dragBox, CLASS_MODAL);
                addClass(this.cropBox, CLASS_HIDDEN);
            }
            return this;
        },
        /**
     * Replace the image's src and rebuild the cropper
     * @param {string} url - The new URL.
     * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
     * @returns {Cropper} this
     */ replace: function replace(url) {
            var hasSameSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            if (!this.disabled && url) {
                if (this.isImg) this.element.src = url;
                if (hasSameSize) {
                    this.url = url;
                    this.image.src = url;
                    if (this.ready) {
                        this.viewBoxImage.src = url;
                        forEach(this.previews, function(element) {
                            element.getElementsByTagName('img')[0].src = url;
                        });
                    }
                } else {
                    if (this.isImg) this.replaced = true;
                    this.options.data = null;
                    this.uncreate();
                    this.load(url);
                }
            }
            return this;
        },
        // Enable (unfreeze) the cropper
        enable: function enable() {
            if (this.ready && this.disabled) {
                this.disabled = false;
                removeClass(this.cropper, CLASS_DISABLED);
            }
            return this;
        },
        // Disable (freeze) the cropper
        disable: function disable() {
            if (this.ready && !this.disabled) {
                this.disabled = true;
                addClass(this.cropper, CLASS_DISABLED);
            }
            return this;
        },
        /**
     * Destroy the cropper and remove the instance from the image
     * @returns {Cropper} this
     */ destroy: function destroy() {
            var element = this.element;
            if (!element[NAMESPACE]) return this;
            element[NAMESPACE] = undefined;
            if (this.isImg && this.replaced) element.src = this.originalUrl;
            this.uncreate();
            return this;
        },
        /**
     * Move the canvas with relative offsets
     * @param {number} offsetX - The relative offset distance on the x-axis.
     * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
     * @returns {Cropper} this
     */ move: function move(offsetX) {
            var offsetY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : offsetX;
            var _this$canvasData = this.canvasData, left = _this$canvasData.left, top = _this$canvasData.top;
            return this.moveTo(isUndefined(offsetX) ? offsetX : left + Number(offsetX), isUndefined(offsetY) ? offsetY : top + Number(offsetY));
        },
        /**
     * Move the canvas to an absolute point
     * @param {number} x - The x-axis coordinate.
     * @param {number} [y=x] - The y-axis coordinate.
     * @returns {Cropper} this
     */ moveTo: function moveTo(x) {
            var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
            var canvasData = this.canvasData;
            var changed = false;
            x = Number(x);
            y = Number(y);
            if (this.ready && !this.disabled && this.options.movable) {
                if (isNumber(x)) {
                    canvasData.left = x;
                    changed = true;
                }
                if (isNumber(y)) {
                    canvasData.top = y;
                    changed = true;
                }
                if (changed) this.renderCanvas(true);
            }
            return this;
        },
        /**
     * Zoom the canvas with a relative ratio
     * @param {number} ratio - The target ratio.
     * @returns {Cropper} this
     */ zoom: function zoom(ratio) {
            return _zoom.call(this, ratio);
        },
        /**
     * Zoom the canvas to an absolute ratio
     * @param {number} ratio - The target ratio.
     * @param {Object} pivot - The zoom pivot point coordinate.
     * @returns {Cropper} this
     */ zoomTo: function zoomTo(ratio, pivot) {
            return _zoomTo.call(this, ratio, pivot);
        },
        /**
     * Rotate the canvas with a relative degree
     * @param {number} degree - The rotate degree.
     * @returns {Cropper} this
     */ rotate: function rotate(degree) {
            return this.rotateTo((this.imageData.rotate || 0) + Number(degree));
        },
        /**
     * Rotate the canvas to an absolute degree
     * @param {number} degree - The rotate degree.
     * @returns {Cropper} this
     */ rotateTo: function rotateTo(degree) {
            degree = Number(degree);
            if (isNumber(degree) && this.ready && !this.disabled && this.options.rotatable) {
                this.imageData.rotate = degree % 360;
                this.renderCanvas(true, true);
            }
            return this;
        },
        /**
     * Scale the image on the x-axis.
     * @param {number} scaleX - The scale ratio on the x-axis.
     * @returns {Cropper} this
     */ scaleX: function scaleX(_scaleX) {
            var scaleY = this.imageData.scaleY;
            return this.scale(_scaleX, isNumber(scaleY) ? scaleY : 1);
        },
        /**
     * Scale the image on the y-axis.
     * @param {number} scaleY - The scale ratio on the y-axis.
     * @returns {Cropper} this
     */ scaleY: function scaleY(_scaleY) {
            var scaleX = this.imageData.scaleX;
            return this.scale(isNumber(scaleX) ? scaleX : 1, _scaleY);
        },
        /**
     * Scale the image
     * @param {number} scaleX - The scale ratio on the x-axis.
     * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
     * @returns {Cropper} this
     */ scale: function scale(scaleX) {
            var scaleY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scaleX;
            var imageData = this.imageData;
            var transformed = false;
            scaleX = Number(scaleX);
            scaleY = Number(scaleY);
            if (this.ready && !this.disabled && this.options.scalable) {
                if (isNumber(scaleX)) {
                    imageData.scaleX = scaleX;
                    transformed = true;
                }
                if (isNumber(scaleY)) {
                    imageData.scaleY = scaleY;
                    transformed = true;
                }
                if (transformed) this.renderCanvas(true, true);
            }
            return this;
        },
        /**
     * Get the cropped area position and size data (base on the original image)
     * @param {boolean} [rounded=false] - Indicate if round the data values or not.
     * @returns {Object} The result cropped data.
     */ getData: function getData() {
            var rounded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var options = this.options, imageData = this.imageData, canvasData = this.canvasData, cropBoxData = this.cropBoxData;
            var data;
            if (this.ready && this.cropped) {
                data = {
                    x: cropBoxData.left - canvasData.left,
                    y: cropBoxData.top - canvasData.top,
                    width: cropBoxData.width,
                    height: cropBoxData.height
                };
                var ratio = imageData.width / imageData.naturalWidth;
                forEach(data, function(n, i) {
                    data[i] = normalizeDecimalNumber(n / ratio);
                });
                if (rounded) {
                    // In case rounding off leads to extra 1px in right or bottom border
                    // we should round the top-left corner and the dimension (#343).
                    var bottom = Math.round(data.y + data.height);
                    var right = Math.round(data.x + data.width);
                    data.x = Math.round(data.x);
                    data.y = Math.round(data.y);
                    data.width = right - data.x;
                    data.height = bottom - data.y;
                }
            } else data = {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            };
            if (options.rotatable) data.rotate = imageData.rotate || 0;
            if (options.scalable) {
                data.scaleX = imageData.scaleX || 1;
                data.scaleY = imageData.scaleY || 1;
            }
            return data;
        },
        /**
     * Set the cropped area position and size with new data
     * @param {Object} data - The new data.
     * @returns {Cropper} this
     */ setData: function setData(data) {
            var options = this.options, imageData = this.imageData, canvasData = this.canvasData;
            var cropBoxData = {};
            if (this.ready && !this.disabled && isPlainObject(data)) {
                var transformed = false;
                if (options.rotatable) {
                    if (isNumber(data.rotate) && data.rotate !== imageData.rotate) {
                        imageData.rotate = data.rotate;
                        transformed = true;
                    }
                }
                if (options.scalable) {
                    if (isNumber(data.scaleX) && data.scaleX !== imageData.scaleX) {
                        imageData.scaleX = data.scaleX;
                        transformed = true;
                    }
                    if (isNumber(data.scaleY) && data.scaleY !== imageData.scaleY) {
                        imageData.scaleY = data.scaleY;
                        transformed = true;
                    }
                }
                if (transformed) this.renderCanvas(true, true);
                var ratio = imageData.width / imageData.naturalWidth;
                if (isNumber(data.x)) cropBoxData.left = data.x * ratio + canvasData.left;
                if (isNumber(data.y)) cropBoxData.top = data.y * ratio + canvasData.top;
                if (isNumber(data.width)) cropBoxData.width = data.width * ratio;
                if (isNumber(data.height)) cropBoxData.height = data.height * ratio;
                this.setCropBoxData(cropBoxData);
            }
            return this;
        },
        /**
     * Get the container size data.
     * @returns {Object} The result container data.
     */ getContainerData: function getContainerData() {
            return this.ready ? assign({}, this.containerData) : {};
        },
        /**
     * Get the image position and size data.
     * @returns {Object} The result image data.
     */ getImageData: function getImageData() {
            return this.sized ? assign({}, this.imageData) : {};
        },
        /**
     * Get the canvas position and size data.
     * @returns {Object} The result canvas data.
     */ getCanvasData: function getCanvasData() {
            var canvasData = this.canvasData;
            var data = {};
            if (this.ready) forEach([
                'left',
                'top',
                'width',
                'height',
                'naturalWidth',
                'naturalHeight'
            ], function(n) {
                data[n] = canvasData[n];
            });
            return data;
        },
        /**
     * Set the canvas position and size with new data.
     * @param {Object} data - The new canvas data.
     * @returns {Cropper} this
     */ setCanvasData: function setCanvasData(data) {
            var canvasData = this.canvasData;
            var aspectRatio = canvasData.aspectRatio;
            if (this.ready && !this.disabled && isPlainObject(data)) {
                if (isNumber(data.left)) canvasData.left = data.left;
                if (isNumber(data.top)) canvasData.top = data.top;
                if (isNumber(data.width)) {
                    canvasData.width = data.width;
                    canvasData.height = data.width / aspectRatio;
                } else if (isNumber(data.height)) {
                    canvasData.height = data.height;
                    canvasData.width = data.height * aspectRatio;
                }
                this.renderCanvas(true);
            }
            return this;
        },
        /**
     * Get the crop box position and size data.
     * @returns {Object} The result crop box data.
     */ getCropBoxData: function getCropBoxData() {
            var cropBoxData = this.cropBoxData;
            var data;
            if (this.ready && this.cropped) data = {
                left: cropBoxData.left,
                top: cropBoxData.top,
                width: cropBoxData.width,
                height: cropBoxData.height
            };
            return data || {};
        },
        /**
     * Set the crop box position and size with new data.
     * @param {Object} data - The new crop box data.
     * @returns {Cropper} this
     */ setCropBoxData: function setCropBoxData(data) {
            var cropBoxData = this.cropBoxData;
            var aspectRatio = this.options.aspectRatio;
            var widthChanged;
            var heightChanged;
            if (this.ready && this.cropped && !this.disabled && isPlainObject(data)) {
                if (isNumber(data.left)) cropBoxData.left = data.left;
                if (isNumber(data.top)) cropBoxData.top = data.top;
                if (isNumber(data.width) && data.width !== cropBoxData.width) {
                    widthChanged = true;
                    cropBoxData.width = data.width;
                }
                if (isNumber(data.height) && data.height !== cropBoxData.height) {
                    heightChanged = true;
                    cropBoxData.height = data.height;
                }
                if (aspectRatio) {
                    if (widthChanged) cropBoxData.height = cropBoxData.width / aspectRatio;
                    else if (heightChanged) cropBoxData.width = cropBoxData.height * aspectRatio;
                }
                this.renderCropBox();
            }
            return this;
        },
        /**
     * Get a canvas drawn the cropped image.
     * @param {Object} [options={}] - The config options.
     * @returns {HTMLCanvasElement} - The result canvas.
     */ getCroppedCanvas: function getCroppedCanvas() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (!this.ready || !window.HTMLCanvasElement) return null;
            var canvasData = this.canvasData;
            var source = getSourceCanvas(this.image, this.imageData, canvasData, options);
            // Returns the source canvas if it is not cropped.
            if (!this.cropped) return source;
            var _this$getData = this.getData(options.rounded), initialX = _this$getData.x, initialY = _this$getData.y, initialWidth = _this$getData.width, initialHeight = _this$getData.height;
            var ratio = source.width / Math.floor(canvasData.naturalWidth);
            if (ratio !== 1) {
                initialX *= ratio;
                initialY *= ratio;
                initialWidth *= ratio;
                initialHeight *= ratio;
            }
            var aspectRatio = initialWidth / initialHeight;
            var maxSizes = getAdjustedSizes({
                aspectRatio: aspectRatio,
                width: options.maxWidth || Infinity,
                height: options.maxHeight || Infinity
            });
            var minSizes = getAdjustedSizes({
                aspectRatio: aspectRatio,
                width: options.minWidth || 0,
                height: options.minHeight || 0
            }, 'cover');
            var _getAdjustedSizes = getAdjustedSizes({
                aspectRatio: aspectRatio,
                width: options.width || (ratio !== 1 ? source.width : initialWidth),
                height: options.height || (ratio !== 1 ? source.height : initialHeight)
            }), width = _getAdjustedSizes.width, height = _getAdjustedSizes.height;
            width = Math.min(maxSizes.width, Math.max(minSizes.width, width));
            height = Math.min(maxSizes.height, Math.max(minSizes.height, height));
            var canvas = document.createElement('canvas');
            var context = canvas.getContext('2d');
            canvas.width = normalizeDecimalNumber(width);
            canvas.height = normalizeDecimalNumber(height);
            context.fillStyle = options.fillColor || 'transparent';
            context.fillRect(0, 0, width, height);
            var _options$imageSmoothi = options.imageSmoothingEnabled, imageSmoothingEnabled = _options$imageSmoothi === void 0 ? true : _options$imageSmoothi, imageSmoothingQuality = options.imageSmoothingQuality;
            context.imageSmoothingEnabled = imageSmoothingEnabled;
            if (imageSmoothingQuality) context.imageSmoothingQuality = imageSmoothingQuality;
            if (isFunction(options.beforeDraw)) options.beforeDraw.call(this, context, canvas);
            // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D.drawImage
            var sourceWidth = source.width;
            var sourceHeight = source.height;
            // Source canvas parameters
            var srcX = initialX;
            var srcY = initialY;
            var srcWidth;
            var srcHeight;
            // Destination canvas parameters
            var dstX;
            var dstY;
            var dstWidth;
            var dstHeight;
            if (srcX <= -initialWidth || srcX > sourceWidth) {
                srcX = 0;
                srcWidth = 0;
                dstX = 0;
                dstWidth = 0;
            } else if (srcX <= 0) {
                dstX = -srcX;
                srcX = 0;
                srcWidth = Math.min(sourceWidth, initialWidth + srcX);
                dstWidth = srcWidth;
            } else if (srcX <= sourceWidth) {
                dstX = 0;
                srcWidth = Math.min(initialWidth, sourceWidth - srcX);
                dstWidth = srcWidth;
            }
            if (srcWidth <= 0 || srcY <= -initialHeight || srcY > sourceHeight) {
                srcY = 0;
                srcHeight = 0;
                dstY = 0;
                dstHeight = 0;
            } else if (srcY <= 0) {
                dstY = -srcY;
                srcY = 0;
                srcHeight = Math.min(sourceHeight, initialHeight + srcY);
                dstHeight = srcHeight;
            } else if (srcY <= sourceHeight) {
                dstY = 0;
                srcHeight = Math.min(initialHeight, sourceHeight - srcY);
                dstHeight = srcHeight;
            }
            var params = [
                srcX,
                srcY,
                srcWidth,
                srcHeight
            ];
            // Avoid "IndexSizeError"
            if (dstWidth > 0 && dstHeight > 0) {
                var scale = width / initialWidth;
                params.push(dstX * scale, dstY * scale, dstWidth * scale, dstHeight * scale);
            }
            // All the numerical parameters should be integer for `drawImage`
            // https://github.com/fengyuanchen/cropper/issues/476
            context.drawImage.apply(context, [
                source
            ].concat(_toConsumableArray(params.map(function(param) {
                return Math.floor(normalizeDecimalNumber(param));
            }))));
            if (this.options.borderRadius) {
                context.globalCompositeOperation = 'destination-in';
                context.fillStyle = '#000';
                drawRoundedRect(context, width, height, this.options.borderRadius, width / this.cropBoxData.width);
            }
            return canvas;
        },
        /**
     * Change the aspect ratio of the crop box.
     * @param {number} aspectRatio - The new aspect ratio.
     * @returns {Cropper} this
     */ setAspectRatio: function setAspectRatio(aspectRatio) {
            var options = this.options;
            if (!this.disabled && !isUndefined(aspectRatio)) {
                // 0 -> NaN
                options.aspectRatio = Math.max(0, aspectRatio) || NaN;
                if (this.ready) {
                    this.initCropBox();
                    if (this.cropped) this.renderCropBox();
                }
            }
            return this;
        },
        /**
     * Change the drag mode.
     * @param {string} mode - The new drag mode.
     * @returns {Cropper} this
     */ setDragMode: function setDragMode(mode) {
            var options = this.options, dragBox = this.dragBox, face = this.face;
            if (this.ready && !this.disabled) {
                var croppable = mode === DRAG_MODE_CROP;
                var movable = options.movable && mode === DRAG_MODE_MOVE;
                mode = croppable || movable ? mode : DRAG_MODE_NONE;
                options.dragMode = mode;
                setData(dragBox, DATA_ACTION, mode);
                toggleClass(dragBox, CLASS_CROP, croppable);
                toggleClass(dragBox, CLASS_MOVE, movable);
                if (!options.cropBoxMovable) {
                    // Sync drag mode to crop box when it is not movable
                    setData(face, DATA_ACTION, mode);
                    toggleClass(face, CLASS_CROP, croppable);
                    toggleClass(face, CLASS_MOVE, movable);
                }
            }
            return this;
        }
    };
    var handlers = {
        resize: function resize() {
            if (this.disabled) return;
            var options = this.options, container = this.container, containerData = this.containerData;
            var ratioX = container.offsetWidth / containerData.width;
            var ratioY = container.offsetHeight / containerData.height;
            var ratio = Math.abs(ratioX - 1) > Math.abs(ratioY - 1) ? ratioX : ratioY;
            // Resize when width changed or height changed
            if (ratio !== 1) {
                var canvasData;
                var cropBoxData;
                if (options.restore) {
                    canvasData = this.getCanvasData();
                    cropBoxData = this.getCropBoxData();
                }
                this.render();
                if (options.restore) {
                    this.setCanvasData(forEach(canvasData, function(n, i) {
                        canvasData[i] = n * ratio;
                    }));
                    this.setCropBoxData(forEach(cropBoxData, function(n, i) {
                        cropBoxData[i] = n * ratio;
                    }));
                }
            }
        },
        dblclick: function dblclick() {
            if (this.disabled || this.options.dragMode === DRAG_MODE_NONE) return;
            this.setDragMode(hasClass(this.dragBox, CLASS_CROP) ? DRAG_MODE_MOVE : DRAG_MODE_CROP);
        },
        wheel: function wheel(event) {
            var _this = this;
            var ratio = Number(this.options.wheelZoomRatio) || 0.1;
            var delta = 1;
            if (this.disabled) return;
            event.preventDefault();
            // Limit wheel speed to prevent zoom too fast (#21)
            if (this.wheeling) return;
            this.wheeling = true;
            setTimeout(function() {
                _this.wheeling = false;
            }, 50);
            if (event.deltaY) delta = event.deltaY > 0 ? 1 : -1;
            else if (event.wheelDelta) delta = -event.wheelDelta / 120;
            else if (event.detail) delta = event.detail > 0 ? 1 : -1;
            zoomWithEvent.call(this, -delta * ratio, event);
        },
        cropStart: function cropStart(event) {
            var buttons = event.buttons, button = event.button;
            if (this.disabled || (event.type === 'mousedown' || event.type === 'pointerdown' && event.pointerType === 'mouse') && // No primary button (Usually the left button)
            (isNumber(buttons) && buttons !== 1 || isNumber(button) && button !== 0 || event.ctrlKey)) return;
            var options = this.options, pointers = this.pointers;
            var action;
            if (event.changedTouches) // Handle touch event
            forEach(event.changedTouches, function(touch) {
                pointers[touch.identifier] = getPointer(touch);
            });
            else // Handle mouse event and pointer event
            pointers[event.pointerId || 0] = getPointer(event);
            if (Object.keys(pointers).length > 1 && options.zoomable && options.zoomOnTouch) action = ACTION_ZOOM;
            else action = getData(event.target, DATA_ACTION);
            if (!REGEXP_ACTIONS.test(action)) return;
            if (dispatchEvent(this.element, EVENT_CROP_START, {
                originalEvent: event,
                action: action
            }) === false) return;
            // This line is required for preventing page zooming in iOS browsers
            event.preventDefault();
            this.action = action;
            this.cropping = false;
            this.cropBoxDragStartData = null;
            this.cropBoxDragStartAction = options.cropBoxMoveMode === 'dragStart' && action !== ACTION_CROP && action !== ACTION_MOVE && action !== ACTION_ZOOM ? action : '';
            if (action === ACTION_CROP) {
                this.cropping = true;
                addClass(this.dragBox, CLASS_MODAL);
            }
        },
        cropMove: function cropMove(event) {
            var action = this.action;
            if (this.disabled || !action) return;
            var pointers = this.pointers;
            event.preventDefault();
            if (dispatchEvent(this.element, EVENT_CROP_MOVE, {
                originalEvent: event,
                action: action
            }) === false) return;
            if (event.changedTouches) forEach(event.changedTouches, function(touch) {
                // The first parameter should not be undefined (#432)
                assign(pointers[touch.identifier] || {}, getPointer(touch, true));
            });
            else assign(pointers[event.pointerId || 0] || {}, getPointer(event, true));
            this.change(event);
        },
        cropEnd: function cropEnd(event) {
            if (this.disabled) return;
            var action = this.action, pointers = this.pointers;
            if (event.type === EVENT_BLUR) Object.keys(pointers).forEach(function(pointerId) {
                delete pointers[pointerId];
            });
            else if (event.changedTouches) forEach(event.changedTouches, function(touch) {
                delete pointers[touch.identifier];
            });
            else delete pointers[event.pointerId || 0];
            if (!action) return;
            event.preventDefault();
            if (!Object.keys(pointers).length) {
                this.action = '';
                this.cropBoxDragStartData = null;
                this.cropBoxDragStartAction = '';
            }
            if (this.cropping) {
                this.cropping = false;
                toggleClass(this.dragBox, CLASS_MODAL, this.cropped && this.options.modal);
            }
            dispatchEvent(this.element, EVENT_CROP_END, {
                originalEvent: event,
                action: action
            });
        }
    };
    function resizeCropBoxFromCenter(action, range, aspectRatio, cropBoxData, bounds) {
        var centerX = cropBoxData.left + cropBoxData.width / 2;
        var centerY = cropBoxData.top + cropBoxData.height / 2;
        var isEast = action === ACTION_EAST || action === ACTION_NORTH_EAST || action === ACTION_SOUTH_EAST;
        var isSouth = action === ACTION_SOUTH || action === ACTION_SOUTH_EAST || action === ACTION_SOUTH_WEST;
        var isHorizontal = action === ACTION_EAST || action === ACTION_WEST;
        var isVertical = action === ACTION_NORTH || action === ACTION_SOUTH;
        var width = cropBoxData.width, height = cropBoxData.height;
        if (aspectRatio) {
            if (isHorizontal || !isVertical && isSouth) {
                width += (isEast ? 2 : -2) * range.x;
                height = width / aspectRatio;
            } else {
                height += (isSouth ? 2 : -2) * range.y;
                width = height * aspectRatio;
            }
        } else {
            width += (isEast ? 2 : -2) * range.x;
            height += (isSouth ? 2 : -2) * range.y;
        }
        if (width < 0) {
            width = -width;
            if (!aspectRatio || isHorizontal || !isVertical && isSouth) isEast = !isEast;
        }
        if (height < 0) {
            height = -height;
            if (!aspectRatio || isVertical || !isVertical && !isSouth) isSouth = !isSouth;
        }
        var maxWidth = Math.max(0, 2 * Math.min(centerX - bounds.minLeft, bounds.maxWidth - centerX));
        var maxHeight = Math.max(0, 2 * Math.min(centerY - bounds.minTop, bounds.maxHeight - centerY));
        var minWidth = Math.min(cropBoxData.minWidth, maxWidth);
        var minHeight = Math.min(cropBoxData.minHeight, maxHeight);
        if (aspectRatio) {
            var minScale = Math.max(width ? minWidth / width : 0, height ? minHeight / height : 0, 1);
            var maxScale = Math.min(width ? maxWidth / width : 0, height ? maxHeight / height : 0);
            var scale = Math.min(minScale, maxScale);
            width *= scale;
            height *= scale;
        } else {
            width = Math.min(Math.max(width, minWidth), maxWidth);
            height = Math.min(Math.max(height, minHeight), maxHeight);
        }
        if (isEast) action = isSouth ? ACTION_SOUTH_EAST : ACTION_NORTH_EAST;
        else action = isSouth ? ACTION_SOUTH_WEST : ACTION_NORTH_WEST;
        if (isHorizontal) action = isEast ? ACTION_EAST : ACTION_WEST;
        else if (isVertical) action = isSouth ? ACTION_SOUTH : ACTION_NORTH;
        return {
            action: action,
            left: centerX - width / 2,
            top: centerY - height / 2,
            width: width,
            height: height
        };
    }
    var change = {
        change: function change(event) {
            var options = this.options, canvasData = this.canvasData, containerData = this.containerData, cropBoxData = this.cropBoxData, pointers = this.pointers;
            var action = this.action;
            var aspectRatio = options.aspectRatio;
            var left = cropBoxData.left, top = cropBoxData.top, width = cropBoxData.width, height = cropBoxData.height;
            var right = left + width;
            var bottom = top + height;
            var minLeft = 0;
            var minTop = 0;
            var maxWidth = containerData.width;
            var maxHeight = containerData.height;
            var renderable = true;
            var offset;
            // Locking aspect ratio in "free mode" by holding shift key
            if (!aspectRatio && event.shiftKey) aspectRatio = width && height ? width / height : 1;
            if (this.limited) {
                minLeft = cropBoxData.minLeft;
                minTop = cropBoxData.minTop;
                maxWidth = minLeft + Math.min(containerData.width, canvasData.width, canvasData.left + canvasData.width);
                maxHeight = minTop + Math.min(containerData.height, canvasData.height, canvasData.top + canvasData.height);
            }
            var pointer = pointers[Object.keys(pointers)[0]];
            var isCropBoxDrag = options.cropBoxMoveMode === 'dragStart' && this.cropBoxDragStartAction && [
                ACTION_ALL,
                ACTION_EAST,
                ACTION_NORTH,
                ACTION_SOUTH,
                ACTION_WEST,
                ACTION_NORTH_EAST,
                ACTION_NORTH_WEST,
                ACTION_SOUTH_EAST,
                ACTION_SOUTH_WEST
            ].includes(action);
            if (isCropBoxDrag) {
                if (!this.cropBoxDragStartData) this.cropBoxDragStartData = _objectSpread2({}, cropBoxData);
                Object.assign(cropBoxData, this.cropBoxDragStartData);
                left = cropBoxData.left;
                top = cropBoxData.top;
                width = cropBoxData.width;
                height = cropBoxData.height;
                right = left + width;
                bottom = top + height;
                action = this.cropBoxDragStartAction;
            }
            var range = {
                x: pointer.endX - pointer.startX,
                y: pointer.endY - pointer.startY
            };
            if (options.cropBoxResizeAroundCenter && [
                ACTION_EAST,
                ACTION_NORTH,
                ACTION_SOUTH,
                ACTION_WEST,
                ACTION_NORTH_EAST,
                ACTION_NORTH_WEST,
                ACTION_SOUTH_EAST,
                ACTION_SOUTH_WEST
            ].includes(action)) {
                var cropBox = resizeCropBoxFromCenter(action, range, aspectRatio, cropBoxData, {
                    minLeft: minLeft,
                    minTop: minTop,
                    maxWidth: maxWidth,
                    maxHeight: maxHeight
                });
                cropBoxData.left = cropBox.left;
                cropBoxData.top = cropBox.top;
                cropBoxData.width = cropBox.width;
                cropBoxData.height = cropBox.height;
                this.action = cropBox.action;
                this.renderCropBox();
                if (!isCropBoxDrag) forEach(pointers, function(p) {
                    p.startX = p.endX;
                    p.startY = p.endY;
                });
                return;
            }
            var check = function check(side) {
                switch(side){
                    case ACTION_EAST:
                        if (right + range.x > maxWidth) range.x = maxWidth - right;
                        break;
                    case ACTION_WEST:
                        if (left + range.x < minLeft) range.x = minLeft - left;
                        break;
                    case ACTION_NORTH:
                        if (top + range.y < minTop) range.y = minTop - top;
                        break;
                    case ACTION_SOUTH:
                        if (bottom + range.y > maxHeight) range.y = maxHeight - bottom;
                        break;
                }
            };
            switch(action){
                // Move crop box
                case ACTION_ALL:
                    left += range.x;
                    top += range.y;
                    break;
                // Resize crop box
                case ACTION_EAST:
                    if (range.x >= 0 && (right >= maxWidth || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
                        renderable = false;
                        break;
                    }
                    check(ACTION_EAST);
                    width += range.x;
                    if (width < 0) {
                        action = ACTION_WEST;
                        width = -width;
                        left -= width;
                        if (width < cropBoxData.minWidth) {
                            width = cropBoxData.minWidth;
                            left = cropBoxData.left - width;
                        }
                    }
                    if (aspectRatio) {
                        height = width / aspectRatio;
                        top += (cropBoxData.height - height) / 2;
                    }
                    break;
                case ACTION_NORTH:
                    if (range.y <= 0 && (top <= minTop || aspectRatio && (left <= minLeft || right >= maxWidth))) {
                        renderable = false;
                        break;
                    }
                    check(ACTION_NORTH);
                    height -= range.y;
                    top += range.y;
                    if (height < 0) {
                        action = ACTION_SOUTH;
                        height = -height;
                        top -= height;
                        if (height < cropBoxData.minHeight) {
                            height = cropBoxData.minHeight;
                            top = bottom;
                        }
                    }
                    if (aspectRatio) {
                        width = height * aspectRatio;
                        left += (cropBoxData.width - width) / 2;
                    }
                    break;
                case ACTION_WEST:
                    if (range.x <= 0 && (left <= minLeft || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
                        renderable = false;
                        break;
                    }
                    check(ACTION_WEST);
                    width -= range.x;
                    left += range.x;
                    if (width < 0) {
                        action = ACTION_EAST;
                        width = -width;
                        left -= width;
                        if (width < cropBoxData.minWidth) {
                            width = cropBoxData.minWidth;
                            left = right;
                        }
                    }
                    if (aspectRatio) {
                        height = width / aspectRatio;
                        top += (cropBoxData.height - height) / 2;
                    }
                    break;
                case ACTION_SOUTH:
                    if (range.y >= 0 && (bottom >= maxHeight || aspectRatio && (left <= minLeft || right >= maxWidth))) {
                        renderable = false;
                        break;
                    }
                    check(ACTION_SOUTH);
                    height += range.y;
                    if (height < 0) {
                        action = ACTION_NORTH;
                        height = -height;
                        top -= height;
                        if (height < cropBoxData.minHeight) {
                            height = cropBoxData.minHeight;
                            top = cropBoxData.top - height;
                        }
                    }
                    if (aspectRatio) {
                        width = height * aspectRatio;
                        left += (cropBoxData.width - width) / 2;
                    }
                    break;
                case ACTION_NORTH_EAST:
                    if (aspectRatio) {
                        if (range.y <= 0 && (top <= minTop || right >= maxWidth)) {
                            renderable = false;
                            break;
                        }
                        check(ACTION_NORTH);
                        height -= range.y;
                        top += range.y;
                        width = height * aspectRatio;
                    } else {
                        check(ACTION_NORTH);
                        check(ACTION_EAST);
                        if (range.x >= 0) {
                            if (right < maxWidth) width += range.x;
                            else if (range.y <= 0 && top <= minTop) renderable = false;
                        } else width += range.x;
                        if (range.y <= 0) {
                            if (top > minTop) {
                                height -= range.y;
                                top += range.y;
                            }
                        } else {
                            height -= range.y;
                            top += range.y;
                        }
                    }
                    if (width < 0 && height < 0) {
                        action = ACTION_SOUTH_WEST;
                        height = -height;
                        width = -width;
                        top -= height;
                        left -= width;
                    } else if (width < 0) {
                        action = ACTION_NORTH_WEST;
                        width = -width;
                        left -= width;
                    } else if (height < 0) {
                        action = ACTION_SOUTH_EAST;
                        height = -height;
                        top -= height;
                    }
                    break;
                case ACTION_NORTH_WEST:
                    if (aspectRatio) {
                        if (range.y <= 0 && (top <= minTop || left <= minLeft)) {
                            renderable = false;
                            break;
                        }
                        check(ACTION_NORTH);
                        height -= range.y;
                        top += range.y;
                        width = height * aspectRatio;
                        left += cropBoxData.width - width;
                    } else {
                        check(ACTION_NORTH);
                        check(ACTION_WEST);
                        if (range.x <= 0) {
                            if (left > minLeft) {
                                width -= range.x;
                                left += range.x;
                            } else if (range.y <= 0 && top <= minTop) renderable = false;
                        } else {
                            width -= range.x;
                            left += range.x;
                        }
                        if (range.y <= 0) {
                            if (top > minTop) {
                                height -= range.y;
                                top += range.y;
                            }
                        } else {
                            height -= range.y;
                            top += range.y;
                        }
                    }
                    if (width < 0 && height < 0) {
                        action = ACTION_SOUTH_EAST;
                        height = -height;
                        width = -width;
                        top -= height;
                        left -= width;
                    } else if (width < 0) {
                        action = ACTION_NORTH_EAST;
                        width = -width;
                        left -= width;
                    } else if (height < 0) {
                        action = ACTION_SOUTH_WEST;
                        height = -height;
                        top -= height;
                    }
                    break;
                case ACTION_SOUTH_WEST:
                    if (aspectRatio) {
                        if (range.x <= 0 && (left <= minLeft || bottom >= maxHeight)) {
                            renderable = false;
                            break;
                        }
                        check(ACTION_WEST);
                        width -= range.x;
                        left += range.x;
                        height = width / aspectRatio;
                    } else {
                        check(ACTION_SOUTH);
                        check(ACTION_WEST);
                        if (range.x <= 0) {
                            if (left > minLeft) {
                                width -= range.x;
                                left += range.x;
                            } else if (range.y >= 0 && bottom >= maxHeight) renderable = false;
                        } else {
                            width -= range.x;
                            left += range.x;
                        }
                        if (range.y >= 0) {
                            if (bottom < maxHeight) height += range.y;
                        } else height += range.y;
                    }
                    if (width < 0 && height < 0) {
                        action = ACTION_NORTH_EAST;
                        height = -height;
                        width = -width;
                        top -= height;
                        left -= width;
                    } else if (width < 0) {
                        action = ACTION_SOUTH_EAST;
                        width = -width;
                        left -= width;
                    } else if (height < 0) {
                        action = ACTION_NORTH_WEST;
                        height = -height;
                        top -= height;
                    }
                    break;
                case ACTION_SOUTH_EAST:
                    if (aspectRatio) {
                        if (range.x >= 0 && (right >= maxWidth || bottom >= maxHeight)) {
                            renderable = false;
                            break;
                        }
                        check(ACTION_EAST);
                        width += range.x;
                        height = width / aspectRatio;
                    } else {
                        check(ACTION_SOUTH);
                        check(ACTION_EAST);
                        if (range.x >= 0) {
                            if (right < maxWidth) width += range.x;
                            else if (range.y >= 0 && bottom >= maxHeight) renderable = false;
                        } else width += range.x;
                        if (range.y >= 0) {
                            if (bottom < maxHeight) height += range.y;
                        } else height += range.y;
                    }
                    if (width < 0 && height < 0) {
                        action = ACTION_NORTH_WEST;
                        height = -height;
                        width = -width;
                        top -= height;
                        left -= width;
                    } else if (width < 0) {
                        action = ACTION_SOUTH_WEST;
                        width = -width;
                        left -= width;
                    } else if (height < 0) {
                        action = ACTION_NORTH_EAST;
                        height = -height;
                        top -= height;
                    }
                    break;
                // Move canvas
                case ACTION_MOVE:
                    this.move(range.x, range.y);
                    renderable = false;
                    break;
                // Zoom canvas
                case ACTION_ZOOM:
                    zoomWithEvent.call(this, getMaxZoomRatio(pointers), event);
                    renderable = false;
                    break;
                // Create crop box
                case ACTION_CROP:
                    if (!range.x || !range.y) {
                        renderable = false;
                        break;
                    }
                    offset = getOffset(this.cropper);
                    left = pointer.startX - offset.left;
                    top = pointer.startY - offset.top;
                    if (aspectRatio) {
                        width = Math.max(Math.abs(range.x), Math.abs(range.y) * aspectRatio, cropBoxData.minWidth, cropBoxData.minHeight * aspectRatio);
                        height = width / aspectRatio;
                    } else {
                        width = Math.max(Math.abs(range.x), cropBoxData.minWidth);
                        height = Math.max(Math.abs(range.y), cropBoxData.minHeight);
                    }
                    if (range.x > 0) action = range.y > 0 ? ACTION_SOUTH_EAST : ACTION_NORTH_EAST;
                    else if (range.x < 0) {
                        left -= width;
                        action = range.y > 0 ? ACTION_SOUTH_WEST : ACTION_NORTH_WEST;
                    }
                    if (range.y < 0) top -= height;
                    // Show the crop box if is hidden
                    if (!this.cropped) {
                        removeClass(this.cropBox, CLASS_HIDDEN);
                        this.cropped = true;
                        if (this.limited) this.limitCropBox(true, true);
                    }
                    break;
            }
            if (renderable) {
                cropBoxData.width = width;
                cropBoxData.height = height;
                cropBoxData.left = left;
                cropBoxData.top = top;
                this.action = action;
                this.renderCropBox();
            }
            // Override
            forEach(pointers, function(p) {
                if (action !== ACTION_CROP && !isCropBoxDrag) {
                    p.startX = p.endX;
                    p.startY = p.endY;
                }
            });
        }
    };
    var AnotherCropper = WINDOW.Cropper;
    var Cropper = /*#__PURE__*/ function() {
        /**
     * Create a new Cropper.
     * @param {Element} element - The target image or canvas element to crop.
     * @param {Object} [options={}] - The configuration options.
     */ function Cropper(element) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            _classCallCheck(this, Cropper);
            if (!element || !REGEXP_TAG_NAME.test(element.tagName)) throw new Error('The first argument is required and must be an <img> or <canvas> element.');
            this.element = element;
            this.options = assign({}, DEFAULTS, isPlainObject(options) && options);
            this.cropped = false;
            this.disabled = false;
            this.pointers = {};
            this.ready = false;
            this.reloading = false;
            this.replaced = false;
            this.sized = false;
            this.sizing = false;
            this.init();
        }
        return _createClass(Cropper, [
            {
                key: "init",
                value: function init() {
                    var element = this.element;
                    var tagName = element.tagName.toLowerCase();
                    var url;
                    if (element[NAMESPACE]) return;
                    element[NAMESPACE] = this;
                    if (tagName === 'img') {
                        this.isImg = true;
                        // e.g.: "img/picture.jpg"
                        url = element.getAttribute('src') || '';
                        this.originalUrl = url;
                        // Stop when it's a blank image
                        if (!url) return;
                        // e.g.: "https://example.com/img/picture.jpg"
                        url = element.src;
                    } else if (tagName === 'canvas' && window.HTMLCanvasElement) url = element.toDataURL();
                    this.load(url);
                }
            },
            {
                key: "load",
                value: function load(url) {
                    var _this = this;
                    if (!url) return;
                    this.url = url;
                    this.imageData = {};
                    var element = this.element, options = this.options;
                    if (!options.rotatable && !options.scalable) options.checkOrientation = false;
                    // Only IE10+ supports Typed Arrays
                    if (!options.checkOrientation || !window.ArrayBuffer) {
                        this.clone();
                        return;
                    }
                    // Detect the mime type of the image directly if it is a Data URL
                    if (REGEXP_DATA_URL.test(url)) {
                        // Read ArrayBuffer from Data URL of JPEG images directly for better performance
                        if (REGEXP_DATA_URL_JPEG.test(url)) this.read(dataURLToArrayBuffer(url));
                        else // Only a JPEG image may contain Exif Orientation information,
                        // the rest types of Data URLs are not necessary to check orientation at all.
                        this.clone();
                        return;
                    }
                    // 1. Detect the mime type of the image by a XMLHttpRequest.
                    // 2. Load the image as ArrayBuffer for reading orientation if its a JPEG image.
                    var xhr = new XMLHttpRequest();
                    var clone = this.clone.bind(this);
                    this.reloading = true;
                    this.xhr = xhr;
                    // 1. Cross origin requests are only supported for protocol schemes:
                    // http, https, data, chrome, chrome-extension.
                    // 2. Access to XMLHttpRequest from a Data URL will be blocked by CORS policy
                    // in some browsers as IE11 and Safari.
                    xhr.onabort = clone;
                    xhr.onerror = clone;
                    xhr.ontimeout = clone;
                    xhr.onprogress = function() {
                        // Abort the request directly if it not a JPEG image for better performance
                        if (xhr.getResponseHeader('content-type') !== MIME_TYPE_JPEG) xhr.abort();
                    };
                    xhr.onload = function() {
                        _this.read(xhr.response);
                    };
                    xhr.onloadend = function() {
                        _this.reloading = false;
                        _this.xhr = null;
                    };
                    // Bust cache when there is a "crossOrigin" property to avoid browser cache error
                    if (options.checkCrossOrigin && isCrossOriginURL(url) && element.crossOrigin) url = addTimestamp(url);
                    // The third parameter is required for avoiding side-effect (#682)
                    xhr.open('GET', url, true);
                    xhr.responseType = 'arraybuffer';
                    xhr.withCredentials = element.crossOrigin === 'use-credentials';
                    xhr.send();
                }
            },
            {
                key: "read",
                value: function read(arrayBuffer) {
                    var options = this.options, imageData = this.imageData;
                    // Reset the orientation value to its default value 1
                    // as some iOS browsers will render image with its orientation
                    var orientation = resetAndGetOrientation(arrayBuffer);
                    var rotate = 0;
                    var scaleX = 1;
                    var scaleY = 1;
                    if (orientation > 1) {
                        // Generate a new URL which has the default orientation value
                        this.url = arrayBufferToDataURL(arrayBuffer, MIME_TYPE_JPEG);
                        var _parseOrientation = parseOrientation(orientation);
                        rotate = _parseOrientation.rotate;
                        scaleX = _parseOrientation.scaleX;
                        scaleY = _parseOrientation.scaleY;
                    }
                    if (options.rotatable) imageData.rotate = rotate;
                    if (options.scalable) {
                        imageData.scaleX = scaleX;
                        imageData.scaleY = scaleY;
                    }
                    this.clone();
                }
            },
            {
                key: "clone",
                value: function clone() {
                    var _this2 = this;
                    var element = this.element, options = this.options, url = this.url;
                    var crossOrigin = element.crossOrigin;
                    var crossOriginUrl = url;
                    if (this.options.checkCrossOrigin && isCrossOriginURL(url)) {
                        if (!crossOrigin) crossOrigin = 'anonymous';
                        // Bust cache when there is not a "crossOrigin" property (#519)
                        crossOriginUrl = addTimestamp(url);
                    }
                    this.crossOrigin = crossOrigin;
                    this.crossOriginUrl = crossOriginUrl;
                    var image = document.createElement('img');
                    if (crossOrigin) image.crossOrigin = crossOrigin;
                    image.src = crossOriginUrl || url;
                    image.alt = element.alt || 'The image to crop';
                    this.image = image;
                    image.onload = this.start.bind(this);
                    if (isFunction(options.error)) addListener(element, EVENT_ERROR, options.error, {
                        once: true
                    });
                    image.onerror = function(error) {
                        dispatchEvent(element, EVENT_ERROR, error);
                        _this2.stop();
                    };
                    addClass(image, CLASS_HIDE);
                    element.parentNode.insertBefore(image, element.nextSibling);
                }
            },
            {
                key: "start",
                value: function start() {
                    var _this3 = this;
                    var image = this.image;
                    image.onload = null;
                    image.onerror = null;
                    this.sizing = true;
                    // Match all browsers that use WebKit as the layout engine in iOS devices,
                    // such as Safari for iOS, Chrome for iOS, and in-app browsers.
                    var isIOSWebKit = WINDOW.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(WINDOW.navigator.userAgent);
                    var done = function done(naturalWidth, naturalHeight) {
                        assign(_this3.imageData, {
                            naturalWidth: naturalWidth,
                            naturalHeight: naturalHeight,
                            aspectRatio: naturalWidth / naturalHeight
                        });
                        _this3.initialImageData = assign({}, _this3.imageData);
                        _this3.sizing = false;
                        _this3.sized = true;
                        _this3.build();
                    };
                    var sizingImage = document.createElement('img');
                    var body = document.body || document.documentElement;
                    this.sizingImage = sizingImage;
                    sizingImage.onload = function() {
                        done(sizingImage.width, sizingImage.height);
                        if (!isIOSWebKit) body.removeChild(sizingImage);
                    };
                    sizingImage.src = image.src;
                    // iOS WebKit will convert the image automatically
                    // with its orientation once append it into DOM (#279)
                    if (!isIOSWebKit) {
                        sizingImage.style.cssText = "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;image-orientation:0deg;position:absolute;top:0;z-index:-1;";
                        body.appendChild(sizingImage);
                    }
                }
            },
            {
                key: "stop",
                value: function stop() {
                    var image = this.image;
                    image.onload = null;
                    image.onerror = null;
                    image.parentNode.removeChild(image);
                    this.image = null;
                }
            },
            {
                key: "build",
                value: function build() {
                    if (!this.sized || this.ready) return;
                    var element = this.element, options = this.options, image = this.image;
                    // Create cropper elements
                    var container = element.parentNode;
                    var template = document.createElement('div');
                    template.innerHTML = TEMPLATE;
                    var cropper = template.querySelector(".".concat(NAMESPACE, "-container"));
                    var canvas = cropper.querySelector(".".concat(NAMESPACE, "-canvas"));
                    var dragBox = cropper.querySelector(".".concat(NAMESPACE, "-drag-box"));
                    var cropBox = cropper.querySelector(".".concat(NAMESPACE, "-crop-box"));
                    var face = cropBox.querySelector(".".concat(NAMESPACE, "-face"));
                    this.container = container;
                    this.cropper = cropper;
                    this.canvas = canvas;
                    this.dragBox = dragBox;
                    this.cropBox = cropBox;
                    this.viewBox = cropper.querySelector(".".concat(NAMESPACE, "-view-box"));
                    this.face = face;
                    canvas.appendChild(image);
                    // Hide the original image
                    addClass(element, CLASS_HIDDEN);
                    // Inserts the cropper after to the current image
                    container.insertBefore(cropper, element.nextSibling);
                    // Show the hidden image
                    removeClass(image, CLASS_HIDE);
                    this.initPreview();
                    this.bind();
                    options.initialAspectRatio = Math.max(0, options.initialAspectRatio) || NaN;
                    options.aspectRatio = Math.max(0, options.aspectRatio) || NaN;
                    options.viewMode = Math.max(0, Math.min(3, Math.round(options.viewMode))) || 0;
                    addClass(cropBox, CLASS_HIDDEN);
                    if (!options.guides) addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-dashed")), CLASS_HIDDEN);
                    if (!options.center) addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-center")), CLASS_HIDDEN);
                    if (options.background) addClass(cropper, "".concat(NAMESPACE, "-bg"));
                    if (!options.highlight) addClass(face, CLASS_INVISIBLE);
                    if (options.cropBoxMovable) {
                        addClass(face, CLASS_MOVE);
                        setData(face, DATA_ACTION, ACTION_ALL);
                    }
                    if (!options.cropBoxResizable) {
                        addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-line")), CLASS_HIDDEN);
                        addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-point")), CLASS_HIDDEN);
                    }
                    this.render();
                    this.ready = true;
                    this.setDragMode(options.dragMode);
                    if (options.autoCrop) this.crop();
                    this.setData(options.data);
                    if (isFunction(options.ready)) addListener(element, EVENT_READY, options.ready, {
                        once: true
                    });
                    dispatchEvent(element, EVENT_READY);
                }
            },
            {
                key: "unbuild",
                value: function unbuild() {
                    if (!this.ready) return;
                    this.ready = false;
                    this.unbind();
                    this.resetPreview();
                    var parentNode = this.cropper.parentNode;
                    if (parentNode) parentNode.removeChild(this.cropper);
                    removeClass(this.element, CLASS_HIDDEN);
                }
            },
            {
                key: "uncreate",
                value: function uncreate() {
                    if (this.ready) {
                        this.unbuild();
                        this.ready = false;
                        this.cropped = false;
                    } else if (this.sizing) {
                        this.sizingImage.onload = null;
                        this.sizing = false;
                        this.sized = false;
                    } else if (this.reloading) {
                        this.xhr.onabort = null;
                        this.xhr.abort();
                    } else if (this.image) this.stop();
                }
            }
        ], [
            {
                key: "create",
                value: function create(element, options) {
                    return new Cropper(element, options);
                }
            },
            {
                key: "setDefaults",
                value: function setDefaults(options) {
                    assign(DEFAULTS, isPlainObject(options) && options);
                }
            },
            {
                key: "noConflict",
                value: function noConflict() {
                    window.Cropper = AnotherCropper;
                    return Cropper;
                }
            }
        ]);
    }();
    assign(Cropper.prototype, render, preview, events, handlers, change, methods);
    return Cropper;
});


const $b79b362cd19a3d19$var$CROPPED_SIZE = 300;
class $b79b362cd19a3d19$export$2e2bcd8739ae039 extends (0, $1e1b4d625d583414$export$bd0bf19f25da8474) {
    static{
        this.targets = [
            "blob",
            "crop",
            "file",
            "input",
            "name",
            "preview",
            "sheet"
        ];
    }
    static{
        /** The "Photo chosen {0}" sentence, so the browser says it the way the server would have. */ this.values = {
            chosen: String
        };
    }
    /*
   * No `this.x = this.x.bind(this)` here any more. Every one of these is reached through a
   * `data-action` attribute, and Stimulus invokes the method on the controller, so the bindings
   * were rebuilding five functions on every connect to no effect.
   */ connect() {
        this.initialSource = this.cropTarget.src;
    }
    disconnect() {
        this.cropper?.destroy();
        this.cropper = undefined;
    }
    /* Every way out of the sheet ends here, because `close` is what Cancel, Escape, a click on the
     backdrop and a pull downwards all raise. Tearing the cropper down in Cancel's own handler
     instead would leave it alive behind the other three. */ onSheetClose() {
        this.resetCropper();
        this.fileTarget.hidden = true;
        this.nameTarget.textContent = "";
    }
    initCropper(image) {
        this.cropTarget.src = image;
        this.cropper = new (0, (/*@__PURE__*/$parcel$interopDefault($18c4fa6e0dd314b9$exports)))(this.cropTarget, {
            aspectRatio: 1
        });
    }
    resetCropper() {
        this.cropTarget.src = this.initialSource;
        this.cropper?.destroy();
        this.cropper = undefined;
    }
    openSheet() {
        this.sheetTarget.showModal();
    }
    onChange() {
        /* `find` then `?.` rather than `find(...).files[0]`: with no file chosen `find` answers
           undefined, and the old chain read a property straight off it and threw. */ const file = this.inputTargets.map((it)=>it.files?.[0]).find((it)=>it !== undefined);
        if (file === undefined) return;
        this.nameTarget.textContent = this.chosenValue ? this.chosenValue.replace("{0}", file.name) : file.name;
        this.fileTarget.hidden = false;
        const reader = new FileReader();
        reader.onload = ()=>{
            if (typeof reader.result === "string") {
                /* The sheet opens first. Nothing inside a closed <dialog> has a layout, and a cropper
           built in there measures a box of no size: it came up with the photograph at its full
           width and no crop area on it. */ this.openSheet();
                this.initCropper(reader.result);
            }
        };
        reader.readAsDataURL(file);
    }
    save(event) {
        if (this.cropper === undefined) return;
        const blob = this.cropper.getCroppedCanvas({
            height: $b79b362cd19a3d19$var$CROPPED_SIZE,
            width: $b79b362cd19a3d19$var$CROPPED_SIZE
        }).toDataURL();
        this.blobTarget.value = blob.split(",")[1] ?? "";
        this.inputTarget.value = "";
        this.previewTarget.src = blob;
        /* Closing raises `close`, which is what resets the cropper -- see `onSheetClose`. */ this.sheetTarget.close();
        event.preventDefault();
        /* Cropping is the confirmation, so cropping is what saves. The app uploads the moment the
           picker returns; the screen this is on has no Save button of its own any more, and a
           cropped picture sitting in a hidden field waiting for one is a picture you think you
           changed. `requestSubmit` and not `submit`, so the form's own validation still runs. */ this.element.closest("form")?.requestSubmit();
    }
    constructor(...args){
        super(...args), this.initialSource = "";
    }
}



class $821cd980ff0c9d36$export$2e2bcd8739ae039 extends (0, $1e1b4d625d583414$export$bd0bf19f25da8474) {
    static{
        this.targets = [
            "value"
        ];
    }
    static{
        this.values = {
            /* What the target says while the copy is still fresh, for a row whose value is a code rather
       than a word: dimming a twelve-character reference and letting it fade back is not visibly
       different from nothing happening at all. Left unset, the row keeps the fade on its own. */ copiedText: String,
            resetAfter: {
                type: Number,
                default: 1500
            },
            text: String
        };
    }
    disconnect() {
        this.clearTimer();
    }
    async copy(event) {
        event.preventDefault();
        const text = this.textValue || (this.valueTarget.textContent ?? "").trim();
        if (text === "") return;
        if (!await this.write(text)) return;
        this.element.setAttribute("data-copied", "true");
        if (this.copiedTextValue !== "") {
            /* Captured on the first copy only: a second tap before the timer runs out would otherwise
         record the confirmation as the thing to restore. */ this.restore ??= this.valueTarget.textContent ?? "";
            this.valueTarget.textContent = this.copiedTextValue;
        }
        this.clearTimer();
        this.timer = setTimeout(()=>this.reset(), this.resetAfterValue);
    }
    reset() {
        this.element.removeAttribute("data-copied");
        if (this.restore !== undefined) {
            this.valueTarget.textContent = this.restore;
            this.restore = undefined;
        }
    }
    async write(text) {
        if (window.isSecureContext && navigator.clipboard !== undefined) try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch  {
        /* Falls through to the textarea below. */ }
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.setAttribute("readonly", "");
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.select();
        try {
            return document.execCommand("copy");
        } finally{
            document.body.removeChild(textarea);
        }
    }
    clearTimer() {
        if (this.timer !== undefined) {
            clearTimeout(this.timer);
            this.timer = undefined;
        }
    }
}



/**
 * Search as you type inside a bottom sheet, with the results as a Turbo frame.
 *
 * The three sheets that pick something out of a search share this: the doubles partner on an
 * enrollment, the home club and the player references on a registration. What they share is
 * everything except what choosing a row means, which is `onPick` and is left to the subclass.
 *
 * It is deliberately not the autocomplete controller. That one is a combobox: a floating list under
 * a field, which blur closes and Escape dismisses. Here the list is the sheet's body, so closing it
 * on blur empties the sheet when somebody taps its header, and swallowing Escape stops the key that
 * is supposed to dismiss the sheet. Both are right for a dropdown and wrong for this.
 *
 * What it does instead is what `search-controller` does, because this is the same screen in a sheet:
 * wait out the typing, then point a Turbo frame at the address the results live at. The frame
 * renders rows, the invitation or the dead end, so this file never builds markup and a sheet never
 * has a second opinion about what a result looks like.
 *
 * Opening and dismissing the sheet are not here at all. `data-wp-sheet-open` is the component
 * library's, and the <dialog> it opens brings the backdrop, the focus trap, Escape and
 * pull-to-dismiss with it.
 */ /* iOS's numbers, from `SearchViewModel`, which the search screen holds to as well: 500ms after the
   typing stops, and nothing is asked for under three characters. The server applies the same floor
   -- the address is a URL anybody can request -- so this is the keystroke saved, not the rule. */ const $93a025088c3b8fce$var$DEBOUNCE_MS = 500;
const $93a025088c3b8fce$var$MINIMUM_LENGTH = 3;
const $93a025088c3b8fce$var$PARAM_QUERY = "query";
class $93a025088c3b8fce$export$2e2bcd8739ae039 extends (0, $1e1b4d625d583414$export$bd0bf19f25da8474) {
    static{
        this.targets = [
            "frame"
        ];
    }
    static{
        this.values = {
            url: String
        };
    }
    /*
   * The frame arrives server-rendered with the invitation in it, which is the answer to an empty
   * query. Saying so here rather than leaving this empty is what stops the first keystroke under
   * the minimum fetching that same invitation again.
   */ connect() {
        this.loaded = this.address();
    }
    disconnect() {
        clearTimeout(this.pending);
    }
    /*
   * The busy flag goes on at the keystroke rather than when the request starts, as it does on the
   * search screen and for the same reason: for the next half second the list is an answer to a
   * question that is no longer being asked, and nothing would say so. Turbo marks and clears the
   * frame busy around its own fetch, so it takes the flag over from here.
   */ onInput() {
        clearTimeout(this.pending);
        this.frameTarget.setAttribute("aria-busy", "true");
        this.pending = setTimeout(()=>this.search(), $93a025088c3b8fce$var$DEBOUNCE_MS);
    }
    /**
   * Enter searches now, and never submits.
   *
   * A sheet renders inside whatever form it was opened over - a <dialog> moves to the top layer to
   * be drawn but stays where it is in the document - and there is no inner form to catch the key,
   * because a form inside a form is not a form. Without this, pressing Enter on a half-typed name
   * submits the step.
   */ onKeydown(event) {
        if (event.key !== "Enter") return;
        event.preventDefault();
        clearTimeout(this.pending);
        this.search();
    }
    /**
   * Back to the empty prompt: the query cleared and the frame pointed at the invitation again.
   *
   * For a sheet that is reopened later. Leaving the last search in it means reopening onto results
   * for something somebody has already finished looking for, which is what `resetPlayerSearchResults`
   * exists for on iOS.
   */ reset() {
        clearTimeout(this.pending);
        this.field().value = "";
        this.search();
    }
    /*
   * The field is found rather than declared as a target, as the search screen's is: it is drawn by
   * the component library's `search` fragment, which takes the handful of parameters it takes and
   * knows nothing about Stimulus.
   */ field() {
        const field = this.element.querySelector('input[type="search"]');
        if (field === null) throw new Error("this sheet has no search field in it");
        return field;
    }
    search() {
        const address = this.address();
        /* Nothing to ask for: the query came back to what the frame already shows, which is what
       deleting the character you just typed does. Turbo never starts, so the flag it would have
       cleared has to come off here. */ if (address === this.loaded) {
            this.frameTarget.removeAttribute("aria-busy");
            return;
        }
        this.loaded = address;
        this.frameTarget.setAttribute("src", address);
    }
    /**
   * Where the results for whatever is in the field right now live.
   *
   * Under the minimum the query is left off altogether, which asks for the invitation: the same
   * thing a query that short does on iOS, where it clears the results and hands the screen back.
   * No history is touched, unlike the search screen's own: a sheet over a form is not an address
   * anybody navigated to, and replacing the URL from inside one would make the back button leave
   * the form.
   */ address() {
        const url = new URL(this.urlValue, window.location.href);
        const query = this.field().value.trim();
        if (query.length >= $93a025088c3b8fce$var$MINIMUM_LENGTH) url.searchParams.set($93a025088c3b8fce$var$PARAM_QUERY, query);
        else url.searchParams.delete($93a025088c3b8fce$var$PARAM_QUERY);
        return `${url.pathname}${url.search}`;
    }
    constructor(...args){
        super(...args), /** The address the frame already shows, so typing and deleting a character asks for nothing. */ this.loaded = "";
    }
}


class $35b922f3b84703dc$export$2e2bcd8739ae039 extends (0, $93a025088c3b8fce$export$2e2bcd8739ae039) {
    static{
        /* The base's own values are spread back in for the type checker's benefit. Stimulus reads
     `values` up the prototype chain and would find `url` either way; TypeScript compares the two
     static shapes and takes a subclass that redeclares the property as narrowing it away. */ this.values = {
            ...(0, $93a025088c3b8fce$export$2e2bcd8739ae039).values,
            hiddenId: String,
            nameHiddenId: String,
            valueId: String
        };
    }
    /**
   * The two `input`/`change` events are for anything watching the fields: a hidden input set by
   * script fires neither by itself.
   *
   * The ids are handed over as values rather than reached for as targets, because the field and the
   * sheet are siblings and a target has to sit inside its own controller's element.
   */ onPick(event) {
        const target = event.target;
        if (!(target instanceof Element)) return;
        const row = target.closest("[data-club-id]");
        if (row === null) return;
        const name = row.dataset.clubName ?? "";
        this.write(this.hiddenIdValue, row.dataset.clubId ?? "");
        this.write(this.nameHiddenIdValue, name);
        /* `data-chosen` is what tells the stylesheet this is a value and not the prompt it started as,
       so the two read differently without this having to know which class says so. */ const value = document.getElementById(this.valueIdValue);
        if (value !== null) {
            value.textContent = name;
            value.setAttribute("data-chosen", "");
        }
        this.element.close();
    }
    write(id, value) {
        const field = document.getElementById(id);
        if (!(field instanceof HTMLInputElement)) return;
        field.value = value;
        field.dispatchEvent(new Event("input", {
            bubbles: true
        }));
        field.dispatchEvent(new Event("change", {
            bubbles: true
        }));
    }
}



// canvas-confetti v1.9.4 built on 2025-10-25T05:14:56.640Z
var $333c9735f62f4f24$var$module = {};
// source content
/* globals Map */ (function main(global, module, isWorker, workerSize) {
    var canUseWorker = !!(global.Worker && global.Blob && global.Promise && global.OffscreenCanvas && global.OffscreenCanvasRenderingContext2D && global.HTMLCanvasElement && global.HTMLCanvasElement.prototype.transferControlToOffscreen && global.URL && global.URL.createObjectURL);
    var canUsePaths = typeof Path2D === 'function' && typeof DOMMatrix === 'function';
    var canDrawBitmap = function() {
        // this mostly supports ssr
        if (!global.OffscreenCanvas) return false;
        try {
            var canvas = new OffscreenCanvas(1, 1);
            var ctx = canvas.getContext('2d');
            ctx.fillRect(0, 0, 1, 1);
            var bitmap = canvas.transferToImageBitmap();
            ctx.createPattern(bitmap, 'no-repeat');
        } catch (e) {
            return false;
        }
        return true;
    }();
    function noop() {}
    // create a promise if it exists, otherwise, just
    // call the function directly
    function promise(func) {
        var ModulePromise = module.exports.Promise;
        var Prom = ModulePromise !== void 0 ? ModulePromise : global.Promise;
        if (typeof Prom === 'function') return new Prom(func);
        func(noop, noop);
        return null;
    }
    var bitmapMapper = function(skipTransform, map) {
        // see https://github.com/catdad/canvas-confetti/issues/209
        // creating canvases is actually pretty expensive, so we should create a
        // 1:1 map for bitmap:canvas, so that we can animate the confetti in
        // a performant manner, but also not store them forever so that we don't
        // have a memory leak
        return {
            transform: function(bitmap) {
                if (skipTransform) return bitmap;
                if (map.has(bitmap)) return map.get(bitmap);
                var canvas = new OffscreenCanvas(bitmap.width, bitmap.height);
                var ctx = canvas.getContext('2d');
                ctx.drawImage(bitmap, 0, 0);
                map.set(bitmap, canvas);
                return canvas;
            },
            clear: function() {
                map.clear();
            }
        };
    }(canDrawBitmap, new Map());
    var raf = function() {
        var TIME = Math.floor(1000 / 60);
        var frame, cancel;
        var frames = {};
        var lastFrameTime = 0;
        if (typeof requestAnimationFrame === 'function' && typeof cancelAnimationFrame === 'function') {
            frame = function(cb) {
                var id = Math.random();
                frames[id] = requestAnimationFrame(function onFrame(time) {
                    if (lastFrameTime === time || lastFrameTime + TIME - 1 < time) {
                        lastFrameTime = time;
                        delete frames[id];
                        cb();
                    } else frames[id] = requestAnimationFrame(onFrame);
                });
                return id;
            };
            cancel = function(id) {
                if (frames[id]) cancelAnimationFrame(frames[id]);
            };
        } else {
            frame = function(cb) {
                return setTimeout(cb, TIME);
            };
            cancel = function(timer) {
                return clearTimeout(timer);
            };
        }
        return {
            frame: frame,
            cancel: cancel
        };
    }();
    var getWorker = function() {
        var worker;
        var prom;
        var resolves = {};
        function decorate(worker) {
            function execute(options, callback) {
                worker.postMessage({
                    options: options || {},
                    callback: callback
                });
            }
            worker.init = function initWorker(canvas) {
                var offscreen = canvas.transferControlToOffscreen();
                worker.postMessage({
                    canvas: offscreen
                }, [
                    offscreen
                ]);
            };
            worker.fire = function fireWorker(options, size, done) {
                if (prom) {
                    execute(options, null);
                    return prom;
                }
                var id = Math.random().toString(36).slice(2);
                prom = promise(function(resolve) {
                    function workerDone(msg) {
                        if (msg.data.callback !== id) return;
                        delete resolves[id];
                        worker.removeEventListener('message', workerDone);
                        prom = null;
                        bitmapMapper.clear();
                        done();
                        resolve();
                    }
                    worker.addEventListener('message', workerDone);
                    execute(options, id);
                    resolves[id] = workerDone.bind(null, {
                        data: {
                            callback: id
                        }
                    });
                });
                return prom;
            };
            worker.reset = function resetWorker() {
                worker.postMessage({
                    reset: true
                });
                for(var id in resolves){
                    resolves[id]();
                    delete resolves[id];
                }
            };
        }
        return function() {
            if (worker) return worker;
            if (!isWorker && canUseWorker) {
                var code = [
                    'var CONFETTI, SIZE = {}, module = {};',
                    '(' + main.toString() + ')(this, module, true, SIZE);',
                    'onmessage = function(msg) {',
                    '  if (msg.data.options) {',
                    '    CONFETTI(msg.data.options).then(function () {',
                    '      if (msg.data.callback) {',
                    '        postMessage({ callback: msg.data.callback });',
                    '      }',
                    '    });',
                    '  } else if (msg.data.reset) {',
                    '    CONFETTI && CONFETTI.reset();',
                    '  } else if (msg.data.resize) {',
                    '    SIZE.width = msg.data.resize.width;',
                    '    SIZE.height = msg.data.resize.height;',
                    '  } else if (msg.data.canvas) {',
                    '    SIZE.width = msg.data.canvas.width;',
                    '    SIZE.height = msg.data.canvas.height;',
                    '    CONFETTI = module.exports.create(msg.data.canvas);',
                    '  }',
                    '}'
                ].join('\n');
                try {
                    worker = new Worker(URL.createObjectURL(new Blob([
                        code
                    ])));
                } catch (e) {
                    // eslint-disable-next-line no-console
                    typeof console !== 'undefined' && typeof console.warn === 'function' && console.warn("\uD83C\uDF8A Could not load worker", e);
                    return null;
                }
                decorate(worker);
            }
            return worker;
        };
    }();
    var defaults = {
        particleCount: 50,
        angle: 90,
        spread: 45,
        startVelocity: 45,
        decay: 0.9,
        gravity: 1,
        drift: 0,
        ticks: 200,
        x: 0.5,
        y: 0.5,
        shapes: [
            'square',
            'circle'
        ],
        zIndex: 100,
        colors: [
            '#26ccff',
            '#a25afd',
            '#ff5e7e',
            '#88ff5a',
            '#fcff42',
            '#ffa62d',
            '#ff36ff'
        ],
        // probably should be true, but back-compat
        disableForReducedMotion: false,
        scalar: 1
    };
    function convert(val, transform) {
        return transform ? transform(val) : val;
    }
    function isOk(val) {
        return !(val === null || val === undefined);
    }
    function prop(options, name, transform) {
        return convert(options && isOk(options[name]) ? options[name] : defaults[name], transform);
    }
    function onlyPositiveInt(number) {
        return number < 0 ? 0 : Math.floor(number);
    }
    function randomInt(min, max) {
        // [min, max)
        return Math.floor(Math.random() * (max - min)) + min;
    }
    function toDecimal(str) {
        return parseInt(str, 16);
    }
    function colorsToRgb(colors) {
        return colors.map(hexToRgb);
    }
    function hexToRgb(str) {
        var val = String(str).replace(/[^0-9a-f]/gi, '');
        if (val.length < 6) val = val[0] + val[0] + val[1] + val[1] + val[2] + val[2];
        return {
            r: toDecimal(val.substring(0, 2)),
            g: toDecimal(val.substring(2, 4)),
            b: toDecimal(val.substring(4, 6))
        };
    }
    function getOrigin(options) {
        var origin = prop(options, 'origin', Object);
        origin.x = prop(origin, 'x', Number);
        origin.y = prop(origin, 'y', Number);
        return origin;
    }
    function setCanvasWindowSize(canvas) {
        canvas.width = document.documentElement.clientWidth;
        canvas.height = document.documentElement.clientHeight;
    }
    function setCanvasRectSize(canvas) {
        var rect = canvas.getBoundingClientRect();
        canvas.width = rect.width;
        canvas.height = rect.height;
    }
    function getCanvas(zIndex) {
        var canvas = document.createElement('canvas');
        canvas.style.position = 'fixed';
        canvas.style.top = '0px';
        canvas.style.left = '0px';
        canvas.style.pointerEvents = 'none';
        canvas.style.zIndex = zIndex;
        return canvas;
    }
    function ellipse(context, x, y, radiusX, radiusY, rotation, startAngle, endAngle, antiClockwise) {
        context.save();
        context.translate(x, y);
        context.rotate(rotation);
        context.scale(radiusX, radiusY);
        context.arc(0, 0, 1, startAngle, endAngle, antiClockwise);
        context.restore();
    }
    function randomPhysics(opts) {
        var radAngle = opts.angle * (Math.PI / 180);
        var radSpread = opts.spread * (Math.PI / 180);
        return {
            x: opts.x,
            y: opts.y,
            wobble: Math.random() * 10,
            wobbleSpeed: Math.min(0.11, Math.random() * 0.1 + 0.05),
            velocity: opts.startVelocity * 0.5 + Math.random() * opts.startVelocity,
            angle2D: -radAngle + (0.5 * radSpread - Math.random() * radSpread),
            tiltAngle: (Math.random() * 0.5 + 0.25) * Math.PI,
            color: opts.color,
            shape: opts.shape,
            tick: 0,
            totalTicks: opts.ticks,
            decay: opts.decay,
            drift: opts.drift,
            random: Math.random() + 2,
            tiltSin: 0,
            tiltCos: 0,
            wobbleX: 0,
            wobbleY: 0,
            gravity: opts.gravity * 3,
            ovalScalar: 0.6,
            scalar: opts.scalar,
            flat: opts.flat
        };
    }
    function updateFetti(context, fetti) {
        fetti.x += Math.cos(fetti.angle2D) * fetti.velocity + fetti.drift;
        fetti.y += Math.sin(fetti.angle2D) * fetti.velocity + fetti.gravity;
        fetti.velocity *= fetti.decay;
        if (fetti.flat) {
            fetti.wobble = 0;
            fetti.wobbleX = fetti.x + 10 * fetti.scalar;
            fetti.wobbleY = fetti.y + 10 * fetti.scalar;
            fetti.tiltSin = 0;
            fetti.tiltCos = 0;
            fetti.random = 1;
        } else {
            fetti.wobble += fetti.wobbleSpeed;
            fetti.wobbleX = fetti.x + 10 * fetti.scalar * Math.cos(fetti.wobble);
            fetti.wobbleY = fetti.y + 10 * fetti.scalar * Math.sin(fetti.wobble);
            fetti.tiltAngle += 0.1;
            fetti.tiltSin = Math.sin(fetti.tiltAngle);
            fetti.tiltCos = Math.cos(fetti.tiltAngle);
            fetti.random = Math.random() + 2;
        }
        var progress = fetti.tick++ / fetti.totalTicks;
        var x1 = fetti.x + fetti.random * fetti.tiltCos;
        var y1 = fetti.y + fetti.random * fetti.tiltSin;
        var x2 = fetti.wobbleX + fetti.random * fetti.tiltCos;
        var y2 = fetti.wobbleY + fetti.random * fetti.tiltSin;
        context.fillStyle = 'rgba(' + fetti.color.r + ', ' + fetti.color.g + ', ' + fetti.color.b + ', ' + (1 - progress) + ')';
        context.beginPath();
        if (canUsePaths && fetti.shape.type === 'path' && typeof fetti.shape.path === 'string' && Array.isArray(fetti.shape.matrix)) context.fill(transformPath2D(fetti.shape.path, fetti.shape.matrix, fetti.x, fetti.y, Math.abs(x2 - x1) * 0.1, Math.abs(y2 - y1) * 0.1, Math.PI / 10 * fetti.wobble));
        else if (fetti.shape.type === 'bitmap') {
            var rotation = Math.PI / 10 * fetti.wobble;
            var scaleX = Math.abs(x2 - x1) * 0.1;
            var scaleY = Math.abs(y2 - y1) * 0.1;
            var width = fetti.shape.bitmap.width * fetti.scalar;
            var height = fetti.shape.bitmap.height * fetti.scalar;
            var matrix = new DOMMatrix([
                Math.cos(rotation) * scaleX,
                Math.sin(rotation) * scaleX,
                -Math.sin(rotation) * scaleY,
                Math.cos(rotation) * scaleY,
                fetti.x,
                fetti.y
            ]);
            // apply the transform matrix from the confetti shape
            matrix.multiplySelf(new DOMMatrix(fetti.shape.matrix));
            var pattern = context.createPattern(bitmapMapper.transform(fetti.shape.bitmap), 'no-repeat');
            pattern.setTransform(matrix);
            context.globalAlpha = 1 - progress;
            context.fillStyle = pattern;
            context.fillRect(fetti.x - width / 2, fetti.y - height / 2, width, height);
            context.globalAlpha = 1;
        } else if (fetti.shape === 'circle') context.ellipse ? context.ellipse(fetti.x, fetti.y, Math.abs(x2 - x1) * fetti.ovalScalar, Math.abs(y2 - y1) * fetti.ovalScalar, Math.PI / 10 * fetti.wobble, 0, 2 * Math.PI) : ellipse(context, fetti.x, fetti.y, Math.abs(x2 - x1) * fetti.ovalScalar, Math.abs(y2 - y1) * fetti.ovalScalar, Math.PI / 10 * fetti.wobble, 0, 2 * Math.PI);
        else if (fetti.shape === 'star') {
            var rot = Math.PI / 2 * 3;
            var innerRadius = 4 * fetti.scalar;
            var outerRadius = 8 * fetti.scalar;
            var x = fetti.x;
            var y = fetti.y;
            var spikes = 5;
            var step = Math.PI / spikes;
            while(spikes--){
                x = fetti.x + Math.cos(rot) * outerRadius;
                y = fetti.y + Math.sin(rot) * outerRadius;
                context.lineTo(x, y);
                rot += step;
                x = fetti.x + Math.cos(rot) * innerRadius;
                y = fetti.y + Math.sin(rot) * innerRadius;
                context.lineTo(x, y);
                rot += step;
            }
        } else {
            context.moveTo(Math.floor(fetti.x), Math.floor(fetti.y));
            context.lineTo(Math.floor(fetti.wobbleX), Math.floor(y1));
            context.lineTo(Math.floor(x2), Math.floor(y2));
            context.lineTo(Math.floor(x1), Math.floor(fetti.wobbleY));
        }
        context.closePath();
        context.fill();
        return fetti.tick < fetti.totalTicks;
    }
    function animate(canvas, fettis, resizer, size, done) {
        var animatingFettis = fettis.slice();
        var context = canvas.getContext('2d');
        var animationFrame;
        var destroy;
        var prom = promise(function(resolve) {
            function onDone() {
                animationFrame = destroy = null;
                context.clearRect(0, 0, size.width, size.height);
                bitmapMapper.clear();
                done();
                resolve();
            }
            function update() {
                if (isWorker && !(size.width === workerSize.width && size.height === workerSize.height)) {
                    size.width = canvas.width = workerSize.width;
                    size.height = canvas.height = workerSize.height;
                }
                if (!size.width && !size.height) {
                    resizer(canvas);
                    size.width = canvas.width;
                    size.height = canvas.height;
                }
                context.clearRect(0, 0, size.width, size.height);
                animatingFettis = animatingFettis.filter(function(fetti) {
                    return updateFetti(context, fetti);
                });
                if (animatingFettis.length) animationFrame = raf.frame(update);
                else onDone();
            }
            animationFrame = raf.frame(update);
            destroy = onDone;
        });
        return {
            addFettis: function(fettis) {
                animatingFettis = animatingFettis.concat(fettis);
                return prom;
            },
            canvas: canvas,
            promise: prom,
            reset: function() {
                if (animationFrame) raf.cancel(animationFrame);
                if (destroy) destroy();
            }
        };
    }
    function confettiCannon(canvas, globalOpts) {
        var isLibCanvas = !canvas;
        var allowResize = !!prop(globalOpts || {}, 'resize');
        var hasResizeEventRegistered = false;
        var globalDisableForReducedMotion = prop(globalOpts, 'disableForReducedMotion', Boolean);
        var shouldUseWorker = canUseWorker && !!prop(globalOpts || {}, 'useWorker');
        var worker = shouldUseWorker ? getWorker() : null;
        var resizer = isLibCanvas ? setCanvasWindowSize : setCanvasRectSize;
        var initialized = canvas && worker ? !!canvas.__confetti_initialized : false;
        var preferLessMotion = typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion)').matches;
        var animationObj;
        function fireLocal(options, size, done) {
            var particleCount = prop(options, 'particleCount', onlyPositiveInt);
            var angle = prop(options, 'angle', Number);
            var spread = prop(options, 'spread', Number);
            var startVelocity = prop(options, 'startVelocity', Number);
            var decay = prop(options, 'decay', Number);
            var gravity = prop(options, 'gravity', Number);
            var drift = prop(options, 'drift', Number);
            var colors = prop(options, 'colors', colorsToRgb);
            var ticks = prop(options, 'ticks', Number);
            var shapes = prop(options, 'shapes');
            var scalar = prop(options, 'scalar');
            var flat = !!prop(options, 'flat');
            var origin = getOrigin(options);
            var temp = particleCount;
            var fettis = [];
            var startX = canvas.width * origin.x;
            var startY = canvas.height * origin.y;
            while(temp--)fettis.push(randomPhysics({
                x: startX,
                y: startY,
                angle: angle,
                spread: spread,
                startVelocity: startVelocity,
                color: colors[temp % colors.length],
                shape: shapes[randomInt(0, shapes.length)],
                ticks: ticks,
                decay: decay,
                gravity: gravity,
                drift: drift,
                scalar: scalar,
                flat: flat
            }));
            // if we have a previous canvas already animating,
            // add to it
            if (animationObj) return animationObj.addFettis(fettis);
            animationObj = animate(canvas, fettis, resizer, size, done);
            return animationObj.promise;
        }
        function fire(options) {
            var disableForReducedMotion = globalDisableForReducedMotion || prop(options, 'disableForReducedMotion', Boolean);
            var zIndex = prop(options, 'zIndex', Number);
            if (disableForReducedMotion && preferLessMotion) return promise(function(resolve) {
                resolve();
            });
            if (isLibCanvas && animationObj) // use existing canvas from in-progress animation
            canvas = animationObj.canvas;
            else if (isLibCanvas && !canvas) {
                // create and initialize a new canvas
                canvas = getCanvas(zIndex);
                document.body.appendChild(canvas);
            }
            if (allowResize && !initialized) // initialize the size of a user-supplied canvas
            resizer(canvas);
            var size = {
                width: canvas.width,
                height: canvas.height
            };
            if (worker && !initialized) worker.init(canvas);
            initialized = true;
            if (worker) canvas.__confetti_initialized = true;
            function onResize() {
                if (worker) {
                    // TODO this really shouldn't be immediate, because it is expensive
                    var obj = {
                        getBoundingClientRect: function() {
                            if (!isLibCanvas) return canvas.getBoundingClientRect();
                        }
                    };
                    resizer(obj);
                    worker.postMessage({
                        resize: {
                            width: obj.width,
                            height: obj.height
                        }
                    });
                    return;
                }
                // don't actually query the size here, since this
                // can execute frequently and rapidly
                size.width = size.height = null;
            }
            function done() {
                animationObj = null;
                if (allowResize) {
                    hasResizeEventRegistered = false;
                    global.removeEventListener('resize', onResize);
                }
                if (isLibCanvas && canvas) {
                    if (document.body.contains(canvas)) document.body.removeChild(canvas);
                    canvas = null;
                    initialized = false;
                }
            }
            if (allowResize && !hasResizeEventRegistered) {
                hasResizeEventRegistered = true;
                global.addEventListener('resize', onResize, false);
            }
            if (worker) return worker.fire(options, size, done);
            return fireLocal(options, size, done);
        }
        fire.reset = function() {
            if (worker) worker.reset();
            if (animationObj) animationObj.reset();
        };
        return fire;
    }
    // Make default export lazy to defer worker creation until called.
    var defaultFire;
    function getDefaultFire() {
        if (!defaultFire) defaultFire = confettiCannon(null, {
            useWorker: true,
            resize: true
        });
        return defaultFire;
    }
    function transformPath2D(pathString, pathMatrix, x, y, scaleX, scaleY, rotation) {
        var path2d = new Path2D(pathString);
        var t1 = new Path2D();
        t1.addPath(path2d, new DOMMatrix(pathMatrix));
        var t2 = new Path2D();
        // see https://developer.mozilla.org/en-US/docs/Web/API/DOMMatrix/DOMMatrix
        t2.addPath(t1, new DOMMatrix([
            Math.cos(rotation) * scaleX,
            Math.sin(rotation) * scaleX,
            -Math.sin(rotation) * scaleY,
            Math.cos(rotation) * scaleY,
            x,
            y
        ]));
        return t2;
    }
    function shapeFromPath(pathData) {
        if (!canUsePaths) throw new Error('path confetti are not supported in this browser');
        var path, matrix;
        if (typeof pathData === 'string') path = pathData;
        else {
            path = pathData.path;
            matrix = pathData.matrix;
        }
        var path2d = new Path2D(path);
        var tempCanvas = document.createElement('canvas');
        var tempCtx = tempCanvas.getContext('2d');
        if (!matrix) {
            // attempt to figure out the width of the path, up to 1000x1000
            var maxSize = 1000;
            var minX = maxSize;
            var minY = maxSize;
            var maxX = 0;
            var maxY = 0;
            var width, height;
            // do some line skipping... this is faster than checking
            // every pixel and will be mostly still correct
            for(var x = 0; x < maxSize; x += 2){
                for(var y = 0; y < maxSize; y += 2)if (tempCtx.isPointInPath(path2d, x, y, 'nonzero')) {
                    minX = Math.min(minX, x);
                    minY = Math.min(minY, y);
                    maxX = Math.max(maxX, x);
                    maxY = Math.max(maxY, y);
                }
            }
            width = maxX - minX;
            height = maxY - minY;
            var maxDesiredSize = 10;
            var scale = Math.min(maxDesiredSize / width, maxDesiredSize / height);
            matrix = [
                scale,
                0,
                0,
                scale,
                -Math.round(width / 2 + minX) * scale,
                -Math.round(height / 2 + minY) * scale
            ];
        }
        return {
            type: 'path',
            path: path,
            matrix: matrix
        };
    }
    function shapeFromText(textData) {
        var text, scalar = 1, color = '#000000', // see https://nolanlawson.com/2022/04/08/the-struggle-of-using-native-emoji-on-the-web/
        fontFamily = '"Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", "EmojiOne Color", "Android Emoji", "Twemoji Mozilla", "system emoji", sans-serif';
        if (typeof textData === 'string') text = textData;
        else {
            text = textData.text;
            scalar = 'scalar' in textData ? textData.scalar : scalar;
            fontFamily = 'fontFamily' in textData ? textData.fontFamily : fontFamily;
            color = 'color' in textData ? textData.color : color;
        }
        // all other confetti are 10 pixels,
        // so this pixel size is the de-facto 100% scale confetti
        var fontSize = 10 * scalar;
        var font = '' + fontSize + 'px ' + fontFamily;
        var canvas = new OffscreenCanvas(fontSize, fontSize);
        var ctx = canvas.getContext('2d');
        ctx.font = font;
        var size = ctx.measureText(text);
        var width = Math.ceil(size.actualBoundingBoxRight + size.actualBoundingBoxLeft);
        var height = Math.ceil(size.actualBoundingBoxAscent + size.actualBoundingBoxDescent);
        var padding = 2;
        var x = size.actualBoundingBoxLeft + padding;
        var y = size.actualBoundingBoxAscent + padding;
        width += padding + padding;
        height += padding + padding;
        canvas = new OffscreenCanvas(width, height);
        ctx = canvas.getContext('2d');
        ctx.font = font;
        ctx.fillStyle = color;
        ctx.fillText(text, x, y);
        var scale = 1 / scalar;
        return {
            type: 'bitmap',
            // TODO these probably need to be transfered for workers
            bitmap: canvas.transferToImageBitmap(),
            matrix: [
                scale,
                0,
                0,
                scale,
                -width * scale / 2,
                -height * scale / 2
            ]
        };
    }
    module.exports = function() {
        return getDefaultFire().apply(this, arguments);
    };
    module.exports.reset = function() {
        getDefaultFire().reset();
    };
    module.exports.create = confettiCannon;
    module.exports.shapeFromPath = shapeFromPath;
    module.exports.shapeFromText = shapeFromText;
})(function() {
    if (typeof window !== 'undefined') return window;
    if (typeof self !== 'undefined') return self;
    return this || {};
}(), $333c9735f62f4f24$var$module, false);
var // end source content
$333c9735f62f4f24$export$2e2bcd8739ae039 = $333c9735f62f4f24$var$module.exports;
var $333c9735f62f4f24$export$185802fd694ee1f5 = $333c9735f62f4f24$var$module.exports.create;


const $adfa29faa56d32bf$var$FIREWORK_INTERVAL_MILLISECONDS = 400;
class $adfa29faa56d32bf$export$2e2bcd8739ae039 extends (0, $1e1b4d625d583414$export$bd0bf19f25da8474) {
    static{
        this.values = {
            autoplay: Boolean,
            autoplayDuration: Number,
            burst: Boolean,
            sound: String
        };
    }
    connect() {
        if (!this.autoplayValue) return;
        /* One burst that falls, rather than a display that keeps going. `ConfettiView` throws a
           single handful and lets it land - about five seconds of falling, not five seconds of
           firing - and a match page that kept launching would read as a party rather than as
           "you won this". The birthday on the profile is the other case and keeps the display. */ if (this.burstValue) {
            this.fire();
            return;
        }
        this.playFireworks(this.autoplayDurationValue);
    }
    disconnect() {
        /* The firework loop outlives the element otherwise, firing into a page that has navigated
           away from the match it was celebrating. */ if (this.interval !== undefined) {
            clearInterval(this.interval);
            this.interval = undefined;
        }
    }
    fire() {
        if (this.soundValue !== "") new Audio(this.soundValue).play();
        const count = 200;
        const defaults = {
            origin: {
                y: 0.7
            }
        };
        const burst = (particleRatio, options)=>{
            (0, $333c9735f62f4f24$export$2e2bcd8739ae039)({
                ...defaults,
                ...options,
                particleCount: Math.floor(count * particleRatio)
            });
        };
        burst(0.25, {
            spread: 26,
            startVelocity: 55
        });
        burst(0.2, {
            spread: 60
        });
        burst(0.35, {
            decay: 0.91,
            scalar: 0.8,
            spread: 100
        });
        burst(0.1, {
            decay: 0.92,
            scalar: 1.2,
            spread: 120,
            startVelocity: 25
        });
        burst(0.1, {
            spread: 120,
            startVelocity: 45
        });
    }
    playFireworks(durationSeconds) {
        const durationMilliseconds = durationSeconds * 1000;
        const animationEnd = Date.now() + durationMilliseconds;
        const defaults = {
            spread: 360,
            startVelocity: 40,
            ticks: 60,
            zIndex: 0
        };
        this.interval = setInterval(()=>{
            const timeLeft = animationEnd - Date.now();
            if (timeLeft <= 0) {
                this.disconnect();
                return;
            }
            const particleCount = 50 * (timeLeft / durationMilliseconds);
            /* Since particles fall down, start a bit higher than random. */ (0, $333c9735f62f4f24$export$2e2bcd8739ae039)({
                ...defaults,
                origin: {
                    x: this.randomInRange(0.1, 0.3),
                    y: Math.random() - 0.2
                },
                particleCount: particleCount
            });
            (0, $333c9735f62f4f24$export$2e2bcd8739ae039)({
                ...defaults,
                origin: {
                    x: this.randomInRange(0.7, 0.9),
                    y: Math.random() - 0.2
                },
                particleCount: particleCount
            });
        }, $adfa29faa56d32bf$var$FIREWORK_INTERVAL_MILLISECONDS);
    }
    randomInRange(min, max) {
        return Math.random() * (max - min) + min;
    }
}



/**
 * Search as you type inside the doubles partner sheet, and the choice it ends in.
 *
 * It no longer extends the autocomplete controller, and the sheet is why. That controller is a
 * combobox: a floating list under a field, which blur closes and Escape dismisses. Here the list
 * is the sheet's body, so closing it on blur empties the sheet when somebody taps its header, and
 * swallowing Escape stops the key that is supposed to dismiss the sheet. Both are right for a
 * dropdown and wrong for this, and neither was reachable to override.
 *
 * What it does instead is what `search-controller` does, because this is the same screen in a
 * sheet: wait out the typing, then point a Turbo frame at the address the results live at. The
 * frame renders rows, the invitation or the dead end, so this file never builds markup and the
 * sheet never has a second opinion about what a player looks like.
 *
 * Opening and dismissing the sheet are not here at all. `data-wp-sheet-open` is the component
 * library's, and the <dialog> it opens brings the backdrop, the focus trap, Escape and
 * pull-to-dismiss with it.
 */ /* iOS's numbers, from `SearchViewModel`, which the search screen holds to as well: 500ms after the
   typing stops, and nothing is asked for under three characters. The server applies the same floor
   -- the address is a URL anybody can request -- so this is the keystroke saved, not the rule. */ const $78490bebdba82f75$var$DEBOUNCE_MS = 500;
const $78490bebdba82f75$var$MINIMUM_LENGTH = 3;
const $78490bebdba82f75$var$PARAM_QUERY = "query";
class $78490bebdba82f75$export$2e2bcd8739ae039 extends (0, $1e1b4d625d583414$export$bd0bf19f25da8474) {
    static{
        this.targets = [
            "frame"
        ];
    }
    static{
        this.values = {
            hiddenId: String,
            nameId: String,
            url: String
        };
    }
    /*
   * The frame arrives server-rendered with the invitation in it, which is the answer to an empty
   * query. Saying so here rather than leaving this empty is what stops the first keystroke under
   * the minimum fetching that same invitation again.
   */ connect() {
        this.loaded = this.address();
    }
    disconnect() {
        clearTimeout(this.pending);
    }
    /*
   * The busy flag goes on at the keystroke rather than when the request starts, as it does on the
   * search screen and for the same reason: for the next half second the list is an answer to a
   * question that is no longer being asked, and nothing would say so. Turbo marks and clears the
   * frame busy around its own fetch, so it takes the flag over from here.
   */ onInput() {
        clearTimeout(this.pending);
        this.frameTarget.setAttribute("aria-busy", "true");
        this.pending = setTimeout(()=>this.search(), $78490bebdba82f75$var$DEBOUNCE_MS);
    }
    /**
   * Enter searches now, and never submits.
   *
   * The sheet renders inside the enrollment form - a <dialog> moves to the top layer to be drawn
   * but stays where it is in the document - and there is no inner form to catch the key, because
   * a form inside a form is not a form. Without this, pressing Enter on a half-typed name enrols
   * you with no partner.
   */ onKeydown(event) {
        if (event.key !== "Enter") return;
        event.preventDefault();
        clearTimeout(this.pending);
        this.search();
    }
    /**
   * Choosing a row: the id into the form, the name onto the row that opened the sheet, and shut.
   *
   * Bound on the frame rather than on the rows, which Turbo replaces on every search and which
   * therefore cannot carry a listener of their own.
   *
   * The two `input`/`change` events are for anything watching the field: the hidden input is set
   * by script, and a programmatic assignment fires neither by itself.
   */ onPick(event) {
        const target = event.target;
        if (!(target instanceof Element)) return;
        const row = target.closest("[data-doubles-partner-id]");
        if (row === null) return;
        const hidden = document.getElementById(this.hiddenIdValue);
        if (hidden instanceof HTMLInputElement) {
            hidden.value = row.dataset.doublesPartnerId ?? "";
            hidden.dispatchEvent(new Event("input", {
                bubbles: true
            }));
            hidden.dispatchEvent(new Event("change", {
                bubbles: true
            }));
        }
        /* `data-chosen` is what tells the stylesheet this is a value and not the prompt it started
           as, so the two read differently without this having to know which class says so. */ const name = document.getElementById(this.nameIdValue);
        if (name !== null) {
            name.textContent = row.dataset.doublesPartnerName ?? "";
            name.setAttribute("data-chosen", "");
        }
        this.element.close();
    }
    search() {
        const address = this.address();
        /* Nothing to ask for: the query came back to what the frame already shows, which is what
           deleting the character you just typed does. Turbo never starts, so the flag it would
           have cleared has to come off here. */ if (address === this.loaded) {
            this.frameTarget.removeAttribute("aria-busy");
            return;
        }
        this.loaded = address;
        this.frameTarget.setAttribute("src", address);
    }
    /**
   * Where the results for whatever is in the field right now live.
   *
   * Under the minimum the query is left off altogether, which asks for the invitation: the same
   * thing a query that short does on iOS, where it clears the results and hands the screen back.
   * No history is touched, unlike the search screen's own: a sheet over a form is not an address
   * anybody navigated to, and replacing the URL from inside one would make the back button leave
   * the enrollment.
   */ address() {
        const url = new URL(this.urlValue, window.location.href);
        const query = this.field().value.trim();
        if (query.length >= $78490bebdba82f75$var$MINIMUM_LENGTH) url.searchParams.set($78490bebdba82f75$var$PARAM_QUERY, query);
        else url.searchParams.delete($78490bebdba82f75$var$PARAM_QUERY);
        return `${url.pathname}${url.search}`;
    }
    /*
   * The field is found rather than declared as a target, as the search screen's is: it is drawn by
   * the component library's `search` fragment, which takes the handful of parameters it takes and
   * knows nothing about Stimulus.
   */ field() {
        const field = this.element.querySelector('input[type="search"]');
        if (field === null) throw new Error("the doubles partner sheet has no search field in it");
        return field;
    }
    constructor(...args){
        super(...args), /** The address the frame already shows, so typing and deleting a character asks for nothing. */ this.loaded = "";
    }
}



class $91ae0a51bbca2e65$export$2e2bcd8739ae039 extends (0, $1e1b4d625d583414$export$bd0bf19f25da8474) {
    static{
        this.targets = [
            "retry",
            "status"
        ];
    }
    static{
        this.values = {
            reconnectedLabel: String,
            /** How long the reconnected label is left up before the page reloads under it. */ reloadAfter: {
                type: Number,
                default: 600
            },
            retryingLabel: String
        };
    }
    connect() {
        window.addEventListener("online", this.onOnline);
    }
    disconnect() {
        window.removeEventListener("online", this.onOnline);
        if (this.timer !== undefined) {
            clearTimeout(this.timer);
            this.timer = undefined;
        }
    }
    back(event) {
        /* `length > 1` is the only thing a page can ask: the entries themselves are not readable, and
       a tab opened straight onto this URL has exactly one. With no history to go back to, the
       link's own href - the home page - is where the reader should end up, so the event is left
       alone. */ if (window.history.length <= 1) return;
        event.preventDefault();
        window.history.back();
    }
    retry() {
        this.busy();
        window.location.reload();
    }
    busy() {
        if (!this.hasRetryTarget) return;
        this.retryTarget.setAttribute("aria-busy", "true");
        this.retryTarget.disabled = true;
        if (this.retryingLabelValue !== "") this.retryTarget.textContent = this.retryingLabelValue;
    }
    reconnected() {
        if (this.hasStatusTarget) {
            this.statusTarget.classList.add("wp-status-active");
            if (this.reconnectedLabelValue !== "") this.statusTarget.textContent = this.reconnectedLabelValue;
        }
        this.busy();
        /* A beat before the reload, so the reader sees that it reconnected rather than watching the
       page blink for no stated reason. */ this.timer = setTimeout(()=>window.location.reload(), this.reloadAfterValue);
    }
    constructor(...args){
        super(...args), this.onOnline = ()=>this.reconnected();
    }
}



class $2337fc35a39e1c2f$export$2e2bcd8739ae039 extends (0, $1e1b4d625d583414$export$bd0bf19f25da8474) {
    static{
        this.targets = [
            "select"
        ];
    }
    onChange() {
        const url = this.selectTarget.value;
        /* An option with nowhere to go: `locale_urls` is absent on a page rendered outside a request
       that could resolve it, and following "" would reload the page the reader is already on. */ if (url === "") return;
        window.location.assign(url);
    }
}



class $2014f5e600daf242$export$2e2bcd8739ae039 extends (0, $1e1b4d625d583414$export$bd0bf19f25da8474) {
    static{
        this.targets = [
            "dateDay",
            "dateMonth",
            "error",
            "form",
            "relative",
            "unscheduled",
            "when"
        ];
    }
    async submit() {
        /* Any control that holds its value somewhere other than its own field - the time wheels
           do - writes it back now, before the form is read. */ document.dispatchEvent(new CustomEvent("wp:commit", {
            detail: {
                root: this.element
            }
        }));
        /* `URLSearchParams` and not `FormData`: a FormData body is sent as `multipart/form-data`,
           and Spring Security's CsrfFilter reads the token with `request.getParameter`, which for
           a multipart request answers nothing unless a MultipartFilter runs ahead of the security
           chain - and none does here. So the token was in the body, the filter could not see it,
           and every save was rejected and redirected to the login page. This form has no file in
           it and never needed the heavier encoding. */ const response = await fetch(this.formTarget.action, {
            body: this.body(),
            method: "post"
        });
        /* A redirect means the save did not happen: `fetch` follows one transparently, so a
           rejected POST lands on the login page with a cheerful 200 and `ok` is true. Treating
           that as success is what made a save that never happened look like one that did. */ const saved = response.ok && !response.redirected;
        if (this.hasErrorTarget) this.errorTarget.hidden = saved;
        if (saved) {
            this.reflect();
            this.formTarget.closest("dialog")?.close();
        }
    }
    /**
   * Puts the form back to what the server rendered, for a sheet that is being dismissed rather
   * than saved.
   *
   * Closing is not by itself discarding: the calendar and the wheels write into their fields as
   * they are used, and only the posting waits for Save. Without this, a date chosen and then
   * cancelled would still be sitting in the field the next time Save was pressed.
   */ discard() {
        this.formTarget.reset();
        document.dispatchEvent(new CustomEvent("wp:paint", {
            detail: {
                root: this.element
            }
        }));
    }
    /**
   * The form, encoded the way the server expects to read it.
   *
   * Built entry by entry rather than handing the `FormData` straight to `URLSearchParams`: the
   * two are only loosely compatible, and copying the string entries across says out loud that
   * this form holds no files - which is the assumption the encoding above depends on.
   */ body() {
        const body = new URLSearchParams();
        new FormData(this.formTarget).forEach((value, key)=>{
            if (typeof value === "string") body.append(key, value);
        });
        return body;
    }
    /** The value of one of the form's own fields, or undefined when the form has no such field. */ field(name) {
        const element = this.formTarget.elements.namedItem(name);
        return element instanceof HTMLInputElement ? element.value : undefined;
    }
    /**
   * Writes the saved date back onto the row behind the sheet.
   *
   * The time comes off the form rather than being formatted here, because that is the string the
   * server rendered too and re-deriving it in a second place is how the two come to disagree.
   * The month and the weekday are `Intl` in the page's own language, which is what the library's
   * own date formatting uses.
   */ reflect() {
        const date = this.field("scheduledAtDate");
        if (date === undefined || date === "") return;
        /* A fixture with no date yet is a different row - a clock and "date to be confirmed", not
           a date tile. Rebuilding that shape here would be the template written twice, so the
           server draws it and this asks for it. */ if (this.hasUnscheduledTarget) {
            window.location.reload();
            return;
        }
        if (!this.hasDateDayTarget) return;
        const time = this.field("scheduledAtTime") || "12:00";
        const at = new Date(`${date}T${time}`);
        const locale = document.documentElement.lang || undefined;
        const weekday = new Intl.DateTimeFormat(locale, {
            weekday: "long"
        }).format(at);
        this.dateMonthTarget.textContent = new Intl.DateTimeFormat(locale, {
            month: "short"
        }).format(at);
        this.dateDayTarget.textContent = String(at.getDate());
        if (this.hasWhenTarget) this.whenTarget.textContent = `${weekday.charAt(0).toLocaleUpperCase(locale)}${weekday.slice(1)} \xb7 ${time}`;
        if (this.hasRelativeTarget) {
            this.relativeTarget.setAttribute("datetime", at.toISOString());
            /* The library owns what that element reads; this only changed the instant under it. */ document.dispatchEvent(new CustomEvent("wp:paint", {
                detail: {
                    root: this.element
                }
            }));
        }
    }
}



class $32289d48784a1cb1$export$2e2bcd8739ae039 extends (0, $1e1b4d625d583414$export$bd0bf19f25da8474) {
    static{
        this.targets = [
            "counter",
            "dialog",
            "item",
            "track"
        ];
    }
    disconnect() {
        this.stopped();
    }
    open(event) {
        event.preventDefault();
        const trigger = event.currentTarget;
        const index = Number(trigger.dataset["mediaViewerIndexParam"] ?? "0");
        this.dialogTarget.showModal();
        /* After the dialog is shown, so the track has a width to scroll within: a scrollLeft set on
           a `display: none` element is silently dropped and the viewer opens on the first item
           however far down the strip the reader clicked. */ this.page(index, "instant");
        this.render(index);
    }
    close() {
        this.dialogTarget.close();
    }
    /** The dialog's own `close` event, so Escape and the button are the same path. */ stopped() {
        this.element.querySelectorAll("video").forEach((video)=>video.pause());
    }
    /** Keeps the counter honest while the reader pages, bound to `scroll` on the track. */ track() {
        this.render(this.current());
    }
    /** Left and right page, as the arrows on a gallery are expected to. */ key(event) {
        const step = event.key === "ArrowRight" ? 1 : event.key === "ArrowLeft" ? -1 : 0;
        if (step === 0) return;
        event.preventDefault();
        this.page(this.clamp(this.current() + step), "smooth");
    }
    /**
   * A drag on a pointer that cannot already swipe.
   *
   * Touch is left alone: the track scrolls natively there, and taking the gesture over would
   * replace momentum and rubber-banding with a worse copy of both. `setPointerCapture` keeps the
   * drag alive when the cursor leaves the window, and snapping is turned off for its duration
   * because a mandatory snap fights a scrollLeft written on every move.
   */ dragStart(event) {
        if (event.pointerType === "touch") return;
        /* A pointer that came down on the film is the film's own. Taking it would `preventDefault`
           the control's default action and then `setPointerCapture` the pointerup away from it, so
           the button never completes -- which is why play, the scrubber and the volume were all
           dead in Safari. Chrome's controls synthesise a click of their own and survived it, which
           is what made this look like a codec problem rather than a handler one. */ if (event.target.closest("video") !== null) return;
        event.preventDefault();
        this.origin = {
            scrollLeft: this.trackTarget.scrollLeft,
            x: event.clientX
        };
        this.trackTarget.style.scrollSnapType = "none";
        this.trackTarget.setPointerCapture(event.pointerId);
    }
    dragMove(event) {
        if (this.origin === undefined) return;
        this.trackTarget.scrollLeft = this.origin.scrollLeft - (event.clientX - this.origin.x);
    }
    dragEnd() {
        if (this.origin === undefined) return;
        this.origin = undefined;
        this.trackTarget.style.scrollSnapType = "";
        this.page(this.current(), "smooth");
    }
    current() {
        const width = this.trackTarget.clientWidth;
        return width === 0 ? 0 : this.clamp(Math.round(this.trackTarget.scrollLeft / width));
    }
    clamp(index) {
        return Math.min(Math.max(index, 0), Math.max(this.itemTargets.length - 1, 0));
    }
    page(index, behavior) {
        this.trackTarget.scrollTo({
            left: index * this.trackTarget.clientWidth,
            behavior: behavior
        });
        this.render(index);
    }
    render(index) {
        if (this.hasCounterTarget) this.counterTarget.textContent = `${index + 1} / ${this.itemTargets.length}`;
    }
}



class $eb0b863d8c17e3de$export$2e2bcd8739ae039 extends (0, $1e1b4d625d583414$export$bd0bf19f25da8474) {
    static{
        this.targets = [
            "attached",
            "blob",
            "empty",
            "input",
            "memberId",
            "name",
            "preview",
            "submit"
        ];
    }
    static{
        /** The "Photo ready {0}" sentence, so the filename the browser learns reads like the one the server renders. */ this.values = {
            ready: String
        };
    }
    connect() {
        this.render();
    }
    openPicker() {
        this.inputTarget.click();
    }
    onChange() {
        const file = this.inputTargets.map((it)=>it.files?.[0]).find((it)=>it !== undefined);
        if (file === undefined) return;
        if (this.hasNameTarget) this.nameTarget.textContent = this.readyValue ? this.readyValue.replace("{0}", file.name) : file.name;
        const reader = new FileReader();
        reader.onloadend = ()=>this.save(reader.result);
        reader.readAsDataURL(file);
    }
    save(result) {
        if (typeof result !== "string") return;
        this.blobTarget.value = result.split(",")[1] ?? "";
        this.inputTarget.value = "";
        this.previewTarget.src = result;
        this.previewTarget.classList.remove("membership-document-placeholder");
        this.render();
    }
    /** The member number gates the action as much as the photo does. */ onMemberIdInput() {
        this.render();
    }
    /** Back to the empty state: the photo, the bytes that were going to be posted, and the name. */ remove() {
        this.blobTarget.value = "";
        this.previewTarget.removeAttribute("src");
        this.inputTargets.forEach((it)=>it.value = "");
        if (this.hasNameTarget) this.nameTarget.textContent = "";
        this.render();
    }
    /** The upload is a plain form post, so this is the only moment the sheet can say it is working. */ onSubmit() {
        if (this.hasSubmitTarget) {
            this.submitTarget.disabled = true;
            this.submitTarget.dataset["loading"] = "true";
        }
    }
    render() {
        // A card already on file arrives as a `src` with no blob, which is just as attached.
        const attached = this.blobTarget.value !== "" || (this.previewTarget.getAttribute("src") ?? "") !== "";
        if (this.hasEmptyTarget) this.emptyTarget.hidden = attached;
        if (this.hasAttachedTarget) this.attachedTarget.hidden = !attached;
        if (this.hasSubmitTarget) this.submitTarget.disabled = !attached || !this.hasMemberId();
    }
    hasMemberId() {
        return !this.hasMemberIdTarget || this.memberIdTarget.value.trim() !== "";
    }
}



class $37d9c55b7e8ac099$export$2e2bcd8739ae039 extends (0, $1e1b4d625d583414$export$bd0bf19f25da8474) {
    static{
        this.targets = [
            "heading",
            "title"
        ];
    }
    connect() {
        if (!this.hasHeadingTarget || !this.hasTitleTarget) return;
        const scrolled = this.titleTarget.dataset["wpTitleScrolled"];
        if (scrolled === undefined || scrolled === "") return;
        /* Not `IntersectionObserver` in happy-dom, and not in a browser old enough to matter either.
           Without it the bar keeps the title the server rendered, which is the behaviour this
           replaces rather than a broken version of it. */ if (typeof IntersectionObserver !== "function") return;
        this.pageTitle = this.titleTarget.textContent ?? "";
        /* The heading counts as gone when it passes under the bar rather than when it leaves the
           window, so the viewport is shortened by the bar's own height. Read from the custom
           property so the two cannot drift; happy-dom resolves a custom property to the empty
           string, which is what the fallback is for. */ const height = Number.parseInt(getComputedStyle(document.documentElement).getPropertyValue("--wp-navbar-height"), 10);
        this.observer = new IntersectionObserver((entries)=>{
            for (const entry of entries)this.render(entry.isIntersecting ? this.pageTitle : scrolled);
        }, {
            rootMargin: `-${Number.isNaN(height) ? 56 : height}px 0px 0px 0px`,
            threshold: 0
        });
        this.observer.observe(this.headingTarget);
    }
    disconnect() {
        /* The observer outlives the element it was watching, so it goes with the controller rather
           than being left holding a node that has been navigated away from. */ this.observer?.disconnect();
        this.observer = undefined;
    }
    /** Writes a title only when it is not the one already there, so a scroll does not churn the DOM. */ render(title) {
        if (this.titleTarget.textContent !== title) this.titleTarget.textContent = title;
    }
    constructor(...args){
        super(...args), /** The bar's own title, kept so the swap can be undone on the way back up. */ this.pageTitle = "";
    }
}



class $0a8301baca1469fe$export$2e2bcd8739ae039 extends (0, $1e1b4d625d583414$export$bd0bf19f25da8474) {
    static{
        this.targets = [
            "row"
        ];
    }
    connect() {
        const platform = this.platform();
        for (const row of this.rowTargets)if (row.dataset.platformRow === platform) row.removeAttribute("hidden");
    }
    /**
   * iPhone and iPad, where the App Store is a tap away.
   *
   * The second test is iPadOS 13 and later, which reports itself as a Mac down to the user-agent
   * string: `MacIntel` with a touch screen is an iPad, because no Mac has ever had one.
   */ platform() {
        const agent = window.navigator.userAgent;
        const iPadOS = window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1;
        return /iPhone|iPad|iPod/.test(agent) || iPadOS ? "ios" : "other";
    }
}



/**
 * The reference sheet: find a player from the club, then say how matches with them usually go.
 *
 * Two panels in one sheet rather than iOS's sheet over a sheet, which on a page would be a modal
 * over a modal. Picking a player does not add them - it carries their id, name and picture into the
 * outcome panel's hidden fields and swaps the panels over, and the reference is only added once one
 * of that panel's three submit buttons is pressed. So the choice is still asked once, at selection
 * time, which is what lets the row on the step behind show the outcome as a fact rather than as
 * another control.
 *
 * The outcome labels and the question above them name the player, so they are rendered with `{0}`
 * left in and filled in here. Rendering three labels per search result server-side would mean
 * knowing who is about to be picked.
 */ const $d6e8da0f110a32e4$var$LABEL_PLACEHOLDER = "{0}";
class $d6e8da0f110a32e4$export$2e2bcd8739ae039 extends (0, $93a025088c3b8fce$export$2e2bcd8739ae039) {
    static{
        this.targets = [
            "outcomeLabel",
            "outcomePanel",
            "playerFirstName",
            "playerId",
            "playerImage",
            "playerName",
            "prompt",
            "searchField",
            "searchResults"
        ];
    }
    onPick(event) {
        const target = event.target;
        if (!(target instanceof Element)) return;
        const row = target.closest("[data-player-id]");
        if (row === null) return;
        const name = row.dataset.playerName ?? "";
        const firstName = row.dataset.playerFirstName ?? "";
        this.playerFirstNameTarget.value = firstName;
        this.playerIdTarget.value = row.dataset.playerId ?? "";
        this.playerImageTarget.value = row.dataset.playerImage ?? "";
        this.playerNameTarget.value = name;
        /* The same fallback every player row in this flow makes: a search result without a separate
       first name is drawn, and named, by its display name. */ const spoken = firstName === "" ? name : firstName;
        this.fill(this.promptTarget, spoken);
        this.outcomeLabelTargets.forEach((label)=>this.fill(label, spoken));
        this.showOutcomePanel(true);
    }
    /**
   * Back to the search panel whenever the sheet shuts.
   *
   * Bound to the dialog's own `close` event rather than to the Cancel button, because Escape and a
   * press on the backdrop close a <dialog> without going anywhere near Cancel - and a sheet
   * reopened on the outcome panel of a player somebody just backed out of is a sheet that lost its
   * place.
   */ onClose() {
        this.showOutcomePanel(false);
        this.reset();
    }
    showOutcomePanel(showing) {
        this.outcomePanelTarget.hidden = !showing;
        this.searchFieldTarget.hidden = showing;
        this.searchResultsTarget.hidden = showing;
    }
    /**
   * The template stays on the element rather than being read back out of its own text, so filling
   * it in twice for two different players still names the second one.
   */ fill(element, name) {
        const template = element.dataset.labelTemplate ?? element.textContent ?? "";
        element.textContent = template.split($d6e8da0f110a32e4$var$LABEL_PLACEHOLDER).join(name);
    }
}



class $b5d29ca8e8fdfc8c$export$2e2bcd8739ae039 extends (0, $1e1b4d625d583414$export$bd0bf19f25da8474) {
    static{
        this.targets = [
            "input",
            "option",
            "outputDescription",
            "outputValue"
        ];
    }
    onChange() {
        const value = parseFloat(this.inputTarget.value).toFixed(1);
        const option = this.optionTargets.find((it)=>it.value === value);
        this.outputDescriptionTarget.textContent = option?.dataset.playingAbilityDescription ?? "";
        this.outputValueTarget.textContent = value;
    }
}




/**
 * The recent searches, kept in the browser.
 *
 * `SearchViewModel` persists the `SearchResultItem` the reader chose - deduped by id, newest
 * first, capped at ten - in plain `UserDefaults`, and draws its recent rows from that rather
 * than asking the server again. This is the same store on the web: `localStorage` rather than
 * `UserDefaults`, under the same key, and nothing in it ever reaches the server. A list of who
 * somebody looked up is theirs, and the server has no reason to hold one.
 *
 * What is kept per entry is the row the server already rendered, not the fields it was rendered
 * from. A recent row has to look exactly like a result row - the same squircle avatar, the same
 * two-line name, the same flag and chevron, every one of them a component-library fragment and
 * inline SVG - and rebuilding that in TypeScript would be a second copy of
 * `fragment/search-result/table` to keep in step. Keeping the markup means there is only ever
 * one version of a row. The cost is that an entry stored before that fragment changed is drawn
 * the old way until it is chosen again: a cosmetic difference, in a list of at most ten rows,
 * that heals itself as they are used.
 */ /** The same key `SearchViewModel` uses, so the two stores are recognisably the same one. */ const $c25d9eced1c6d51c$var$KEY = "com.getweplay.search.recent_searches";
/** `SearchViewModel.maxRecentSearches`. */ const $c25d9eced1c6d51c$var$LIMIT = 10;
/**
 * What never comes back out of the store, whatever is in it.
 *
 * The store is same-origin and this page is its only writer, so the markup in it is already
 * Thymeleaf-escaped and the only person who can put anything else there is the reader, in their
 * own browser, to their own browser. That is nobody's attack on anybody. But `<img onerror>`
 * fires from a parsed document whether or not somebody meant it to, and a stored row is the one
 * string on this page that outlives the page that wrote it, so stripping the handlers and the
 * elements that fetch or run anything costs a dozen lines and removes the question.
 */ const $c25d9eced1c6d51c$var$FORBIDDEN_ELEMENTS = "embed, iframe, link, meta, object, script, style";
/** The schemes that are code or a payload rather than somewhere to go. */ const $c25d9eced1c6d51c$var$FORBIDDEN_SCHEME = /^\s*(data|javascript|vbscript):/i;
function $c25d9eced1c6d51c$var$isRecentSearch(value) {
    if (typeof value !== "object" || value === null) return false;
    const candidate = value;
    return typeof candidate.id === "string" && candidate.id !== "" && typeof candidate.row === "string" && typeof candidate.url === "string" && candidate.url !== "";
}
/*
 * Every read and write is guarded, because `localStorage` is not always there to be used: a
 * browser told to block site data throws on the property itself, and a private window has
 * historically thrown on `setItem` the moment anything was put in it. Neither is a reason for the
 * search screen to stop working, so a store that cannot be reached is an empty one.
 */ function $c25d9eced1c6d51c$var$read() {
    try {
        return window.localStorage.getItem($c25d9eced1c6d51c$var$KEY);
    } catch  {
        return null;
    }
}
function $c25d9eced1c6d51c$var$write(entries) {
    try {
        window.localStorage.setItem($c25d9eced1c6d51c$var$KEY, JSON.stringify(entries));
    } catch  {
    /* Nothing to do and nothing to say: the list the caller was handed is still right for the
           rest of this page's life, it just will not survive into the next one. */ }
}
function $c25d9eced1c6d51c$export$11e63f7b0f3d9900() {
    const stored = $c25d9eced1c6d51c$var$read();
    if (stored === null) return [];
    let parsed;
    try {
        parsed = JSON.parse(stored);
    } catch  {
        return [];
    }
    if (!Array.isArray(parsed) || !parsed.every($c25d9eced1c6d51c$var$isRecentSearch)) return [];
    return parsed.slice(0, $c25d9eced1c6d51c$var$LIMIT);
}
function $c25d9eced1c6d51c$export$8130aacad3681905(entry) {
    const kept = $c25d9eced1c6d51c$export$11e63f7b0f3d9900().filter((stored)=>stored.id !== entry.id);
    const entries = [
        entry,
        ...kept
    ].slice(0, $c25d9eced1c6d51c$var$LIMIT);
    $c25d9eced1c6d51c$var$write(entries);
    return entries;
}
function $c25d9eced1c6d51c$export$cd7f480d6b8286c3(id) {
    const entries = $c25d9eced1c6d51c$export$11e63f7b0f3d9900().filter((stored)=>stored.id !== id);
    $c25d9eced1c6d51c$var$write(entries);
    return entries;
}
function $c25d9eced1c6d51c$export$42ffd38884aecdac() {
    $c25d9eced1c6d51c$var$write([]);
    return [];
}
function $c25d9eced1c6d51c$export$8141cd873df499ba(row) {
    const parsed = new DOMParser().parseFromString(row, "text/html");
    parsed.body.querySelectorAll($c25d9eced1c6d51c$var$FORBIDDEN_ELEMENTS).forEach((element)=>element.remove());
    parsed.body.querySelectorAll("*").forEach((element)=>{
        element.getAttributeNames().forEach((name)=>{
            const lowered = name.toLowerCase();
            /* `on*` is every inline handler there is. A location is left alone unless its scheme is
               code: the avatar's `src` and the row's own `href` are two of the three things a
               row is made of. */ if (lowered.startsWith("on") || [
                "href",
                "src",
                "srcset"
            ].includes(lowered) && $c25d9eced1c6d51c$var$FORBIDDEN_SCHEME.test(element.getAttribute(name) ?? "")) element.removeAttribute(name);
        });
    });
    const fragment = document.createDocumentFragment();
    Array.from(parsed.body.childNodes).forEach((node)=>fragment.append(document.importNode(node, true)));
    return fragment;
}


/**
 * Search as you type and remember what was chosen, which is what `SearchViewModel` does on iOS.
 *
 * The screen was a GET form and nothing else: you typed, you pressed Enter, the page reloaded.
 * That is still what happens with no script, and it is still the address a result is shared
 * under. What this adds is the app's own behaviour on top of it - the list follows the field, and
 * the screen you land on is the last people you looked up rather than an empty invitation.
 *
 * The results are a Turbo frame pointed back at this very page rather than at a fragment
 * endpoint of its own. The live path and the no-script path then render from the same controller
 * and the same template, so the two cannot drift: there is no second view of a search result to
 * keep in step. The layout around the frame is rebuilt and thrown away on each pass, which costs
 * a Thymeleaf render and no extra query, because the search itself is the only thing on this
 * page that touches the database.
 *
 * The recent searches are the other way round: they are the reader's own, they are held in their
 * own browser by `lib/recent-search`, and the server is never told about them or asked to render
 * them. Which of the two lists is on screen is this controller's single rule, below.
 */ /* iOS's numbers, from `SearchViewModel`: 500ms after the typing stops, and nothing is asked for
   under three characters. Constants rather than Stimulus values because there is one search
   screen and these are the app's rules, not this page's settings. */ const $6e28d4c7d9c47fb8$var$DEBOUNCE_MS = 500;
const $6e28d4c7d9c47fb8$var$MINIMUM_LENGTH = 3;
class $6e28d4c7d9c47fb8$export$2e2bcd8739ae039 extends (0, $1e1b4d625d583414$export$bd0bf19f25da8474) {
    static{
        this.targets = [
            "form",
            "frame",
            "recent",
            "recentList",
            "recentRow"
        ];
    }
    connect() {
        this.loaded = this.address();
        this.draw((0, $c25d9eced1c6d51c$export$11e63f7b0f3d9900)());
    }
    disconnect() {
        clearTimeout(this.pending);
    }
    /*
   * The busy flag goes on here, on the keystroke, and not when the request starts.
   *
   * That is `SearchViewModel` setting `isLoading` in `queryChanged()` rather than in
   * `performSearch`, and for the same reason: for the next half second the page is showing an
   * answer to a question that is no longer being asked, and nothing would say so.
   *
   * Turbo marks and clears the frame busy around its own fetch, so it takes the flag over from
   * here and removes it once the frame has rendered - including when the request failed.
   *
   * The swap between the two lists is not debounced, though. `SearchViewModel` switches on the
   * character that takes the query over the minimum, not half a second after it, and a screen
   * still showing yesterday's searches while today's are being typed reads as a field that has
   * stopped listening.
   */ onInput() {
        clearTimeout(this.pending);
        this.frameTarget.setAttribute("aria-busy", "true");
        this.reveal();
        this.pending = setTimeout(()=>this.search(), $6e28d4c7d9c47fb8$var$DEBOUNCE_MS);
    }
    /** Enter is somebody saying they have finished typing, so it does not wait out the debounce. */ onSubmit(event) {
        event.preventDefault();
        clearTimeout(this.pending);
        this.reveal();
        this.search();
    }
    /**
   * Remembers whichever row was chosen, live result or recent search alike.
   *
   * `SearchViewModel.selectResult` is called from both lists for the same reason: choosing a
   * recent search is still choosing it, and it belongs back at the top afterwards.
   *
   * One delegated handler on the controller's own element rather than a `data-action` per row.
   * The result rows are written by the server into a frame it replaces wholesale, and the recent
   * rows are written here; a listener above both is the only place that covers them without the
   * row markup having to know which of the two lists it is in.
   *
   * Nothing is drawn afterwards. The click is a whole-page navigation - the frame is
   * `target="_top"` - so this page is on its way out, and `localStorage` is written
   * synchronously, which is what makes that safe.
   */ onSelect(event) {
        const target = event.target;
        if (!(target instanceof Element)) return;
        const row = target.closest("a[data-search-result-id]");
        if (row === null) return;
        const id = row.dataset.searchResultId;
        const url = row.getAttribute("href");
        if (id === undefined || url === null) return;
        (0, $c25d9eced1c6d51c$export$8130aacad3681905)({
            id: id,
            row: row.innerHTML,
            url: url
        });
    }
    /**
   * One recent search, which is iOS's swipe-to-delete without the swipe.
   *
   * Delegated from the controller's element for the same reason `onSelect` is, and not declared
   * on the button in the template: an action attribute only binds once Stimulus has seen the
   * element, and these rows are written by the controller itself. A listener above them is
   * already connected when they arrive.
   */ removeRecent(event) {
        const target = event.target;
        if (!(target instanceof Element) || target.closest("[data-search-recent-remove]") === null) return;
        const id = target.closest("[data-search-recent-id]")?.dataset.searchRecentId;
        if (id === undefined) return;
        this.draw((0, $c25d9eced1c6d51c$export$cd7f480d6b8286c3)(id));
    }
    /**
   * All of them, which the sheet over this page has already asked about.
   *
   * The confirmation is the app's own: `SearchView` puts an alert in front of this, because the
   * list cannot be got back and a mis-aimed tap on a header button is an easy way to lose it.
   * The sheet closes itself through the component library's `data-wp-sheet-close`, so there is
   * nothing here about dismissing it.
   */ clearRecent() {
        this.draw((0, $c25d9eced1c6d51c$export$42ffd38884aecdac)());
    }
    search() {
        /* A pending search belongs to the page it was typed on, and a Turbo visit can take that page
           away while the debounce is still running. `disconnect()` is what cancels it; this is what
           makes that true even when the cancellation has not reached us yet, which is the one order
           of events that would otherwise point a frame nobody is looking at at a new address. */ if (!this.element.isConnected) return;
        const address = this.address();
        /* Nothing to ask for: the query came back to what is already on screen, which is what
           deleting the character you just typed does. Turbo never starts, so the flag it would
           have cleared has to come off here. */ if (address === this.loaded) {
            this.frameTarget.removeAttribute("aria-busy");
            return;
        }
        this.loaded = address;
        this.frameTarget.setAttribute("src", address);
        /* Replace rather than push: a result is a URL somebody can keep or share, which is the
           whole reason the field is a GET form, but one history entry per keystroke would make
           the back button walk backwards through the typing. Turbo's own history rather than
           `history.replaceState`, so the session's idea of where it is stays true. */ (0, $dae3d0e46d061380$export$ec7c8efa7f5790ae).history.replace(new URL(address, window.location.href));
    }
    /**
   * Draws the recent searches and then decides which list the screen is showing.
   *
   * The rows are built from the template the server put on the page rather than from markup
   * written here, so the remove button's glyph and its label come out of the component library
   * and the app's own resource bundle like everything else on the screen does.
   */ draw(entries) {
        this.recentListTarget.replaceChildren();
        entries.forEach((entry, index)=>{
            const row = this.recentRowTarget.content.cloneNode(true);
            const wrapper = row.querySelector(".wp-list-row");
            const link = row.querySelector("a");
            if (wrapper === null || link === null) return;
            wrapper.dataset.searchRecentId = entry.id;
            link.dataset.searchResultId = entry.id;
            link.href = entry.url;
            link.append((0, $c25d9eced1c6d51c$export$8141cd873df499ba)(entry.row));
            /* The stored row carries the number it had among the results it was chosen from, which
               was a fact about that search and not about this list. `SearchRowView` is passed its
               row's position either way, so the number is restated here rather than kept. */ const position = link.querySelector(".wp-position");
            if (position !== null) position.textContent = String(index + 1);
            this.recentListTarget.append(row);
        });
        this.reveal(entries.length);
    }
    /**
   * Which of the two lists is on screen.
   *
   * `SearchView` shows the recent searches below the minimum and the results above it, and falls
   * back to the invitation when there is nothing recent to show. That is one rule with three
   * outcomes, and the frame is hidden rather than emptied for the third: the invitation and the
   * "nothing matched" state are both inside it, already rendered, and whichever of them is in
   * there is the right thing to show the moment the recent list empties.
   */ reveal(count = this.recentListTarget.childElementCount) {
        const recent = count > 0 && this.query().length < $6e28d4c7d9c47fb8$var$MINIMUM_LENGTH;
        /* Each only when it is actually changing. Every keystroke calls this, and writing an
           attribute the element already has would be a DOM mutation per character for nothing. */ if (this.recentTarget.hidden !== !recent) this.recentTarget.hidden = !recent;
        if (this.frameTarget.hidden !== recent) this.frameTarget.hidden = recent;
    }
    /**
   * Where the results for whatever is in the field right now live.
   *
   * Built from the form's own action and the field's own name, so the controller keeps no copy
   * of either. Under the minimum the query is left off altogether, which asks for the bare
   * page: on iOS a query that short clears the results and hands the screen back to the recent
   * searches, and this does both of those too.
   *
   * Dropping everything but the path and the query also resets the paging, which is right -
   * page four of the last search is not page four of this one.
   */ address() {
        const url = new URL(this.formTarget.action, window.location.href);
        const field = this.field();
        const query = this.query();
        if (query.length >= $6e28d4c7d9c47fb8$var$MINIMUM_LENGTH) url.searchParams.set(field.name, query);
        return `${url.pathname}${url.search}`;
    }
    query() {
        return this.field().value.trim();
    }
    /*
   * The field is found rather than declared as a target: it is drawn by the component library's
   * `search` fragment, which takes the handful of parameters it takes and knows nothing about
   * Stimulus. Giving it a `data-search-target` would mean teaching a design-system fragment
   * about this application's controllers.
   */ field() {
        const field = this.formTarget.querySelector('input[type="search"]');
        if (field === null) throw new Error("the search form has no search field in it");
        return field;
    }
    constructor(...args){
        super(...args), /** The address the frame already shows, so typing and deleting a character asks for nothing. */ this.loaded = "";
    }
}



const $3d02c15d57df4503$var$FALLBACK_ROW = 34;
const $3d02c15d57df4503$var$HOURS = 23;
const $3d02c15d57df4503$var$MINUTES = 59;
class $3d02c15d57df4503$export$2e2bcd8739ae039 extends (0, $1e1b4d625d583414$export$bd0bf19f25da8474) {
    static{
        this.targets = [
            "action",
            "dateInput",
            "dateSheet",
            "dateValue",
            "hourWheel",
            "minuteWheel",
            "playedAt",
            "resultTypeOption",
            "resultTypeSheet",
            "resultTypeValue",
            "retiredRow",
            "retiredSheet",
            "retiredSideId",
            "retiredValue",
            "scoreMode",
            "scoreSheet",
            "scoreSheetTitle",
            "scoreWheel",
            "setScore",
            "tab",
            "timeSheet",
            "timeValue",
            "winnerRow",
            "winnerSheet",
            "winnerSideId",
            "winnerValue"
        ];
    }
    static{
        this.values = {
            maxGames: {
                type: Number,
                default: 7
            },
            maxTieBreak: {
                type: Number,
                default: 20
            }
        };
    }
    connect() {
        this.buildWheel(this.hourWheelTarget, this.range(0, $3d02c15d57df4503$var$HOURS).map((it)=>this.pad(it)));
        this.buildWheel(this.minuteWheelTarget, this.range(0, $3d02c15d57df4503$var$MINUTES).map((it)=>this.pad(it)));
        const action = new URL(window.location.href).searchParams.get("action");
        this.changeAction(action === null ? "regular" : action.substring(7));
    }
    /* ----------------------------------------------------------------- result type ---- */ openResultType() {
        this.markSelected(this.resultTypeSheetTarget, this.resultType);
        this.resultTypeSheetTarget.showModal();
    }
    onChangeResultType(event) {
        this.changeAction(this.eventValue(event).toLowerCase());
    }
    openRetiredSide() {
        this.markSelected(this.retiredSheetTarget, this.retiredSideIdTarget.value);
        this.retiredSheetTarget.showModal();
    }
    onChangeRetiredSide(event) {
        const option = this.eventTarget(event);
        this.retiredSideIdTarget.value = option.value;
        this.retiredValueTarget.textContent = this.optionLabel(option);
        this.markSelected(this.retiredSheetTarget, option.value);
    }
    openWinnerSide() {
        this.markSelected(this.winnerSheetTarget, this.winnerSideIdTarget.value);
        this.winnerSheetTarget.showModal();
    }
    onChangeWinnerSide(event) {
        const option = this.eventTarget(event);
        this.winnerSideIdTarget.value = option.value;
        this.winnerValueTarget.textContent = this.optionLabel(option);
        this.markSelected(this.winnerSheetTarget, option.value);
    }
    /* The route decides which model the server binds, so the result type is a change of `action`
       as well as of what the screen shows. */ changeAction(selected) {
        this.resultType = selected.toUpperCase();
        const actionUrl = new URL(this.actionTarget.getAttribute("action") ?? "", window.location.href);
        actionUrl.searchParams.set("action", `submit-${selected}`);
        this.actionTarget.setAttribute("action", actionUrl.toString());
        const option = this.resultTypeOptionTargets.find((it)=>it.value === this.resultType);
        if (option !== undefined) this.resultTypeValueTarget.textContent = this.optionLabel(option);
        this.markSelected(this.resultTypeSheetTarget, this.resultType);
        this.tabTargets.forEach((it)=>{
            it.hidden = it.id !== `submit-score-tab-${selected}`;
        });
        /* A row only exists for the result type that needs it, and the input behind it is disabled
           while the row is away: a disabled control posts nothing, so a walkover cannot carry a
           retired side. */ this.toggleSide(this.retiredRowTarget, this.retiredSideIdTarget, selected === "retirement");
        this.toggleSide(this.winnerRowTarget, this.winnerSideIdTarget, selected === "walkover");
        /* A walkover has no games at all. */ this.setScoreTargets.forEach((section)=>{
            section.hidden = selected === "walkover";
            section.querySelectorAll("input").forEach((input)=>{
                input.disabled = selected === "walkover";
            });
        });
    }
    toggleSide(row, input, isShown) {
        row.hidden = !isShown;
        input.disabled = !isShown;
        input.required = isShown;
    }
    /* ----------------------------------------------------------------- set score ------ */ openScore(event) {
        const row = this.eventTarget(event);
        const section = row.closest("[data-set-index]");
        if (section === null) return;
        this.scoreSet = Number(section.dataset.setIndex);
        this.scoreSide = row.dataset.side ?? "";
        this.scoreSheetTitleTarget.textContent = (section.querySelector(".wp-list-title")?.textContent ?? "").trim();
        const mode = this.scoreModeBySet.get(this.scoreSet) ?? "regular";
        this.scoreModeTargets.forEach((it)=>{
            it.checked = it.value === mode;
        });
        this.scoreSheetTarget.showModal();
        this.fillScoreWheel(mode);
    }
    onChangeScoreMode(event) {
        const mode = this.asScoreMode(this.eventValue(event));
        this.scoreModeBySet.set(this.scoreSet, mode);
        this.fillScoreWheel(mode);
    }
    confirmScore() {
        const input = this.scoreInput(this.scoreSet, this.scoreSide, this.scoreMode());
        if (input !== null) input.value = String(this.wheelValue(this.scoreWheelTarget));
        this.refreshScores(this.scoreSet);
        this.scoreSheetTarget.close();
    }
    fillScoreWheel(mode) {
        const limit = mode === "tie-break" ? this.maxTieBreakValue : this.maxGamesValue;
        const current = Number(this.scoreInput(this.scoreSet, this.scoreSide, mode)?.value ?? 0);
        this.buildWheel(this.scoreWheelTarget, this.range(0, limit));
        this.scrollWheel(this.scoreWheelTarget, Math.min(current, limit));
    }
    scoreMode() {
        const checked = this.scoreModeTargets.find((it)=>it.checked);
        return checked === undefined ? "regular" : this.asScoreMode(checked.value);
    }
    scoreInput(set, side, mode) {
        const section = this.setScoreTargets.find((it)=>Number(it.dataset.setIndex) === set);
        return section?.querySelector(`[data-score="${side}-${mode}"]`) ?? null;
    }
    /* Both rows of the set are redrawn, not just the one that was edited: the tie-break shows on a
       row as soon as EITHER side has points on it, the same rule the app's `hasTieBreak` uses and
       the same one a finished match's scoreline follows. */ refreshScores(set) {
        const section = this.setScoreTargets.find((it)=>Number(it.dataset.setIndex) === set);
        if (section === undefined) return;
        const value = (side, mode)=>Number(section.querySelector(`[data-score="${side}-${mode}"]`)?.value ?? 0);
        const hasTieBreak = value("a", "tie-break") > 0 || value("b", "tie-break") > 0;
        section.querySelectorAll("[data-side]").forEach((row)=>{
            const side = row.dataset.side ?? "";
            const games = row.querySelector("[data-score-games]");
            if (games !== null) games.textContent = String(value(side, "regular"));
            const tieBreak = row.querySelector("[data-score-tie-break]");
            if (tieBreak !== null) {
                tieBreak.textContent = String(value(side, "tie-break"));
                tieBreak.hidden = !hasTieBreak;
            }
        });
    }
    /* ----------------------------------------------------------------- played at ------ */ openDate() {
        this.dateInputTarget.value = this.playedAtTarget.value.substring(0, 10);
        this.dateInputTarget.min = (this.playedAtTarget.min || "").substring(0, 10);
        this.dateInputTarget.max = (this.playedAtTarget.max || "").substring(0, 10);
        this.dateSheetTarget.showModal();
        /* The month grid is drawn from the field, and the field was just given a different value
           and a different window. The sheet is opened here rather than through the library's own
           opener, which is what would otherwise have asked for this. */ document.dispatchEvent(new CustomEvent("wp:paint", {
            detail: {
                root: this.dateSheetTarget
            }
        }));
    }
    confirmDate() {
        if (this.dateInputTarget.value !== "") this.setPlayedAt(this.dateInputTarget.value, this.playedAtTarget.value.substring(11, 16));
        this.dateSheetTarget.close();
    }
    openTime() {
        const [hour, minute] = this.playedAtTarget.value.substring(11, 16).split(":");
        this.timeSheetTarget.showModal();
        this.scrollWheel(this.hourWheelTarget, Number(hour ?? 0));
        this.scrollWheel(this.minuteWheelTarget, Number(minute ?? 0));
    }
    confirmTime() {
        const hour = this.pad(this.wheelValue(this.hourWheelTarget));
        const minute = this.pad(this.wheelValue(this.minuteWheelTarget));
        this.setPlayedAt(this.playedAtTarget.value.substring(0, 10), `${hour}:${minute}`);
        this.timeSheetTarget.close();
    }
    /* `playedAt` is one value and the screen shows it as two, so both rows are redrawn from it
       rather than from whichever sheet was just confirmed. */ setPlayedAt(date, time) {
        this.playedAtTarget.value = `${date}T${time}`;
        /* Day, short month, year - the order the server renders it in with `d MMM yyyy`, rather
           than whatever order the locale would put those three in on its own. The month name is
           still the locale's. */ const parsed = new Date(`${date}T${time}`);
        const locale = document.documentElement.lang || undefined;
        const month = parsed.toLocaleDateString(locale, {
            month: "short"
        });
        this.dateValueTarget.textContent = `${parsed.getDate()} ${month} ${parsed.getFullYear()}`;
        this.timeValueTarget.textContent = time;
    }
    /* ----------------------------------------------------------------- wheel ---------- */ buildWheel(wheel, values) {
        wheel.replaceChildren(...values.map((value)=>{
            const option = document.createElement("li");
            option.className = "wp-wheel-option";
            option.setAttribute("role", "option");
            option.textContent = String(value);
            return option;
        }));
    }
    scrollWheel(wheel, index) {
        wheel.scrollTo({
            behavior: "instant",
            top: index * this.rowHeight(wheel)
        });
        this.markWheelValue(wheel, index);
    }
    wheelValue(wheel) {
        const index = Math.round(wheel.scrollTop / this.rowHeight(wheel));
        this.markWheelValue(wheel, index);
        return index;
    }
    markWheelValue(wheel, index) {
        Array.from(wheel.children).forEach((option, position)=>{
            option.setAttribute("aria-selected", String(position === index));
        });
    }
    rowHeight(wheel) {
        return parseFloat(getComputedStyle(wheel).getPropertyValue("--wp-wheel-row")) || $3d02c15d57df4503$var$FALLBACK_ROW;
    }
    /* ----------------------------------------------------------------- helpers -------- */ markSelected(sheet, value) {
        sheet.querySelectorAll("[value]").forEach((option)=>{
            const mark = option.querySelector("[data-selected-mark]");
            if (mark !== null) mark.hidden = option.value !== value;
        });
    }
    optionLabel(option) {
        return (option.querySelector(".wp-list-label")?.textContent ?? "").trim();
    }
    range(from, to) {
        return Array.from({
            length: to - from + 1
        }, (_, index)=>from + index);
    }
    pad(value) {
        return String(value).padStart(2, "0");
    }
    /** The control a `data-action` fired on. */ eventTarget(event) {
        const target = event.currentTarget;
        if (!(target instanceof HTMLButtonElement) && !(target instanceof HTMLInputElement)) throw new TypeError("A submit-score action fired on something with no value to read");
        return target;
    }
    eventValue(event) {
        return this.eventTarget(event).value;
    }
    asScoreMode(value) {
        return value === "tie-break" ? "tie-break" : "regular";
    }
    constructor(...args){
        super(...args), /*
   * Which of a set's two numbers each set's sheet is dialling, kept per set the way the app keeps
   * `scoreModeBySetIndex`: picking the tie-break for set two should not change what set one
   * opens on.
   */ this.scoreModeBySet = new Map(), this.resultType = "", this.scoreSet = 0, this.scoreSide = "";
    }
}


const $c4a57d39a9183f39$var$application = (0, $1e1b4d625d583414$export$16975c34e60e1e61).start();
$c4a57d39a9183f39$var$application.register("appearance", (0, $54329b5e509ad2da$export$2e2bcd8739ae039));
$c4a57d39a9183f39$var$application.register("avatar-upload", (0, $b79b362cd19a3d19$export$2e2bcd8739ae039));
$c4a57d39a9183f39$var$application.register("clipboard", (0, $821cd980ff0c9d36$export$2e2bcd8739ae039));
$c4a57d39a9183f39$var$application.register("club-select", (0, $35b922f3b84703dc$export$2e2bcd8739ae039));
$c4a57d39a9183f39$var$application.register("confetti", (0, $adfa29faa56d32bf$export$2e2bcd8739ae039));
$c4a57d39a9183f39$var$application.register("doubles-partner-select", (0, $78490bebdba82f75$export$2e2bcd8739ae039));
$c4a57d39a9183f39$var$application.register("error", (0, $91ae0a51bbca2e65$export$2e2bcd8739ae039));
$c4a57d39a9183f39$var$application.register("language-select", (0, $2337fc35a39e1c2f$export$2e2bcd8739ae039));
$c4a57d39a9183f39$var$application.register("match-up-edit", (0, $2014f5e600daf242$export$2e2bcd8739ae039));
$c4a57d39a9183f39$var$application.register("media-viewer", (0, $32289d48784a1cb1$export$2e2bcd8739ae039));
$c4a57d39a9183f39$var$application.register("membership-document-upload", (0, $eb0b863d8c17e3de$export$2e2bcd8739ae039));
$c4a57d39a9183f39$var$application.register("nav-title", (0, $37d9c55b7e8ac099$export$2e2bcd8739ae039));
$c4a57d39a9183f39$var$application.register("platform", (0, $0a8301baca1469fe$export$2e2bcd8739ae039));
$c4a57d39a9183f39$var$application.register("player-reference-select", (0, $d6e8da0f110a32e4$export$2e2bcd8739ae039));
$c4a57d39a9183f39$var$application.register("playing-ability", (0, $b5d29ca8e8fdfc8c$export$2e2bcd8739ae039));
$c4a57d39a9183f39$var$application.register("search", (0, $6e28d4c7d9c47fb8$export$2e2bcd8739ae039));
$c4a57d39a9183f39$var$application.register("submit-score", (0, $3d02c15d57df4503$export$2e2bcd8739ae039));
(0, $54ecc3f76f39aa81$export$2e2bcd8739ae039)();
/* Turbo hardcodes `turbo-progress-bar` as the class on the progress bar it creates and offers no
   setting for it, so the element is tagged here and `.wp-progress-bar` is what paints it in the
   brand colour. The bar is built by the session's adapter at import time and is the same element
   for the life of the page, so tagging it once at boot covers every navigation. */ /* `progressBar` is on Turbo's BrowserAdapter rather than on the `Adapter` interface the session
   is typed with, so it is reached through a narrow local shape. Every hop stays optional: on a
   session using a different adapter there is no bar, and that is not an error. */ const $c4a57d39a9183f39$var$adapter = (0, $dae3d0e46d061380$export$55427e926be628d4).adapter;
$c4a57d39a9183f39$var$adapter?.progressBar?.progressElement?.classList.add("wp-progress-bar");
/* Reporting is off in development, where a stack trace in the console is more use than one in
   Sentry and the noise would otherwise be attributed to the production project. */ const $c4a57d39a9183f39$var$profile = document.querySelector('meta[name="ApplicationProfile"]');
if ($c4a57d39a9183f39$var$profile?.content !== "dev") $3892e5b7960d5b8e$export$2cd8252107eb640b({
    dsn: "https://8b2446049dcd42e09078a4c847654660@o226940.ingest.sentry.io/6178573",
    integrations: [
        new (0, $06791d67b9ee3cd2$exports).BrowserTracing()
    ],
    /* 1.0 captures every transaction for performance monitoring; worth revisiting if the
           volume ever becomes a cost. */ tracesSampleRate: 1.0
});
/*
 * A frame that answers with `X-Navigator-History-Url` is saying "this frame swap was a navigation,
 * put it in the address bar": Turbo does not change the URL for a frame render on its own.
 */ document.addEventListener("turbo:frame-render", (event)=>{
    const detail = event.detail;
    const url = detail.fetchResponse?.response.headers.get("X-Navigator-History-Url");
    if (url === null || url === undefined || url === "") return;
    const current = new URL(window.location.href);
    (0, $dae3d0e46d061380$export$ec7c8efa7f5790ae).history.push(new URL(`${current.origin}${url}`));
});
/* The server formats every date and time in the viewer's own zone, and this is the only way the
   browser can tell it which that is. */ document.cookie = `TIMEZONE=${Intl.DateTimeFormat().resolvedOptions().timeZone}; path=/; SameSite=Strict; Secure`;

})();
//# sourceMappingURL=index.js.map
